/*!
 * froala_editor v4.0.8 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2021 Froala Labs
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.FroalaEditor = factory());
}(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  // Closest polyfill.
  if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  if (!Element.prototype.closest) Element.prototype.closest = function (s) {
    var el = this;
    if (!document.documentElement.contains(el)) return null;

    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);

    return null;
  }; // Matches polyfill.

  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;

      while (--i >= 0 && matches.item(i) !== this) {}

      return i > -1;
    };
  } // isArray polyfill.


  if (!Array.isArray) {
    Array.isArray = function (arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    };
  } // Object.assign


  if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) {

        if (target == null) {
          // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) {
            // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }

        return to;
      },
      writable: true,
      configurable: true
    });
  }

  (function _scopeShim() {
    // Match usage of scope
    var scopeRE = /^\s*:scope/gi;
    var scopeREComma = /,\s*:scope/gi; // A temporary element to query against for elements not currently in the DOM
    // We'll also use this element to test for :scope support

    var container = document.createElement('div'); // Overrides

    function overrideNodeMethod(prototype, methodName) {
      // Store the old method for use later
      var oldMethod = prototype[methodName]; // Override the method

      prototype[methodName] = function (query) {
        var nodeList;
        var gaveId = false;
        var gaveContainer = false;

        if (query && !Array.isArray(query) && (query.match(scopeRE) || query.match(scopeREComma))) {
          if (!this.parentNode) {
            // Add to temporary container
            container.appendChild(this);
            gaveContainer = true;
          }

          var parentNode = this.parentNode;

          if (!this.id) {
            // Give temporary ID
            this.id = "rootedQuerySelector_id_".concat(new Date().getTime());
            gaveId = true;
          } // Find elements against parent node
          // Replace :scope with node's id


          nodeList = oldMethod.call(parentNode, query.replace(scopeRE, "#".concat(this.id)).replace(scopeREComma, ",#".concat(this.id))); // Reset the ID

          if (gaveId) {
            this.id = '';
          } // Remove from temporary container


          if (gaveContainer) {
            container.removeChild(this);
          }

          return nodeList;
        } // No immediate child selector used


        return oldMethod.call(this, query);
      };
    } // Check if the browser supports :scope


    try {
      // Browser supports :scope, do nothing
      var nodeColl = container.querySelectorAll(':scope *');

      if (!nodeColl || Array.isArray(nodeColl)) {
        throw 'error';
      }
    } catch (e) {
      // Browser doesn't support :scope, add polyfill
      overrideNodeMethod(Element.prototype, 'querySelector');
      overrideNodeMethod(Element.prototype, 'querySelectorAll');
      overrideNodeMethod(HTMLElement.prototype, 'querySelector');
      overrideNodeMethod(HTMLElement.prototype, 'querySelectorAll');
    }
  })(); //classlist library code

  /*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */


  "document" in self && ("classList" in document.createElement("_") && (!document.createElementNS || "classList" in document.createElementNS("http://www.w3.org/2000/svg", "g")) || !function (t) {

    if ("Element" in t) {
      var e = "classList",
          n = "prototype",
          i = t.Element[n],
          s = Object,
          r = String[n].trim || function () {
        return this.replace(/^\s+|\s+$/g, "");
      },
          o = Array[n].indexOf || function (t) {
        for (var e = 0, n = this.length; n > e; e++) {
          if (e in this && this[e] === t) return e;
        }

        return -1;
      },
          c = function c(t, e) {
        this.name = t, this.code = DOMException[t], this.message = e;
      },
          a = function a(t, e) {
        if ("" === e) throw new c("SYNTAX_ERR", "The token must not be empty.");
        if (/\s/.test(e)) throw new c("INVALID_CHARACTER_ERR", "The token must not contain space characters.");
        return o.call(t, e);
      },
          l = function l(t) {
        for (var e = r.call(t.getAttribute("class") || ""), n = e ? e.split(/\s+/) : [], i = 0, s = n.length; s > i; i++) {
          this.push(n[i]);
        }

        this._updateClassName = function () {
          t.setAttribute("class", this.toString());
        };
      },
          u = l[n] = [],
          h = function h() {
        return new l(this);
      };

      if (c[n] = Error[n], u.item = function (t) {
        return this[t] || null;
      }, u.contains = function (t) {
        return ~a(this, t + "");
      }, u.add = function () {
        var t,
            e = arguments,
            n = 0,
            i = e.length,
            s = !1;

        do {
          t = e[n] + "", ~a(this, t) || (this.push(t), s = !0);
        } while (++n < i);

        s && this._updateClassName();
      }, u.remove = function () {
        var t,
            e,
            n = arguments,
            i = 0,
            s = n.length,
            r = !1;

        do {
          for (t = n[i] + "", e = a(this, t); ~e;) {
            this.splice(e, 1), r = !0, e = a(this, t);
          }
        } while (++i < s);

        r && this._updateClassName();
      }, u.toggle = function (t, e) {
        var n = this.contains(t),
            i = n ? e !== !0 && "remove" : e !== !1 && "add";
        return i && this[i](t), e === !0 || e === !1 ? e : !n;
      }, u.replace = function (t, e) {
        var n = a(t + "");
        ~n && (this.splice(n, 1, e), this._updateClassName());
      }, u.toString = function () {
        return this.join(" ");
      }, s.defineProperty) {
        var f = {
          get: h,
          enumerable: !0,
          configurable: !0
        };

        try {
          s.defineProperty(i, e, f);
        } catch (p) {
          void 0 !== p.number && -2146823252 !== p.number || (f.enumerable = !1, s.defineProperty(i, e, f));
        }
      } else s[n].__defineGetter__ && i.__defineGetter__(e, h);
    }
  }(self), function () {

    var t = document.createElement("_");

    if (t.classList.add("c1", "c2"), !t.classList.contains("c2")) {
      var e = function e(t) {
        var e = DOMTokenList.prototype[t];

        DOMTokenList.prototype[t] = function (t) {
          var n,
              i = arguments.length;

          for (n = 0; i > n; n++) {
            t = arguments[n], e.call(this, t);
          }
        };
      };

      e("add"), e("remove");
    }

    if (t.classList.toggle("c3", !1), t.classList.contains("c3")) {
      var n = DOMTokenList.prototype.toggle;

      DOMTokenList.prototype.toggle = function (t, e) {
        return 1 in arguments && !this.contains(t) == !e ? e : n.call(this, t);
      };
    }

    "replace" in document.createElement("_").classList || (DOMTokenList.prototype.replace = function (t, e) {
      var n = this.toString().split(" "),
          i = n.indexOf(t + "");
      ~i && (n = n.slice(i), this.remove.apply(this, n), this.add(e), this.add.apply(this, n.slice(1)));
    }), t = null;
  }());

  var defaults = {
    DEFAULTS: {
      initOnClick: false,
      pluginsEnabled: null
    },
    MODULES: {},
    PLUGINS: {},
    VERSION: '4.0.8',
    INSTANCES: [],
    OPTS_MAPPING: {},
    SHARED: {},
    ID: 0
  };

  function FroalaEditor(selector, options, initCallback) {
    if (typeof selector === 'string') {
      var els = document.querySelectorAll(selector);

      if (options && options.iframe_document) {
        els = options.iframe_document.querySelectorAll(selector);
      }

      var inst = [];

      for (var i = 0; i < els.length; i++) {
        var existing_instance = els[i]['data-froala.editor'];

        if (existing_instance) {
          console.warn('Froala Editor instance already exists.');
          inst.push(existing_instance);
        } else {
          inst.push(new FroalaEditor.Bootstrap(els[i], options, initCallback));
        }
      } // Only one element.


      if (inst.length == 1) {
        return inst[0];
      }

      return inst;
    }

    return new FroalaEditor.Bootstrap(selector, options, initCallback);
  }

  FroalaEditor.RegisterPlugins = function (plgList) {
    for (var i = 0; i < plgList.length; i++) {
      plgList[i].call(FroalaEditor);
    }
  };

  Object.assign(FroalaEditor, defaults);

  FroalaEditor.MODULES.node = function (editor) {
    var $ = editor.$;

    function getContents(node) {
      if (!node || node.tagName === 'IFRAME') {
        return [];
      }

      return Array.prototype.slice.call(node.childNodes || []);
    }
    /**
     * Determine if the node is a block tag.
     */


    function isBlock(node) {
      if (!node) {
        return false;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
      }

      return FroalaEditor.BLOCK_TAGS.indexOf(node.tagName.toLowerCase()) >= 0;
    }
    /**
     * Determine if the node is a link tag.
     */


    function isLink(node) {
      if (!node) {
        return false;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
      }

      return node.tagName.toLowerCase() === 'a';
    }
    /**
     * Check if a DOM element is empty.
     */


    function isEmpty(el, ignore_markers) {
      if (!el) {
        return true;
      }

      if (el.querySelector('table')) {
        return false;
      } // Get element contents.


      var contents = getContents(el); // Check if there is a block tag.

      if (contents.length === 1 && isBlock(contents[0])) {
        contents = getContents(contents[0]);
      }

      var has_br = false;

      for (var i = 0; i < contents.length; i++) {
        var node = contents[i];

        if (ignore_markers && editor.node.hasClass(node, 'fr-marker')) {
          continue;
        }

        if (node.nodeType === Node.TEXT_NODE && node.textContent.length === 0) {
          continue;
        }

        if (node.tagName !== 'BR' && (node.textContent || '').replace(/\u200B/gi, '').replace(/\n/g, '').length > 0) {
          return false;
        }

        if (has_br) {
          return false;
        } else if (node.tagName === 'BR') {
          has_br = true;
        }
      } // Look for void nodes.


      if (el.querySelectorAll(FroalaEditor.VOID_ELEMENTS.join(',')).length - el.querySelectorAll('br').length) {
        return false;
      } // Look for empty allowed tags.


      if (el.querySelector("".concat(editor.opts.htmlAllowedEmptyTags.join(':not(.fr-marker),'), ":not(.fr-marker)"))) {
        return false;
      } // Look for block tags.


      if (el.querySelectorAll(FroalaEditor.BLOCK_TAGS.join(',')).length > 1) {
        return false;
      } // Look for do not wrap tags.


      if (el.querySelector("".concat(editor.opts.htmlDoNotWrapTags.join(':not(.fr-marker),'), ":not(.fr-marker)"))) {
        return false;
      }

      return true;
    }
    /**
     * Get the block parent.
     */


    function blockParent(node) {
      while (node && node.parentNode !== editor.el && !(node.parentNode && editor.node.hasClass(node.parentNode, 'fr-inner'))) {
        node = node.parentNode;

        if (isBlock(node)) {
          return node;
        }
      }

      return null;
    }
    /**
     * Get deepest parent till the element.
     */


    function deepestParent(node, until, simple_enter) {
      if (typeof until === 'undefined') {
        until = [];
      }

      if (typeof simple_enter === 'undefined') {
        simple_enter = true;
      }

      until.push(editor.el);

      if (until.indexOf(node.parentNode) >= 0 || node.parentNode && editor.node.hasClass(node.parentNode, 'fr-inner') || node.parentNode && FroalaEditor.SIMPLE_ENTER_TAGS.indexOf(node.parentNode.tagName) >= 0 && simple_enter) {
        return null;
      } // 1. Before until.
      // 2. Parent node doesn't has class fr-inner.
      // 3. Parent node is not a simple enter tag or quote.
      // 4. Parent node is not a block tag


      while (until.indexOf(node.parentNode) < 0 && node.parentNode && !editor.node.hasClass(node.parentNode, 'fr-inner') && (FroalaEditor.SIMPLE_ENTER_TAGS.indexOf(node.parentNode.tagName) < 0 || !simple_enter) && !(isBlock(node) && !isBlock(node.parentNode)) && (!(isBlock(node) && isBlock(node.parentNode)) || !simple_enter)) {
        node = node.parentNode;
      }

      return node;
    }

    function rawAttributes(node) {
      var attrs = {};
      var atts = node.attributes;

      if (atts) {
        for (var i = 0; i < atts.length; i++) {
          var att = atts[i];
          attrs[att.nodeName] = att.value;
        }
      }

      return attrs;
    }
    /**
     * Get attributes for a node as a string.
     */


    function attributes(node) {
      var str = '';
      var atts = rawAttributes(node);
      var keys = Object.keys(atts).sort();

      for (var i = 0; i < keys.length; i++) {
        var nodeName = keys[i];
        var value = atts[nodeName]; // Double quote + no single quote. (")

        if (value.indexOf('\'') < 0 && value.indexOf('"') >= 0) {
          str += " ".concat(nodeName, "='").concat(value, "'");
        } // Double quote + single quote. ("')
        else if (value.indexOf('"') >= 0 && value.indexOf('\'') >= 0) {
          value = value.replace(/"/g, '&quot;');
          str += " ".concat(nodeName, "=\"").concat(value, "\"");
        } // Single quote or no quote at all.
        else {
          str += " ".concat(nodeName, "=\"").concat(value, "\"");
        }
      }

      return str;
    }

    function clearAttributes(node) {
      var atts = node.attributes;

      for (var i = atts.length - 1; i >= 0; i--) {
        var att = atts[i];
        node.removeAttribute(att.nodeName);
      }
    }
    /**
     * Open string for a node.
     */


    function openTagString(node) {
      return "<".concat(node.tagName.toLowerCase()).concat(attributes(node), ">");
    }
    /**
     * Close string for a node.
     */


    function closeTagString(node) {
      return "</".concat(node.tagName.toLowerCase(), ">");
    }
    /**
     * Determine if the node has any left sibling.
     */


    function isFirstSibling(node, ignore_markers) {
      if (typeof ignore_markers === 'undefined') {
        ignore_markers = true;
      }

      var sibling = node.previousSibling;

      while (sibling && ignore_markers && editor.node.hasClass(sibling, 'fr-marker')) {
        sibling = sibling.previousSibling;
      }

      if (!sibling) {
        return true;
      }

      if (sibling.nodeType === Node.TEXT_NODE && sibling.textContent === '') {
        return isFirstSibling(sibling);
      }

      return false;
    }
    /**
     * Determine if the node has any right sibling.
     */


    function isLastSibling(node, ignore_markers) {
      if (typeof ignore_markers === 'undefined') {
        ignore_markers = true;
      }

      var sibling = node.nextSibling;

      while (sibling && ignore_markers && editor.node.hasClass(sibling, 'fr-marker')) {
        sibling = sibling.nextSibling;
      }

      if (!sibling) {
        return true;
      }

      if (sibling.nodeType === Node.TEXT_NODE && sibling.textContent === '') {
        return isLastSibling(sibling);
      }

      return false;
    }

    function isVoid(node) {
      return node && node.nodeType === Node.ELEMENT_NODE && FroalaEditor.VOID_ELEMENTS.indexOf((node.tagName || '').toLowerCase()) >= 0;
    }
    /**
     * Check if the node is a list.
     */


    function isList(node) {
      if (!node) {
        return false;
      }

      return ['UL', 'OL'].indexOf(node.tagName) >= 0;
    }
    /**
     * Check if the node is the editable element.
     */


    function isElement(node) {
      return node === editor.el;
    }
    /**
     * Check if the node is the editable element.
     */


    function isDeletable(node) {
      return node && node.nodeType === Node.ELEMENT_NODE && node.getAttribute('class') && (node.getAttribute('class') || '').indexOf('fr-deletable') >= 0;
    }
    /**
     * Check if the node has focus.
     */


    function hasFocus(node) {
      return node === editor.doc.activeElement && (!editor.doc.hasFocus || editor.doc.hasFocus()) && Boolean(isElement(node) || node.type || node.href || ~node.tabIndex);
    }

    function isEditable(node) {
      return (!node.getAttribute || node.getAttribute('contenteditable') !== 'false') && ['STYLE', 'SCRIPT'].indexOf(node.tagName) < 0;
    }

    function hasClass(el, cls) {
      if (el instanceof $) {
        el = el.get(0);
      }

      return el && el.classList && el.classList.contains(cls);
    }

    function filter(callback) {
      if (editor.browser.msie) {
        return callback;
      }

      return {
        acceptNode: callback
      };
    }

    return {
      isBlock: isBlock,
      isEmpty: isEmpty,
      blockParent: blockParent,
      deepestParent: deepestParent,
      rawAttributes: rawAttributes,
      attributes: attributes,
      clearAttributes: clearAttributes,
      openTagString: openTagString,
      closeTagString: closeTagString,
      isFirstSibling: isFirstSibling,
      isLastSibling: isLastSibling,
      isList: isList,
      isLink: isLink,
      isElement: isElement,
      contents: getContents,
      isVoid: isVoid,
      hasFocus: hasFocus,
      isEditable: isEditable,
      isDeletable: isDeletable,
      hasClass: hasClass,
      filter: filter
    };
  };

  Object.assign(FroalaEditor.DEFAULTS, {
    DOMPurify: window.DOMPurify,
    // Tags that describe head from HEAD http://www.w3schools.com/html/html_head.asp.
    htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'],
    htmlRemoveTags: ['script', 'style'],
    htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'allowfullscreen', 'allowtransparency', 'alt', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'frameborder', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'mozallowfullscreen', 'multiple', 'muted', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'webkitallowfullscreen', 'width', 'wrap'],
    htmlAllowedStyleProps: ['.*'],
    htmlAllowComments: true,
    htmlUntouched: false,
    fullPage: false // Will also turn iframe on.

  });
  FroalaEditor.HTML5Map = {
    B: 'STRONG',
    I: 'EM',
    STRIKE: 'S'
  };

  FroalaEditor.MODULES.clean = function (editor) {
    var $ = editor.$;
    var allowedTagsRE;
    var removeTagsRE;
    var allowedAttrsRE;
    var allowedStylePropsRE;

    function _removeInvisible(node) {
      if (node.nodeType === Node.ELEMENT_NODE && node.getAttribute('class') && node.getAttribute('class').indexOf('fr-marker') >= 0) {
        return false;
      } // Get node contents.


      var contents = editor.node.contents(node);
      var markers = [];
      var i; // Loop through contents.

      for (i = 0; i < contents.length; i++) {
        // If node is not void.
        if (contents[i].nodeType === Node.ELEMENT_NODE && !editor.node.isVoid(contents[i])) {
          // There are invisible spaces.
          if (contents[i].textContent.replace(/\u200b/g, '').length !== contents[i].textContent.length) {
            // Do remove invisible spaces.
            _removeInvisible(contents[i]);
          }
        } // If node is text node, replace invisible spaces.
        else if (contents[i].nodeType === Node.TEXT_NODE) {
          contents[i].textContent = contents[i].textContent.replace(/\u200b/g, ''); // .replace(/&/g, '&amp;');
        }
      } // Reasess contents after cleaning invisible spaces.


      if (node.nodeType === Node.ELEMENT_NODE && !editor.node.isVoid(node)) {
        node.normalize();
        contents = editor.node.contents(node);
        markers = node.querySelectorAll('.fr-marker'); // All we have left are markers.

        if (contents.length - markers.length === 0) {
          // Make sure contents are all markers.
          for (i = 0; i < contents.length; i++) {
            if (contents[i].nodeType === Node.ELEMENT_NODE && (contents[i].getAttribute('class') || '').indexOf('fr-marker') < 0) {
              return false;
            }
          }

          for (i = 0; i < markers.length; i++) {
            node.parentNode.insertBefore(markers[i].cloneNode(true), node);
          }

          node.parentNode.removeChild(node);
          return false;
        }
      }
    }

    function _toHTML(el, is_pre) {
      if (el.nodeType === Node.COMMENT_NODE) {
        return "<!--".concat(el.nodeValue, "-->");
      }

      if (el.nodeType === Node.TEXT_NODE) {
        if (is_pre) {
          return el.textContent.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }

        return el.textContent.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\u00A0/g, '&nbsp;').replace(/\u0009/g, '');
      }

      if (el.nodeType !== Node.ELEMENT_NODE) {
        return el.outerHTML;
      }

      if (el.nodeType === Node.ELEMENT_NODE && ['STYLE', 'SCRIPT', 'NOSCRIPT'].indexOf(el.tagName) >= 0) {
        return el.outerHTML;
      }

      if (el.nodeType === Node.ELEMENT_NODE && el.tagName === 'svg') {
        var temp = document.createElement('div');
        var node_clone = el.cloneNode(true);
        temp.appendChild(node_clone);
        return temp.innerHTML;
      }

      if (el.tagName === 'IFRAME') {
        return el.outerHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
      }

      var contents = el.childNodes;

      if (contents.length === 0) {
        return el.outerHTML;
      }

      var str = '';

      for (var i = 0; i < contents.length; i++) {
        if (el.tagName === 'PRE') {
          is_pre = true;
        }

        str += _toHTML(contents[i], is_pre);
      }

      return editor.node.openTagString(el) + str + editor.node.closeTagString(el);
    }

    var scripts = [];

    function _encode(dirty_html) {
      // Replace script tag with comments.
      scripts = [];
      dirty_html = dirty_html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, function (str) {
        scripts.push(str);
        return "[FROALA.EDITOR.SCRIPT ".concat(scripts.length - 1, "]");
      });
      dirty_html = dirty_html.replace(/<noscript\b[^<]*(?:(?!<\/noscript>)<[^<]*)*<\/noscript>/gi, function (str) {
        scripts.push(str);
        return "[FROALA.EDITOR.NOSCRIPT ".concat(scripts.length - 1, "]");
      });
      dirty_html = dirty_html.replace(/<meta((?:[\w\W]*?)) http-equiv="/g, '<meta$1 data-fr-http-equiv="');
      dirty_html = dirty_html.replace(/<img((?:[\w\W]*?)) src="/g, '<img$1 data-fr-src="');
      return dirty_html;
    }

    function _decode(dirty_html) {
      // Replace script comments with the original script.
      dirty_html = dirty_html.replace(/\[FROALA\.EDITOR\.SCRIPT ([\d]*)\]/gi, function (str, a1) {
        if (editor.opts.htmlRemoveTags.indexOf('script') >= 0) {
          return '';
        }

        return scripts[parseInt(a1, 10)];
      });
      dirty_html = dirty_html.replace(/\[FROALA\.EDITOR\.NOSCRIPT ([\d]*)\]/gi, function (str, a1) {
        if (editor.opts.htmlRemoveTags.indexOf('noscript') >= 0) {
          return '';
        }

        var nonscriptBlock = scripts[parseInt(a1, 10)].replace(/&lt;/g, '<').replace(/&gt;/g, '>');
        var $nonscriptBlock = $(nonscriptBlock); // Clean the HTML within the noscript block to avoid any XSS threats

        if ($nonscriptBlock && $nonscriptBlock.length) {
          var sanitizedHtml = _process($nonscriptBlock.html(), _run);

          $nonscriptBlock.html(sanitizedHtml);
          nonscriptBlock = $nonscriptBlock.get(0).outerHTML;
        }

        return nonscriptBlock;
      });
      dirty_html = dirty_html.replace(/<img((?:[\w\W]*?)) data-fr-src="/g, '<img$1 src="');
      return dirty_html;
    }
    /*
     * Clean style attribute.
     */


    function _cleanStyle(style) {
      var cleaned_style = style.replace(/;;/gi, ';');
      cleaned_style = cleaned_style.replace(/^;/gi, '');

      if (cleaned_style.charAt(cleaned_style.length) !== ';') {
        cleaned_style += ';';
      }

      return cleaned_style;
    }

    function _cleanAttrs(attrs) {
      var nm;

      for (nm in attrs) {
        if (Object.prototype.hasOwnProperty.call(attrs, nm)) {
          // Check if attr is allowed.
          var is_attr_allowed = nm.match(allowedAttrsRE); // Check for allowed style properties.

          var allowed_style_props_matches = null; // There are allowed style props.

          if (nm === 'style' && editor.opts.htmlAllowedStyleProps.length) {
            allowed_style_props_matches = attrs[nm].match(allowedStylePropsRE);
          } // Attribute is allowed and there are style matches.


          if (is_attr_allowed && allowed_style_props_matches) {
            // Override attr value with only the allowed properties.
            attrs[nm] = _cleanStyle(allowed_style_props_matches.join(';'));
          } else if (!is_attr_allowed || nm === 'style' && !allowed_style_props_matches) {
            delete attrs[nm];
          }
        }
      }

      var str = '';
      var keys = Object.keys(attrs).sort();

      for (var i = 0; i < keys.length; i++) {
        nm = keys[i]; // Make sure we don't break any HTML.

        if (attrs[nm].indexOf('"') < 0) {
          str += " ".concat(nm, "=\"").concat(attrs[nm], "\"");
        } else {
          str += " ".concat(nm, "='").concat(attrs[nm], "'");
        }
      }

      return str;
    }

    function _rebuild(body_html, head_html, original_html) {
      if (editor.opts.fullPage) {
        // Get DOCTYPE.
        var doctype = editor.html.extractDoctype(original_html); // Get HTML attributes.

        var html_attrs = _cleanAttrs(editor.html.extractNodeAttrs(original_html, 'html')); // Get HEAD data.


        head_html = head_html === null ? editor.html.extractNode(original_html, 'head') || '<title></title>' : head_html;

        var head_attrs = _cleanAttrs(editor.html.extractNodeAttrs(original_html, 'head')); // Get BODY attributes.


        var body_attrs = _cleanAttrs(editor.html.extractNodeAttrs(original_html, 'body'));

        return "".concat(doctype, "<html").concat(html_attrs, "><head").concat(head_attrs, ">").concat(head_html, "</head><body").concat(body_attrs, ">").concat(body_html, "</body></html>");
      }

      return body_html;
    }

    function _process(html, func) {
      var i;
      var doc = document.implementation.createHTMLDocument('Froala DOC');
      var el = doc.createElement('DIV');
      $(el).append(html);
      var new_html = '';

      if (el) {
        var els = editor.node.contents(el);

        for (i = 0; i < els.length; i++) {
          func(els[i]);
        }

        els = editor.node.contents(el);

        for (i = 0; i < els.length; i++) {
          new_html += _toHTML(els[i]);
        }
      }

      return new_html;
    }

    function exec(html, func, parse_head) {
      html = _encode(html);
      var b_html = html;
      var h_html = null;

      if (editor.opts.fullPage) {
        // Get BODY data.
        b_html = editor.html.extractNode(html, 'body') || (html.indexOf('<body') >= 0 ? '' : html);

        if (parse_head) {
          h_html = editor.html.extractNode(html, 'head') || '';
        }
      }

      b_html = _process(b_html, func);

      if (h_html) {
        h_html = _process(h_html, func);
      }

      var new_html = _rebuild(b_html, h_html, html);

      return _decode(new_html);
    }

    function invisibleSpaces(dirty_html) {
      if (dirty_html.replace(/\u200b/g, '').length === dirty_html.length) {
        return dirty_html;
      }

      return editor.clean.exec(dirty_html, _removeInvisible);
    }

    function toHTML5() {
      var els = editor.el.querySelectorAll(Object.keys(FroalaEditor.HTML5Map).join(','));

      if (els.length) {
        var sel_saved = false;

        if (!editor.el.querySelector('.fr-marker')) {
          editor.selection.save();
          sel_saved = true;
        }

        for (var i = 0; i < els.length; i++) {
          if (editor.node.attributes(els[i]) === '') {
            $(els[i]).replaceWith("<".concat(FroalaEditor.HTML5Map[els[i].tagName], ">").concat(els[i].innerHTML, "</").concat(FroalaEditor.HTML5Map[els[i].tagName], ">"));
          }
        }

        if (sel_saved) {
          editor.selection.restore();
        }
      }
    } // Fixes paths coming as HTML entities which are later on converted to their coresponding chars.


    function _convertHref(href) {
      var div = editor.doc.createElement('DIV');
      div.innerText = href;
      return div.textContent;
    }

    function _node(node) {
      // Skip when we're dealing with markers.
      if (node.tagName === 'SPAN' && (node.getAttribute('class') || '').indexOf('fr-marker') >= 0) {
        return false;
      }

      if (node.tagName === 'PRE') {
        _cleanPre(node);
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.getAttribute('data-fr-src') && node.getAttribute('data-fr-src').indexOf('blob:') !== 0) {
          node.setAttribute('data-fr-src', editor.helpers.sanitizeURL(_convertHref(node.getAttribute('data-fr-src'))));
        }

        if (node.getAttribute('href')) {
          node.setAttribute('href', editor.helpers.sanitizeURL(_convertHref(node.getAttribute('href'))));
        }

        if (node.getAttribute('src')) {
          node.setAttribute('src', editor.helpers.sanitizeURL(_convertHref(node.getAttribute('src'))));
        } // https://github.com/froala-labs/froala-editor-js-2/issues/3048
        // Check srcdoc attribute for iframe and clean the HTML embedded


        if (node.getAttribute('srcdoc')) {
          node.setAttribute('srcdoc', editor.clean.html(node.getAttribute('srcdoc')));
        }

        if (['TABLE', 'TBODY', 'TFOOT', 'TR'].indexOf(node.tagName) >= 0) {
          node.innerHTML = node.innerHTML.trim();
        }
      } // Remove local images if option they are not allowed.


      if (!editor.opts.pasteAllowLocalImages && node.nodeType === Node.ELEMENT_NODE && node.tagName === 'IMG' && node.getAttribute('data-fr-src') && node.getAttribute('data-fr-src').indexOf('file://') === 0) {
        node.parentNode.removeChild(node);
        return false;
      }

      if (node.nodeType === Node.ELEMENT_NODE && FroalaEditor.HTML5Map[node.tagName] && editor.node.attributes(node) === '') {
        var tg = FroalaEditor.HTML5Map[node.tagName];
        var new_node = "<".concat(tg, ">").concat(node.innerHTML, "</").concat(tg, ">");
        node.insertAdjacentHTML('beforebegin', new_node);
        node = node.previousSibling;
        node.parentNode.removeChild(node.nextSibling);
      }

      if (!editor.opts.htmlAllowComments && node.nodeType === Node.COMMENT_NODE) {
        // Do not remove FROALA.EDITOR comments.
        if (node.data.indexOf('[FROALA.EDITOR') !== 0) {
          node.parentNode.removeChild(node);
        }
      } // Remove completely tags in denied tags.
      else if (node.tagName && node.tagName.match(removeTagsRE)) {
        // https://github.com/froala-labs/froala-editor-js-2/issues/1787
        // adding styles from style tag to inline styles
        if (node.tagName == 'STYLE' && editor.helpers.isMac()) {
          (function () {
            var styleString = node.innerHTML.trim();
            var classValues = [];
            var rxp = /{([^}]+)}/g;
            var curMatch;
            styleString = styleString.replace(/\/\*[\s\S]*?\*\/|([^\\:]|^)\/\/.*|<!--[\s\S]*?-->$/, ''); // eslint-disable-next-line no-cond-assign

            while (curMatch = rxp.exec(styleString)) {
              classValues.push(curMatch[1]);
            }

            var _loop = function _loop(i) {
              var className = styleString.substring(0, styleString.indexOf('{')).trim();

              if (!/^[a-z_-][a-z\d_-]*$/i.test(className) == false) {
                node.parentNode.querySelectorAll(className).forEach(function (item) {
                  item.removeAttribute('class');
                  item.setAttribute('style', classValues[i]);
                });
              }

              styleString = styleString.substring(styleString.indexOf('}') + 1);
            };

            for (var i = 0; styleString.indexOf('{') != -1; i++) {
              _loop(i);
            }
          })();
        }

        node.parentNode.removeChild(node);
      } // Unwrap tags not in allowed tags.
      else if (node.tagName && !node.tagName.match(allowedTagsRE)) {
        // https://github.com/froala/wysiwyg-editor/issues/1711 . If svg is not allowed then remove it because it is a leaf node.
        if (node.tagName === 'svg') {
          node.parentNode.removeChild(node);
        } // Ignore path tag nodes that are inside a svg tag node.
        else if (!(editor.browser.safari && node.tagName === 'path' && node.parentNode && node.parentNode.tagName === 'svg')) {
          node.outerHTML = node.innerHTML;
        }
      } // Check denied attributes.
      else {
        var attrs = node.attributes;

        if (attrs) {
          for (var i = attrs.length - 1; i >= 0; i--) {
            var attr = attrs[i]; // Check if attr is allowed.

            var is_attr_allowed = attr.nodeName.match(allowedAttrsRE); // Check for allowed style properties.

            var allowed_style_props_matches = null; // There are allowed style props.

            if (attr.nodeName === 'style' && editor.opts.htmlAllowedStyleProps.length) {
              allowed_style_props_matches = attr.value.match(allowedStylePropsRE);
            } // Attribute is allowed and there are style matches.


            if (is_attr_allowed && allowed_style_props_matches) {
              // Override attr value with only the allowed properties.
              attr.value = _cleanStyle(allowed_style_props_matches.join(';'));
            } else if (!is_attr_allowed || attr.nodeName === 'style' && !allowed_style_props_matches) {
              node.removeAttribute(attr.nodeName);
            }
          }
        }
      }
    }

    function _run(node) {
      var contents = editor.node.contents(node);

      for (var i = 0; i < contents.length; i++) {
        if (contents[i].nodeType !== Node.TEXT_NODE) {
          _run(contents[i]);
        }
      }

      _node(node);
    }
    /**
     * Clean pre.
     */


    function _cleanPre(pre) {
      var content = pre.innerHTML;

      if (content.indexOf('\n') >= 0) {
        pre.innerHTML = content.replace(/\n/g, '<br>');
      }
    }
    /**
     * Clean the html input.
     */


    function html(dirty_html, denied_tags, denied_attrs, full_page) {
      if (typeof denied_tags === 'undefined') {
        denied_tags = [];
      }

      if (typeof denied_attrs === 'undefined') {
        denied_attrs = [];
      }

      if (typeof full_page === 'undefined') {
        full_page = false;
      } // Empty spaces after BR always collapse.
      // dirty_html = dirty_html.replace(/<br> */g, '<br>');
      // Build the allowed tags array.


      var allowed_tags = $.merge([], editor.opts.htmlAllowedTags);
      var i;

      for (i = 0; i < denied_tags.length; i++) {
        if (allowed_tags.indexOf(denied_tags[i]) >= 0) {
          allowed_tags.splice(allowed_tags.indexOf(denied_tags[i]), 1);
        }
      } // Build the allowed attrs array.


      var allowed_attrs = $.merge([], editor.opts.htmlAllowedAttrs);

      for (i = 0; i < denied_attrs.length; i++) {
        if (allowed_attrs.indexOf(denied_attrs[i]) >= 0) {
          allowed_attrs.splice(allowed_attrs.indexOf(denied_attrs[i]), 1);
        }
      } // We should allow data-fr.


      allowed_attrs.push('data-fr-.*');
      allowed_attrs.push('fr-.*'); // Generate cleaning RegEx.

      allowedTagsRE = new RegExp("^".concat(allowed_tags.join('$|^'), "$"), 'gi');
      allowedAttrsRE = new RegExp("^".concat(allowed_attrs.join('$|^'), "$"), 'gi');
      removeTagsRE = new RegExp("^".concat(editor.opts.htmlRemoveTags.join('$|^'), "$"), 'gi');

      if (editor.opts.htmlAllowedStyleProps.length) {
        allowedStylePropsRE = new RegExp("((^|;|\\s)".concat(editor.opts.htmlAllowedStyleProps.join(':.+?(?=;|$))|((^|;|\\s)'), ":.+?(?=(;)|$))"), 'gi');
      } else {
        allowedStylePropsRE = null;
      }

      dirty_html = exec(dirty_html, _run, true);

      if (typeof editor.opts.DOMPurify !== 'undefined') {
        dirty_html = editor.opts.DOMPurify.sanitize(dirty_html);
      }

      return dirty_html;
    }

    function _tablesWrapTHEAD() {
      var trs = editor.el.querySelectorAll('tr'); // Make sure the TH lives inside thead.

      for (var i = 0; i < trs.length; i++) {
        // Search for th inside tr.
        var children = trs[i].children;
        var ok = true;

        for (var j = 0; j < children.length; j++) {
          if (children[j].tagName !== 'TH') {
            ok = false;
            break;
          }
        } // If there is something else than TH.


        if (ok === false || children.length === 0) {
          continue;
        }

        var tr = trs[i];

        while (tr && tr.tagName !== 'TABLE' && tr.tagName !== 'THEAD') {
          tr = tr.parentNode;
        }

        var thead = tr;

        if (thead.tagName !== 'THEAD') {
          thead = editor.doc.createElement('THEAD');
          tr.insertBefore(thead, tr.firstChild);
        }

        thead.appendChild(trs[i]);
      }
    }
    /**
     * Clean tables.
     */


    function tables() {
      _tablesWrapTHEAD();
    }

    function _listsWrapMissplacedLI() {
      // Find missplaced list items.
      var lis = [];

      function filterListItem(li) {
        return !editor.node.isList(li.parentNode);
      }

      do {
        if (lis.length) {
          var li = lis[0];
          var ul = editor.doc.createElement('ul');
          li.parentNode.insertBefore(ul, li);

          do {
            var tmp = li;
            li = li.nextSibling;
            ul.appendChild(tmp);
          } while (li && li.tagName === 'LI');
        }

        lis = [];
        var li_sel = editor.el.querySelectorAll('li');

        for (var i = 0; i < li_sel.length; i++) {
          if (filterListItem(li_sel[i])) {
            lis.push(li_sel[i]);
          }
        }
      } while (lis.length > 0);
    }

    function _listsJoinSiblings() {
      // Join lists.
      var sibling_lists = editor.el.querySelectorAll('ol + ol, ul + ul');

      for (var k = 0; k < sibling_lists.length; k++) {
        var list = sibling_lists[k];

        if (editor.node.isList(list.previousSibling) && editor.node.openTagString(list) === editor.node.openTagString(list.previousSibling)) {
          var childs = editor.node.contents(list);

          for (var i = 0; i < childs.length; i++) {
            list.previousSibling.appendChild(childs[i]);
          }

          list.parentNode.removeChild(list);
        }
      }
    }

    function _listsRemoveEmpty() {
      var i; // Remove empty lists.

      var do_remove;

      function removeEmptyList(lst) {
        if (!lst.querySelector('LI')) {
          do_remove = true;
          lst.parentNode.removeChild(lst);
        }
      }

      do {
        do_remove = false; // Remove empty li.

        var empty_lis = editor.el.querySelectorAll('li:empty');

        for (i = 0; i < empty_lis.length; i++) {
          empty_lis[i].parentNode.removeChild(empty_lis[i]);
        } // Remove empty ul and ol.


        var remaining_lists = editor.el.querySelectorAll('ul, ol');

        for (i = 0; i < remaining_lists.length; i++) {
          removeEmptyList(remaining_lists[i]);
        }
      } while (do_remove === true);
    }

    function _listsWrapLists() {
      // Do not allow list directly inside another list.
      var direct_lists = editor.el.querySelectorAll('ul > ul, ol > ol, ul > ol, ol > ul');

      for (var i = 0; i < direct_lists.length; i++) {
        var list = direct_lists[i];
        var prev_li = list.previousSibling;

        if (prev_li) {
          if (prev_li.tagName === 'LI') {
            prev_li.appendChild(list);
          } else {
            $(list).wrap('<li></li>');
          }
        }
      }
    }

    function _listsNoTagAfterNested() {
      // Check if nested lists don't have HTML after them.
      var nested_lists = editor.el.querySelectorAll('li > ul, li > ol');

      for (var i = 0; i < nested_lists.length; i++) {
        var lst = nested_lists[i];

        if (lst.nextSibling) {
          var node = lst.nextSibling; //If prev sibling and next sibling tag name are same then all children under next sibling are added to the prev sibling

          while (node.childNodes.length > 0) {
            lst.append(node.childNodes[0]);
          }
        }
      }
    }

    function _listsTypeInNested() {
      // Make sure we can type in nested list.
      var nested_lists = editor.el.querySelectorAll('li > ul, li > ol');

      for (var i = 0; i < nested_lists.length; i++) {
        var lst = nested_lists[i]; // List is the first in the LI.

        if (editor.node.isFirstSibling(lst) && lst.parentNode.style.listStyleType != 'none') {
          $(lst).before('<br/>');
        } // Make sure we don't leave BR before list.
        else if (lst.previousSibling && lst.previousSibling.tagName === 'BR') {
          var prev_node = lst.previousSibling.previousSibling; // Skip markers.

          while (prev_node && editor.node.hasClass(prev_node, 'fr-marker')) {
            prev_node = prev_node.previousSibling;
          } // Remove BR only if there is something else than BR.


          if (prev_node && prev_node.tagName !== 'BR') {
            $(lst.previousSibling).remove();
          }
        }
      }
    }

    function _listsRemoveEmptyLI() {
      // Remove empty li.
      var empty_lis = editor.el.querySelectorAll('li:empty');

      for (var i = 0; i < empty_lis.length; i++) {
        $(empty_lis[i]).remove();
      }
    }

    function _listsFindMissplacedText() {
      var lists = editor.el.querySelectorAll('ul, ol');

      for (var i = 0; i < lists.length; i++) {
        var contents = editor.node.contents(lists[i]);
        var $li = null;

        for (var j = contents.length - 1; j >= 0; j--) {
          // https://github.com/froala-labs/froala-editor-js-2/issues/3235
          if (!contents[j].tagName && editor.opts.htmlUntouched) {
            $li = null;
            continue;
          } // https://github.com/froala/wysiwyg-editor/issues/3033


          if (contents[j].tagName !== 'LI' && contents[j].tagName != 'UL' && contents[j].tagName != 'OL') {
            if (!$li) {
              $li = $(editor.doc.createElement('LI'));
              $li.insertBefore(contents[j]);
            }

            $li.prepend(contents[j]);
          } else {
            $li = null;
          }
        }
      }
    }
    /**
     * Clean lists.
     */


    function lists() {
      _listsWrapMissplacedLI();

      _listsJoinSiblings();

      _listsFindMissplacedText();

      _listsRemoveEmpty();

      _listsWrapLists();

      _listsNoTagAfterNested();

      _listsTypeInNested();

      _listsRemoveEmptyLI();
    }
    /**
     * Initialize
     */


    function _init() {
      // If fullPage is on allow head and title.
      if (editor.opts.fullPage) {
        $.merge(editor.opts.htmlAllowedTags, ['head', 'title', 'style', 'link', 'base', 'body', 'html', 'meta']);
      }
    }

    return {
      _init: _init,
      html: html,
      toHTML5: toHTML5,
      tables: tables,
      lists: lists,
      invisibleSpaces: invisibleSpaces,
      exec: exec
    };
  };

  //Screen Size constants

  FroalaEditor.XS = 0;
  FroalaEditor.SM = 1;
  FroalaEditor.MD = 2;
  FroalaEditor.LG = 3;
  var screenSm = 768;
  var screenMd = 992;
  var screenLg = 1200; // Chars to allow.

  var x = "a-z\\u0080-\\u009f\\u00a1-\\uffff0-9-_\\."; // Common regex to avoid double chars.

  FroalaEditor.LinkRegExCommon = "[".concat(x, "]{1,}"); // PORT:something_else.php

  FroalaEditor.LinkRegExEnd = "((:[0-9]{1,5})|)(((\\/|\\?|#)[a-z\\u00a1-\\uffff0-9@?\\|!^=%&amp;\\/~+#-\\'*-_{}]*)|())"; // Common TLD

  FroalaEditor.LinkRegExTLD = "((".concat(FroalaEditor.LinkRegExCommon, ")(\\.(com|net|org|edu|mil|gov|co|biz|info|me|dev)))"); // Starts with HTTP.

  FroalaEditor.LinkRegExHTTP = "((ftp|http|https):\\/\\/".concat(FroalaEditor.LinkRegExCommon, ")"); // Authenticate with HTTP.

  FroalaEditor.LinkRegExAuth = "((ftp|http|https):\\/\\/[\\u0021-\\uffff]{1,}@".concat(FroalaEditor.LinkRegExCommon, ")"); // Starts with WWWW.

  FroalaEditor.LinkRegExWWW = "(www\\.".concat(FroalaEditor.LinkRegExCommon, "\\.[a-z0-9-]{2,24})"); // Join.

  FroalaEditor.LinkRegEx = "(".concat(FroalaEditor.LinkRegExTLD, "|").concat(FroalaEditor.LinkRegExHTTP, "|").concat(FroalaEditor.LinkRegExWWW, "|").concat(FroalaEditor.LinkRegExAuth, ")").concat(FroalaEditor.LinkRegExEnd); // Link protocols.

  FroalaEditor.LinkProtocols = ['mailto', 'tel', 'sms', 'notes', 'data']; // https://davidcel.is/posts/stop-validating-email-addresses-with-regex/

  FroalaEditor.MAIL_REGEX = /.+@.+\..+/i;

  FroalaEditor.MODULES.helpers = function (editor) {
    var $ = editor.$;
    /**
     * Get the IE version.
     */

    function _ieVersion() {
      /* global navigator */
      var rv = -1;
      var ua;
      var re;

      if (navigator.appName === 'Microsoft Internet Explorer') {
        ua = navigator.userAgent;
        re = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})');

        if (re.exec(ua) !== null) {
          rv = parseFloat(RegExp.$1);
        }
      } else if (navigator.appName === 'Netscape') {
        ua = navigator.userAgent;
        re = new RegExp('Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})');

        if (re.exec(ua) !== null) {
          rv = parseFloat(RegExp.$1);
        }
      }

      return rv;
    }
    /**
     * Determine the browser.
     */


    function _browser() {
      var browser = {};

      var ie_version = _ieVersion();

      if (ie_version > 0) {
        browser.msie = true;
      } else {
        var ua = navigator.userAgent.toLowerCase();
        var match = /(edge)[ /]([\w.]+)/.exec(ua) || /(chrome)[ /]([\w.]+)/.exec(ua) || /(webkit)[ /]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ /]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
        var matched = {
          browser: match[1] || '',
          version: match[2] || '0'
        };

        if (match[1]) {
          browser[matched.browser] = true;
        } // Chrome is Webkit, but Webkit is also Safari.


        if (browser.chrome) {
          browser.webkit = true;
        } else if (browser.webkit) {
          browser.safari = true;
        }
      }

      if (browser.msie) {
        browser.version = ie_version;
      }

      return browser;
    }

    function isIOS() {
      return /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && !isWindowsPhone();
    }

    function isAndroid() {
      return /(Android)/g.test(navigator.userAgent) && !isWindowsPhone();
    }

    function isBlackberry() {
      return /(Blackberry)/g.test(navigator.userAgent);
    }

    function isWindowsPhone() {
      return /(Windows Phone)/gi.test(navigator.userAgent);
    }

    function isMobile() {
      return isAndroid() || isIOS() || isBlackberry();
    }

    function requestAnimationFrame() {
      return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
        window.setTimeout(callback, 1000 / 60);
      };
    }

    function getPX(val) {
      return parseInt(val, 10) || 0;
    } //https://github.com/froala-labs/froala-editor-js-2/issues/1878
    //ScreenSize calculation on the fr-box class


    function screenSize(isBox) {
      try {
        var width = 0;
        if (isBox) width = editor.$box.width();else width = editor.$sc.width();

        if (width < screenSm) {
          return FroalaEditor.XS;
        }

        if (width >= screenSm && width < screenMd) {
          return FroalaEditor.SM;
        }

        if (width >= screenMd && width < screenLg) {
          return FroalaEditor.MD;
        }

        if (width >= screenLg) {
          return FroalaEditor.LG;
        }
      } catch (ex) {
        return FroalaEditor.LG;
      }
    }

    function isTouch() {
      return 'ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch;
    }

    function isURL(url) {
      // Check if it starts with http.
      if (!/^(https?:|ftps?:|)\/\//i.test(url)) {
        return false;
      }

      url = String(url).replace(/</g, '%3C').replace(/>/g, '%3E').replace(/"/g, '%22').replace(/ /g, '%20');
      var test_reg = new RegExp("^".concat(FroalaEditor.LinkRegExHTTP).concat(FroalaEditor.LinkRegExEnd, "$"), 'gi');
      return test_reg.test(url);
    }

    function isEmail(url) {
      if (/^(https?:|ftps?:|)\/\//i.test(url)) {
        return false;
      }

      return FroalaEditor.MAIL_REGEX.test(url);
    } // Sanitize URL.


    function sanitizeURL(url) {
      var local_path = /^([A-Za-z]:(\\){1,2}|[A-Za-z]:((\\){1,2}[^\\]+)+)(\\)?$/i;

      if (/^(https?:|ftps?:|)\/\//i.test(url)) {
        return url;
      } else if (local_path.test(url)) {
        return url;
      } else if (new RegExp("^(".concat(FroalaEditor.LinkProtocols.join('|'), "):"), 'i').test(url)) {
        return url;
      }

      url = encodeURIComponent(url).replace(/%23/g, '#').replace(/%2F/g, '/').replace(/%25/g, '%').replace(/mailto%3A/gi, 'mailto:').replace(/file%3A/gi, 'file:').replace(/sms%3A/gi, 'sms:').replace(/tel%3A/gi, 'tel:').replace(/notes%3A/gi, 'notes:').replace(/data%3Aimage/gi, 'data:image').replace(/blob%3A/gi, 'blob:').replace(/%3A(\d)/gi, ':$1').replace(/webkit-fake-url%3A/gi, 'webkit-fake-url:').replace(/%3F/g, '?').replace(/%3D/g, '=').replace(/%26/g, '&').replace(/&amp;/g, '&').replace(/%2C/g, ',').replace(/%3B/g, ';').replace(/%2B/g, '+').replace(/%40/g, '@').replace(/%5B/g, '[').replace(/%5D/g, ']').replace(/%7B/g, '{').replace(/%7D/g, '}');
      return url;
    }

    function isArray(obj) {
      return obj && !Object.prototype.propertyIsEnumerable.call(obj, 'length') && _typeof(obj) === 'object' && typeof obj.length === 'number';
    }
    /*
     * Transform RGB color to hex value.
     */


    function RGBToHex(rgb) {
      function hex(x) {
        return "0".concat(parseInt(x, 10).toString(16)).slice(-2);
      }

      try {
        if (!rgb || rgb === 'transparent') {
          return '';
        }

        if (/^#[0-9A-F]{6}$/i.test(rgb)) {
          return rgb;
        }

        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        return "#".concat(hex(rgb[1])).concat(hex(rgb[2])).concat(hex(rgb[3])).toUpperCase();
      } catch (ex) {
        return null;
      }
    }

    function HEXtoRGB(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? "rgb(".concat(parseInt(result[1], 16), ", ").concat(parseInt(result[2], 16), ", ").concat(parseInt(result[3], 16), ")") : '';
    }
    /*
     * Get block alignment.
     */


    var default_alignment;

    function getAlignment($block) {
      if (!$block.css) {
        $block = $($block);
      }

      var alignment = ($block.css('text-align') || '').replace(/-(.*)-/g, ''); // Detect rtl.

      if (['left', 'right', 'justify', 'center'].indexOf(alignment) < 0) {
        if (!default_alignment) {
          var $div = $("<div dir=\"".concat(editor.opts.direction === 'rtl' ? 'rtl' : 'auto', "\" style=\"text-align: ").concat(editor.$el.css('text-align'), "; position: fixed; left: -3000px;\"><span id=\"s1\">.</span><span id=\"s2\">.</span></div>"));
          $('body').first().append($div);
          var l1 = $div.find('#s1').get(0).getBoundingClientRect().left;
          var l2 = $div.find('#s2').get(0).getBoundingClientRect().left;
          $div.remove();
          default_alignment = l1 < l2 ? 'left' : 'right';
        }

        alignment = default_alignment;
      }

      return alignment;
    }
    /**
     * Check if is mac.
     */


    var is_mac = null;

    function isMac() {
      if (is_mac === null) {
        is_mac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      }

      return is_mac;
    }

    function scrollTop() {
      // Firefox, Chrome, Opera, Safari
      if (editor.o_win.pageYOffset) {
        return editor.o_win.pageYOffset;
      } // Internet Explorer 6 - standards mode


      if (editor.o_doc.documentElement && editor.o_doc.documentElement.scrollTop) {
        return editor.o_doc.documentElement.scrollTop;
      } // Internet Explorer 6, 7 and 8


      if (editor.o_doc.body.scrollTop) {
        return editor.o_doc.body.scrollTop;
      }

      return 0;
    }

    function scrollLeft() {
      // Firefox, Chrome, Opera, Safari
      if (editor.o_win.pageXOffset) {
        return editor.o_win.pageXOffset;
      } // Internet Explorer 6 - standards mode


      if (editor.o_doc.documentElement && editor.o_doc.documentElement.scrollLeft) {
        return editor.o_doc.documentElement.scrollLeft;
      } // Internet Explorer 6, 7 and 8


      if (editor.o_doc.body.scrollLeft) {
        return editor.o_doc.body.scrollLeft;
      }

      return 0;
    } // https://stackoverflow.com/a/7557433/1806855


    function isInViewPort(el) {
      var rect = el.getBoundingClientRect(); // Round for FF.

      rect = {
        top: Math.round(rect.top),
        bottom: Math.round(rect.bottom)
      };
      return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) || // Top is higher than 0 and bottom is smaller than the window height.
      rect.top <= 0 && rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) // Top is smaller than 0 and bottom is higher than window height.
      ;
    }
    /**
     * Tear up.
     */


    function _init() {
      editor.browser = _browser();
    }

    return {
      _init: _init,
      isIOS: isIOS,
      isMac: isMac,
      isAndroid: isAndroid,
      isBlackberry: isBlackberry,
      isWindowsPhone: isWindowsPhone,
      isMobile: isMobile,
      isEmail: isEmail,
      requestAnimationFrame: requestAnimationFrame,
      getPX: getPX,
      screenSize: screenSize,
      isTouch: isTouch,
      sanitizeURL: sanitizeURL,
      isArray: isArray,
      RGBToHex: RGBToHex,
      HEXtoRGB: HEXtoRGB,
      isURL: isURL,
      getAlignment: getAlignment,
      scrollTop: scrollTop,
      scrollLeft: scrollLeft,
      isInViewPort: isInViewPort
    };
  };

  FroalaEditor.MODULES.events = function (editor) {
    var $ = editor.$;
    var _events = {};

    var _do_blur;

    function _assignEvent($el, evs, handler) {
      $on($el, evs, handler);
    }

    function _forPaste() {
      _assignEvent(editor.$el, 'cut copy paste beforepaste', function (e) {
        trigger(e.type, [e]);
      });
    }

    function _forElement() {
      _assignEvent(editor.$el, 'click mouseup mousemove mousedown touchstart touchend dragenter dragover dragleave dragend drop dragstart', function (e) {
        trigger(e.type, [e]);
      });

      on('mousedown', function () {
        for (var i = 0; i < FroalaEditor.INSTANCES.length; i++) {
          if (FroalaEditor.INSTANCES[i] !== editor && FroalaEditor.INSTANCES[i].popups && FroalaEditor.INSTANCES[i].popups.areVisible()) {
            FroalaEditor.INSTANCES[i].$el.find('.fr-marker').remove();
          }
        }
      });
    }

    function _forKeys() {
      // Map events.
      _assignEvent(editor.$el, 'beforeinput keydown keypress keyup input', function (e) {
        trigger(e.type, [e]);
      });
    }

    function _forWindow() {
      _assignEvent(editor.$win, editor._mousedown, function (e) {
        trigger('window.mousedown', [e]);
        enableBlur();
      });

      _assignEvent(editor.$win, editor._mouseup, function (e) {
        trigger('window.mouseup', [e]);
      });

      _assignEvent(editor.$win, 'beforeinput cut copy keydown keyup touchmove touchend', function (e) {
        trigger("window.".concat(e.type), [e]);
      });
    }

    function _forDocument() {
      _assignEvent(editor.$doc, 'dragend drop', function (e) {
        trigger("document.".concat(e.type), [e]);
      });
    }

    function focus(do_focus) {
      var info;

      if (typeof do_focus === 'undefined') {
        do_focus = true;
      }

      if (!editor.$wp) {
        return false;
      } // Focus the editor window.


      if (editor.helpers.isIOS()) {
        editor.$win.get(0).focus();
      } // If there is focus, stop.


      if (editor.core.hasFocus()) {
        return false;
      } // If there is no focus, then force focus.


      if (!editor.core.hasFocus() && do_focus) {
        var st = editor.$win.scrollTop(); // Hack to prevent scrolling IE.

        if (editor.browser.msie && editor.$box) {
          editor.$box.css('position', 'fixed');
        } // hack to prevent scrolling.


        if (editor.browser.msie && editor.$wp) {
          editor.$wp.css('overflow', 'visible');
        }

        if (editor.browser.msie && editor.$sc) editor.$sc.css('position', 'fixed');

        if (!editor.browser.msie) {
          disableBlur();
          editor.el.focus();
          editor.events.trigger('focus');
          enableBlur();
        } // Revert position IE.


        if (editor.browser.msie && editor.$sc) editor.$sc.css('position', ''); // Revert position.

        if (editor.browser.msie && editor.$box) {
          editor.$box.css('position', '');
        } // Revert scroll.


        if (editor.browser.msie && editor.$wp) {
          editor.$wp.css('overflow', 'auto');
        }

        if (st !== editor.$win.scrollTop()) {
          editor.$win.scrollTop(st);
        }

        info = editor.selection.info(editor.el); // If selection is at start, we should make sure we're in the first block tag.

        if (!info.atStart) {
          return false;
        }
      } // Don't go further if we haven't focused or there are markers.


      if (!editor.core.hasFocus() || editor.$el.find('.fr-marker').length > 0) {
        return false;
      }

      info = editor.selection.info(editor.el);

      if (info.atStart && editor.selection.isCollapsed()) {
        if (editor.html.defaultTag() !== null) {
          var marker = editor.markers.insert();

          if (marker && !editor.node.blockParent(marker)) {
            $(marker).remove();
            var element = editor.$el.find(editor.html.blockTagsQuery()).get(0);

            if (element) {
              $(element).prepend(FroalaEditor.MARKERS);
              editor.selection.restore();
            }
          } else if (marker) {
            $(marker).remove();
          }
        }
      }
    }

    var focused = false;

    function _forFocus() {
      _assignEvent(editor.$el, 'focus', function (e) {
        if (blurActive()) {
          focus(false);

          if (focused === false) {
            trigger(e.type, [e]);

            if (editor.helpers.isMobile()) {
              disableBlur();
            }
          }
        }
      });

      _assignEvent(editor.$el, 'blur', function (e) {
        if (blurActive()
        /* && document.activeElement !== this */
        ) {
          if (focused === true) {
            trigger(e.type, [e]);

            if (editor.helpers.isMobile() && editor.opts.toolbarContainer) {
              editor.shared.selected_editor = editor.id;
            }

            enableBlur();
          }
        }
      }); // Prevent blur when clicking contenteditable.


      $on(editor.$el, 'mousedown', '[contenteditable="true"]', function () {
        disableBlur();
        editor.$el.blur();
      });
      on('focus', function () {
        focused = true;
      });
      on('blur', function () {
        focused = false;
      });
    }

    function _forMouse() {
      if (editor.helpers.isMobile()) {
        editor._mousedown = 'touchstart';
        editor._mouseup = 'touchend';
        editor._move = 'touchmove';
        editor._mousemove = 'touchmove';
      } else {
        editor._mousedown = 'mousedown';
        editor._mouseup = 'mouseup';
        editor._move = '';
        editor._mousemove = 'mousemove';
      }
    }

    function _buttonMouseDown(e) {
      var $btn = $(e.currentTarget);

      if (editor.edit.isDisabled() || editor.node.hasClass($btn.get(0), 'fr-disabled')) {
        e.preventDefault();
        return false;
      } // Not click button.


      if (e.type === 'mousedown' && e.which !== 1) {
        return true;
      } // Scroll in list.


      if (!editor.helpers.isMobile()) {
        e.preventDefault();
      }

      if ((editor.helpers.isAndroid() || editor.helpers.isWindowsPhone()) && $btn.parents('.fr-dropdown-menu').length === 0) {
        e.preventDefault();
        e.stopPropagation();
      } // Simulate click.


      $btn.addClass('fr-selected');
      editor.events.trigger('commands.mousedown', [$btn]);
    }

    function _buttonMouseUp(e, handler) {
      var $btn = $(e.currentTarget);

      if (editor.edit.isDisabled() || editor.node.hasClass($btn.get(0), 'fr-disabled')) {
        e.preventDefault();
        return false;
      }

      if (e.type === 'mouseup' && e.which !== 1) {
        return true;
      } // https://github.com/froala-labs/froala-editor-js-2/issues/1877
      // when you click the button and drag to the other button, current target would be different than clicked button


      if (editor.button.getButtons('.fr-selected', true).get(0) == $btn.get(0) && !editor.node.hasClass($btn.get(0), 'fr-selected')) {
        return true;
      }

      if (e.type !== 'touchmove') {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault(); // Simulate click.

        if (!editor.node.hasClass($btn.get(0), 'fr-selected')) {
          editor.button.getButtons('.fr-selected', true).removeClass('fr-selected');
          return false;
        }

        editor.button.getButtons('.fr-selected', true).removeClass('fr-selected');

        if ($btn.data('dragging') || $btn.attr('disabled')) {
          $btn.removeData('dragging');
          return false;
        }

        var timeout = $btn.data('timeout');

        if (timeout) {
          clearTimeout(timeout);
          $btn.removeData('timeout');
        }

        handler.apply(editor, [e]);
      } else if (!$btn.data('timeout')) {
        $btn.data('timeout', setTimeout(function () {
          $btn.data('dragging', true);
        }, 100));
      }
    }

    function enableBlur() {
      _do_blur = true;
    }

    function disableBlur() {
      _do_blur = false;
    }

    function blurActive() {
      return _do_blur;
    }
    /**
     * Bind click on an element.
     */


    function bindClick($element, selector, handler) {
      $on($element, editor._mousedown, selector, function (e) {
        if (!editor.edit.isDisabled()) {
          _buttonMouseDown(e);
        }
      }, true);
      $on($element, "".concat(editor._mouseup, " ").concat(editor._move), selector, function (e) {
        if (!editor.edit.isDisabled()) {
          _buttonMouseUp(e, handler);
        }
      }, true);
      $on($element, 'mousedown click mouseup', selector, function (e) {
        if (!editor.edit.isDisabled()) {
          e.stopPropagation();
        }
      }, true);
      on('window.mouseup', function () {
        if (!editor.edit.isDisabled()) {
          $element.find(selector).removeClass('fr-selected');
          enableBlur();
        }
      });
      $on($element, 'mouseover', selector, function () {
        if ($(this).hasClass('fr-options')) {
          $(this).prev('.fr-btn').addClass('fr-btn-hover');
        }

        if ($(this).next('.fr-btn').hasClass('fr-options')) {
          $(this).next('.fr-btn').addClass('fr-btn-hover');
        }
      });
      $on($element, 'mouseout', selector, function () {
        if ($(this).hasClass('fr-options')) {
          $(this).prev('.fr-btn').removeClass('fr-btn-hover');
        }

        if ($(this).next('.fr-btn').hasClass('fr-options')) {
          $(this).next('.fr-btn').removeClass('fr-btn-hover');
        }
      });
    }
    /**
     * Add event.
     */


    function on(name, callback, first) {
      var names = name.split(' ');

      if (names.length > 1) {
        for (var i = 0; i < names.length; i++) {
          on(names[i], callback, first);
        }

        return true;
      }

      if (typeof first === 'undefined') {
        first = false;
      }

      var callbacks;

      if (name.indexOf('shared.') !== 0) {
        _events[name] = _events[name] || [];
        callbacks = _events[name];
      } else {
        editor.shared._events[name] = editor.shared._events[name] || [];
        callbacks = editor.shared._events[name];
      }

      if (first) {
        callbacks.unshift(callback);
      } else {
        callbacks.push(callback);
      }
    }

    var $_events = [];

    function $on($el, evs, selector, callback, shared) {
      if (typeof selector === 'function') {
        shared = callback;
        callback = selector;
        selector = false;
      }

      var ary = !shared ? $_events : editor.shared.$_events;
      var id = !shared ? editor.id : editor.sid;
      var eventName = "".concat(evs.trim().split(' ').join(".ed".concat(id, " ")), ".ed").concat(id);

      if (!selector) {
        $el.on(eventName, callback);
      } else {
        $el.on(eventName, selector, callback);
      }

      ary.push([$el, eventName]);
    }

    function _$off(evs) {
      for (var i = 0; i < evs.length; i++) {
        evs[i][0].off(evs[i][1]);
      }
    }

    function $off() {
      _$off($_events);

      $_events = [];

      if (editor.shared.count === 0) {
        _$off(editor.shared.$_events);

        editor.shared.$_events = [];
      }
    }
    /**
     * Trigger an event.
     */


    function trigger(name, args, force) {
      if (!editor.edit.isDisabled() || force) {
        var callbacks;

        if (name.indexOf('shared.') !== 0) {
          callbacks = _events[name];
        } else {
          if (editor.shared.count > 0) {
            return false;
          }

          callbacks = editor.shared._events[name];
        }

        var val;

        if (callbacks) {
          for (var i = 0; i < callbacks.length; i++) {
            val = callbacks[i].apply(editor, args);

            if (val === false) {
              return false;
            }
          }
        }

        if (editor.opts.events && editor.opts.events[name]) {
          val = editor.opts.events[name].apply(editor, args);

          if (val === false) {
            return false;
          }
        }

        return val;
      }
    }

    function chainTrigger(name, param, force) {
      if (!editor.edit.isDisabled() || force) {
        var callbacks;

        if (name.indexOf('shared.') !== 0) {
          callbacks = _events[name];
        } else {
          if (editor.shared.count > 0) {
            return false;
          }

          callbacks = editor.shared._events[name];
        }

        var resp;

        if (callbacks) {
          for (var i = 0; i < callbacks.length; i++) {
            // Get the callback response.
            resp = callbacks[i].apply(editor, [param]); // If callback response is defined then assign it to param.

            if (typeof resp !== 'undefined') {
              param = resp;
            }
          }
        }

        if (editor.opts.events && editor.opts.events[name]) {
          resp = editor.opts.events[name].apply(editor, [param]);

          if (typeof resp !== 'undefined') {
            param = resp;
          }
        }

        return param;
      }
    }
    /**
     * Destroy
     */


    function _destroy() {
      // Clear the events list.
      for (var k in _events) {
        if (Object.prototype.hasOwnProperty.call(_events, k)) {
          delete _events[k];
        }
      }
    }

    function _sharedDestroy() {
      for (var k in editor.shared._events) {
        if (Object.prototype.hasOwnProperty.call(editor.shared._events, k)) {
          delete editor.shared._events[k];
        }
      }
    }
    /**
     * Tear up.
     */


    function _init() {
      editor.shared.$_events = editor.shared.$_events || [];
      editor.shared._events = {};

      _forMouse();

      _forElement();

      _forWindow();

      _forDocument();

      _forKeys();

      _forFocus();

      enableBlur();

      _forPaste();

      on('destroy', _destroy);
      on('shared.destroy', _sharedDestroy);
    }

    return {
      _init: _init,
      on: on,
      trigger: trigger,
      bindClick: bindClick,
      disableBlur: disableBlur,
      enableBlur: enableBlur,
      blurActive: blurActive,
      focus: focus,
      chainTrigger: chainTrigger,
      $on: $on,
      $off: $off
    };
  };

  Object.assign(FroalaEditor.DEFAULTS, {
    indentMargin: 20
  });
  FroalaEditor.COMMANDS = {
    bold: {
      title: 'Bold',
      toggle: true,
      refresh: function refresh($btn) {
        var format = this.format.is('strong');
        $btn.toggleClass('fr-active', format).attr('aria-pressed', format);
      }
    },
    italic: {
      title: 'Italic',
      toggle: true,
      refresh: function refresh($btn) {
        var format = this.format.is('em');
        $btn.toggleClass('fr-active', format).attr('aria-pressed', format);
      }
    },
    underline: {
      title: 'Underline',
      toggle: true,
      refresh: function refresh($btn) {
        var format = this.format.is('u');
        $btn.toggleClass('fr-active', format).attr('aria-pressed', format);
      }
    },
    strikeThrough: {
      title: 'Strikethrough',
      toggle: true,
      refresh: function refresh($btn) {
        var format = this.format.is('s');
        $btn.toggleClass('fr-active', format).attr('aria-pressed', format);
      }
    },
    subscript: {
      title: 'Subscript',
      toggle: true,
      refresh: function refresh($btn) {
        var format = this.format.is('sub');
        $btn.toggleClass('fr-active', format).attr('aria-pressed', format);
      }
    },
    superscript: {
      title: 'Superscript',
      toggle: true,
      refresh: function refresh($btn) {
        var format = this.format.is('sup');
        $btn.toggleClass('fr-active', format).attr('aria-pressed', format);
      }
    },
    outdent: {
      title: 'Decrease Indent'
    },
    indent: {
      title: 'Increase Indent'
    },
    undo: {
      title: 'Undo',
      undo: false,
      forcedRefresh: true,
      disabled: true
    },
    redo: {
      title: 'Redo',
      undo: false,
      forcedRefresh: true,
      disabled: true
    },
    insertHR: {
      title: 'Insert Horizontal Line'
    },
    clearFormatting: {
      title: 'Clear Formatting'
    },
    selectAll: {
      title: 'Select All',
      undo: false
    },
    moreText: {
      title: 'More Text',
      undo: false
    },
    moreParagraph: {
      title: 'More Paragraph',
      undo: false
    },
    moreRich: {
      title: 'More Rich',
      undo: false
    },
    moreMisc: {
      title: 'More Misc',
      undo: false
    }
  };

  FroalaEditor.RegisterCommand = function (name, info) {
    FroalaEditor.COMMANDS[name] = info;
  };

  FroalaEditor.MODULES.commands = function (editor) {
    var $ = editor.$;

    function _createDefaultTag(empty) {
      if (editor.html.defaultTag()) {
        empty = "<".concat(editor.html.defaultTag(), ">").concat(empty, "</").concat(editor.html.defaultTag(), ">");
      }

      return empty;
    }

    var mapping = {
      bold: function bold() {
        _execCommand('bold', 'strong');
      },
      subscript: function subscript() {
        // Remove sup.
        if (editor.format.is('sup')) {
          editor.format.remove('sup');
        }

        _execCommand('subscript', 'sub');
      },
      superscript: function superscript() {
        // Remove sub.
        if (editor.format.is('sub')) {
          editor.format.remove('sub');
        }

        _execCommand('superscript', 'sup');
      },
      italic: function italic() {
        _execCommand('italic', 'em');
      },
      strikeThrough: function strikeThrough() {
        _execCommand('strikeThrough', 's');
      },
      underline: function underline() {
        _execCommand('underline', 'u');
      },
      undo: function undo() {
        editor.undo.run();
      },
      redo: function redo() {
        editor.undo.redo();
      },
      indent: function indent() {
        _processIndent(1);
      },
      outdent: function outdent() {
        _processIndent(-1);
      },
      show: function show() {
        if (editor.opts.toolbarInline) {
          editor.toolbar.showInline(null, true);
        }
      },
      insertHR: function insertHR() {
        editor.selection.remove();
        var empty = '';

        if (editor.core.isEmpty()) {
          empty = '<br>';
          empty = _createDefaultTag(empty);
        }

        var hrCode = "<hr id=\"fr-just\" class=\"fr-just\">".concat(empty);

        if (editor.opts.trackChangesEnabled) {
          var changeHTML = editor.track_changes.wrapInTracking($(hrCode), 'hrWrapper');
          hrCode = changeHTML.get(0).outerHTML;
        }

        editor.html.insert(hrCode);
        var $hr = editor.$el.find('hr#fr-just').length ? editor.$el.find('hr#fr-just') : editor.$el.find('.fr-just');
        $hr.removeAttr('id');
        $hr.removeAttr('class');
        var check;
        var trackHRflag = editor.opts.trackChangesEnabled && $hr[0].parentNode.tagName === 'SPAN' && $hr[0].parentNode.parentNode.tagName === 'P'; // Make sure we can type after HR.

        if ($hr.next().length === 0) {
          var default_tag = editor.html.defaultTag();

          if (default_tag && !trackHRflag) {
            $hr.after($(editor.doc.createElement(default_tag)).append('<br>').get(0));
          } else if (!trackHRflag) {
            $hr.after('<br>');
          } else {
            $hr[0].parentNode.after($(editor.doc.createElement(default_tag)).append('<br>').get(0));
          }
        }

        if ($hr.prev().is('hr')) {
          check = editor.selection.setAfter($hr.get(0), false);
        } else if ($hr.next().is('hr')) {
          check = editor.selection.setBefore($hr.get(0), false);
        } else {
          if (!trackHRflag && !editor.selection.setAfter($hr.get(0), false)) {
            editor.selection.setBefore($hr.get(0), false);
          } else {
            editor.selection.setAfter($hr[0].parentNode, false);
          }
        } // Added fix for this issue https://github.com/froala-labs/froala-editor-js-2/issues/384


        if (!check && typeof check !== 'undefined') {
          empty = "".concat(FroalaEditor.MARKERS, "<br>");
          empty = _createDefaultTag(empty);
          $hr.after(empty);
        }

        editor.selection.restore();
      },
      clearFormatting: function clearFormatting() {
        editor.format.remove();
      },
      selectAll: function selectAll() {
        editor.doc.execCommand('selectAll', false, false);
      },
      moreText: function moreText(cmd) {
        _moreExec(cmd);
      },
      moreParagraph: function moreParagraph(cmd) {
        _moreExec(cmd);
      },
      moreRich: function moreRich(cmd) {
        _moreExec(cmd);
      },
      moreMisc: function moreMisc(cmd) {
        _moreExec(cmd);
      },
      moreTrackChanges: function moreTrackChanges() {
        _moreExec('trackChanges');
      }
    };
    /**
     * Executes more button commands
     */

    function _moreExec(cmd) {
      var $btn = editor.$tb.find("[data-cmd=".concat(cmd, "]"));
      var $btnCodeView = editor.$tb.find('[data-cmd=html]');

      if (editor.opts.trackChangesEnabled) {
        $btnCodeView && $btnCodeView.addClass('fr-disabled');
      } else {
        $btnCodeView && $btnCodeView.removeClass('fr-disabled');
      } // Toggle more button in the toolbar


      _toggleMoreButton($btn); // Set the height of all more toolbars


      editor.toolbar.setMoreToolbarsHeight();
    }
    /**
     * Display/Hide the toolbar buttons on clicking the more button
     */


    function _toggleMoreButton($btn) {
      if (editor.helpers.isMobile() && editor.opts.toolbarInline) {
        editor.events.disableBlur();
      } // Get the corresponding button group for that more button


      var $buttonGroup = editor.$tb.find(".fr-more-toolbar[data-name=\"".concat($btn.attr('data-group-name'), "\"]"));

      if ($btn.data('cmd') === 'trackChanges') {
        // https://github.com/froala-labs/froala-editor-js-2/issues/3980
        // if toolbarcontainer is set, then only 1 instance of toolbar is there
        $buttonGroup = editor.$tb.find(".fr-more-toolbar[data-name=\"".concat($btn.attr('id'), "\"]"));
      } // Hide all button groups before opening any one


      editor.$tb.find('.fr-open').not($btn).not('[data-cmd="trackChanges"]').removeClass('fr-open');
      $btn.toggleClass('fr-open'); // Make sure we hide height properly.

      editor.$tb.find('.fr-more-toolbar').removeClass('fr-overflow-visible'); // We already have a more toolbar expanded.

      if (editor.$tb.find('.fr-expanded').not($buttonGroup).length) {
        // Toggle existing toolbar.
        var prevElem = editor.$tb.find('.fr-expanded').not($buttonGroup);
        prevElem.each(function (index, element) {
          if ($(element).data('name').indexOf('trackChanges-') != 0 && $(element).data('name').indexOf('moreRich-') != 0) {
            $(element).toggleClass('fr-expanded');
          } else {
            if (!$btn.parents('[data-name^="moreRich-"]').length) {
              if ($(element).data('name').indexOf('trackChanges-') != 0 && (!$(element).find('[id^="trackChanges-"]').length || !editor.opts.trackChangesEnabled)) $(element).toggleClass('fr-expanded');
            }
          }
        }); // Open the new toolbar.

        $buttonGroup.toggleClass('fr-expanded');
      } else {
        // Open toolbar.
        $buttonGroup.toggleClass('fr-expanded');
        editor.$box.toggleClass('fr-toolbar-open');
        editor.$tb.toggleClass('fr-toolbar-open');
      }
    }
    /**
     * Exec command.
     */


    function exec(cmd, params) {
      // if markdown enabled then disable bold/italic/underline shortcuts
      if (editor.markdown && editor.markdown.isEnabled() && (cmd === 'bold' || cmd === 'italic' || cmd === 'underline') || editor.opts.trackChangesEnabled && cmd === 'markdown') {
        return;
      } // Trigger before command to see if to execute the default callback.


      if (editor.events.trigger('commands.before', $.merge([cmd], params || [])) !== false) {
        // Get the callback.
        var callback = FroalaEditor.COMMANDS[cmd] && FroalaEditor.COMMANDS[cmd].callback || mapping[cmd];
        var focus = true;
        var accessibilityFocus = false;

        if (FroalaEditor.COMMANDS[cmd]) {
          if (typeof FroalaEditor.COMMANDS[cmd].focus !== 'undefined') {
            focus = FroalaEditor.COMMANDS[cmd].focus;
          }

          if (typeof FroalaEditor.COMMANDS[cmd].accessibilityFocus !== 'undefined') {
            accessibilityFocus = FroalaEditor.COMMANDS[cmd].accessibilityFocus;
          }
        } // Make sure we have focus.


        if (!editor.core.hasFocus() && focus || !editor.core.hasFocus() && accessibilityFocus && editor.accessibility.hasFocus()) {
          // Focus in the editor at any position.

          // when aligning image, only focus ir popovers are hidden
          // fix https://github.com/SweetProcess/sweetprocess.com/issues/7942#issuecomment-1040419805
          var doNotScrollCommands = ['imageAlign', 'textColor', 'backgroundColor', 'applytextColor', 'applybackgroundColor', 'imageDisplay']
          if (doNotScrollCommands.indexOf(cmd) === -1 || !editor.popups.areVisible()) {
            editor.el.focus();
            editor.events.trigger('focus');
          }
        } // Callback.
        // Save undo step.


        if (FroalaEditor.COMMANDS[cmd] && FroalaEditor.COMMANDS[cmd].undo !== false) {
          if (editor.$el.find('.fr-marker').length) {
            editor.events.disableBlur();
            editor.selection.restore();
          }

          editor.undo.saveStep();
        }

        if (callback) {
          callback.apply(editor, $.merge([cmd], params || []));
        } // Trigger after command.


        editor.events.trigger('commands.after', $.merge([cmd], params || [])); // Save undo step again.

        if (FroalaEditor.COMMANDS[cmd] && FroalaEditor.COMMANDS[cmd].undo !== false) {
          editor.undo.saveStep();
        }
      }
    }
    /**
     * Exex default.
     */


    function _execCommand(cmd, tag) {
      editor.format.toggle(tag);
    }

    function _processIndent(indent) {
      editor.selection.save();
      editor.html.wrap(true, true, true, true);
      editor.selection.restore();
      var blocks = editor.selection.blocks();

      for (var i = 0; i < blocks.length; i++) {
        if (blocks[i].tagName !== 'LI' || blocks[i].parentNode.tagName !== 'LI') {
          var $block = $(blocks[i]);

          if (blocks[i].tagName != 'LI' && blocks[i].parentNode.tagName == 'LI') {
            $block = $(blocks[i].parentNode);
          }

          var prop = editor.opts.direction === 'rtl' || $block.css('direction') === 'rtl' ? 'margin-right' : 'margin-left';
          var margin_left = editor.helpers.getPX($block.css(prop)); // Do not allow text to go out of the editor view.

          if ($block.width() < 2 * editor.opts.indentMargin && indent > 0) {
            continue;
          } //Do not allow margin for list


          if (blocks[i].parentNode.tagName != 'UL' && blocks[i].parentNode.tagName != 'OL' && blocks[i].parentNode.tagName != 'LI') $block.css(prop, Math.max(margin_left + indent * editor.opts.indentMargin, 0) || '');
          $block.removeClass('fr-temp-div');
        }
      }

      editor.selection.save();
      editor.html.unwrap();
      editor.selection.restore();
    }

    function callExec(k) {
      return function () {
        exec(k);
      };
    }

    var resp = {};

    for (var k in mapping) {
      if (Object.prototype.hasOwnProperty.call(mapping, k)) {
        resp[k] = callExec(k);
      }
    }

    function _init() {
      // Prevent typing in HR.
      editor.events.on('keydown', function (e) {
        var el = editor.selection.element();

        if (el && el.tagName === 'HR' && !editor.keys.isArrow(e.which)) {
          e.preventDefault();
          return false;
        }
      });
      editor.events.on('keyup', function (e) {
        var el = editor.selection.element();

        if (el && el.tagName === 'HR') {
          if (e.which === FroalaEditor.KEYCODE.ARROW_LEFT || e.which === FroalaEditor.KEYCODE.ARROW_UP) {
            if (el.previousSibling) {
              if (!editor.node.isBlock(el.previousSibling)) {
                $(el).before(FroalaEditor.MARKERS);
              } else {
                editor.selection.setAtEnd(el.previousSibling);
              }

              editor.selection.restore();
              return false;
            }
          } else if (e.which === FroalaEditor.KEYCODE.ARROW_RIGHT || e.which === FroalaEditor.KEYCODE.ARROW_DOWN) {
            if (el.nextSibling) {
              if (!editor.node.isBlock(el.nextSibling)) {
                $(el).after(FroalaEditor.MARKERS);
              } else {
                editor.selection.setAtStart(el.nextSibling);
              }

              editor.selection.restore();
              return false;
            }
          }
        }
      }); // Do not allow mousedown on HR.

      editor.events.on('mousedown', function (e) {
        if (e.target && e.target.tagName === 'HR') {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }); // If somehow focus gets in HR remove it.

      editor.events.on('mouseup', function () {
        var s_el = editor.selection.element();
        var e_el = editor.selection.endElement();

        if (s_el === e_el && s_el && s_el.tagName === 'HR') {
          if (s_el.nextSibling) {
            if (!editor.node.isBlock(s_el.nextSibling)) {
              $(s_el).after(FroalaEditor.MARKERS);
            } else {
              editor.selection.setAtStart(s_el.nextSibling);
            }
          }

          editor.selection.restore();
        }
      });
    }

    return Object.assign(resp, {
      exec: exec,
      _init: _init
    });
  };

  FroalaEditor.MODULES.cursorLists = function (editor) {
    var $ = editor.$;
    /**
     * Find the first li parent.
     */

    function _firstParentLI(node) {
      var p_node = node;

      while (p_node.tagName !== 'LI') {
        p_node = p_node.parentNode;
      }

      return p_node;
    }
    /**
     * Find the first list parent.
     */


    function _firstParentList(node) {
      var p_node = node;

      while (!editor.node.isList(p_node)) {
        p_node = p_node.parentNode;
      }

      return p_node;
    } // https://github.com/froala-labs/froala-editor-js-2/issues/2844


    function getStyles(atts) {
      var extractedAtts = '';

      for (var i = 0; i < atts.length; i++) {
        var att = atts[i];
        extractedAtts += "".concat(att.name, "='").concat(att.value, "' ");
      }

      return extractedAtts;
    }
    /**
     * Do enter at the beginning of a list item.
     */


    function _startEnter(marker) {
      var li = _firstParentLI(marker); // Get previous and next siblings.


      var next_li = li.nextSibling;
      var prev_li = li.previousSibling;
      var default_tag = editor.html.defaultTag();
      var ul; // We are in a list item at the middle of the list or an list item that is not empty.

      if (editor.node.isEmpty(li, true) && next_li) {
        var o_str = '';
        var c_str = '';
        var p_node = marker.parentNode; // Create open / close string.

        while (!editor.node.isList(p_node) && p_node.parentNode && (p_node.parentNode.tagName !== 'LI' || p_node.parentNode === li)) {
          // https://github.com/froala-labs/froala-editor-js-2/issues/2844
          // _startEnter empty LI create open / close string for list and list item only
          if (['OL', 'LI', 'UL'].indexOf(p_node.tagName) > -1) {
            o_str = editor.node.openTagString(p_node) + o_str;
            c_str += editor.node.closeTagString(p_node);
          }

          p_node = p_node.parentNode;
        }

        o_str = editor.node.openTagString(p_node) + o_str;
        c_str += editor.node.closeTagString(p_node);
        var str = '';

        if (p_node.parentNode && p_node.parentNode.tagName === 'LI') {
          // https://github.com/froala-labs/froala-editor-js-2/issues/2844
          // add p_node.parentNode attributes / styles to new <li>
          if (p_node.parentNode.attributes.length) {
            var allAtts = getStyles(p_node.parentNode.attributes);
            str = "".concat(c_str, "<li ").concat(allAtts, ">").concat(FroalaEditor.MARKERS, "<br>").concat(o_str);
          } else {
            str = "".concat(c_str, "<li>").concat(FroalaEditor.MARKERS, "<br>").concat(o_str);
          }
        } else if (default_tag) {
          str = "".concat(c_str, "<").concat(default_tag, ">").concat(FroalaEditor.MARKERS, "<br></").concat(default_tag, ">").concat(o_str);
        } else {
          str = "".concat(c_str + FroalaEditor.MARKERS, "<br>").concat(o_str);
        }

        while (['UL', 'OL'].indexOf(p_node.tagName) < 0 || p_node.parentNode && p_node.parentNode.tagName === 'LI') {
          p_node = p_node.parentNode;
        }

        $(li).replaceWith('<span id="fr-break"></span>');
        var html = editor.node.openTagString(p_node) + $(p_node).html() + editor.node.closeTagString(p_node);
        html = html.replace(/<span id="fr-break"><\/span>/g, str);
        $(p_node).replaceWith(html);
        editor.$el.find('li:empty').remove(); // https://github.com/froala-labs/froala-editor-js-2/issues/2844
        // check & remove empty <li> having <li><p><span> special case for #pasted lists from google sheet

        if (editor.$el.find('li > p > span:empty').length) {
          editor.$el.find('li > p > span:empty')[0].parentNode.parentNode.remove();
        }
      } else if (prev_li && next_li || !editor.node.isEmpty(li, true)) {
        var br_str = '<br>';
        var nd = marker.parentNode; // https://github.com/froala-labs/froala-editor-js-2/issues/3399

        if (nd && nd.tagName === 'A') {
          nd = null;
        }

        while (nd && nd.tagName !== 'LI') {
          br_str = editor.node.openTagString(nd) + br_str + editor.node.closeTagString(nd);
          nd = nd.parentNode;
        } // https://github.com/froala-labs/froala-editor-js-2/issues/2844
        // add parentNode attributes / styles to new <li>


        if (nd && nd.attributes.length) {
          var _allAtts = getStyles(nd.attributes);

          $(li).before("<li ".concat(_allAtts, ">").concat(br_str, "</li>"));
        } else {
          $(li).before("<li>".concat(br_str, "</li>"));
        }

        $(marker).remove();
      } // There is no previous list item so transform the current list item to an empty line.
      else if (!prev_li) {
        ul = _firstParentList(li); // We are in a nested list so add a new li before it.

        if (ul.parentNode && ul.parentNode.tagName === 'LI') {
          if (next_li) {
            $(ul.parentNode).before("".concat(editor.node.openTagString(li) + FroalaEditor.MARKERS, "<br></li>"));
          } else {
            $(ul.parentNode).after("".concat(editor.node.openTagString(li) + FroalaEditor.MARKERS, "<br></li>"));
          }
        } // We are in a normal list. Add a new line before.
        else if (default_tag) {
          $(ul).before("<".concat(default_tag, ">").concat(FroalaEditor.MARKERS, "<br></").concat(default_tag, ">"));
        } else {
          $(ul).before("".concat(FroalaEditor.MARKERS, "<br>"));
        } // Remove the current li.


        $(li).remove();
      } // There is no next_li item so transform the current list item to an empty line.
      else {
        ul = _firstParentList(li);
        var new_str = "".concat(FroalaEditor.MARKERS, "<br>");
        var ndx = marker.parentNode;

        while (ndx && ndx.tagName !== 'LI') {
          new_str = editor.node.openTagString(ndx) + new_str + editor.node.closeTagString(ndx);
          ndx = ndx.parentNode;
        } // We are in a nested lists so add a new li after it.


        if (ul.parentNode && ul.parentNode.tagName === 'LI') {
          // https://github.com/froala-labs/froala-editor-js-2/issues/2844
          // add parentNode attributes / styles to new <li>
          if (ul.parentNode.attributes.length) {
            var _allAtts2 = getStyles(ul.parentNode.attributes);

            $(ul.parentNode).after("<li ".concat(_allAtts2, ">").concat(new_str, "</li>"));
          } else {
            $(ul.parentNode).after("<li>".concat(new_str, "</li>"));
          }
        } // We are in a normal list. Add a new line after.
        else if (default_tag) {
          $(ul).after("<".concat(default_tag, ">").concat(new_str, "</").concat(default_tag, ">"));
        } else {
          $(ul).after(new_str);
        } // Remove the current li.


        $(li).remove();
      }
    }
    /**
     * Enter at the middle of a list.
     */


    function _middleEnter(marker) {
      var li = _firstParentLI(marker); // Build the closing / opening list item string.


      var str = '';
      var node = marker;
      var o_str = '';
      var c_str = '';
      var add_invisible = false;

      while (node !== li) {
        node = node.parentNode;
        var cls = node.tagName === 'A' && editor.cursor.isAtEnd(marker, node) ? 'fr-to-remove' : '';

        if (!add_invisible && node != li && !editor.node.isBlock(node)) {
          add_invisible = true;
          o_str = o_str + FroalaEditor.INVISIBLE_SPACE;
        }

        o_str = editor.node.openTagString($(node).clone().addClass(cls).get(0)) + o_str; // https://github.com/froala-labs/froala-editor-js-2/issues/1589

        c_str += editor.node.closeTagString(node);
      } // Add markers.


      str = c_str + str + o_str + FroalaEditor.MARKERS + (editor.opts.keepFormatOnDelete ? FroalaEditor.INVISIBLE_SPACE : ''); // Build HTML.

      $(marker).replaceWith('<span id="fr-break"></span>');
      var html = editor.node.openTagString(li) + $(li).html() + editor.node.closeTagString(li);
      html = html.replace(/<span id="fr-break"><\/span>/g, str); // Replace the current list item.

      $(li).replaceWith(html);
    }
    /**
     * Enter at the end of a list item.
     */


    function _endEnter(marker) {
      var li = _firstParentLI(marker);

      var end_str = FroalaEditor.MARKERS;
      var start_str = '';
      var node = marker;
      var add_invisible = false;

      while (node !== li) {
        node = node.parentNode; // https://github.com/froala-labs/froala-editor-js-2/issues/1864
        // For next sibling list item it was adding unnecessary div tag of elder sibling list.

        if (node.classList.contains('fr-img-space-wrap') || node.classList.contains('fr-img-space-wrap2')) {
          continue;
        }

        var cls = node.tagName === 'A' && editor.cursor.isAtEnd(marker, node) ? 'fr-to-remove' : '';

        if (!add_invisible && node !== li && !editor.node.isBlock(node)) {
          add_invisible = true;
          start_str += FroalaEditor.INVISIBLE_SPACE;
        }

        start_str = editor.node.openTagString($(node).clone().addClass(cls).get(0)) + start_str;
        end_str += editor.node.closeTagString(node);
      }

      var str = start_str + end_str;
      $(marker).remove();
      $(li).after(str);
    }
    /**
     * Do backspace on a list item. This method is called only when wer are at the beginning of a LI.
     */


    function _backspace(marker) {
      var li = _firstParentLI(marker); // Get previous sibling.


      var prev_li = li.previousSibling; // There is a previous li.

      if (prev_li) {
        // Get the li inside a nested list or inner block tags.
        prev_li = $(prev_li).find(editor.html.blockTagsQuery()).get(-1) || prev_li; // Add markers.

        $(marker).replaceWith(FroalaEditor.MARKERS); // Remove possible BR at the end of the previous list.

        var contents = editor.node.contents(prev_li);

        if (contents.length && contents[contents.length - 1].tagName === 'BR') {
          $(contents[contents.length - 1]).remove();
        } // Remove any nodes that might be wrapped.


        $(li).find(editor.html.blockTagsQuery()).not('ol, ul, table').each(function () {
          if (this.parentNode === li) {
            $(this).replaceWith($(this).html() + (editor.node.isEmpty(this) ? '' : '<br>'));
          }
        }); // Append the current list item content to the previous one.

        var node = editor.node.contents(li)[0];
        var tmp;

        while (node && !editor.node.isList(node)) {
          tmp = node.nextSibling;
          $(prev_li).append(node);
          node = tmp;
        }

        prev_li = li.previousSibling;

        while (node) {
          tmp = node.nextSibling;
          $(prev_li).append(node);
          node = tmp;
        } // Remove ending BR.


        contents = editor.node.contents(prev_li);

        if (contents.length > 1 && contents[contents.length - 1].tagName === 'BR') {
          $(contents[contents.length - 1]).remove();
        } // Remove the current LI.


        $(li).remove();
      } // No previous li.
      else {
        var ul = _firstParentList(li); // Add markers.


        $(marker).replaceWith(FroalaEditor.MARKERS); // Nested lists.

        if (ul.parentNode && ul.parentNode.tagName === 'LI') {
          var prev_node = ul.previousSibling; // Previous node is block.

          if (editor.node.isBlock(prev_node)) {
            // Remove any nodes that might be wrapped.
            $(li).find(editor.html.blockTagsQuery()).not('ol, ul, table').each(function () {
              if (this.parentNode === li) {
                $(this).replaceWith($(this).html() + (editor.node.isEmpty(this) ? '' : '<br>'));
              }
            });
            $(prev_node).append($(li).html());
          } // Text right in li.
          else {
            $(ul).before($(li).html());
          }
        } // Normal lists. Add an empty li instead.
        else {
          var default_tag = editor.html.defaultTag();

          if (default_tag && $(li).find(editor.html.blockTagsQuery()).length === 0) {
            $(ul).before("<".concat(default_tag, ">").concat($(li).html(), "</").concat(default_tag, ">"));
          } else {
            $(ul).before($(li).html());
          }
        } // Remove the current li.


        $(li).remove();
        editor.html.wrap(); // Remove the ul if it is empty.

        if ($(ul).find('li').length === 0) {
          $(ul).remove();
        }
      }
    }
    /**
     * Delete at the end of list item.
     */


    function _del(marker) {
      var li = _firstParentLI(marker);

      var next_li = li.nextSibling;
      var contents; // There is a next li.

      if (next_li) {
        // Remove possible BR at the beginning of the next LI.
        contents = editor.node.contents(next_li);

        if (contents.length && contents[0].tagName === 'BR') {
          $(contents[0]).remove();
        } // Unwrap content from the next node.


        $(next_li).find(editor.html.blockTagsQuery()).not('ol, ul, table').each(function () {
          if (this.parentNode === next_li) {
            $(this).replaceWith($(this).html() + (editor.node.isEmpty(this) ? '' : '<br>'));
          }
        }); // Append the next LI to the current LI.

        var last_node = marker;
        var node = editor.node.contents(next_li)[0];
        var tmp;

        while (node && !editor.node.isList(node)) {
          tmp = node.nextSibling;
          $(last_node).after(node);
          last_node = node;
          node = tmp;
        } // Append nested lists.


        while (node) {
          tmp = node.nextSibling;
          $(li).append(node);
          node = tmp;
        } // Replace marker with markers.


        $(marker).replaceWith(FroalaEditor.MARKERS); // Remove next li.

        $(next_li).remove();
      } // No next li.
      else {
        // Search the next sibling in parents.
        var next_node = li;

        while (!next_node.nextSibling && next_node !== editor.el) {
          next_node = next_node.parentNode;
        } // We're right at the end.


        if (next_node === editor.el) {
          return false;
        } // Get the next sibling.


        next_node = next_node.nextSibling; // Next sibling is a block tag.

        if (editor.node.isBlock(next_node)) {
          // Check if we can do delete in it.
          if (FroalaEditor.NO_DELETE_TAGS.indexOf(next_node.tagName) < 0) {
            // Add markers.
            $(marker).replaceWith(FroalaEditor.MARKERS); // Remove any possible BR at the end of the LI.

            contents = editor.node.contents(li);

            if (contents.length && contents[contents.length - 1].tagName === 'BR') {
              $(contents[contents.length - 1]).remove();
            } // https://github.com/froala-labs/froala-editor-js-2/issues/3794


            if (next_node.isContentEditable && next_node.tagName === 'DIV' && (!editor.node.isBlock(next_node.previousSibling) || next_node.previousSibling.tagName === 'DIV')) {
              return;
            } // Append next node.


            $(li).append($(next_node).html()); // Remove the next node.

            $(next_node).remove();
          }
        } // Append everything till the next block tag or BR.
        else {
          // Remove any possible BR at the end of the LI.
          contents = editor.node.contents(li);

          if (contents.length && contents[contents.length - 1].tagName === 'BR') {
            $(contents[contents.length - 1]).remove();
          } // var next_node = next_li;


          $(marker).replaceWith(FroalaEditor.MARKERS);

          while (next_node && !editor.node.isBlock(next_node) && next_node.tagName !== 'BR') {
            $(li).append($(next_node));
            next_node = next_node.nextSibling;
          } // Remove the next node.


          $(next_node).remove();
        }
      }
    }

    return {
      _startEnter: _startEnter,
      _middleEnter: _middleEnter,
      _endEnter: _endEnter,
      _backspace: _backspace,
      _del: _del
    };
  };

  FroalaEditor.NO_DELETE_TAGS = ['TH', 'TD', 'TR', 'TABLE', 'FORM']; // Do simple enter.

  FroalaEditor.SIMPLE_ENTER_TAGS = ['TH', 'TD', 'LI', 'DL', 'DT', 'FORM'];

  FroalaEditor.MODULES.cursor = function (editor) {
    var $ = editor.$;
    /**
     * Check if node is at the end of a block tag.
     */

    function _atEnd(node) {
      if (!node) {
        return false;
      }

      if (editor.node.isBlock(node)) {
        // https://github.com/froala-labs/froala-editor-js-2/issues/2844
        // "LI > P" & "P" having <OL> as nextElementSibling (special case for #pasted lists from google sheet)
        if (node.tagName === 'P' && node.nextElementSibling && node.parentElement && node.nextElementSibling.tagName === 'OL' && node.parentElement.tagName === 'LI') {
          return false;
        } else {
          return true;
        }
      }

      if (node.nextSibling && node.nextSibling.nodeType === Node.TEXT_NODE && node.nextSibling.textContent.replace(/\u200b/g, '').length === 0) {
        return _atEnd(node.nextSibling);
      }

      if (node.nextSibling && !(node.previousSibling && node.nextSibling.tagName === 'BR' && !node.nextSibling.nextSibling)) {
        return false;
      }

      return _atEnd(node.parentNode);
    }
    /**
     * Check if node is at the start of a block tag.
     */


    function _atStart(node) {
      if (!node) {
        return false;
      }

      if (editor.node.isBlock(node)) {
        return true;
      }

      if (node.previousSibling && node.previousSibling.nodeType === Node.TEXT_NODE && node.previousSibling.textContent.replace(/\u200b/g, '').length === 0) {
        return _atStart(node.previousSibling);
      }

      if (node.previousSibling) {
        return false;
      }

      if (!node.previousSibling && editor.node.hasClass(node.parentNode, 'fr-inner')) {
        return true;
      }

      return _atStart(node.parentNode);
    }
    /**
     * Check if node is a the start of the container.
     */


    function _isAtStart(node, container) {
      if (!node) {
        return false;
      }

      if (node === editor.$wp.get(0)) {
        return false;
      }

      if (node.previousSibling && node.previousSibling.nodeType === Node.TEXT_NODE && node.previousSibling.textContent.replace(/\u200b/g, '').length === 0) {
        return _isAtStart(node.previousSibling, container);
      }

      if (node.previousSibling) {
        return false;
      }

      if (node.parentNode === container) {
        return true;
      }

      return _isAtStart(node.parentNode, container);
    }
    /**
     * Check if node is a the start of the container.
     */


    function _isAtEnd(node, container) {
      if (!node) {
        return false;
      }

      if (node === editor.$wp.get(0)) {
        return false;
      }

      if (node.nextSibling && node.nextSibling.nodeType === Node.TEXT_NODE && node.nextSibling.textContent.replace(/\u200b/g, '').length === 0) {
        return _isAtEnd(node.nextSibling, container);
      }

      if (node.nextSibling && !(node.previousSibling && node.nextSibling.tagName === 'BR' && !node.nextSibling.nextSibling)) {
        return false;
      }

      if (node.parentNode === container) {
        return true;
      }

      return _isAtEnd(node.parentNode, container);
    }
    /**
     * Check if the node is inside a LI.
     */


    function _inLi(node) {
      return $(node).parentsUntil(editor.$el, 'LI').length > 0 && $(node).parentsUntil('LI', 'TABLE').length === 0;
    }
    /**
     * Get the length of the first or last character from text. Note: A special character can contain 1, 2 or 4 javascript 16bits characters.
     */


    function _getExtremityCharacterLength(text, first) {
      var special_chars_regex = new RegExp("".concat(first ? '^' : '', "(([\\uD83C-\\uDBFF\\uDC00-\\uDFFF]+\\u200D)*[\\uD83C-\\uDBFF\\uDC00-\\uDFFF]{2})").concat(first ? '' : '$'), 'i');
      var matches = text.match(special_chars_regex); // No matches means there is a normal character.

      if (!matches) {
        return 1;
      } // Special character match. Can be 1, 2 or 4 characters.


      return matches[0].length;
    }
    /**
     * Do backspace at the start of a block tag.
     */


    function _startBackspace(marker) {
      var quote = $(marker).parentsUntil(editor.$el, 'BLOCKQUOTE').length > 0;
      var deep_parent = editor.node.deepestParent(marker, [], !quote);
      var current_block = deep_parent; // Check for nested block tags if no previous element.

      while (deep_parent && !deep_parent.previousSibling && deep_parent.tagName !== 'BLOCKQUOTE' && deep_parent.parentElement !== editor.el && !editor.node.hasClass(deep_parent.parentElement, 'fr-inner') && FroalaEditor.SIMPLE_ENTER_TAGS.indexOf(deep_parent.parentElement.tagName) < 0) {
        deep_parent = deep_parent.parentElement;
      }

      if (deep_parent && deep_parent.tagName === 'BLOCKQUOTE') {
        var m_parent = editor.node.deepestParent(marker, [$(marker).parentsUntil(editor.$el, 'BLOCKQUOTE').get(0)]);

        if (m_parent && m_parent.previousSibling) {
          deep_parent = m_parent;
          current_block = m_parent;
        }
      } // Deepest parent is not the main element.


      if (deep_parent !== null) {
        var prev_node = deep_parent.previousSibling;
        var contents; // We are inside a block tag.

        if (editor.node.isBlock(deep_parent) && editor.node.isEditable(deep_parent)) {
          // There is a previous node.
          if (prev_node && FroalaEditor.NO_DELETE_TAGS.indexOf(prev_node.tagName) < 0) {
            if (editor.node.isDeletable(prev_node)) {
              $(prev_node).remove();
              $(marker).replaceWith(FroalaEditor.MARKERS);
            } else {
              // Previous node is a block tag.
              if (editor.node.isEditable(prev_node)) {
                if (editor.node.isBlock(prev_node)) {
                  if (editor.node.isEmpty(prev_node) && !editor.node.isList(prev_node)) {
                    $(prev_node).remove(); // https://github.com/froala/wysiwyg-editor/issues/1877.

                    $(marker).after(editor.opts.keepFormatOnDelete ? FroalaEditor.INVISIBLE_SPACE : '');
                  } else {
                    if (editor.node.isList(prev_node)) {
                      prev_node = $(prev_node).find('li').last().get(0);
                    } // Remove last BR.


                    contents = editor.node.contents(prev_node);

                    if (contents.length && contents[contents.length - 1].tagName === 'BR') {
                      $(contents[contents.length - 1]).remove();
                    } // Prev node is blockquote but the current one isn't.


                    if (prev_node.tagName === 'BLOCKQUOTE' && deep_parent.tagName !== 'BLOCKQUOTE') {
                      contents = editor.node.contents(prev_node);

                      while (contents.length && editor.node.isBlock(contents[contents.length - 1])) {
                        prev_node = contents[contents.length - 1];
                        contents = editor.node.contents(prev_node);
                      }
                    } // Prev node is not blockquote, but the current one is.
                    else if (prev_node.tagName !== 'BLOCKQUOTE' && current_block.tagName === 'BLOCKQUOTE') {
                      contents = editor.node.contents(current_block);

                      while (contents.length && editor.node.isBlock(contents[0])) {
                        current_block = contents[0];
                        contents = editor.node.contents(current_block);
                      }
                    } // When current node is empty place the cursor at the end of the prev node.


                    if (editor.node.isEmpty(deep_parent)) {
                      $(marker).remove();
                      editor.selection.setAtEnd(prev_node, true);
                    } // Replace marker with markers.
                    else {
                      $(marker).replaceWith(FroalaEditor.MARKERS); // Previous node may have only block children.

                      var prev_children = prev_node.childNodes; // Append to prev node current HTML

                      if (!editor.node.isBlock(prev_children[prev_children.length - 1])) {
                        $(prev_node).append(current_block.innerHTML);
                      } else {
                        // Append the HTML to the last child of the previous node.
                        $(prev_children[prev_children.length - 1]).append(current_block.innerHTML);
                      }
                    } // Remove current block.


                    $(current_block).remove(); // Remove current deep parent if empty.

                    if (editor.node.isEmpty(deep_parent)) {
                      $(deep_parent).remove();
                    }
                  }
                } else {
                  $(marker).replaceWith(FroalaEditor.MARKERS);

                  if (deep_parent.tagName === 'BLOCKQUOTE' && prev_node.nodeType === Node.ELEMENT_NODE) {
                    $(prev_node).remove();
                  } else {
                    $(prev_node).after(editor.node.isEmpty(deep_parent) ? '' : $(deep_parent).html());
                    $(deep_parent).remove();

                    if (prev_node.tagName === 'BR') {
                      $(prev_node).remove();
                    }
                  }
                }
              }
            }
          } else if (!prev_node) {
            if (deep_parent && deep_parent.tagName === 'BLOCKQUOTE' && $(deep_parent).text().replace(/\u200B/g, '').length === 0) {
              $(deep_parent).remove();
            } else {
              var next_node = deep_parent.nextSibling; // https://github.com/froala-labs/froala-editor-js-2/issues/1304

              if (editor.node.isEmpty(deep_parent) && deep_parent.parentNode && editor.node.isEditable(deep_parent.parentNode) && !next_node) {
                // check for the editor el
                if (deep_parent.parentNode != editor.el && deep_parent.parentNode.tagName !== 'TD') {
                  $(deep_parent.parentNode).remove();
                } else if (deep_parent.parentNode != editor.el && deep_parent.parentNode.tagName === 'TD') {
                  // https://github.com/froala-labs/froala-editor-js-2/issues/3774
                  $(deep_parent).remove();
                }
              }
            }
          }
        }
        /* jshint ignore:end */

        /* jscs:enable */

      }
    }
    /**
     * Do backspace at the middle of a block tag.
     */


    function _middleBackspace(marker) {
      var prev_node = marker; // Get the parent node that has a prev sibling.

      while (!prev_node.previousSibling) {
        prev_node = prev_node.parentNode;

        if (editor.node.isElement(prev_node)) {
          return false;
        }
      }

      prev_node = prev_node.previousSibling; // Not block tag.

      var contents;
      var emptyTagsOpt = editor.opts.htmlAllowedEmptyTags;
      var prevNodeTagname = prev_node.tagName && prev_node.tagName.toLowerCase();

      if ((!editor.node.isBlock(prev_node) || prev_node.lastChild && prevNodeTagname && emptyTagsOpt.indexOf(prevNodeTagname) >= 0) && editor.node.isEditable(prev_node)) {
        contents = editor.node.contents(prev_node); // Previous node is text.

        while (prev_node.nodeType !== Node.TEXT_NODE && !editor.node.isDeletable(prev_node) && contents.length && editor.node.isEditable(prev_node)) {
          prev_node = contents[contents.length - 1];
          contents = editor.node.contents(prev_node);
        }

        if (prev_node.nodeType === Node.TEXT_NODE) {
          var txt = prev_node.textContent;
          var len = txt.length; // We have a \n character.

          if (txt.length && txt[txt.length - 1] === '\n') {
            prev_node.textContent = txt.substring(0, len - 2);

            if (prev_node.textContent.length === 0) {
              prev_node.parentNode.removeChild(prev_node);
            }

            return _middleBackspace(marker);
          } // Tab UNDO.


          if (editor.opts.tabSpaces && txt.length >= editor.opts.tabSpaces) {
            var tab_str = txt.substr(txt.length - editor.opts.tabSpaces, txt.length - 1);

            if (tab_str.replace(/ /g, '').replace(new RegExp(FroalaEditor.UNICODE_NBSP, 'g'), '').length === 0) {
              len = txt.length - editor.opts.tabSpaces + 1;
            }
          }

          prev_node.textContent = txt.substring(0, len - _getExtremityCharacterLength(txt)); // https://github.com/froala-labs/froala-editor-js-2/issues/3463

          var newTextContent = prev_node.textContent;

          if (editor.opts.enter === FroalaEditor.ENTER_BR && newTextContent.length > 0 && newTextContent.charAt(newTextContent.length - 1) === ' ' || newTextContent.length === 0 && marker.previousSibling && marker.previousSibling.nodeType === 3 && marker.parentNode.tagName !== 'TD' && marker.parentNode.tagName !== 'LI' && txt !== String.fromCharCode(8203)) {
            marker.insertAdjacentHTML('beforebegin', FroalaEditor.INVISIBLE_SPACE);
            if (prev_node.nextSibling != null) {
                prev_node = prev_node.nextSibling;
            }
          } //Remove blank element when text length 0  and track changes enable.


          if (editor.opts.trackChangesEnabled && prev_node.textContent.length === 0) {
            if ($(prev_node.parentElement).data('tracking') && $(prev_node.parentElement).find('[data-tracking-deleted=true]').length === 0) {
              $(marker).insertBefore(prev_node.parentElement);
              $(prev_node.parentElement).remove();
              prev_node = $(marker)[0].previousSibling;
            }
          } // https://github.com/froala/wysiwyg-editor/issues/3034


          if (editor.opts.htmlUntouched && !marker.nextSibling && prev_node.textContent.length && prev_node.textContent[prev_node.textContent.length - 1] === ' ') {
            prev_node.textContent = prev_node.textContent.substring(0, prev_node.textContent.length - 1) + FroalaEditor.UNICODE_NBSP;
          }

          var deleted = txt.length !== prev_node.textContent.length; // https://github.com/froala-labs/froala-editor-js-2/issues/3548

          if (prev_node.textContent.length === 0 && prev_node.previousSibling && prev_node.previousSibling.tagName === 'BR') {
            prev_node.previousSibling.remove();
          } // Remove nodwhile (!editor.node.isElement(preve if empty.


          if (prev_node.textContent.length === 0) {
            // Here we check to see if we should keep the current formatting.
            if (deleted && editor.opts.keepFormatOnDelete) {
              $(prev_node).after(FroalaEditor.INVISIBLE_SPACE + FroalaEditor.MARKERS);
            } else {
              if (txt.length === 0 || !editor.node.isBlock(prev_node.parentNode)) {
                // Condition prev_node.parentNode.childNodes.length == 1 is from https://github.com/froala/wysiwyg-editor/issues/1855 .
                if ((prev_node.parentNode.childNodes.length == 2 && prev_node.parentNode == marker.parentNode || prev_node.parentNode.childNodes.length == 1) && !editor.node.isBlock(prev_node.parentNode) && !editor.node.isElement(prev_node.parentNode) && editor.node.isDeletable(prev_node.parentNode)) {
                  $(prev_node.parentNode).after(FroalaEditor.MARKERS);
                  $(prev_node.parentNode).remove();
                } else {
                  var isEmptyATag;
                  var previous_node = prev_node; // https://github.com/froala/wysiwyg-editor/issues/2626.

                  while (!editor.node.isElement(prev_node.parentNode) && editor.node.isEmpty(prev_node.parentNode) && FroalaEditor.NO_DELETE_TAGS.indexOf(prev_node.parentNode.tagName) < 0) {
                    prev_node = prev_node.parentNode;

                    if (prev_node.tagName === 'A') {
                      var c_node = prev_node.childNodes[0];
                      $(prev_node).before(c_node);
                      isEmptyATag = true;

                      while (c_node.childNodes.length > 0) {
                        c_node = c_node.childNodes[0];
                      }

                      prev_node.parentNode.removeChild(prev_node);
                      prev_node = c_node;
                      break;
                    }
                  }

                  if (!isEmptyATag) prev_node = previous_node;
                  $(prev_node).after(FroalaEditor.MARKERS); // https://github.com/froala/wysiwyg-editor/issues/1379.

                  if (editor.node.isElement(prev_node.parentNode) && !marker.nextSibling && prev_node.previousSibling && prev_node.previousSibling.tagName === 'BR') {
                    $(marker).after('<br>');
                  }

                  var p_node = prev_node.parentNode;
                  prev_node.parentNode.removeChild(prev_node);
                  if (editor.node.isEmpty(p_node)) $(p_node).html(FroalaEditor.INVISIBLE_SPACE + FroalaEditor.MARKERS);
                }
              } else {
                $(prev_node).after(FroalaEditor.MARKERS);
              }
            }
          } else {
            $(prev_node).after(FroalaEditor.MARKERS);
          }
        } else if (editor.node.isDeletable(prev_node)) {
          $(prev_node).after(FroalaEditor.MARKERS);
          $(prev_node).remove();
        } else if (marker.nextSibling && marker.nextSibling.tagName === 'BR' && editor.node.isVoid(prev_node) && prev_node.tagName !== 'BR') {
          $(marker.nextSibling).remove();
          $(marker).replaceWith(FroalaEditor.MARKERS);
        } else if (editor.events.trigger('node.remove', [$(prev_node)]) !== false) {
          $(prev_node).after(FroalaEditor.MARKERS);
          $(prev_node).remove();
        }
      } // Block tag but we are allowed to delete it.
      else if (FroalaEditor.NO_DELETE_TAGS.indexOf(prev_node.tagName) < 0 && (editor.node.isEditable(prev_node) || editor.node.isDeletable(prev_node))) {
        if (editor.node.isDeletable(prev_node)) {
          $(marker).replaceWith(FroalaEditor.MARKERS);
          $(prev_node).remove();
        } else if (editor.node.isEmpty(prev_node) && !editor.node.isList(prev_node)) {
          $(prev_node).remove();
          $(marker).replaceWith(FroalaEditor.MARKERS);
        } else {
          // List correction.
          if (editor.node.isList(prev_node)) {
            prev_node = $(prev_node).find('li').last().get(0);
          }

          contents = editor.node.contents(prev_node); // https://github.com/froala-labs/froala-editor-js-2/issues/3822

          if (contents && contents.length > 0 && contents[contents.length - 1].tagName === 'BR') {
            $(contents[contents.length - 1]).remove();
          }

          contents = editor.node.contents(prev_node); // https://github.com/froala-labs/froala-editor-js-2/issues/3822

          while (contents && contents.length > 0 && editor.node.isBlock(contents[contents.length - 1])) {
            prev_node = contents[contents.length - 1];
            contents = editor.node.contents(prev_node);
          }

          $(prev_node).append(FroalaEditor.MARKERS);
          var next_node = marker;

          while (!next_node.previousSibling) {
            next_node = next_node.parentNode;
          }

          while (next_node && next_node.tagName !== 'BR' && !editor.node.isBlock(next_node)) {
            var copy_node = next_node;
            next_node = next_node.nextSibling;
            $(prev_node).append(copy_node);
          } // Remove BR.


          if (next_node && next_node.tagName === 'BR') {
            $(next_node).remove();
          }

          $(marker).remove();
        }
      } else if (marker.nextSibling && marker.nextSibling.tagName === 'BR') {
        $(marker.nextSibling).remove();
      }

      return true;
    }
    /**
     * Do backspace.
     */


    function backspace() {
      var do_default = false; // Add a marker in HTML.

      var marker = editor.markers.insert();

      if (!marker) {
        return true;
      } // Do not allow edit inside contenteditable="false".


      var p_node = marker.parentNode;

      while (p_node && !editor.node.isElement(p_node)) {
        if (p_node.getAttribute('contenteditable') === 'false') {
          $(marker).replaceWith(FroalaEditor.MARKERS);
          editor.selection.restore();
          return false;
        } // https://github.com/froala-labs/froala-editor-js-2/issues/2070
        // Break the loop if node has no content and it is editable
        else if (p_node.innerText.length && p_node.getAttribute('contenteditable') === 'true') {
          break;
        }

        p_node = p_node.parentNode;
      }

      editor.el.normalize(); // We should remove invisible space first of all.

      var prev_node = marker.previousSibling;

      if (prev_node) {
        var txt = prev_node.textContent; // Check if we have an invisible space before the marker.

        if (txt && txt.length && txt.charCodeAt(txt.length - 1) === 8203) {
          if (txt.length !== 1) {
            prev_node.textContent = prev_node.textContent.substr(0, txt.length - _getExtremityCharacterLength(txt));
          }
        }
      } // Delete at end.


      if (_atEnd(marker)) {
        if (_inLi(marker) && _isAtStart(marker, $(marker).parents('li').first().get(0))) {
          editor.cursorLists._backspace(marker);
        } else {
          do_default = _middleBackspace(marker);
        }
      } // Delete at start.
      else if (_atStart(marker)) {
        if (_inLi(marker) && _isAtStart(marker, $(marker).parents('li').first().get(0))) {
          editor.cursorLists._backspace(marker);
        } else {
          _startBackspace(marker);
        }
      } // Delete at middle.
      else {
        do_default = _middleBackspace(marker);
      }

      $(marker).remove();

      _cleanEmptyBlockquotes();

      editor.html.fillEmptyBlocks(true);

      if (!editor.opts.htmlUntouched) {
        editor.html.cleanEmptyTags();
        editor.clean.lists();
        editor.spaces.normalizeAroundCursor();
      }

      editor.selection.restore();
      return do_default;
    }
    /**
     * Delete at the end of a block tag.
     */


    function _endDel(marker) {
      var quote = $(marker).parentsUntil(editor.$el, 'BLOCKQUOTE').length > 0;
      var deep_parent = editor.node.deepestParent(marker, [], !quote);

      if (deep_parent && deep_parent.tagName === 'BLOCKQUOTE') {
        var m_parent = editor.node.deepestParent(marker, [$(marker).parentsUntil(editor.$el, 'BLOCKQUOTE').get(0)]);

        if (m_parent && m_parent.nextSibling) {
          deep_parent = m_parent;
        }
      } // Deepest parent is not the main element.


      if (deep_parent !== null) {
        var next_node = deep_parent.nextSibling;
        var contents; // We are inside a block tag.

        if (editor.node.isBlock(deep_parent) && (editor.node.isEditable(deep_parent) || editor.node.isDeletable(deep_parent))) {
          // There is a next node.
          if (next_node && FroalaEditor.NO_DELETE_TAGS.indexOf(next_node.tagName) < 0) {
            if (editor.node.isDeletable(next_node)) {
              $(next_node).remove();
              $(marker).replaceWith(FroalaEditor.MARKERS);
            } else {
              // Next node is a block tag.
              if (editor.node.isBlock(next_node) && editor.node.isEditable(next_node)) {
                // Next node is a list.
                if (editor.node.isList(next_node)) {
                  // Current block tag is empty.
                  if (editor.node.isEmpty(deep_parent, true)) {
                    $(deep_parent).remove();
                    $(next_node).find('li').first().prepend(FroalaEditor.MARKERS);
                  } else {
                    var $li = $(next_node).find('li').first();

                    if (deep_parent.tagName === 'BLOCKQUOTE') {
                      contents = editor.node.contents(deep_parent);

                      if (contents.length && editor.node.isBlock(contents[contents.length - 1])) {
                        deep_parent = contents[contents.length - 1];
                      }
                    } // There are no nested lists.


                    if ($li.find('ul, ol').length === 0) {
                      $(marker).replaceWith(FroalaEditor.MARKERS); // Remove any nodes that might be wrapped.

                      $li.find(editor.html.blockTagsQuery()).not('ol, ul, table').each(function () {
                        if (this.parentNode === $li.get(0)) {
                          $(this).replaceWith($(this).html() + (editor.node.isEmpty(this) ? '' : '<br>'));
                        }
                      });
                      $(deep_parent).append(editor.node.contents($li.get(0)));
                      $li.remove();

                      if ($(next_node).find('li').length === 0) {
                        $(next_node).remove();
                      }
                    }
                  }
                } else {
                  // Remove last BR.
                  contents = editor.node.contents(next_node);

                  if (contents.length && contents[0].tagName === 'BR') {
                    $(contents[0]).remove();
                  }

                  if (next_node.tagName !== 'BLOCKQUOTE' && deep_parent.tagName === 'BLOCKQUOTE') {
                    contents = editor.node.contents(deep_parent);

                    while (contents.length && editor.node.isBlock(contents[contents.length - 1])) {
                      deep_parent = contents[contents.length - 1];
                      contents = editor.node.contents(deep_parent);
                    }
                  } else if (next_node.tagName === 'BLOCKQUOTE' && deep_parent.tagName !== 'BLOCKQUOTE') {
                    contents = editor.node.contents(next_node);

                    while (contents.length && editor.node.isBlock(contents[0])) {
                      next_node = contents[0];
                      contents = editor.node.contents(next_node);
                    }
                  }

                  $(marker).replaceWith(FroalaEditor.MARKERS);
                  $(deep_parent).append(next_node.innerHTML);
                  $(next_node).remove();
                }
              } else {
                $(marker).replaceWith(FroalaEditor.MARKERS); // var next_node = next_node.nextSibling;

                while (next_node && next_node.tagName !== 'BR' && !editor.node.isBlock(next_node) && editor.node.isEditable(next_node)) {
                  var copy_node = next_node;
                  next_node = next_node.nextSibling;
                  $(deep_parent).append(copy_node);
                }

                if (next_node && next_node.tagName === 'BR' && editor.node.isEditable(next_node)) {
                  $(next_node).remove();
                }
              }
            }
          }
        }
        /* jshint ignore:end */

        /* jscs:enable */

      }
    }
    /**
     * Delete at the middle of a block tag.
     */


    function _middleDel(marker) {
      var next_node = marker; // Get the parent node that has a next sibling.

      while (!next_node.nextSibling) {
        next_node = next_node.parentNode;

        if (editor.node.isElement(next_node)) {
          return false;
        }
      }

      next_node = next_node.nextSibling; // Handle the case when the next node is a BR.

      if (next_node.tagName === 'BR' && editor.node.isEditable(next_node)) {
        // There is a next sibling.
        if (next_node.nextSibling) {
          if (editor.node.isBlock(next_node.nextSibling) && editor.node.isEditable(next_node.nextSibling)) {
            if (FroalaEditor.NO_DELETE_TAGS.indexOf(next_node.nextSibling.tagName) < 0) {
              next_node = next_node.nextSibling;
              $(next_node.previousSibling).remove();
            } else {
              $(next_node).remove();
              return;
            }
          }
        } // No next sibling. We should check if BR is at the end.
        else if (_atEnd(next_node)) {
          if (_inLi(marker)) {
            editor.cursorLists._del(marker);
          } else {
            var deep_parent = editor.node.deepestParent(next_node);

            if (deep_parent) {
              if (!editor.node.isEmpty(editor.node.blockParent(next_node)) || (editor.node.blockParent(next_node).nextSibling && FroalaEditor.NO_DELETE_TAGS.indexOf(editor.node.blockParent(next_node).nextSibling.tagName)) < 0) {
                $(next_node).remove();
              }

              _endDel(marker);
            }
          }

          return;
        }
      } // Not block tag.


      var contents;

      if (!editor.node.isBlock(next_node) && editor.node.isEditable(next_node)) {
        contents = editor.node.contents(next_node); // Next node is text.

        while (next_node.nodeType !== Node.TEXT_NODE && contents.length && !editor.node.isDeletable(next_node) && editor.node.isEditable(next_node)) {
          next_node = contents[0];
          contents = editor.node.contents(next_node);
        }

        if (next_node.nodeType === Node.TEXT_NODE) {
          $(next_node).before(FroalaEditor.MARKERS);

          if (next_node.textContent.length) {
            next_node.textContent = next_node.textContent.substring(_getExtremityCharacterLength(next_node.textContent, true), next_node.textContent.length);
          }
        } else if (editor.node.isDeletable(next_node)) {
          $(next_node).before(FroalaEditor.MARKERS);
          $(next_node).remove();
        } else if (editor.events.trigger('node.remove', [$(next_node)]) !== false) {
          $(next_node).before(FroalaEditor.MARKERS);
          $(next_node).remove();
        }

        $(marker).remove();
      } // Block tag.
      else if (FroalaEditor.NO_DELETE_TAGS.indexOf(next_node.tagName) < 0 && (editor.node.isEditable(next_node) || editor.node.isDeletable(next_node))) {
        if (editor.node.isDeletable(next_node)) {
          $(marker).replaceWith(FroalaEditor.MARKERS);
          $(next_node).remove();
        } else if (editor.node.isList(next_node)) {
          // There is a previous sibling.
          if (marker.previousSibling) {
            $(next_node).find('li').first().prepend(marker);

            editor.cursorLists._backspace(marker);
          } // No previous sibling.
          else {
            $(next_node).find('li').first().prepend(FroalaEditor.MARKERS);
            $(marker).remove();
          }
        } else {
          contents = editor.node.contents(next_node); // https://github.com/froala-labs/froala-editor-js-2/issues/3822

          if (contents && contents.length > 0 && contents[0].tagName === 'BR') {
            $(contents[0]).remove();
          } // Deal with blockquote.
          // https://github.com/froala-labs/froala-editor-js-2/issues/3822


          if (contents && contents.length > 0 && next_node.tagName === 'BLOCKQUOTE') {
            var node = contents[0];
            $(marker).before(FroalaEditor.MARKERS);

            while (node && node.tagName !== 'BR') {
              var tmp = node;
              node = node.nextSibling;
              $(marker).before(tmp);
            }

            if (node && node.tagName === 'BR') {
              $(node).remove();
            }
          } else {
            $(marker).after($(next_node).html()).after(FroalaEditor.MARKERS);
            $(next_node).remove();
          }
        }
      }
    }
    /**
     * Delete.
     */


    function del() {
      var marker = editor.markers.insert();

      if (!marker) {
        return false;
      }

      editor.el.normalize(); // Delete at end.

      if (_atEnd(marker)) {
        if (_inLi(marker)) {
          if ($(marker).parents('li').first().find('ul, ol').length === 0) {
            editor.cursorLists._del(marker);
          } else {
            var $li = $(marker).parents('li').first().find('ul, ol').first().find('li').first();
            $li = $li.find(editor.html.blockTagsQuery()).get(-1) || $li;
            $li.prepend(marker);

            editor.cursorLists._backspace(marker);
          }
        } else {
          _endDel(marker);
        }
      } // Delete at start.
      else if (_atStart(marker)) {
        _middleDel(marker);
      } // Delete at middle.
      else {
        _middleDel(marker);
      }

      $(marker).remove();

      _cleanEmptyBlockquotes();

      editor.html.fillEmptyBlocks(true);

      if (!editor.opts.htmlUntouched) {
        editor.html.cleanEmptyTags();
        editor.clean.lists();
      }

      editor.spaces.normalizeAroundCursor();
      editor.selection.restore();
    }

    function _cleanEmptyBlockquotes() {
      var blks = editor.el.querySelectorAll('blockquote:empty');

      for (var i = 0; i < blks.length; i++) {
        blks[i].parentNode.removeChild(blks[i]);
      }
    }

    function _cleanNodesToRemove() {
      editor.$el.find('.fr-to-remove').each(function () {
        var contents = editor.node.contents(this);

        for (var i = 0; i < contents.length; i++) {
          if (contents[i].nodeType === Node.TEXT_NODE) {
            contents[i].textContent = contents[i].textContent.replace(/\u200B/g, '');
          }
        }

        $(this).replaceWith(this.innerHTML);
      });
    }
    /**
     * Enter at the end of a block tag.
     */


    function _endEnter(marker, shift, quote) {
      var deep_parent = editor.node.deepestParent(marker, [], !quote);
      var default_tag;

      if (deep_parent && deep_parent.tagName === 'BLOCKQUOTE') {
        if (_isAtEnd(marker, deep_parent)) {
          default_tag = editor.html.defaultTag();

          if (!shift) {
            if (default_tag) {
              $(deep_parent).after("<".concat(default_tag, ">").concat(FroalaEditor.MARKERS, "<br></").concat(default_tag, ">"));
            } else {
              $(deep_parent).after("".concat(FroalaEditor.MARKERS, "<br>"));
            }
          } else {
            $(marker).replaceWith('<br>' + FroalaEditor.MARKERS);
          }

          $(marker).remove();
          return false;
        }

        _middleEnter(marker, shift, quote);

        return false;
      } // We are right in the main element.


      if (deep_parent === null) {
        default_tag = editor.html.defaultTag();

        if (!default_tag || !editor.node.isElement(marker.parentNode)) {
          if (marker.previousSibling && !$(marker.previousSibling).is('br') && !marker.nextSibling) {
            $(marker).replaceWith("<br>".concat(FroalaEditor.MARKERS, "<br>"));
          } else {
            $(marker).replaceWith("<br>".concat(FroalaEditor.MARKERS));
          }
        } else {
          $(marker).replaceWith("<".concat(default_tag, ">").concat(FroalaEditor.MARKERS, "<br></").concat(default_tag, ">"));
        }
      } // There is a parent.
      else {
        // Block tag parent.
        var c_node = marker;
        var str = '';

        if (deep_parent.tagName == 'PRE' && !marker.nextSibling) {
          shift = true;
        }

        if (!editor.node.isBlock(deep_parent) || shift) {
          str = '<br/>';
        }

        var c_str = '';
        var o_str = '';
        default_tag = editor.html.defaultTag();
        var open_default_tag = '';
        var close_default_tag = '';

        if (default_tag && editor.node.isBlock(deep_parent)) {
          open_default_tag = "<".concat(default_tag, ">");
          close_default_tag = "</".concat(default_tag, ">");

          if (deep_parent.tagName === default_tag.toUpperCase()) {
            open_default_tag = editor.node.openTagString($(deep_parent).clone().removeAttr('id').get(0));
          }
        }

        do {
          c_node = c_node.parentNode; // Shift condition.

          if (!shift || c_node !== deep_parent || shift && !editor.node.isBlock(deep_parent)) {
            c_str += editor.node.closeTagString(c_node); // Open str when there is a block parent.

            if (c_node === deep_parent && editor.node.isBlock(deep_parent)) {
              o_str = open_default_tag + o_str;
            } else {
              var cls = (c_node.tagName === 'A' || editor.node.hasClass(c_node, 'fa')) && _isAtEnd(marker, c_node) ? 'fr-to-remove' : ''; // For pasted text, style will not be copied

              if (c_node.getAttribute('id') === 'isPasted') {
                o_str = editor.node.openTagString($(c_node).clone().attr('style', '').addClass(cls).get(0)) + o_str;
              } else {
                o_str = editor.node.openTagString($(c_node).clone().addClass(cls).get(0)) + o_str;
              }
            }
          }
        } while (c_node !== deep_parent); // Add BR if deep parent is block tag.


        str = c_str + str + o_str + (marker.parentNode === deep_parent && editor.node.isBlock(deep_parent) ? '' : FroalaEditor.INVISIBLE_SPACE) + FroalaEditor.MARKERS;

        if (editor.node.isBlock(deep_parent) && !$(deep_parent).find('*').last().is('br')) {
          $(deep_parent).append('<br/>');
        }

        $(marker).after('<span id="fr-break"></span>');
        $(marker).remove(); // Add a BR after to make sure we display the last line.

        if ((!deep_parent.nextSibling || editor.node.isBlock(deep_parent.nextSibling)) && !editor.node.isBlock(deep_parent)) {
          $(deep_parent).after('<br>');
        }

        var html; // No shift.

        if (!shift && editor.node.isBlock(deep_parent)) {
          html = editor.node.openTagString(deep_parent) + $(deep_parent).html() + close_default_tag;
        } else {
          html = editor.node.openTagString(deep_parent) + $(deep_parent).html() + editor.node.closeTagString(deep_parent);
        }

        html = html.replace(/<span id="fr-break"><\/span>/g, str);
        $(deep_parent).replaceWith(html);
      }
    }
    /**
     * Start at the beginning of a block tag.
     */


    function _startEnter(marker, shift, quote) {
      var deep_parent = editor.node.deepestParent(marker, [], !quote);
      var default_tag; // https://github.com/froala-labs/froala-editor-js-2/issues/320

      if (deep_parent && deep_parent.tagName === 'TABLE') {
        $(deep_parent).find('td, th').first().prepend(marker);
        return _startEnter(marker, shift, quote);
      }

      if (deep_parent && deep_parent.tagName === 'BLOCKQUOTE') {
        if (_isAtStart(marker, deep_parent)) {
          if (!shift) {
            default_tag = editor.html.defaultTag();

            if (default_tag) {
              $(deep_parent).before("<".concat(default_tag, ">").concat(FroalaEditor.MARKERS, "<br></").concat(default_tag, ">"));
            } else {
              $(deep_parent).before("".concat(FroalaEditor.MARKERS, "<br>"));
            }

            $(marker).remove();
            return false;
          }
        } else if (_isAtEnd(marker, deep_parent)) {
          _endEnter(marker, shift, true);
        } else {
          _middleEnter(marker, shift, true);
        }
      } // We are right in the main element.


      if (deep_parent === null) {
        default_tag = editor.html.defaultTag();

        if (!default_tag || !editor.node.isElement(marker.parentNode)) {
          $(marker).replaceWith("<br>".concat(FroalaEditor.MARKERS));
        } else {
          $(marker).replaceWith("<".concat(default_tag, ">").concat(FroalaEditor.MARKERS, "<br></").concat(default_tag, ">"));
        }
      } else {
        default_tag = editor.html.defaultTag();

        if (editor.node.isBlock(deep_parent)) {
          if (deep_parent.tagName === 'PRE') {
            shift = true;
          }

          if (shift) {
            $(marker).remove();
            $(deep_parent).prepend("<br>".concat(FroalaEditor.MARKERS));
          } else if (marker.nextSibling && marker.nextSibling.tagName == 'IMG' || marker.nextSibling && marker.nextSibling.nextElementSibling && marker.nextSibling.nextElementSibling == 'IMG') {
            $(marker).replaceWith('<' + editor.html.defaultTag() + '>' + FroalaEditor.MARKERS + '<br></' + editor.html.defaultTag() + '>');
          } else if (editor.node.isEmpty(deep_parent, true)) {
            return _endEnter(marker, shift, quote);
          } else if (!editor.opts.keepFormatOnDelete && deep_parent.tagName !== 'DIV' && editor.html.defaultTag() !== 'div') {
            $(deep_parent).before("".concat(editor.node.openTagString($(deep_parent).clone().removeAttr('id').get(0)), "<br>").concat(editor.node.closeTagString(deep_parent)));
          } else if (!editor.opts.keepFormatOnDelete && deep_parent.tagName === 'DIV' || editor.html.defaultTag() === 'div') {
            $(deep_parent).before('<' + editor.html.defaultTag() + '><br></' + editor.html.defaultTag() + '>');
          } // https://github.com/froala-labs/froala-editor-js-2/issues/3424
          else if (editor.opts.keepFormatOnDelete && deep_parent.tagName !== 'DIV' && editor.html.defaultTag() !== 'div' && _atStart(editor.selection.get().focusNode)) {
            $(deep_parent).before("".concat(editor.node.openTagString($(deep_parent).clone().removeAttr('id').get(0)), "<br>").concat(editor.node.closeTagString(deep_parent)));
          } else {
            var tmp = marker;
            var str = FroalaEditor.INVISIBLE_SPACE; // Look up to all parents.

            while (tmp !== deep_parent && !editor.node.isElement(tmp)) {
              tmp = tmp.parentNode;
              str = editor.node.openTagString(tmp) + str + editor.node.closeTagString(tmp);
            }

            $(deep_parent).before(str);
          }
        } else {
          $(deep_parent).before('<br>');
        }

        $(marker).remove();
      }
    }
    /**
     * Enter at the middle of a block tag.
     */


    function _middleEnter(marker, shift, quote) {
      var deep_parent = editor.node.deepestParent(marker, [], !quote); // We are right in the main element.

      if (deep_parent === null) {
        // Default tag is not enter.
        if (editor.html.defaultTag() && marker.parentNode === editor.el) {
          $(marker).replaceWith("<".concat(editor.html.defaultTag(), ">").concat(FroalaEditor.MARKERS, "<br></").concat(editor.html.defaultTag(), ">"));
        } else {
          // Add a BR after to make sure we display the last line.
          if (!marker.nextSibling || editor.node.isBlock(marker.nextSibling)) {
            $(marker).after('<br>');
          }

          $(marker).replaceWith("<br>".concat(FroalaEditor.MARKERS));
        }
      } // https://github.com/froala/wysiwyg-editor/issues/3392
      else if (marker.previousSibling && marker.previousSibling.tagName == 'IMG' || marker.nextSibling && marker.nextSibling.tagName == 'IMG') {
        $(marker).replaceWith('<' + editor.html.defaultTag() + '>' + FroalaEditor.MARKERS + '<br></' + editor.html.defaultTag() + '>');
      } // There is a parent.
      else {
        // Block tag parent.
        var c_node = marker;
        var str = '';

        if (deep_parent.tagName === 'PRE') {
          shift = true;
        }

        if (!editor.node.isBlock(deep_parent) || shift) {
          str = '<br>';
        }

        var c_str = '';
        var o_str = '';

        do {
          var tmp = c_node;
          c_node = c_node.parentNode; // Move marker after node it if is empty and we are in quote.

          if (deep_parent.tagName === 'BLOCKQUOTE' && editor.node.isEmpty(tmp) && !editor.node.hasClass(tmp, 'fr-marker')) {
            if ($(tmp).contains(marker)) {
              $(tmp).after(marker);
            }
          } // If not at end or start of element in quote.


          if (!(deep_parent.tagName === 'BLOCKQUOTE' && (_isAtEnd(marker, c_node) || _isAtStart(marker, c_node)))) {
            // 1. No shift.
            // 2. c_node is not deep parent.
            // 3. Shift and deep parent is not block tag.
            if (!shift || c_node !== deep_parent || shift && !editor.node.isBlock(deep_parent)) {
              c_str += editor.node.closeTagString(c_node);
              var cls = c_node.tagName == 'A' && _isAtEnd(marker, c_node) || editor.node.hasClass(c_node, 'fa') ? 'fr-to-remove' : '';
              o_str = editor.node.openTagString($(c_node).clone().addClass(cls).removeAttr('id').get(0)) + o_str;

              if (editor.opts.enter !== FroalaEditor.ENTER_DIV && c_node === deep_parent && deep_parent.tagName === 'DIV') {
                c_str = '<br>';
                o_str = '';
              }
            } else if (deep_parent.tagName == 'BLOCKQUOTE' && shift) {
              c_str = '';
              o_str = '';
            }
          }
        } while (c_node !== deep_parent); // We should add an invisible space if:
        // 1. parent node is not deep parent and block tag.
        // 2. marker has no next sibling.


        var add = deep_parent === marker.parentNode && editor.node.isBlock(deep_parent) || marker.nextSibling;

        if (deep_parent.tagName === 'BLOCKQUOTE') {
          if (marker.previousSibling && editor.node.isBlock(marker.previousSibling) && marker.nextSibling && marker.nextSibling.tagName === 'BR') {
            $(marker.nextSibling).after(marker);

            if (marker.nextSibling && marker.nextSibling.tagName === 'BR') {
              $(marker.nextSibling).remove();
            }
          }

          if (shift) {
            str = c_str + str + FroalaEditor.MARKERS + o_str;
          } else {
            var default_tag = editor.html.defaultTag();
            str = "".concat(c_str + str + (default_tag ? "<".concat(default_tag, ">") : '') + FroalaEditor.MARKERS, "<br>").concat(default_tag ? "</".concat(default_tag, ">") : '').concat(o_str);
          }
        } else {
          str = c_str + str + o_str + (add ? '' : FroalaEditor.INVISIBLE_SPACE) + FroalaEditor.MARKERS;
        }

        $(marker).replaceWith('<span id="fr-break"></span>');
        var html = editor.node.openTagString(deep_parent) + $(deep_parent).html() + editor.node.closeTagString(deep_parent);
        html = html.replace(/<span id="fr-break"><\/span>/g, str);
        $(deep_parent).replaceWith(html);
      }
    }

    function offset(el) {
      var rect = el.getBoundingClientRect(),
          scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
          scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft
      };
    }

    function getSelection() {
      var sel = editor.selection.get();
      var start_node = null; // Selection must be inside editor.

      if (editor.selection.inEditor() && sel.rangeCount) {
        // Loop through ranges.
        var rngs = editor.selection.ranges();

        for (var i = 0; i < rngs.length; i++) {
          var range = rngs[i]; // Get start node and end node for range.

          start_node = editor.selection.rangeElement(range.startContainer, range.startOffset);
          break;
        }
      }

      return start_node;
    }
    /**
     * Do enter.
     */


    function enter(shift) {
      // Add a marker in HTML.
      var marker = editor.markers.insert();

      if (!marker) {
        return true;
      } // Do not allow edit inside contenteditable="false".


      var p_node = marker.parentNode;

      while (p_node && !editor.node.isElement(p_node)) {
        if (p_node.getAttribute('contenteditable') === 'false') {
          $(marker).replaceWith(FroalaEditor.MARKERS);
          editor.selection.restore();
          return false;
        } else if (p_node.getAttribute('contenteditable') === 'true') {
          break;
        }

        p_node = p_node.parentNode;
      }

      editor.el.normalize();
      var quote = false;

      if ($(marker).parentsUntil(editor.$el, 'BLOCKQUOTE').length > 0) {
        //shift = false
        quote = true;
      }

      if ($(marker).parentsUntil(editor.$el, 'TD, TH').length) {
        quote = false;
      } // At the end.


      if (_atEnd(marker)) {
        // Enter in list.
        if (_inLi(marker) && !shift && !quote) {
          editor.cursorLists._endEnter(marker);
        } else {
          _endEnter(marker, shift, quote);
        }
      } // At start.
      else if (_atStart(marker)) {
        // Enter in list.
        if (_inLi(marker) && !shift && !quote) {
          editor.cursorLists._startEnter(marker);
        } else {
          _startEnter(marker, shift, quote);
        }
      } // At middle.
      else {
        // Enter in list.
        if (_inLi(marker) && !shift && !quote) {
          editor.cursorLists._middleEnter(marker);
        } else {
          _middleEnter(marker, shift, quote);
        }
      }

      _cleanNodesToRemove();

      editor.html.fillEmptyBlocks(true);

      if (!editor.opts.htmlUntouched) {
        editor.html.cleanEmptyTags();
        editor.clean.lists();
        editor.spaces.normalizeAroundCursor();
      }

      editor.selection.restore(); // https://github.com/froala-labs/froala-editor-js-2/issues/2261
      // scroll to the bottom if editor el's height is more than viewport height

      var windowHeight = editor.o_win.innerHeight;

      if (editor.$oel[0].offsetHeight > windowHeight) {
        var current_block = getSelection();

        if (current_block) {
          var x = offset(current_block);
          var offsetTop = current_block.getBoundingClientRect().top; // https://github.com/froala-labs/froala-editor-js-2/issues/3366

          if (current_block.parentNode && current_block.parentNode.tagName === 'TD' && offsetTop > windowHeight) {
            editor.o_win.scroll(0, offsetTop - 50);
          } else if (offsetTop < 0) {
            editor.o_win.scroll(0, x.top - 80);
          } else if (offsetTop + 20 > windowHeight) {
            editor.o_win.scroll(0, x.top - windowHeight + 50);
          }
        }
      }
    }

    return {
      enter: enter,
      backspace: backspace,
      del: del,
      isAtEnd: _isAtEnd,
      isAtStart: _isAtStart
    };
  };

  FroalaEditor.MODULES.data = function (A) {
    function t(A) {
      return A;
    }

    function n(A) {
      if (!A) return A;
      var n = "";
      var B = t("charCodeAt"),
          D = t("fromCharCode");
      var o = u.indexOf(A[0]);

      for (var _t = 1; _t < A.length - 2; _t++) {
        var _r = C(++o);

        var _i = A[B](_t),
            _c = "";

        for (; /[0-9-]/.test(A[_t + 1]);) {
          _c += A[++_t];
        }

        _c = parseInt(_c, 10) || 0, _i = e(_i, _r, _c), _i ^= o - 1 & 31, n += String[D](_i);
      }

      return n;
    }

    function C(A) {
      var t = A.toString();
      var n = 0;

      for (var _A = 0; _A < t.length; _A++) {
        n += parseInt(t.charAt(_A), 10);
      }

      return n > 10 ? n % 9 + 1 : n;
    }

    function e(A, t, n) {
      var C = Math.abs(n);

      for (; C-- > 0;) {
        A -= t;
      }

      return n < 0 && (A += 123), A;
    }

    function B(t) {
      return t && "block" !== t.css("display") ? (t.remove(), !0) : t && 0 === A.helpers.getPX(t.css("height")) ? (t.remove(), !0) : !(!t || "absolute" !== t.css("position") && "fixed" !== t.css("position")) && (t.remove(), !0);
    }

    function D(t) {
      return t && 0 === A.$box.find(t).length;
    }

    function o() {
      return B(g) || B(b) || D(g) || D(b);
    }

    function r() {
      if (w > 10 && (A[t(m("0ppecjvc=="))](), setTimeout(function () {
        h.FE = null;
      }, 10)), !A.$box) return !1;
      A.$wp.prepend(m(t(m(G)))), g = A.$wp.find("> div").first(), b = g.find("> a"), "rtl" === A.opts.direction && g.css("left", "auto").css("right", 0).attr("direction", "rtl"), w++;
    }

    function i(A) {
      var t = m("9qqG-7amjlwq=="),
          n = m("KA3B3C2A6D1D5H5H1A3=="),
          C = m("3B9B3B5F3C4G3E3=="),
          e = m("QzbzvxyB2yA-9m=="),
          B = m("ji1kacwmgG5bc=="),
          D = m("nmA-13aogi1A3c1jd=="),
          o = m("BA9ggq=="),
          r = m("emznbjbH3fij=="),
          i = m("tkC-22d1qC-13sD1wzF-7=="),
          c = m("tA3jjf=="),
          E = m("1D1brkm=="),
          f = [t, n, C, e, B, D, o, r, i, c, E];

      for (var _t2 = 0; _t2 < f.length; _t2++) {
        if (String.prototype.endsWith || (String.prototype.endsWith = function (A, t) {
          return (void 0 === t || t > this.length) && (t = this.length), this.substring(t - A.length, t) === A;
        }), A.endsWith(f[_t2])) return !0;
      }

      return !1;
    }

    function c(A) {
      var t = (m(A) || "").split("|");
      return 4 === t.length && "V3" === t[0] ? [t[1], t[3], t[2]] : [null, null, ""];
    }

    function E(A) {
      return null === A || (0 == A.indexOf("TRIAL") ? (A = new Date(A.replace(/TRIAL/, "")), new Date(A) < new Date() && (d = F, !0)) : new Date(A) < new Date(m(H)));
    }

    function f() {
      var A = m(t(a)),
          n = m(t("tzgatD-13eD1dtdrvmF3c1nrC-7saQcdav==")).split(".");

      try {
        return window.parent.document.querySelector(A) && window[n[1]][n[2]];
      } catch (A) {
        return !1;
      }
    }

    function s() {
      var n = A.opts.key || [""];
      var C = m(t("ziRA1E3B9pA5B-11D-11xg1A3ZB5D1D4B-11ED2EG2pdeoC1clIH4wB-22yQD5uF4YE3E3A9=="));
      "string" == typeof n && (n = [n]), A.ul = !0;
      var e = !1,
          B = 0;

      for (var _C = 0; _C < n.length; _C++) {
        var _D = c(n[_C]),
            _o = _D[2],
            _r2 = m(t(m("LGnD1KNZf1CPBYCAZB-8F3UDSLLSG1VFf1A3C2==")));

        if (_o === _r2 || _o.indexOf(p, _o.length - p.length) >= 0 || i(p) || f()) {
          if (!(E(_D[1]) && (p || "").length > 0) || i(p) || f()) {
            A.ul = !1;
            break;
          }

          e = !0, G = d, B = _D[0] || -1;
        }
      }

      var D = new Image();
      A.ul === !0 && (r(), D.src = e ? "".concat(t(m(C)), "e=").concat(B) : "".concat(t(m(C)), "u")), A.ul === !0 && (A.events.on("contentChanged", function () {
        o() && r();
      }), A.events.on("html.get", function (A) {
        return A + m(l);
      })), A.events.on("html.set", function () {
        var t = A.el.querySelector('[data-f-id="pbf"]');
        t && h(t).remove();
      }), A.events.on("destroy", function () {
        g && g.length && g.remove();
      }, !0);
    }

    var h = A.$,
        u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var d = "sC-7OB2fwhVC4vsG-7ohPA4ZD4D-8f1J3stzB-11bFE2FC1A3NB2IF1HE1TH4WB8eB-11zVG2F3I3yYB5ZG4CB2DA15CC5AD3F1A1KG1oLA10B1A6wQF1H3vgale2C4F4XA2qc2A5D5B3pepmriKB3OE1HD1fUC10pjD-11E-11TB4YJ3bC-16zE-11yc1B2CE2BC3jhjKC1pdA-21OA6C1D5B-8vF4QA11pD6sqf1C3lldA-16BD4A2H3qoEA7bB-16rmNH5H1F1vSB7RE2A3TH4YC5A5b1A4d1B3whepyAC3AA2zknC3mbgf1SC4WH4PD8TC5ZB2C3H3jb2A5ZA2EF2aoFC5qqHC4B1H1zeGA7UA5RF4TA29TA6ZC4d1C3hyWA10A3rBB2E3decorationRD3QC10UD3E6E6ZD2F3F3fme2E5uxxrEC9C3E4fB-11azhHB1LD7D6VF4VVTPC6b1C4TYG3qzDD6B3B3AH4I2H2kxbHE1JD1yihfd1QD6WB1D4mhrc1B5rvFG3A14A7cDA2OC1AA1JB5zC-16KA6WB4C-8wvlTB5A5lkZB2C2C7zynBD2D2bI-7C-21d1HE2cubyvPC8A6VB3aroxxZE4C4F4e1I2BE1WjdifH1H4A14NA1GB1YG-10tWA3A14A9sVA2C5XH2A29b2A6gsleGG2jaED2D-13fhE1OA8NjwytyTD4e1sc1D-16ZC3B5C-9e1C2FB6EFF5B2C2JH4E1C2tdLE5A3UG4G-7b2D3B4fA-9oh1G3kqvB4AG3ibnjcAC6D2B1cDA9KC2QA6bRC4VA30RB8hYB2A4A-8h1A21A2B2==";
    var F = "7D4YH4fkhHB3pqDC3H2E1fkMD1IB1NF1D3QD9wB5rxqlh1A8c2B4ZA3FD2AA6FB5EB3jJG4D2J-7aC-21GB6PC5RE4TC11QD6XC4XE3XH3mlvnqjbaOA2OC2BE6A1fmI-7ujwbc1G5f1F3e1C11mXF4owBG3E1yD1E4F1D2D-8B-8C-7yC-22HD1MF5UE4cWA3D8D6a1B2C3H3a3I3sZA4B3A2akfwEB3xHD5D1F1wIC11pA-16xdxtVI2C9A6YC4a1A2F3B2GA6B4C3lsjyJB1eMA1D-11MF5PE4ja1D3D7byrf1C3e1C7D-16lwqAF3H2A1B-21wNE1MA1OG1HB2A-16tSE5UD4RB3icRA4F-10wtwzBB3E1C3CC2DA8LA2LA1EB1kdH-8uVB7decorg1J2B7B6qjrqGI2J1C6ijehIB1hkemC-13hqkrH4H-7QD6XF5XF3HLNAC3CB2aD2CD2KB10B4ycg1A-8KA4H4B11jVB5TC4yqpB-21pd1E4pedzGB6MD5B3ncB-7MA4LD2JB6PD5uH-8TB9C7YD5XD2E3I3jmiDB3zeimhLD8E2F2JC1H-9ivkPC5lG-10SB1D3H3A-21rc1A3d1E3fsdqwfGA2KA1OrC-22LA6D1B4afUB16SC7AitC-8qYA11fsxcajGA15avjNE2A-9h1hDB16B9tPC1C5F5UC1G3B8d2A5d1D4RnHJ3C3JB5D3ucMG1yzD-17hafjC-8VD3yWC6e1YD2H3ZE2C8C5oBA3H3D2vFA4WzJC4C2i1A-65fNB8afWA1H4A26mvkC-13ZB3E3h1A21BC4eFB2GD2AA5ghqND2A2B2==",
        l = "qD2H-9G3ioD-17qA1tE1B-8qI3A4hA-13C-11E2C1njfldD1E6pg1C-8sC3hfbkcD2G3stC-22gqgB3G2B-7vtoA4nweeD1A31A15B9uC-16A1F5dkykdc1B8dE-11bA3F2D3A9gd1E7F2tlI-8H-7vtxB2A5B2C3B2F2B5A6ldbyC4iqC-22D-17E-13mA3D2dywiB3oxlvfC1H4C2TjqbzlnI3ntB4E3qA2zaqsC6D3pmnkoE3C6D5wvuE3bwifdhB6hch1E4xibD-17dmrC1rG-7pntnF6nB-8F1D2A11C8plrkmF2F3MC-16bocqA2WwA-21ayeA1C4d1isC-22rD-13D6DfjpjtC2E6hB2G2G4A-7D2==",
        a = "MekC-11nB-8tIzpD7pewxvzC6mD-16xerg1==",
        H = "lC4B3A3B2B5A1C2E4G1A2==";
    var G = "sC-7OB2fwhVC4vsG-7ohPA4ZD4D-8f1J3stzB-11bFE2EE1MA2ND1KD1IE4cA-21pSD2D5ve1G3h1A8b1E5ZC3CD2FA16mC5OC5E1hpnG1NA10B1D7hkUD4I-7b2C3C5nXD2E3F3whidEC2EH3GI2mJE2E2bxci1WA10VC7pllSG2F3A7xd1A4ZC3DB2aaeGA2DE4H2E1j1ywD-13FD1A3VE4WA3D8C6wuc1A2hf1B5B7vnrrjA1B9ic1mpbD1oMB1iSB7rWC4RI4G-7upB6jd1A2F3H2EA4FD3kDF4A2moc1anJD1TD4VI4b2C7oeQF4c1E3XC7ZA3C3G3uDB2wGB6D1JC4D1JD4C1hTE6QC5pH4pD3C-22D7c1A3textAA4gdlB2mpozkmhNC1mrxA3yWA5edhg1I2H3B7ozgmvAI3I2B5GD1LD2RSNH1KA1XA5SB4PA3sA9tlmC-9tnf1G3nd1coBH4I2I2JC3C-16LE6A1tnUA3vbwQB1G3f1A20a3A8a1C6pxAB2eniuE1F3kH2lnjB2hB-16XA5PF1G4zwtYA5B-11mzTG2B9pHB3BE2hGH3B3B2cMD5C1F1wzPA8E7VG5H5vD3H-7C8tyvsVF2I1G2A5fE3bg1mgajoyxMA4fhuzSD8aQB2B4g1A20ukb1A4B3F3GG2CujjanIC1ObiB11SD1C5pWC1D4YB8YE5FE-11jXE2F-7jB4CC2G-10uLH4E1C2tA-13yjUH5d1H1A7sWD5E4hmjF-7pykafoGA16hDD4joyD-8OA33B3C2tC7cRE4SA31a1B8d1e2A4F4g1A2A22CC5zwlAC2C1A12==";

    var p = function () {
      var A = 0,
          t = document.domain;
      var n = t.split("."),
          C = "_gd".concat(new Date().getTime());

      for (; A < n.length - 1 && document.cookie.indexOf("".concat(C, "=").concat(C)) === -1;) {
        t = n.slice(-1 - ++A).join("."), document.cookie = "".concat(C, "=").concat(C, ";domain=").concat(t, ";");
      }

      return document.cookie = "".concat(C, "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=").concat(t, ";"), (t || "").replace(/(^\.*)|(\.*$)/g, "");
    }(),
        m = t(n);

    var g,
        b,
        w = 0;
    return {
      _init: s
    };
  };

  FroalaEditor.MODULES.edit = function (editor) {
    /**
     * Disable editing design.
     */
    function disableDesign() {
      if (editor.browser.mozilla) {
        try {
          editor.doc.execCommand('enableObjectResizing', false, 'false');
          editor.doc.execCommand('enableInlineTableEditing', false, 'false');
        } catch (ex) {// ok.
        }
      }

      if (editor.browser.msie) {
        try {
          editor.doc.body.addEventListener('mscontrolselect', function (e) {
            // Add focus to the element when clicked
            e.srcElement.focus();
            return false;
          });
        } catch (ex) {// ok.
        }
      }
    }

    var disabled = false;
    /**
     * Add contneteditable attribute.
     */

    function on() {
      if (editor.$wp) {
        editor.$el.attr('contenteditable', true);
        editor.$el.removeClass('fr-disabled').attr('aria-disabled', false);
        disableDesign();
      } else if (editor.$el.is('a')) {
        editor.$el.attr('contenteditable', true);
      }

      editor.events.trigger('edit.on', [], true);
      disabled = false;
    }
    /**
     * Remove contenteditable attribute.
     */


    function off() {
      editor.events.disableBlur();

      if (editor.$wp) {
        editor.$el.attr('contenteditable', false);
        editor.$el.addClass('fr-disabled').attr('aria-disabled', true);
      } else if (editor.$el.is('a')) {
        editor.$el.attr('contenteditable', false);
      }

      editor.events.trigger('edit.off');
      editor.events.enableBlur();
      disabled = true;
    }

    function isDisabled() {
      return disabled;
    }

    function _init() {
      // When there are multiple editor instances and shared toolbar make sure we can edit.
      editor.events.on('focus', function () {
        if (isDisabled()) {
          editor.edit.off();
        } else {
          editor.edit.on();
        }
      });
    }

    return {
      _init: _init,
      on: on,
      off: off,
      disableDesign: disableDesign,
      isDisabled: isDisabled
    };
  };

  FroalaEditor.MODULES.format = function (editor) {
    var $ = editor.$;
    /**
     * Create open tag string.
     */

    function _openTag(tag, attrs) {
      var str = "<".concat(tag);

      for (var key in attrs) {
        if (Object.prototype.hasOwnProperty.call(attrs, key)) {
          str += " ".concat(key, "=\"").concat(attrs[key], "\"");
        }
      }

      str += '>';
      return str;
    }
    /**
     * Create close tag string.
     */


    function _closeTag(tag) {
      return "</".concat(tag, ">");
    }
    /**
     * Create query for the current format.
     */


    function _query(tag, attrs) {
      var selector = tag;

      for (var key in attrs) {
        if (Object.prototype.hasOwnProperty.call(attrs, key)) {
          if (key === 'id') {
            selector += "#".concat(attrs[key]);
          } else if (key === 'class') {
            selector += ".".concat(attrs[key]);
          } else {
            selector += "[".concat(key, "=\"").concat(attrs[key], "\"]");
          }
        }
      }

      return selector;
    }
    /**
     * Test matching element.
     */


    function _matches(el, selector) {
      if (!el || el.nodeType !== Node.ELEMENT_NODE) {
        return false;
      }

      return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector);
    }
    /**
     * Apply format to the current node till we find a marker.
     */


    function _processNodeFormat(start_node, tag, attrs) {
      var parent_li_node;
      var style_alt_for_tags = {
        strong: {
          prop: 'font-weight',
          val: 'bold'
        },
        em: {
          prop: 'font-style',
          val: 'italic'
        }
      };
      var prop;
      var val; // No start node.

      if (!start_node) {
        return;
      } // https://github.com/froala-labs/froala-editor-js-2/issues/2353


      if (editor.node.isBlock(start_node) && start_node.hasAttribute('contenteditable') && start_node.getAttribute('contenteditable') === 'false' || start_node.parentNode && start_node.parentNode.hasAttribute('contenteditable') && start_node.parentNode.getAttribute('contenteditable') === 'false') {
        if (start_node.nextSibling && $(start_node.nextSibling).hasClass('fr-marker')) {
          return;
        } else if (start_node.nextSibling) {
          _processNodeFormat(start_node.nextSibling, tag, attrs);

          return;
        } else if (start_node.parentNode) {
          _processNodeFormat(start_node.parentNode, tag, attrs);

          return;
        }
      } // Skip comments.


      while (start_node.nodeType === Node.COMMENT_NODE) {
        start_node = start_node.nextSibling;
      } // No start node.


      if (!start_node) {
        return;
      } // If we are in a block process starting with the first child.


      if (editor.node.isBlock(start_node) && start_node.tagName !== 'HR') {
        if (editor.node.hasClass(start_node.firstChild, 'fr-marker')) {
          _processNodeFormat(start_node.firstChild.nextSibling, tag, attrs);
        } else {
          _processNodeFormat(start_node.firstChild, tag, attrs);
        }

        return false;
      } // Create new element.


      var $span = $(editor.doc.createElement(tag));
      $span.attr(attrs);
      $span.insertBefore(start_node); // Apply style for the parent when the parent element is a list item.

      parent_li_node = _getStyleApplicableLI(start_node);

      if (parent_li_node && (['strong', 'em'].indexOf(tag) >= 0 || tag === 'span' && attrs.hasOwnProperty('style'))) {
        if (tag === 'span') {
          style_alt_for_tags = attrs.style.replace(/;$/, '').split(':');
          prop = style_alt_for_tags[0].trim();
          val = style_alt_for_tags[1].trim();
        } else {
          prop = style_alt_for_tags[tag].prop;
          val = style_alt_for_tags[tag].val;
        } // Style will not be applied to the parent list element,  if it is the background-color style
        // as it is not making any effect on bullets in HTML.


        if (prop !== 'background-color') {
          $(parent_li_node).css(prop, val);

          _keepDefaultStylesForSubElements(parent_li_node, prop);
        }
      } // Start with the next sibling of the current node.


      var node = start_node; // Search while there is a next node.
      // Next node is not marker.
      // Next node does not contain marker.
      // Next node is not an inner list.

      while (node && !$(node).hasClass('fr-marker') && $(node).find('.fr-marker').length === 0 && node.tagName !== 'UL' && node.tagName !== 'OL') {
        var tmp = node; // Check for Track Changes deleted content

        if (node.tagName === 'SPAN' && $(node).hasClass('fr-tracking-deleted')) {
          node = node.nextSibling;
          continue;
        }

        if (editor.node.isBlock(node) && start_node.tagName !== 'HR') {
          _processNodeFormat(node.firstChild, tag, attrs);

          return false;
        } // merged conflict from master, kept both changes


        if (node.tagName === 'SPAN') {
          _processNodeFormat(node.firstChild, tag, attrs);

          return false;
        } // https://github.com/froala-labs/froala-editor-js-2/issues/2353


        if (node.tagName && node.hasAttribute('contenteditable') && node.getAttribute('contenteditable') === 'false') {
          _processNodeFormat(node.nextSibling, tag, attrs);

          return;
        } // till here


        node = node.nextSibling;
        $span.append(tmp);
      } // If there is no node left at the right look at parent siblings.


      if (!node) {
        var p_node = $span.get(0).parentNode;

        while (p_node && !p_node.nextSibling && !editor.node.isElement(p_node)) {
          p_node = p_node.parentNode;
        }

        if (p_node) {
          var sibling = p_node.nextSibling;

          if (sibling) {
            // Parent sibling is block then look next.
            if (!editor.node.isBlock(sibling)) {
              _processNodeFormat(sibling, tag, attrs);
            } else if (sibling.tagName === 'HR') {
              _processNodeFormat(sibling.nextSibling, tag, attrs);
            } else {
              _processNodeFormat(sibling.firstChild, tag, attrs);
            }
          }
        }
      } // Start processing child nodes if there is a marker or an inner list.
      else if ($(node).find('.fr-marker').length || node.tagName === 'UL' || node.tagName === 'OL') {
        _processNodeFormat(node.firstChild, tag, attrs);
      }

      if ($span.is(':empty')) {
        $span.remove();
      }
    }
    /**
     * Apply tag format.
     */


    function apply(tag, attrs) {
      var i;

      if (typeof attrs === 'undefined') {
        attrs = {};
      }

      if (attrs.style) {
        delete attrs.style;
      } // Selection is collapsed.


      if (editor.selection.isCollapsed()) {
        editor.markers.insert();
        var $marker = editor.$el.find('.fr-marker');
        $marker.replaceWith(_openTag(tag, attrs) + FroalaEditor.INVISIBLE_SPACE + FroalaEditor.MARKERS + _closeTag(tag));
        editor.selection.restore();
      } // Selection is not collapsed.
      else {
        editor.selection.save(); // Check if selection can be deleted.

        var start_marker = editor.$el.find('.fr-marker[data-type="true"]').length && editor.$el.find('.fr-marker[data-type="true"]').get(0).nextSibling;

        _processNodeFormat(start_marker, tag, attrs); // Clean inner spans.


        var inner_spans;

        do {
          inner_spans = editor.$el.find("".concat(_query(tag, attrs), " > ").concat(_query(tag, attrs)));

          for (i = 0; i < inner_spans.length; i++) {
            inner_spans[i].outerHTML = inner_spans[i].innerHTML;
          }
        } while (inner_spans.length);

        editor.el.normalize(); // Have markers inside the new tag.

        var markers = editor.el.querySelectorAll('.fr-marker');

        for (i = 0; i < markers.length; i++) {
          var $mk = $(markers[i]);

          if ($mk.data('type') === true) {
            if (_matches($mk.get(0).nextSibling, _query(tag, attrs))) {
              $mk.next().prepend($mk);
            }
          } else if (_matches($mk.get(0).previousSibling, _query(tag, attrs))) {
            $mk.prev().append($mk);
          }
        }

        editor.selection.restore();
      }
    }
    /**
     * Split at current node the parents with tag.
     */


    function _split($node, tag, attrs, collapsed) {
      if (!collapsed) {
        var changed = false;

        if ($node.data('type') === true) {
          while (editor.node.isFirstSibling($node.get(0)) && !$node.parent().is(editor.$el) && !$node.parent().is('ol') && !$node.parent().is('ul')) {
            $node.parent().before($node);
            changed = true;
          }
        } else if ($node.data('type') === false) {
          while (editor.node.isLastSibling($node.get(0)) && !$node.parent().is(editor.$el) && !$node.parent().is('ol') && !$node.parent().is('ul')) {
            $node.parent().after($node);
            changed = true;
          }
        }

        if (changed) {
          return true;
        }
      } // Check if current node has parents which match our tag.


      if ($node.parents(tag).length || typeof tag === 'undefined') {
        var close_str = '';
        var open_str = '';
        var $p_node = $node.parent();
        var p_html; // Do not split when parent is block.

        if ($p_node.is(editor.$el) || editor.node.isBlock($p_node.get(0))) {
          return false;
        } // Check undefined so that we.


        while (!editor.node.isBlock($p_node.parent().get(0)) && (typeof tag === 'undefined' || !_matches($p_node.get(0), _query(tag, attrs)))) {
          close_str += editor.node.closeTagString($p_node.get(0));
          open_str = editor.node.openTagString($p_node.get(0)) + open_str;
          $p_node = $p_node.parent();
        } // Node STR.


        var node_str = $node.get(0).outerHTML; // Replace node with marker.

        $node.replaceWith('<span id="mark"></span>'); // Rebuild the HTML for the node.

        p_html = $p_node.html().replace(/<span id="mark"><\/span>/, close_str + editor.node.closeTagString($p_node.get(0)) + open_str + node_str + close_str + editor.node.openTagString($p_node.get(0)) + open_str);
        $p_node.replaceWith(editor.node.openTagString($p_node.get(0)) + p_html + editor.node.closeTagString($p_node.get(0)));
        return true;
      }

      return false;
    }
    /**
     * Process node remove.
     */


    function _processNodeRemove($node, should_remove, tag, attrs) {
      var parent_li_node;
      var style_alt_for_tags = {
        strong: {
          prop: 'font-weight',
          val: 'bold'
        },
        em: {
          prop: 'font-style',
          val: 'italic'
        }
      }; // Get contents.

      var contents = editor.node.contents($node.get(0)); // Loop contents.

      for (var i = 0; i < contents.length; i++) {
        var node = contents[i]; // https://github.com/froala-labs/froala-editor-js-2/issues/1954
        // https://github.com/froala-labs/froala-editor-js-2/issues/2644
        // https://github.com/froala-labs/froala-editor-js-2/issues/2770
        // Remove node if it contains zero-width space character only.

        if (node.innerHTML && node.innerHTML.charCodeAt() == 8203 && node.tagName.toLocaleLowerCase() == tag && node.childNodes.length < 2 && !editor.helpers.isMobile()) {
          node.outerHTML = node.innerHTML;
        } // We found a marker => change should_remove flag.


        if (editor.node.hasClass(node, 'fr-marker')) {
          should_remove = (should_remove + 1) % 2;
        } // We should remove.
        else if (should_remove) {
          // Check if we have a marker inside it.
          if ($(node).find('.fr-marker').length > 0) {
            should_remove = _processNodeRemove($(node), should_remove, tag, attrs);
          } // Remove everything starting with the most inner nodes which match the current selector.
          else {
            // Clear the style for the parent list item.
            parent_li_node = node.tagName === 'LI' ? node : $(node).parentsUntil(editor.$el, 'li').get(0);

            if (parent_li_node && (typeof tag === 'undefined' || ['strong', 'em'].indexOf(tag) >= 0)) {
              if (tag) {
                $(parent_li_node).css(style_alt_for_tags[tag].prop, '');
              } else {
                parent_li_node.style = '';
              }
            } // https://github.com/froala-labs/froala-editor-js-2/issues/2916


            parent_li_node = node.parentNode !== editor.el ? node.parentNode : null;

            if (parent_li_node && parent_li_node.nodeType === 1 && tag !== 'a' && parent_li_node.hasAttribute('style') && parent_li_node.tagName !== 'SPAN' && parent_li_node.tagName !== 'LI') {
              parent_li_node.style = '';
            } else if (node && node.nodeType === 1 && tag !== 'a' && node.hasAttribute('style')) {
              node.style = '';
            }

            var nodes = $(node).find(tag || '*:not(br)');

            for (var j = nodes.length - 1; j >= 0; j--) {
              var nd = nodes[j]; // Clear the style for the parent list item.

              parent_li_node = nd.tagName === 'LI' ? nd : $(nd).parentsUntil(editor.$el, 'li').get(0);

              if (parent_li_node && (!tag || ['strong', 'em'].indexOf(tag) >= 0)) {
                if (tag) {
                  $(parent_li_node).css(style_alt_for_tags[tag].prop, '');
                } else {
                  parent_li_node.style = '';
                }
              }

              if (!editor.node.isBlock(nd) && !editor.node.isVoid(nd) && (typeof tag === 'undefined' || _matches(nd, _query(tag, attrs)))) {
                if (!editor.node.hasClass(nd, 'fr-clone') && !editor.node.hasClass(nd, 'fr-tracking-deleted') && !$(nd).data('tracking')) {
                  nd.outerHTML = nd.innerHTML;
                }
              } else if (editor.node.isBlock(nd) && typeof tag === 'undefined' && node.tagName !== 'TABLE') {
                editor.node.clearAttributes(nd);
              }
            } // Check inner nodes.


            if (typeof tag === 'undefined' && node.nodeType === Node.ELEMENT_NODE && !editor.node.isVoid(node) || _matches(node, _query(tag, attrs))) {
              if (!editor.node.isBlock(node)) {
                if (!editor.node.hasClass(node, 'fr-clone') && !editor.opts.trackChangesEnabled) {
                  node.outerHTML = node.innerHTML;
                } else if (!editor.node.hasClass(node, 'fr-clone') && editor.opts.trackChangesEnabled && node.parentNode) {
                  node.outerHTML = node.innerHTML;
                }
              }
            } // Remove formatting from block nodes.
            else if (typeof tag === 'undefined' && node.nodeType === Node.ELEMENT_NODE && editor.node.isBlock(node) && node.tagName !== 'TABLE') {
              editor.node.clearAttributes(node);
            }
          }
        } else {
          // There is a marker.
          if ($(node).find('.fr-marker').length > 0) {
            should_remove = _processNodeRemove($(node), should_remove, tag, attrs);
          }
        }
      }

      return should_remove;
    }
    /**
     * Remove tag.
     */


    function remove(tag, attrs) {
      if (typeof attrs === 'undefined') {
        attrs = {};
      }

      if (attrs.style) {
        delete attrs.style;
      }

      var collapsed = editor.selection.isCollapsed();
      editor.selection.save(); // Split at start and end marker.

      var reassess = true;

      while (reassess) {
        reassess = false;
        var markers = editor.$el.find('.fr-marker');

        for (var i = 0; i < markers.length; i++) {
          var $marker = $(markers[i]);
          var $clone = null;

          if (!$marker.attr('data-cloned') && !collapsed) {
            $clone = $marker.clone().removeClass('fr-marker').addClass('fr-clone');

            if ($marker.data('type') && $marker.data('type').toString() === 'true') {
              $marker.attr('data-cloned', true).after($clone);
            } else {
              $marker.attr('data-cloned', true).before($clone);
            }
          }

          if (_split($marker, tag, attrs, collapsed)) {
            reassess = true;
            break;
          }
        }
      } // Remove format between markers.


      _processNodeRemove(editor.$el, 0, tag, attrs); // Replace markers with their clones.


      if (!collapsed) {
        editor.$el.find('.fr-marker').remove();
        editor.$el.find('.fr-clone').removeClass('fr-clone').addClass('fr-marker');
      } // Selection is collapsed => add invisible spaces.


      if (collapsed) {
        editor.$el.find('.fr-marker').before(FroalaEditor.INVISIBLE_SPACE).after(FroalaEditor.INVISIBLE_SPACE);
      }

      editor.html.cleanEmptyTags();
      editor.el.normalize();
      editor.selection.restore(); // https://github.com/froala-labs/froala-editor-js-2/issues/2168

      var anchorNode = editor.win.getSelection() && editor.win.getSelection().anchorNode;

      if (anchorNode) {
        var blockParent = editor.node.blockParent(anchorNode);
        var multiSelection = anchorNode.textContent.replace(/\u200B/g, '').length ? true : false;

        var _editor$win$getSelect = editor.win.getSelection().getRangeAt(0),
            startOffset = _editor$win$getSelect.startOffset,
            endOffset = _editor$win$getSelect.endOffset; // Keep only one zero width space and remove all the other zero width spaces if selection consists of only zerowidth spaces.


        if (!editor.selection.text().replace(/\u200B/g, '').length) {
          removeZeroWidth(blockParent, anchorNode);
        }

        var range = editor.win.getSelection().getRangeAt(0); // Setting the range to the zerowidthspace index

        if (anchorNode.nodeType === Node.TEXT_NODE) {
          if (!multiSelection || !editor.selection.text().length && startOffset === endOffset) {
            var newOffset = anchorNode.textContent.search(/\u200B/g) + 1; // Fix for IE browser

            if (editor.browser.msie) {
              var tmprange = editor.doc.createRange();
              editor.selection.get().removeAllRanges();
              tmprange.setStart(anchorNode, newOffset);
              tmprange.setEnd(anchorNode, newOffset);
              editor.selection.get().addRange(tmprange);
            } else {
              range.setStart(anchorNode, newOffset);
              range.setEnd(anchorNode, newOffset);
            }
          }
        } else {
          var txtNodeToFocus;
          var tmpNode;
          var tmpIndex = 0;
          var tmpContents = $(anchorNode).contents(); // Fix for IE browser

          if (editor.browser.msie) {
            while (tmpNode = tmpContents[tmpIndex]) {
              if (tmpNode.nodeType === Node.TEXT_NODE && tmpNode.textContent.search(/\u200B/g) >= 0) {
                txtNodeToFocus = tmpNode;
              }

              tmpIndex++;
            }

            txtNodeToFocus = $(txtNodeToFocus);
          } else {
            txtNodeToFocus = tmpContents.filter(function (tmpNode) {
              return tmpNode.nodeType === Node.TEXT_NODE && tmpNode.textContent.search(/\u200B/g) >= 0;
            });
          }

          if (txtNodeToFocus.length && !editor.opts.trackChangesEnabled) {
            var _newOffset = txtNodeToFocus.text().search(/\u200B/g) + 1;

            range.setStart(txtNodeToFocus.get(0), _newOffset);
            range.setEnd(txtNodeToFocus.get(0), _newOffset);
          }
        }
      }
    } // Removes zerowidth spaces and keeps only one zero width space for the marker.


    function removeZeroWidth(blockParent, compareNode) {
      if (blockParent && compareNode) {
        if (blockParent.isSameNode(compareNode)) {
          // keeping only one zerowidth space if there are multiple
          blockParent.textContent = blockParent.textContent.replace(/\u200B(?=.*\u200B)/g, '');
        } else {
          if (blockParent.nodeType === Node.TEXT_NODE) blockParent.textContent = blockParent.textContent.replace(/\u200B/g, '');
        }

        if (!blockParent.childNodes.length) {
          return false;
        } else if (Array.isArray(blockParent.childNodes)) {
          blockParent.childNodes.forEach(function (node) {
            removeZeroWidth(node, compareNode);
          });
        }
      }
    }
    /**
     * Toggle format.
     */


    function toggle(tag, attrs) {
      if (is(tag, attrs)) {
        remove(tag, attrs);
      } else {
        apply(tag, attrs);
      }
    }
    /**
     * Clean format.
     */


    function _cleanFormat(elem, prop) {
      var $elem = $(elem);
      $elem.css(prop, '');

      if ($elem.attr('style') === '') {
        $elem.replaceWith($elem.html());
      }
    }
    /**
     * Filter spans with specific property.
     */


    function _filterSpans(elem, prop) {
      return $(elem).attr('style').indexOf("".concat(prop, ":")) === 0 || $(elem).attr('style').indexOf(";".concat(prop, ":")) >= 0 || $(elem).attr('style').indexOf("; ".concat(prop, ":")) >= 0;
    }
    /**
     * Apply inline style.
     */


    function applyStyle(prop, val) {
      var i;
      var $marker;
      var $span = null;
      var parent_li_node;
      var inner_spans; // Selection is collapsed.

      if (editor.selection.isCollapsed()) {
        editor.markers.insert();
        $marker = editor.$el.find('.fr-marker');
        var $parent = $marker.parent(); // https://github.com/froala/wysiwyg-editor/issues/1084

        if (editor.node.openTagString($parent.get(0)) === "<span style=\"".concat(prop, ": ").concat($parent.css(prop), ";\">")) {
          if (editor.node.isEmpty($parent.get(0))) {
            $span = $(editor.doc.createElement('span')).attr('style', "".concat(prop, ": ").concat(val, ";")).html("".concat(FroalaEditor.INVISIBLE_SPACE).concat(FroalaEditor.MARKERS));
            $parent.replaceWith($span);
          } // We should get out of the current span with the same props.
          else {
            var x = {};
            x['style*'] = "".concat(prop, ":");

            _split($marker, 'span', x, true);

            $marker = editor.$el.find('.fr-marker');

            if (val) {
              $span = $(editor.doc.createElement('span')).attr('style', "".concat(prop, ": ").concat(val, ";")).html("".concat(FroalaEditor.INVISIBLE_SPACE).concat(FroalaEditor.MARKERS));
              $marker.replaceWith($span);
            } else {
              $marker.replaceWith(FroalaEditor.INVISIBLE_SPACE + FroalaEditor.MARKERS);
            }
          }

          editor.html.cleanEmptyTags();
        } else if (editor.node.isEmpty($parent.get(0)) && $parent.is('span')) {
          $marker.replaceWith(FroalaEditor.MARKERS);
          $parent.css(prop, val);
        } else {
          $span = $("<span style=\"".concat(prop, ": ").concat(val, ";\">").concat(FroalaEditor.INVISIBLE_SPACE).concat(FroalaEditor.MARKERS, "</span>"));
          $marker.replaceWith($span);
        } // If we have a span, then split the parent nodes.


        if ($span) {
          _splitParents($span, prop, val);
        }
      } else {
        editor.selection.save(); // When removing selection we should make sure we have selection outside of the first/last parent node.
        // We also need to do this for U tags.

        if (val === null || prop === 'color' && editor.$el.find('.fr-marker').parents('u, a').length > 0) {
          var markers = editor.$el.find('.fr-marker');

          for (i = 0; i < markers.length; i++) {
            $marker = $(markers[i]);

            if ($marker.data('type') === true || $marker.data('type') === 'true') {
              while (editor.node.isFirstSibling($marker.get(0)) && !$marker.parent().is(editor.$el) && !editor.node.isElement($marker.parent().get(0)) && !editor.node.isBlock($marker.parent().get(0))) {
                $marker.parent().before($marker);
              }
            } else {
              while (editor.node.isLastSibling($marker.get(0)) && !$marker.parent().is(editor.$el) && !editor.node.isElement($marker.parent().get(0)) && !editor.node.isBlock($marker.parent().get(0))) {
                $marker.parent().after($marker);
              }
            }
          }
        } // Check if selection can be deleted.


        var start_marker = editor.$el.find('.fr-marker[data-type="true"]').get(0).nextSibling;

        while (start_marker.firstChild) {
          start_marker = start_marker.firstChild;
        }

        var attrs = {
          "class": 'fr-unprocessed'
        };

        if (val) {
          attrs.style = "".concat(prop, ": ").concat(val, ";");
        }

        _processNodeFormat(start_marker, 'span', attrs);

        editor.$el.find('.fr-marker + .fr-unprocessed').each(function () {
          $(this).prepend($(this).prev());
        });
        editor.$el.find('.fr-unprocessed + .fr-marker').each(function () {
          $(this).prev().append($(this));
        }); // When em are being used keep them as the most inner props.

        if ((val || '').match(/\dem$/)) {
          editor.$el.find('span.fr-unprocessed').removeClass('fr-unprocessed');
        }

        while (editor.$el.find('span.fr-unprocessed').length > 0) {
          $span = editor.$el.find('span.fr-unprocessed').first().removeClass('fr-unprocessed');
          parent_li_node = _getStyleApplicableLI($span); // Look at parent node to see if we can merge with it.

          $span.parent().get(0).normalize();

          if ($span.parent().is('span') && $span.parent().get(0).childNodes.length === 1) {
            var tempVal = val; // https://github.com/froala-labs/froala-editor-js-2/issues/3827

            if (editor.browser.msie && !val) {
              tempVal = '';
            }

            $span.parent().css(prop, tempVal);
            var $child = $span;
            $span = $span.parent();
            $child.replaceWith($child.html());
          } // Replace in reverse order to take care of the inner spans first.


          inner_spans = $span.find('span'); // Check if there is a valid parent list item, where the style is applied,
          // then clear the unnecessary spans inside that.

          if (parent_li_node && prop !== 'background-color') {
            parent_li_node.normalize();
            inner_spans = $(parent_li_node).find('span:not(.fr-unprocessed)');
          }

          for (i = inner_spans.length - 1; i >= 0; i--) {
            _cleanFormat(inner_spans[i], prop);
          } // Split parent nodes.


          _splitParents($span, prop, val);
        }
      }

      _normalize();
    }
    /**
       * Keep the initial style for the child elements.
       */


    function _keepDefaultStylesForSubElements(node, prop) {
      var childElements = node.childNodes;
      var i;

      for (i = 0; i < childElements.length; i++) {
        if (['UL', 'OL', 'LI'].indexOf(childElements[i].tagName) >= 0 && childElements[i].style[prop] === '') {
          $(childElements[i]).css(prop, 'initial');
        }
      }
    }
    /**
       * Get the parent list item, when the whole content inside is selected,
       * except the nested list elements if any.
       */


    function _getStyleApplicableLI(start_node) {
      var parent_li_node;
      var end_marker;
      var end_marker_parent_li_node;
      var end_marker_parent;
      var next_sibling;
      var li_node_info;
      parent_li_node = start_node.tagName === 'LI' ? start_node : $(start_node).parentsUntil(editor.$el, 'li').get(0);

      if (parent_li_node) {
        li_node_info = editor.selection.info(parent_li_node); // Return the parent list element if the whole content inside is selected.

        if (li_node_info.atStart && li_node_info.atEnd) {
          return parent_li_node;
        } else if (li_node_info.atStart && !li_node_info.atEnd) {
          end_marker = $(parent_li_node).find('.fr-marker[data-type=false]').get(0);
          end_marker_parent_li_node = $(end_marker).parentsUntil(editor.$el, 'li').get(0);
          end_marker_parent = $(end_marker).parent().get(0);
          next_sibling = end_marker.nextSibling; // Return the parent list element if the whole content inside is selected
          // except the nested elements.

          if (next_sibling && ['UL', 'OL'].indexOf(next_sibling.tagName) >= 0 || !end_marker_parent_li_node.isSameNode(parent_li_node) || !next_sibling && (end_marker_parent.tagName === 'LI' || !end_marker_parent.nextSibling || ['UL', 'OL'].indexOf(end_marker_parent.nextSibling.tagName) >= 0 || editor.node.isVoid(end_marker_parent.nextSibling))) {
            return parent_li_node;
          }
        }
      }

      return;
    }

    function _splitParents($span, prop, val) {
      var i; // Look at parents with the same property.

      var $outer_span = $span.parentsUntil(editor.$el, 'span[style]');
      var to_remove = [];

      for (i = $outer_span.length - 1; i >= 0; i--) {
        if (!_filterSpans($outer_span[i], prop)) {
          to_remove.push($outer_span[i]);
        }
      }

      $outer_span = $outer_span.not(to_remove);

      if ($outer_span.length) {
        var c_str = '';
        var o_str = '';
        var ic_str = '';
        var io_str = '';
        var c_node = $span.get(0);

        do {
          c_node = c_node.parentNode;
          $(c_node).addClass('fr-split');
          c_str += editor.node.closeTagString(c_node);
          o_str = editor.node.openTagString($(c_node).clone().addClass('fr-split').get(0)) + o_str; // Inner close and open.

          if ($outer_span.get(0) !== c_node) {
            ic_str += editor.node.closeTagString(c_node);
            io_str = editor.node.openTagString($(c_node).clone().addClass('fr-split').get(0)) + io_str;
          }
        } while ($outer_span.get(0) !== c_node); // Build breaking string.


        var str = "".concat(c_str + editor.node.openTagString($($outer_span.get(0)).clone().css(prop, val || '').get(0)) + io_str + $span.css(prop, '').get(0).outerHTML + ic_str, "</span>").concat(o_str);
        $span.replaceWith('<span id="fr-break"></span>');
        var html = $outer_span.get(0).outerHTML; // Replace the outer node.

        $($outer_span.get(0)).replaceWith(html.replace(/<span id="fr-break"><\/span>/g, function () {
          return str;
        }));
      }
    }

    function _normalize() {
      var i;

      while (editor.$el.find('.fr-split:empty').length > 0) {
        editor.$el.find('.fr-split:empty').remove();
      }

      editor.$el.find('.fr-split').removeClass('fr-split');
      editor.$el.find('[style=""]').removeAttr('style');
      editor.$el.find('[class=""]').removeAttr('class');
      editor.html.cleanEmptyTags();
      var $spans = editor.$el.find('span');

      for (var k = $spans.length - 1; k >= 0; k--) {
        var msp = $spans[k];

        if (!msp.attributes || msp.attributes.length === 0) {
          $(msp).replaceWith(msp.innerHTML);
        }
      }

      editor.el.normalize(); // Join current spans together if they are one next to each other.

      var just_spans = editor.$el.find('span[style] + span[style]');

      for (i = 0; i < just_spans.length; i++) {
        var $x = $(just_spans[i]);
        var $p = $(just_spans[i]).prev();

        if ($x.get(0).previousSibling === $p.get(0) && editor.node.openTagString($x.get(0)) === editor.node.openTagString($p.get(0))) {
          $x.prepend($p.html());
          $p.remove();
        }
      } // Check if we have span(font-size) inside span(background-color).
      // Then, make a split.


      editor.$el.find('span[style] span[style]').each(function () {
        if ($(this).attr('style').indexOf('font-size') >= 0) {
          var $parent = $(this).parents('span[style]'); // https://github.com/froala-labs/froala-editor-js-2/issues/3406

          if ($parent.attr('style') && $parent.attr('style').indexOf('background-color') >= 0) {
            $(this).attr('style', "".concat($(this).attr('style'), ";").concat($parent.attr('style')));

            _split($(this), 'span[style]', {}, false);
          }
        }
      });
      editor.el.normalize();
      editor.selection.restore();
    }
    /**
     * Remove inline style.
     */


    function removeStyle(prop) {
      applyStyle(prop, null);
    }
    /**
     * Get the current state.
     */


    function is(tag, attrs) {
      if (typeof attrs === 'undefined') {
        attrs = {};
      }

      if (attrs.style) {
        delete attrs.style;
      }

      var range = editor.selection.ranges(0);
      var el = range.startContainer;

      if (el.nodeType === Node.ELEMENT_NODE) {
        // Search for node deeper.
        if (el.childNodes.length > 0 && el.childNodes[range.startOffset]) {
          el = el.childNodes[range.startOffset];
        }
      } // If we are at the end of text node, then check next elements.


      if (!range.collapsed && el.nodeType === Node.TEXT_NODE && range.startOffset === (el.textContent || '').length) {
        while (!editor.node.isBlock(el.parentNode) && !el.nextSibling) {
          el = el.parentNode;
        }

        if (el.nextSibling) {
          el = el.nextSibling;
        }
      } // Check first childs.


      var f_child = el;

      while (f_child && f_child.nodeType === Node.ELEMENT_NODE && !_matches(f_child, _query(tag, attrs))) {
        f_child = f_child.firstChild;
      }

      if (f_child && f_child.nodeType === Node.ELEMENT_NODE && _matches(f_child, _query(tag, attrs))) {
        return true;
      } // Check parents.


      var p_node = el;

      if (p_node && p_node.nodeType !== Node.ELEMENT_NODE) {
        p_node = p_node.parentNode;
      }

      while (p_node && p_node.nodeType === Node.ELEMENT_NODE && p_node !== editor.el && !_matches(p_node, _query(tag, attrs))) {
        p_node = p_node.parentNode;
      }

      if (p_node && p_node.nodeType === Node.ELEMENT_NODE && p_node !== editor.el && _matches(p_node, _query(tag, attrs))) {
        return true;
      }

      return false;
    }

    return {
      is: is,
      toggle: toggle,
      apply: apply,
      remove: remove,
      applyStyle: applyStyle,
      removeStyle: removeStyle
    };
  };

  FroalaEditor.MODULES.spaces = function (editor) {
    function _normalizeNode(node, browser_way) {
      var p_node = node.previousSibling;
      var n_node = node.nextSibling;
      var txt = node.textContent;
      var parent_node = node.parentNode;
      var enterTags = ['P', 'DIV', 'BR'];
      var tagOptsValues = [FroalaEditor.ENTER_P, FroalaEditor.ENTER_DIV, FroalaEditor.ENTER_BR];

      if (editor.html.isPreformatted(parent_node)) {
        return;
      }

      if (browser_way) {
        txt = txt.replace(/[\f\n\r\t\v ]{2,}/g, ' '); // No node after.

        if ((!n_node || n_node.tagName === 'BR' || editor.node.isBlock(n_node)) && (editor.node.isBlock(parent_node) || editor.node.isLink(parent_node) && !parent_node.nextSibling || editor.node.isElement(parent_node))) {
          txt = txt.replace(/[\f\n\r\t\v ]{1,}$/g, '');
        }

        if ((!p_node || p_node.tagName === 'BR' || editor.node.isBlock(p_node)) && (editor.node.isBlock(parent_node) || editor.node.isLink(parent_node) && !parent_node.previousSibling || editor.node.isElement(parent_node))) {
          txt = txt.replace(/^[\f\n\r\t\v ]{1,}/g, '');
        } // https://github.com/froala/wysiwyg-editor/issues/3099


        if (editor.node.isBlock(n_node) || editor.node.isBlock(p_node)) {
          if (!p_node || p_node && p_node.tagName !== 'A') {
            txt = txt.replace(/^[\f\n\r\t\v ]{1,}/g, '');
          }
        } // https://github.com/froala/wysiwyg-editor/issues/1767 .


        if (txt === ' ' && (p_node && editor.node.isVoid(p_node) || n_node && editor.node.isVoid(n_node)) && !(p_node && n_node && editor.node.isVoid(p_node) || n_node && p_node && editor.node.isVoid(n_node))) {
          txt = '';
        }
      } // Collapse spaces when we have nested blocks.


      if ((!p_node && editor.node.isBlock(n_node) || !n_node && editor.node.isBlock(p_node)) && editor.node.isBlock(parent_node) && parent_node !== editor.el) {
        txt = txt.replace(/^[\f\n\r\t\v ]{1,}/g, '');
      } // Convert all non breaking to breaking spaces.


      if (!browser_way) {
        txt = txt.replace(new RegExp(FroalaEditor.UNICODE_NBSP, 'g'), ' ');
      }

      var new_text = '';

      for (var t = 0; t < txt.length; t++) {
        // Do not use unicodes next to void tags.
        // If prev node and next node tags are same use unicode
        // https://github.com/froala-labs/froala-editor-js-2/issues/3915
        if (txt.charCodeAt(t) == 32 && (t === 0 || new_text.charCodeAt(t - 1) == 32) && ((editor.opts.enter === FroalaEditor.ENTER_BR || editor.opts.enter === FroalaEditor.ENTER_DIV) && (p_node && p_node.tagName === 'BR' || n_node && n_node.tagName === 'BR') || p_node && n_node && p_node.tagName === n_node.tagName || !(p_node && n_node && editor.node.isVoid(p_node) || p_node && n_node && editor.node.isVoid(n_node)) || p_node && n_node && ['STRONG', 'U', 'EM'].indexOf(p_node.tagName) >= 0 && n_node.tagName === 'BR')) {
          new_text += FroalaEditor.UNICODE_NBSP;
        } else {
          new_text += txt[t];
        }
      } // https://github.com/froala-labs/froala-editor-js-2/issues/3998
      // replace tailing space with unicode as marker causes issue


      if (editor.browser.chrome && new_text.length > 1 && new_text.charCodeAt(new_text.length - 1) === 32 && (n_node && n_node.nextSibling && n_node.nextSibling.nextSibling && n_node.nextSibling.nextSibling.tagName === 'BR' || n_node && n_node.tagName === 'BR')) {
        new_text = new_text.substring(0, new_text.length - 1) + FroalaEditor.UNICODE_NBSP;
      } // Ending spaces should be NBSP or spaces before block tags.
      // 1. No node after. (and the parent node is block tag.)
      // 2. Next block is block tag.
      // 3. Next element has display block.


      if (!n_node || n_node && editor.node.isBlock(n_node) || n_node && n_node.nodeType === Node.ELEMENT_NODE && editor.win.getComputedStyle(n_node) && editor.win.getComputedStyle(n_node).display === 'block') {
        // OR(||) condition is for https://github.com/froala-labs/froala-editor-js-2/issues/1949
        if (!editor.node.isVoid(p_node) || p_node && enterTags.indexOf(p_node.tagName) !== -1 && tagOptsValues.indexOf(editor.opts.enter) !== -1) {
          new_text = new_text.replace(/ $/, FroalaEditor.UNICODE_NBSP);
        }
      } // Previous sibling is not void or block.


      if (p_node && !editor.node.isVoid(p_node) && !editor.node.isBlock(p_node)) {
        new_text = new_text.replace(/^\u00A0([^ $])/, ' $1'); // https://github.com/froala/wysiwyg-editor/issues/1355.

        if (new_text.length === 1 && new_text.charCodeAt(0) === 160 && n_node && !editor.node.isVoid(n_node) && !editor.node.isBlock(n_node)) {
          // https://github.com/froala-labs/froala-editor-js-2/issues/683
          // if new text is not surrounded by markers
          if (!(editor.node.hasClass(p_node, 'fr-marker') && editor.node.hasClass(n_node, 'fr-marker'))) {
            new_text = ' ';
          }
        }
      } // Convert middle nbsp to spaces.


      if (!browser_way) {
        new_text = new_text.replace(/([^ \u00A0])\u00A0([^ \u00A0])/g, '$1 $2');
      }

      if (node.textContent !== new_text) {
        node.textContent = new_text;
      }
    }

    function normalize(el, browser_way) {
      if (typeof el === 'undefined' || !el) {
        el = editor.el;
      }

      if (typeof browser_way === 'undefined') {
        browser_way = false;
      } // Ignore contenteditable.


      if (el.getAttribute && el.getAttribute('contenteditable') === 'false') {
        return;
      }

      if (el.nodeType === Node.TEXT_NODE) {
        _normalizeNode(el, browser_way);
      } else if (el.nodeType === Node.ELEMENT_NODE) {
        var walker = editor.doc.createTreeWalker(el, NodeFilter.SHOW_TEXT, editor.node.filter(function (node) {
          // Store the current parent node.
          var temp_node = node.parentNode; // Loop through the nodes to see if it is PRE tag, go to the highest parent until editable element.

          while (temp_node && temp_node !== editor.el) {
            if (temp_node.tagName === 'STYLE' || temp_node.tagName === 'IFRAME') {
              return false;
            }

            if (temp_node.tagName !== 'PRE') {
              // Check next parent.
              temp_node = temp_node.parentNode;
            } else {
              // If inside a PRE tag return false and move to next element.
              return false;
            }
          } // If not PRE tag start matching for chars that need to be removed from all other html tags.


          return node.textContent.match(/([ \u00A0\f\n\r\t\v]{2,})|(^[ \u00A0\f\n\r\t\v]{1,})|([ \u00A0\f\n\r\t\v]{1,}$)/g) !== null && !editor.node.hasClass(node.parentNode, 'fr-marker');
        }), false);

        while (walker.nextNode()) {
          _normalizeNode(walker.currentNode, browser_way);
        }
      }
    }

    function normalizeAroundCursor() {
      var nodes = [];
      var markers = editor.el.querySelectorAll('.fr-marker'); // Get the deep parent node of each marker.

      for (var i = 0; i < markers.length; i++) {
        var node = null;
        var p_node = editor.node.blockParent(markers[i]);

        if (p_node) {
          node = p_node;
        } else {
          node = markers[i];
        }

        var next_node = node.nextSibling;
        var prev_node = node.previousSibling;

        while (next_node && next_node.tagName === 'BR') {
          next_node = next_node.nextSibling;
        }

        while (prev_node && prev_node.tagName === 'BR') {
          prev_node = prev_node.previousSibling;
        } // Push current node, prev and next one.


        if (node && nodes.indexOf(node) < 0) {
          nodes.push(node);
        }

        if (prev_node && nodes.indexOf(prev_node) < 0) {
          nodes.push(prev_node);
        }

        if (next_node && nodes.indexOf(next_node) < 0) {
          nodes.push(next_node);
        }
      }

      for (var j = 0; j < nodes.length; j++) {
        normalize(nodes[j]);
      }
    }

    return {
      normalize: normalize,
      normalizeAroundCursor: normalizeAroundCursor
    };
  };

  FroalaEditor.INVISIBLE_SPACE = '&#8203;';
  FroalaEditor.START_MARKER = "<span class=\"fr-marker\" data-id=\"0\" data-type=\"true\" style=\"display: none; line-height: 0;\">".concat(FroalaEditor.INVISIBLE_SPACE, "</span>");
  FroalaEditor.END_MARKER = "<span class=\"fr-marker\" data-id=\"0\" data-type=\"false\" style=\"display: none; line-height: 0;\">".concat(FroalaEditor.INVISIBLE_SPACE, "</span>");
  FroalaEditor.MARKERS = FroalaEditor.START_MARKER + FroalaEditor.END_MARKER;

  FroalaEditor.MODULES.markers = function (editor) {
    var $ = editor.$;
    /**
     * Build marker element.
     */

    function _build(marker, id) {
      var $span = $(editor.doc.createElement('SPAN'));
      $span.addClass('fr-marker').attr('data-id', id).attr('data-type', marker).attr('style', "display: ".concat(editor.browser.safari ? 'none' : 'inline-block', "; line-height: 0;")).html(FroalaEditor.INVISIBLE_SPACE);
      return $span.get(0);
    }
    /**
     * Place marker.
     */


    function place(range, marker, id) {
      var mk;
      var contents;
      var sibling;

      try {
        var boundary = range.cloneRange();
        boundary.collapse(marker);
        boundary.insertNode(_build(marker, id));

        if (marker === true) {
          mk = editor.$el.find("span.fr-marker[data-type=\"true\"][data-id=\"".concat(id, "\"]")).get(0);
          sibling = mk.nextSibling; // Clean empty spaces.

          while (sibling && sibling.nodeType === Node.TEXT_NODE && sibling.textContent.length === 0) {
            $(sibling).remove();
            sibling = mk.nextSibling;
          }
        }

        if (marker === true && !range.collapsed) {
          // Move markers outside of something like this:
          // <p><strong>fooM</strong>bar</p>
          while (!editor.node.isElement(mk.parentNode) && !sibling) {
            // https://github.com/froala-labs/froala-editor-js-2/issues/2164
            // Here as sibling is null if fr-marker is a child of a tag which dont have any text or child
            // then code '$(mk.parentNode).after(mk)' will skip the node completely. This is unexpected in
            // case of parentNode having fontawesome icon. As per the ticket only handling for fontawesome
            // added using 'I' tag.
            if (/\bfa\b/g.test(mk.parentNode.className) > -1 && mk.parentNode.tagName === 'I') {
              $(mk.parentNode).before(mk);
            } else {
              $(mk.parentNode).after(mk);
            }

            sibling = mk.nextSibling;
          }

          if (sibling && sibling.nodeType === Node.ELEMENT_NODE && editor.node.isBlock(sibling) && sibling.tagName !== 'HR') {
            // Place the marker deep inside the block tags.
            contents = [sibling];

            do {
              sibling = contents[0];
              contents = editor.node.contents(sibling);
            } while (contents[0] && editor.node.isBlock(contents[0]));

            $(sibling).prepend($(mk));
          }
        }

        if (marker === false && !range.collapsed) {
          mk = editor.$el.find("span.fr-marker[data-type=\"false\"][data-id=\"".concat(id, "\"]")).get(0);
          sibling = mk.previousSibling;

          if (sibling && sibling.nodeType === Node.ELEMENT_NODE && editor.node.isBlock(sibling) && sibling.tagName !== 'HR') {
            // Place the marker deep inside the block tags.
            contents = [sibling];

            do {
              sibling = contents[contents.length - 1];
              contents = editor.node.contents(sibling);
            } while (contents[contents.length - 1] && editor.node.isBlock(contents[contents.length - 1]));

            $(sibling).append($(mk));
          } // https://github.com/froala/wysiwyg-editor/issues/705
          // https://github.com/froala-labs/froala-editor-js-2/issues/854


          if (mk.parentNode && ['TD', 'TH'].indexOf(mk.parentNode.tagName) >= 0 || !mk.previousSibling && editor.node.isBlock(mk.parentElement)) {
            if (mk.parentNode.previousSibling && !mk.previousSibling) {
              $(mk.parentNode.previousSibling).append(mk);
            } // https://github.com/froala-labs/froala-editor-js-2/issues/2738
            // Check if the end marker is inserted inside a TD/TH and marker is the first child
            // Then move the marker to the end of previous valid node
            else if (['TD', 'TH'].indexOf(mk.parentNode.tagName) >= 0 && mk.parentNode.firstChild === mk) {
              if (mk.parentNode.previousSibling) {
                $(mk.parentNode.previousSibling).append(mk);
              } else if (mk.parentNode.parentNode && mk.parentNode.parentNode.previousSibling) {
                $(mk.parentNode.parentNode.previousSibling).append(mk);
              }
            }
          }
        }

        var dom_marker = editor.$el.find("span.fr-marker[data-type=\"".concat(marker, "\"][data-id=\"").concat(id, "\"]")).get(0); // If image is at the top of the editor in an empty P
        // and floated to right, the text will be pushed down
        // when trying to insert an image.

        if (dom_marker) {
          dom_marker.style.display = 'none';
        }

        return dom_marker;
      } catch (ex) {
        return null;
      }
    }
    /**
     * Insert a single marker.
     */


    function insert() {
      if (!editor.$wp) {
        return null;
      }

      try {
        var range = editor.selection.ranges(0);
        var container = range.commonAncestorContainer; // Check if selection is inside editor.

        if (container !== editor.el && !editor.$el.contains(container)) {
          return null;
        }

        var boundary = range.cloneRange();
        var original_range = range.cloneRange();
        boundary.collapse(true);
        var mk = $(editor.doc.createElement('SPAN')).addClass('fr-marker').attr('style', 'display: none; line-height: 0;').html(FroalaEditor.INVISIBLE_SPACE).get(0);
        boundary.insertNode(mk);
        mk = editor.$el.find('span.fr-marker').get(0);

        if (mk) {
          var sibling = mk.nextSibling;

          while (sibling && sibling.nodeType === Node.TEXT_NODE && sibling.textContent.length === 0) {
            $(sibling).remove();
            sibling = editor.$el.find('span.fr-marker').get(0).nextSibling;
          } // Keep original selection.


          editor.selection.clear();
          editor.selection.get().addRange(original_range);
          return mk;
        }

        return null;
      } catch (ex) {
        console.warn('MARKER', ex);
      }
    }
    /**
     * Split HTML at the marker position.
     */


    function split() {
      if (!editor.selection.isCollapsed()) {
        editor.selection.remove();
      }

      var marker = editor.$el.find('.fr-marker').get(0);

      if (!marker) {
        marker = insert();
      }

      if (!marker) {
        return null;
      }

      var deep_parent = editor.node.deepestParent(marker);

      if (!deep_parent) {
        deep_parent = editor.node.blockParent(marker);

        if (deep_parent && deep_parent.tagName !== 'LI') {
          deep_parent = null;
        }
      }

      if (deep_parent) {
        if (editor.node.isBlock(deep_parent) && editor.node.isEmpty(deep_parent)) {
          // https://github.com/froala/wysiwyg-editor/issues/1730.
          // https://github.com/froala/wysiwyg-editor/issues/1970.
          if (deep_parent.tagName === 'LI' && deep_parent.parentNode.firstElementChild === deep_parent && !editor.node.isEmpty(deep_parent.parentNode)) {
            $(deep_parent).append('<span class="fr-marker"></span>');
          } else {
            $(deep_parent).replaceWith('<span class="fr-marker"></span>');
          }
        } else if (editor.cursor.isAtStart(marker, deep_parent)) {
          $(deep_parent).before('<span class="fr-marker"></span>');
          $(marker).remove();
        } else if (editor.cursor.isAtEnd(marker, deep_parent)) {
          $(deep_parent).after('<span class="fr-marker"></span>');
          $(marker).remove();
        } else {
          var node = marker;
          var close_str = '';
          var open_str = '';

          do {
            node = node.parentNode;
            close_str += editor.node.closeTagString(node);
            open_str = editor.node.openTagString(node) + open_str;
          } while (node !== deep_parent);

          $(marker).replaceWith('<span id="fr-break"></span>');
          var h = editor.node.openTagString(deep_parent) + $(deep_parent).html() + editor.node.closeTagString(deep_parent);
          h = h.replace(/<span id="fr-break"><\/span>/g, "".concat(close_str, "<span class=\"fr-marker\"></span>").concat(open_str));
          $(deep_parent).replaceWith(h);
        }
      }

      return editor.$el.find('.fr-marker').get(0);
    }
    /**
     * Insert marker at point from event.
     *
     * http://stackoverflow.com/questions/11191136/set-a-selection-range-from-a-to-b-in-absolute-position
     * https://developer.mozilla.org/en-US/docs/Web/API/this.document.caretPositionFromPoint
     */


    function insertAtPoint(e) {
      var x = e.clientX;
      var y = e.clientY; // Clear markers.

      remove();
      var start;
      var range = null; // Default.

      if (typeof editor.doc.caretPositionFromPoint !== 'undefined') {
        start = editor.doc.caretPositionFromPoint(x, y);
        range = editor.doc.createRange();
        range.setStart(start.offsetNode, start.offset);
        range.setEnd(start.offsetNode, start.offset);
      } // Webkit.
      else if (typeof editor.doc.caretRangeFromPoint !== 'undefined') {
        start = editor.doc.caretRangeFromPoint(x, y);
        range = editor.doc.createRange();
        range.setStart(start.startContainer, start.startOffset);
        range.setEnd(start.startContainer, start.startOffset);
      } // Set ranges.


      if (range !== null && typeof editor.win.getSelection !== 'undefined') {
        var sel = editor.win.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } // MSIE.
      else if (typeof editor.doc.body.createTextRange !== 'undefined') {
        try {
          range = editor.doc.body.createTextRange();
          range.moveToPoint(x, y);
          var end_range = range.duplicate();
          end_range.moveToPoint(x, y);
          range.setEndPoint('EndToEnd', end_range);
          range.select();
        } catch (ex) {
          return false;
        }
      }

      insert();
    }
    /**
     * Remove markers.
     */


    function remove() {
      editor.$el.find('.fr-marker').remove();
    }

    return {
      place: place,
      insert: insert,
      split: split,
      insertAtPoint: insertAtPoint,
      remove: remove
    };
  };

  FroalaEditor.MODULES.selection = function (editor) {
    var $ = editor.$;
    /**
     * Get selection text.
     */

    function text() {
      var text = '';

      if (editor.win.getSelection) {
        text = editor.win.getSelection();
      } else if (editor.doc.getSelection) {
        text = editor.doc.getSelection();
      } else if (editor.doc.selection) {
        text = editor.doc.selection.createRange().text;
      }

      return text.toString();
    }
    /**
     * Get the selection object.
     */


    function get() {
      var selection = '';

      if (editor.win.getSelection) {
        selection = editor.win.getSelection();
      } else if (editor.doc.getSelection) {
        selection = editor.doc.getSelection();
      } else {
        selection = editor.doc.selection.createRange();
      }

      return selection;
    }
    /**
     * Get the selection ranges or a single range at a specified index.
     */


    function ranges(index) {
      var sel = get();
      var ranges = []; // Get ranges.

      if (sel && sel.getRangeAt && sel.rangeCount) {
        ranges = [];

        for (var i = 0; i < sel.rangeCount; i++) {
          ranges.push(sel.getRangeAt(i));
        }
      } else if (editor.doc.createRange) {
        ranges = [editor.doc.createRange()];
      } else {
        ranges = [];
      }

      return typeof index !== 'undefined' ? ranges[index] : ranges;
    }
    /**
     * Clear selection.
     */


    function clear() {
      var sel = get();

      try {
        if (sel.removeAllRanges) {
          sel.removeAllRanges();
        } else if (sel.empty) {
          // IE?
          sel.empty();
        } else if (sel.clear) {
          sel.clear();
        }
      } catch (ex) {// ok.
      }
    }
    /**
     * Selection element.
     */


    function element() {
      var sel = get();

      try {
        if (sel.rangeCount) {
          var range = ranges(0);
          var node = range.startContainer;
          var child; // When selection starts in element, look deeper.

          if (editor.node.isElement(node) && range.startOffset === 0 && node.childNodes.length) {
            while (node.childNodes.length && node.childNodes[0].nodeType === Node.ELEMENT_NODE) {
              node = node.childNodes[0];
            }
          } // https://github.com/froala/wysiwyg-editor/issues/1399.


          if (node.nodeType === Node.TEXT_NODE && range.startOffset === (node.textContent || '').length && node.nextSibling) {
            node = node.nextSibling;
          } // Get parrent if node type is not DOM.


          if (node.nodeType === Node.ELEMENT_NODE) {
            var node_found = false; // Search for node deeper.

            if (node.childNodes.length > 0 && node.childNodes[range.startOffset]) {
              child = node.childNodes[range.startOffset]; // Ignore empty elements.

              while (child && child.nodeType === Node.TEXT_NODE && child.textContent.length === 0) {
                child = child.nextSibling;
              }

              if (child && child.textContent.replace(/\u200B/g, '') === text().replace(/\u200B/g, '')) {
                node = child;
                node_found = true;
              } // Look back maybe me missed something.


              if (!node_found && node.childNodes.length > 1 && range.startOffset > 0 && node.childNodes[range.startOffset - 1]) {
                child = node.childNodes[range.startOffset - 1];

                while (child && child.nodeType === Node.TEXT_NODE && child.textContent.length === 0) {
                  child = child.nextSibling;
                }

                if (child && child.textContent.replace(/\u200B/g, '') === text().replace(/\u200B/g, '')) {
                  node = child;
                  node_found = true;
                }
              }
            } // Selection starts just at the end of the node.
            else if (!range.collapsed && node.nextSibling && node.nextSibling.nodeType === Node.ELEMENT_NODE) {
              child = node.nextSibling;

              if (child && child.textContent.replace(/\u200B/g, '') === text().replace(/\u200B/g, '')) {
                node = child;
                node_found = true;
              }
            }

            if (!node_found && node.childNodes.length > 0 && $(node.childNodes[0]).text().replace(/\u200B/g, '') === text().replace(/\u200B/g, '') && ['BR', 'IMG', 'HR'].indexOf(node.childNodes[0].tagName) < 0) {
              node = node.childNodes[0];
            }
          } // https://github.com/froala-labs/froala-editor-js-2/issues/3855


          while (node.nodeType !== Node.ELEMENT_NODE && node.parentNode || node.nodeType === Node.ELEMENT_NODE && node.nodeName === 'BR' && node.parentNode) {
            node = node.parentNode;
          } // Make sure the node is in editor.


          var p = node;

          while (p && p.tagName !== 'HTML') {
            if (p === editor.el) {
              return node;
            }

            p = $(p).parent()[0];
          }
        }
      } catch (ex) {// ok.
      }

      return editor.el;
    }
    /**
     * Selection element.
     */


    function endElement() {
      var sel = get();

      try {
        if (sel.rangeCount) {
          var range = ranges(0);
          var node = range.endContainer;
          var child; // Get parrent if node type is not DOM.

          if (node.nodeType === Node.ELEMENT_NODE) {
            var node_found = false; // Search for node deeper.

            if (node.childNodes.length > 0 && node.childNodes[range.endOffset] && $(node.childNodes[range.endOffset]).text() === text()) {
              node = node.childNodes[range.endOffset];
              node_found = true;
            } // Selection starts just at the end of the node.
            else if (!range.collapsed && node.previousSibling && node.previousSibling.nodeType === Node.ELEMENT_NODE) {
              child = node.previousSibling;

              if (child && child.textContent.replace(/\u200B/g, '') === text().replace(/\u200B/g, '')) {
                node = child;
                node_found = true;
              }
            } // Browser sees selection at the beginning of the next node.
            else if (!range.collapsed && node.childNodes.length > 0 && node.childNodes[range.endOffset]) {
              child = node.childNodes[range.endOffset].previousSibling;

              if (child.nodeType === Node.ELEMENT_NODE) {
                if (child && child.textContent.replace(/\u200B/g, '') === text().replace(/\u200B/g, '')) {
                  node = child;
                  node_found = true;
                }
              }
            }

            if (!node_found && node.childNodes.length > 0 && $(node.childNodes[node.childNodes.length - 1]).text() === text() && ['BR', 'IMG', 'HR'].indexOf(node.childNodes[node.childNodes.length - 1].tagName) < 0) {
              node = node.childNodes[node.childNodes.length - 1];
            }
          }

          if (node.nodeType === Node.TEXT_NODE && range.endOffset === 0 && node.previousSibling && node.previousSibling.nodeType === Node.ELEMENT_NODE) {
            node = node.previousSibling;
          }

          while (node.nodeType !== Node.ELEMENT_NODE && node.parentNode) {
            node = node.parentNode;
          } // Make sure the node is in editor.


          var p = node;

          while (p && p.tagName !== 'HTML') {
            if (p === editor.el) {
              return node;
            }

            p = $(p).parent()[0];
          }
        }
      } catch (ex) {// ok.
      }

      return editor.el;
    }
    /**
     * Get the ELEMENTS node where the selection starts.
     * By default TEXT node might be selected.
     */


    function rangeElement(rangeContainer, offset) {
      var node = rangeContainer;

      if (node.nodeType === Node.ELEMENT_NODE) {
        // Search for node deeper.
        if (node.childNodes.length > 0 && node.childNodes[offset]) {
          node = node.childNodes[offset];
        }
      }

      if (node.nodeType === Node.TEXT_NODE) {
        node = node.parentNode;
      }

      return node;
    }
    /**
     * Search for the current selected blocks.
     */


    function blocks(toggleList) {
      var blks = [];
      var i;
      var block_parent;
      var sel = get(); // Selection must be inside editor.

      if (inEditor() && sel.rangeCount) {
        // Loop through ranges.
        var rngs = ranges();

        for (i = 0; i < rngs.length; i++) {
          var range = rngs[i]; // Get start node and end node for range.

          var start_node = rangeElement(range.startContainer, range.startOffset);
          var end_node = rangeElement(range.endContainer, range.endOffset); // Check for the parent node of the start node.

          block_parent = editor.node.blockParent(start_node);

          if (block_parent && blks.indexOf(block_parent) < 0) {
            blks.push(block_parent);
          } // Add the start node.


          if ((editor.node.isBlock(start_node) || editor.node.hasClass(start_node, 'fr-inner')) && blks.indexOf(start_node) < 0) {
            blks.push(start_node);
          } // Do not add nodes where we've been once.


          var was_into = []; // Loop until we reach end.

          var next_node = start_node;

          while (next_node !== end_node && next_node !== editor.el) {
            // Get deeper into the current node.
            if (was_into.indexOf(next_node) < 0 && next_node.children && next_node.children.length) {
              was_into.push(next_node);
              next_node = next_node.children[0];
            } // Get next sibling.
            else if (next_node.nextSibling) {
              next_node = next_node.nextSibling;
            } // Get parent node.
            else if (next_node.parentNode) {
              next_node = next_node.parentNode;
              was_into.push(next_node);
            } // Add node to the list.


            if (editor.node.isBlock(next_node) && was_into.indexOf(next_node) < 0 && blks.indexOf(next_node) < 0) {
              if (next_node !== end_node || range.endOffset > 0) {
                blks.push(next_node);
              }
            }
          } // Add the end node.


          if (editor.node.isBlock(end_node) && blks.indexOf(end_node) < 0 && range.endOffset > 0) {
            blks.push(end_node);
          } // Check for the parent node of the end node.


          block_parent = editor.node.blockParent(end_node);

          if (block_parent && blks.indexOf(block_parent) < 0) {
            blks.push(block_parent);
          }
        }
      } // Remove blocks that we don't need.


      for (i = blks.length - 1; i > 0; i--) {
        // https://github.com/froala-labs/froala-editor-js-2/issues/3197
        // Nodes that contain another node. Don't do it for LI, but remove them if there is a single child and has format.
        if ($(blks[i - 1]).contains(blks[i])) {
          // While toggle list type, include the node if it contains a UL/OL element
          if (toggleList && $(blks[i]).find('ul, ol').length) {
            continue;
          }

          blks.splice(i - 1, 1);
        } else if ($(blks[i]).contains(blks[i - 1])) {
          // While toggle list type, include the node if it contains a UL/OL element
          if (toggleList && $(blks[i]).find('ul, ol').length) {
            continue;
          }

          blks.splice(i, 1);
        }
      }

      return blks;
    }
    /**
     * Save selection.
     */


    function save() {
      if (editor.$wp) {
        editor.markers.remove();
        var rgs = ranges();
        var new_ranges = [];
        var range;
        var i;

        for (i = 0; i < rgs.length; i++) {
          // 2nd condition is for https://github.com/froala/wysiwyg-editor/issues/1750.
          if (rgs[i].startContainer !== editor.doc || editor.browser.msie) {
            range = rgs[i];
            var collapsed = range.collapsed;
            var start_m = editor.markers.place(range, true, i); // Start.

            var end_m = editor.markers.place(range, false, i); // End.
            // Put selection at the end when there is no marker.

            if ((typeof start_m === 'undefined' || !start_m) && collapsed) {
              $('.fr-marker').remove();
              editor.selection.setAtEnd(editor.el);
            } // https://github.com/froala/wysiwyg-editor/issues/1398.


            editor.el.normalize();

            if (editor.browser.safari && !collapsed) {
              try {
                range = editor.doc.createRange();
                range.setStartAfter(start_m);
                range.setEndBefore(end_m);
                new_ranges.push(range);
              } catch (ex) {// Leave this empty.
              }
            }
          }
        }

        if (editor.browser.safari && new_ranges.length) {
          editor.selection.clear();

          for (i = 0; i < new_ranges.length; i++) {
            editor.selection.get().addRange(new_ranges[i]);
          }
        }
      }
    }
    /**
     * Restore selection.
     */


    function restore() {
      var i; // Get markers.

      var markers = editor.el.querySelectorAll('.fr-marker[data-type="true"]');

      if (!editor.$wp) {
        editor.markers.remove();
        return false;
      } // No markers.


      if (markers.length === 0) {
        return false;
      }

      if (editor.browser.msie || editor.browser.edge) {
        for (i = 0; i < markers.length; i++) {
          markers[i].style.display = 'inline-block';
        }
      } // Focus.


      if (!editor.core.hasFocus() && !editor.browser.msie && !editor.browser.webkit) {
        editor.$el.focus();
      }

      clear();
      var sel = get(); // Add ranges.

      for (i = 0; i < markers.length; i++) {
        var id = $(markers[i]).data('id');
        var start_marker = markers[i];
        var range = editor.doc.createRange();
        var end_marker = editor.$el.find(".fr-marker[data-type=\"false\"][data-id=\"".concat(id, "\"]"));

        if (editor.browser.msie || editor.browser.edge) {
          end_marker.css('display', 'inline-block');
        }

        var ghost = null; // Make sure there is an start marker.

        if (end_marker.length > 0) {
          end_marker = end_marker[0];

          try {
            // If we have markers one next to each other inside text, then we should normalize text by joining it.
            var special_case = false; // Clear empty text nodes.

            var s_node = start_marker.nextSibling;
            var tmp = null;

            while (s_node && s_node.nodeType === Node.TEXT_NODE && s_node.textContent.length === 0) {
              tmp = s_node;
              s_node = s_node.nextSibling;
              $(tmp).remove();
            }

            var e_node = end_marker.nextSibling;

            while (e_node && e_node.nodeType === Node.TEXT_NODE && e_node.textContent.length === 0) {
              tmp = e_node;
              e_node = e_node.nextSibling;
              $(tmp).remove();
            }

            if (start_marker.nextSibling === end_marker || end_marker.nextSibling === start_marker) {
              // Decide which is first and which is last between markers.
              var first_node = start_marker.nextSibling === end_marker ? start_marker : end_marker;
              var last_node = first_node === start_marker ? end_marker : start_marker; // Previous node.

              var prev_node = first_node.previousSibling;

              while (prev_node && prev_node.nodeType === Node.TEXT_NODE && prev_node.length === 0) {
                tmp = prev_node;
                prev_node = prev_node.previousSibling;
                $(tmp).remove();
              } // Normalize text before.


              if (prev_node && prev_node.nodeType === Node.TEXT_NODE) {
                while (prev_node && prev_node.previousSibling && prev_node.previousSibling.nodeType === Node.TEXT_NODE) {
                  prev_node.previousSibling.textContent += prev_node.textContent;
                  prev_node = prev_node.previousSibling;
                  $(prev_node.nextSibling).remove();
                }
              } // Next node.


              var next_node = last_node.nextSibling;

              while (next_node && next_node.nodeType === Node.TEXT_NODE && next_node.length === 0) {
                tmp = next_node;
                next_node = next_node.nextSibling;
                $(tmp).remove();
              } // Normalize text after.


              if (next_node && next_node.nodeType === Node.TEXT_NODE) {
                while (next_node && next_node.nextSibling && next_node.nextSibling.nodeType === Node.TEXT_NODE) {
                  next_node.nextSibling.textContent = next_node.textContent + next_node.nextSibling.textContent;
                  next_node = next_node.nextSibling;
                  $(next_node.previousSibling).remove();
                }
              }

              if (prev_node && (editor.node.isVoid(prev_node) || editor.node.isBlock(prev_node))) {
                prev_node = null;
              }

              if (next_node && (editor.node.isVoid(next_node) || editor.node.isBlock(next_node))) {
                next_node = null;
              } // Previous node and next node are both text.


              if (prev_node && next_node && prev_node.nodeType === Node.TEXT_NODE && next_node.nodeType === Node.TEXT_NODE) {
                // Remove markers.
                $(start_marker).remove();
                $(end_marker).remove(); // Save cursor position.

                var len = prev_node.textContent.length;
                prev_node.textContent += next_node.textContent;
                $(next_node).remove(); // Normalize spaces and fixed 3402.

                editor.spaces.normalize(prev_node); // Restore position.

                range.setStart(prev_node, len);
                range.setEnd(prev_node, len);
                special_case = true;
              } else if (!prev_node && next_node && next_node.nodeType === Node.TEXT_NODE) {
                // Remove markers.
                $(start_marker).remove();
                $(end_marker).remove(); // Normalize spaces.

                if (!editor.opts.htmlUntouched) {
                  editor.spaces.normalize(next_node);
                }

                ghost = $(editor.doc.createTextNode("\u200B")).get(0);
                $(next_node).before(ghost); // Restore position.

                range.setStart(next_node, 0);
                range.setEnd(next_node, 0);
                special_case = true;
              } else if (!next_node && prev_node && prev_node.nodeType === Node.TEXT_NODE) {
                // Remove markers.
                $(start_marker).remove();
                $(end_marker).remove(); // Normalize spaces.

                if (!editor.opts.htmlUntouched) {
                  editor.spaces.normalize(prev_node);
                }

                ghost = $(editor.doc.createTextNode("\u200B")).get(0);
                $(prev_node).after(ghost); // Restore position.

                range.setStart(prev_node, prev_node.textContent.length);
                range.setEnd(prev_node, prev_node.textContent.length);
                special_case = true;
              }
            }

            if (!special_case) {
              var x = void 0;
              var y = void 0; // DO NOT TOUCH THIS OR IT WILL BREAK!!!

              if ((editor.browser.chrome || editor.browser.edge) && start_marker.nextSibling === end_marker) {
                x = _normalizedMarker(end_marker, range, true) || range.setStartAfter(end_marker);
                y = _normalizedMarker(start_marker, range, false) || range.setEndBefore(start_marker);
              } else {
                if (start_marker.previousSibling === end_marker) {
                  start_marker = end_marker;
                  end_marker = start_marker.nextSibling;
                } // https://github.com/froala/wysiwyg-editor/issues/759


                if (!(end_marker.nextSibling && end_marker.nextSibling.tagName === 'BR') && !(!end_marker.nextSibling && editor.node.isBlock(start_marker.previousSibling)) && !(start_marker.previousSibling && start_marker.previousSibling.tagName === 'BR')) {
                  start_marker.style.display = 'inline';
                  end_marker.style.display = 'inline';
                  ghost = $(editor.doc.createTextNode("\u200B")).get(0);
                } // https://github.com/froala/wysiwyg-editor/issues/1120 . TODO Check again the below statement on which !editor.opts.enter === FE.ENTER_BR is returing false always.
                // var p_node = start_marker.previousSibling;
                // if (p_node && p_node.style && editor.win.getComputedStyle(p_node).display === 'block' && !editor.opts.enter === FE.ENTER_BR) {
                //   range.setEndAfter(p_node);
                //   range.setStartAfter(p_node);
                // }
                // else {
                //   x = _normalizedMarker(start_marker, range, true) || ($(start_marker).before(ghost) && range.setStartBefore(start_marker));
                //   y = _normalizedMarker(end_marker, range, false) || ($(end_marker).after(ghost) && range.setEndAfter(end_marker));
                // }


                x = _normalizedMarker(start_marker, range, true) || $(start_marker).before(ghost) && range.setStartBefore(start_marker);
                y = _normalizedMarker(end_marker, range, false) || $(end_marker).after(ghost) && range.setEndAfter(end_marker);
              }

              if (typeof x === 'function') {
                x();
              }

              if (typeof y === 'function') {
                y();
              }
            }
          } catch (ex) {
            console.warn('RESTORE RANGE', ex);
          }
        }

        if (ghost) {
          $(ghost).remove();
        }

        try {
          sel.addRange(range);
        } catch (ex) {
          console.warn('ADD RANGE', ex);
        }
      } // Remove used markers.


      editor.markers.remove();
    }
    /**
     * Normalize marker when restoring selection.
     */


    function _normalizedMarker(marker, range, start) {
      var len;
      var prev_node = marker.previousSibling;
      var next_node = marker.nextSibling; // Prev and next node are both text nodes.

      if (prev_node && next_node && prev_node.nodeType === Node.TEXT_NODE && next_node.nodeType === Node.TEXT_NODE) {
        len = prev_node.textContent.length;

        if (start) {
          next_node.textContent = prev_node.textContent + next_node.textContent;
          $(prev_node).remove();
          $(marker).remove();

          if (!editor.opts.htmlUntouched) {
            editor.spaces.normalize(next_node);
          }

          return function () {
            range.setStart(next_node, len);
          };
        }

        prev_node.textContent += next_node.textContent;
        $(next_node).remove();
        $(marker).remove();

        if (!editor.opts.htmlUntouched) {
          editor.spaces.normalize(prev_node);
        }

        return function () {
          range.setEnd(prev_node, len);
        };
      } // Prev node is text node.
      else if (prev_node && !next_node && prev_node.nodeType === Node.TEXT_NODE) {
        len = prev_node.textContent.length;

        if (start) {
          if (!editor.opts.htmlUntouched) {
            editor.spaces.normalize(prev_node);
          }

          return function () {
            range.setStart(prev_node, len);
          };
        }

        if (!editor.opts.htmlUntouched) {
          editor.spaces.normalize(prev_node);
        }

        return function () {
          range.setEnd(prev_node, len);
        };
      } // Next node is text node.
      else if (next_node && !prev_node && next_node.nodeType === Node.TEXT_NODE) {
        if (start) {
          if (!editor.opts.htmlUntouched) {
            editor.spaces.normalize(next_node);
          }

          return function () {
            range.setStart(next_node, 0);
          };
        }

        if (!editor.opts.htmlUntouched) {
          editor.spaces.normalize(next_node);
        }

        return function () {
          range.setEnd(next_node, 0);
        };
      }

      return false;
    }
    /**
     * Determine if we can do delete.
     */


    function _canDelete() {
      // Check if there are markers inside conteneditable="false".
      var markers = editor.$el.find('.fr-marker');

      for (var i = 0; i < markers.length; i++) {
        if ($(markers[i]).parentsUntil('.fr-element, [contenteditable="true"]', '[contenteditable="false"]').length) {
          return false;
        }
      }

      return true;
    }
    /**
     * Check if selection is collapsed.
     */


    function isCollapsed() {
      var rgs = ranges();

      for (var i = 0; i < rgs.length; i++) {
        if (!rgs[i].collapsed) {
          return false;
        }
      }

      return true;
    } // From: http://www.coderexception.com/0B1B33z1NyQxUQSJ/contenteditable-div-how-can-i-determine-if-the-cursor-is-at-the-start-or-end-of-the-content


    function info(el) {
      var atStart = false;
      var atEnd = false;
      var selRange;
      var testRange;

      if (editor.win.getSelection) {
        var sel = editor.win.getSelection();

        if (sel.rangeCount) {
          selRange = sel.getRangeAt(0);
          testRange = selRange.cloneRange();
          testRange.selectNodeContents(el);
          testRange.setEnd(selRange.startContainer, selRange.startOffset);
          atStart = selection(testRange);
          testRange.selectNodeContents(el);
          testRange.setStart(selRange.endContainer, selRange.endOffset);
          atEnd = selection(testRange);
        }
      } else if (editor.doc.selection && editor.doc.selection.type !== 'Control') {
        selRange = editor.doc.selection.createRange();
        testRange = selRange.duplicate();
        testRange.moveToElementText(el);
        testRange.setEndPoint('EndToStart', selRange);
        atStart = selection(testRange);
        testRange.moveToElementText(el);
        testRange.setEndPoint('StartToEnd', selRange);
        atEnd = selection(testRange);
      }

      return {
        atStart: atStart,
        atEnd: atEnd
      };
    } // https://github.com/froala-labs/froala-editor-js-2/issues/1935


    function selection(sel) {
      var result = sel.toString().replace(/[\u200B-\u200D\uFEFF]/g, '');
      return result === '';
    }
    /**
     * Check if everything is selected inside the editor.
     */


    function isFull() {
      if (isCollapsed()) {
        return false;
      }

      editor.selection.save(); // https://github.com/froala/wysiwyg-editor/issues/710

      var els = editor.el.querySelectorAll('td, th, img, br');
      var i;

      for (i = 0; i < els.length; i++) {
        if (els[i].nextSibling || els[i].tagName === 'IMG') {
          // Invisible space character was getting replaced within the "selection" method.
          // So replaced it with "&nbsp;" as a solution.
          els[i].innerHTML = "<span class=\"fr-mk\" style=\"display: none;\">&nbsp;</span>".concat(els[i].innerHTML);
        }
      }

      var full = false;
      var inf = info(editor.el);

      if (inf.atStart && inf.atEnd) {
        full = true;
      } // https://github.com/froala/wysiwyg-editor/issues/710


      els = editor.el.querySelectorAll('.fr-mk');

      for (i = 0; i < els.length; i++) {
        els[i].parentNode.removeChild(els[i]);
      }

      editor.selection.restore();
      return full;
    }
    /**
     * Remove HTML from inner nodes when we deal with keepFormatOnDelete option.
     */


    function _emptyInnerNodes(node, first) {
      if (typeof first === 'undefined') {
        first = true;
      } // Remove invisible spaces.


      var h = $(node).html();

      if (h && h.replace(/\u200b/g, '').length !== h.length) {
        $(node).html(h.replace(/\u200b/g, ''));
      } // Loop contents.


      var contents = editor.node.contents(node);

      for (var j = 0; j < contents.length; j++) {
        // Remove text nodes.
        if (contents[j].nodeType !== Node.ELEMENT_NODE) {
          $(contents[j]).remove();
        } // Empty inner nodes further.
        else {
          // j === 0 determines if the node is the first one and we should keep format.
          _emptyInnerNodes(contents[j], j === 0); // There are inner nodes, ignore the current one.


          if (j === 0) {
            first = false;
          }
        }
      } // First node is a text node, so replace it with a span.


      if (node.nodeType === Node.TEXT_NODE) {
        var span = $(document.createElement('span')).attr('data-first', 'true').attr('data-text', 'true');
        $(node)[0].replaceWith(span[0]);
      } // Add the first node marker so that we add selection in it later on.
      else if (first) {
        $(node).attr('data-first', true);
      }
    }
    /**
     * TODO: check again this function because it will always return true because fr-inner tag does not exist.
     */


    function _filterFrInner() {
      return $(this).find('fr-inner').length === 0;
    }
    /**
     * Process deleting nodes.
     */


    function _processNodeDelete($node, should_delete) {
      var contents = editor.node.contents($node.get(0)); // Node is TD or TH.

      if (['TD', 'TH'].indexOf($node.get(0).tagName) >= 0 && $node.find('.fr-marker').length === 1 && (editor.node.hasClass(contents[0], 'fr-marker') || contents[0].tagName == 'BR' && editor.node.hasClass(contents[0].nextElementSibling, 'fr-marker'))) {
        $node.attr('data-del-cell', true);
      }

      for (var i = 0; i < contents.length; i++) {
        var node = contents[i]; // We found a marker.

        if (editor.node.hasClass(node, 'fr-marker')) {
          should_delete = (should_delete + 1) % 2;
        } else if (should_delete) {
          // Check if we have a marker inside it.
          if ($(node).find('.fr-marker').length > 0) {
            should_delete = _processNodeDelete($(node), should_delete);
          } else {
            // TD, TH or inner, then go further.
            if (['TD', 'TH'].indexOf(node.tagName) < 0 && !editor.node.hasClass(node, 'fr-inner')) {
              if (!editor.opts.keepFormatOnDelete || editor.$el.find('[data-first]').length > 0 || editor.node.isVoid(node)) {
                $(node).remove();
              } else {
                _emptyInnerNodes(node);
              }
            } else if (editor.node.hasClass(node, 'fr-inner')) {
              if ($(node).find('.fr-inner').length === 0) {
                $(node).html('<br>');
              } else {
                $(node).find('.fr-inner').filter(_filterFrInner).html('<br>');
              }
            } else {
              $(node).empty();
              $(node).attr('data-del-cell', true);
            }
          }
        } else if ($(node).find('.fr-marker').length > 0) {
          should_delete = _processNodeDelete($(node), should_delete);
        }
      }

      return should_delete;
    }
    /**
     * Determine if selection is inside the editor.
     */


    function inEditor() {
      try {
        if (!editor.$wp) {
          return false;
        }

        var range = ranges(0);
        var container = range.commonAncestorContainer;

        while (container && !editor.node.isElement(container)) {
          container = container.parentNode;
        }

        if (editor.node.isElement(container)) {
          return true;
        }

        return false;
      } catch (ex) {
        return false;
      }
    }
    /**
     * Remove the current selection html.
     */


    function remove() {
      if (isCollapsed()) {
        return true;
      }

      var i;
      save(); // Get the previous sibling normalized.

      function _prevSibling(node) {
        var prev_node = node.previousSibling;

        while (prev_node && prev_node.nodeType === Node.TEXT_NODE && prev_node.textContent.length === 0) {
          var tmp = prev_node;
          prev_node = prev_node.previousSibling;
          $(tmp).remove();
        }

        return prev_node;
      } // Get the next sibling normalized.


      function _nextSibling(node) {
        var next_node = node.nextSibling;

        while (next_node && next_node.nodeType === Node.TEXT_NODE && next_node.textContent.length === 0) {
          var tmp = next_node;
          next_node = next_node.nextSibling;
          $(tmp).remove();
        }

        return next_node;
      } // Normalize start markers.


      var start_markers = editor.$el.find('.fr-marker[data-type="true"]');

      for (i = 0; i < start_markers.length; i++) {
        var sm = start_markers[i];

        while (!_prevSibling(sm) && !editor.node.isBlock(sm.parentNode) && !editor.$el.is(sm.parentNode) && !editor.node.hasClass(sm.parentNode, 'fr-inner')) {
          $(sm.parentNode).before(sm);
        }
      } // Normalize end markers.


      var end_markers = editor.$el.find('.fr-marker[data-type="false"]');

      for (i = 0; i < end_markers.length; i++) {
        var em = end_markers[i];

        while (!_nextSibling(em) && !editor.node.isBlock(em.parentNode) && !editor.$el.is(em.parentNode) && !editor.node.hasClass(em.parentNode, 'fr-inner')) {
          $(em.parentNode).after(em);
        } // Last node is empty and has a BR in it.


        if (em.parentNode && editor.node.isBlock(em.parentNode) && editor.node.isEmpty(em.parentNode) && !editor.$el.is(em.parentNode) && !editor.node.hasClass(em.parentNode, 'fr-inner') && editor.opts.keepFormatOnDelete) {
          $(em.parentNode).after(em);
        }
      } // Check if selection can be deleted.


      if (_canDelete()) {
        _processNodeDelete(editor.$el, 0); // Look for selection marker.


        var $first_node = editor.$el.find('[data-first="true"]');

        if ($first_node.length) {
          // Remove markers.
          editor.$el.find('.fr-marker').remove(); // Add markers in the node that we marked as the first one.

          $first_node.append(FroalaEditor.INVISIBLE_SPACE + FroalaEditor.MARKERS).removeAttr('data-first'); // Remove span with data-text if there is one.

          if ($first_node.attr('data-text')) {
            $first_node.replaceWith($first_node.html());
          }
        } else {
          // Remove tables.
          editor.$el.find('table').filter(function () {
            var ok = $(this).find('[data-del-cell]').length > 0 && $(this).find('[data-del-cell]').length === $(this).find('td, th').length;
            return ok;
          }).remove();
          editor.$el.find('[data-del-cell]').removeAttr('data-del-cell'); // Merge contents between markers.

          start_markers = editor.$el.find('.fr-marker[data-type="true"]');

          for (i = 0; i < start_markers.length; i++) {
            // Get start marker.
            var start_marker = start_markers[i]; // Get the next node after start marker.

            var next_node = start_marker.nextSibling; // Get the end node.

            var end_marker = editor.$el.find(".fr-marker[data-type=\"false\"][data-id=\"".concat($(start_marker).data('id'), "\"]")).get(0);

            if (end_marker) {
              // Markers are not next to other.
              if (start_marker && !(next_node && next_node === end_marker)) {
                // Get the parents of the nodes.
                var start_parent = editor.node.blockParent(start_marker);
                var end_parent = editor.node.blockParent(end_marker); // https://github.com/froala/wysiwyg-editor/issues/1233

                var list_start = false;
                var list_end = false;

                if (start_parent && ['UL', 'OL'].indexOf(start_parent.tagName) >= 0) {
                  start_parent = null;
                  list_start = true;
                }

                if (end_parent && ['UL', 'OL'].indexOf(end_parent.tagName) >= 0) {
                  end_parent = null;
                  list_end = true;
                } // Move end marker next to start marker.


                $(start_marker).after(end_marker); // The block parent of the start marker is the element itself. We're not in the same parent or moving marker is not enough.

                if (start_parent !== end_parent) {
                  if (start_parent === null && !list_start) {
                    var deep_parent = editor.node.deepestParent(start_marker); // There is a parent for the marker. Move the end html to it.

                    if (deep_parent) {
                      $(deep_parent).after($(end_parent).html());
                      $(end_parent).remove();
                    } // There is no parent for the marker.
                    else if ($(end_parent).parentsUntil(editor.$el, 'table').length === 0) {
                      $(start_marker).next().after($(end_parent).html());
                      $(end_parent).remove();
                    }
                  } // End marker is inside element. We don't merge in table.
                  else if (end_parent === null && !list_end && $(start_parent).parentsUntil(editor.$el, 'table').length === 0) {
                    // Get the node that has a next sibling.
                    next_node = start_parent;

                    while (!next_node.nextSibling && next_node.parentNode !== editor.el) {
                      next_node = next_node.parentNode;
                    }

                    next_node = next_node.nextSibling; // Join HTML inside the start node.

                    while (next_node && next_node.tagName !== 'BR') {
                      var tmp_node = next_node.nextSibling;
                      $(start_parent).append(next_node);
                      next_node = tmp_node;
                    }

                    if (next_node && next_node.tagName === 'BR') {
                      $(next_node).remove();
                    }
                  } // Join end block with start block.
                  else if (start_parent && end_parent && $(start_parent).parentsUntil(editor.$el, 'table').length === 0 && $(end_parent).parentsUntil(editor.$el, 'table').length === 0 && !$(start_parent).contains(end_parent) && !$(end_parent).contains(start_parent)) {
                    $(start_parent).append($(end_parent).html());
                    $(end_parent).remove();
                  }
                }
              }
            } else {
              end_marker = $(start_marker).clone().attr('data-type', false);
              $(start_marker).after(end_marker);
            }
          }
        }
      } // Remove remaining empty lists.


      editor.$el.find('li:empty').remove();

      if (!editor.opts.keepFormatOnDelete) {
        editor.html.fillEmptyBlocks();
      }

      editor.html.cleanEmptyTags(true);

      if (!editor.opts.htmlUntouched) {
        editor.clean.lists();
        editor.$el.find('li:empty').append('<br>');
        editor.spaces.normalize();
      } // https://github.com/froala/wysiwyg-editor/issues/1379 &&


      var last_marker = editor.$el.find('.fr-marker').last().get(0);
      var first_marker = editor.$el.find('.fr-marker').first().get(0); // https://github.com/froala-labs/froala-editor-js-2/issues/491

      if (typeof last_marker !== 'undefined' && typeof first_marker !== 'undefined' && !last_marker.nextSibling && first_marker.previousSibling && first_marker.previousSibling.tagName === 'BR' && editor.node.isElement(last_marker.parentNode) && editor.node.isElement(first_marker.parentNode)) {
        editor.$el.append('<br>');
      }

      restore();
    }

    function setAtStart(node, deep) {
      if (!node || node.getElementsByClassName('fr-marker').length > 0) {
        return false;
      }

      var child = node.firstChild;

      while (child && (editor.node.isBlock(child) || deep && !editor.node.isVoid(child) && child.nodeType === Node.ELEMENT_NODE)) {
        node = child;
        child = child.firstChild;
      }

      node.innerHTML = FroalaEditor.MARKERS + node.innerHTML;
    }

    function setAtEnd(node, deep) {
      if (!node || node.getElementsByClassName('fr-marker').length > 0) {
        return false;
      }

      var child = node.lastChild;

      while (child && (editor.node.isBlock(child) || deep && !editor.node.isVoid(child) && child.nodeType === Node.ELEMENT_NODE)) {
        node = child;
        child = child.lastChild;
      }

      var span = editor.doc.createElement('SPAN');
      span.setAttribute('id', 'fr-sel-markers');
      span.innerHTML = FroalaEditor.MARKERS; // https://github.com/froala/wysiwyg-editor/issues/3078

      while (node.parentNode && editor.opts.htmlAllowedEmptyTags && editor.opts.htmlAllowedEmptyTags.indexOf(node.tagName.toLowerCase()) >= 0) {
        node = node.parentNode;
      }

      node.appendChild(span);
      var nd = node.querySelector('#fr-sel-markers');
      nd.outerHTML = nd.innerHTML;
    }

    function setBefore(node, use_current_node) {
      if (typeof use_current_node === 'undefined') {
        use_current_node = true;
      } // Check if there is any previous sibling by skipping the empty text ones.


      var prev_node = node.previousSibling;

      while (prev_node && prev_node.nodeType === Node.TEXT_NODE && prev_node.textContent.length === 0) {
        prev_node = prev_node.previousSibling;
      } // There is a previous node.


      if (prev_node) {
        // Previous node is block so set the focus at the end of it.
        if (editor.node.isBlock(prev_node)) {
          setAtEnd(prev_node);
        } // Previous node is BR, so place markers before it.
        else if (prev_node.tagName === 'BR') {
          $(prev_node).before(FroalaEditor.MARKERS);
        } // Just place marker.
        else {
          $(prev_node).after(FroalaEditor.MARKERS);
        }

        return true;
      } // Use current node.
      else if (use_current_node) {
        // Current node is block, set selection at start.
        if (editor.node.isBlock(node)) {
          setAtStart(node);
        } // Just place markers.
        else {
          $(node).before(FroalaEditor.MARKERS);
        }

        return true;
      }

      return false;
    }

    function setAfter(node, use_current_node) {
      if (typeof use_current_node === 'undefined') {
        use_current_node = true;
      } // Check if there is any previous sibling by skipping the empty text ones.


      var next_node = node.nextSibling;

      while (next_node && next_node.nodeType === Node.TEXT_NODE && next_node.textContent.length === 0) {
        next_node = next_node.nextSibling;
      } // There is a next node.


      if (next_node) {
        // Next node is block so set the focus at the end of it.
        if (editor.node.isBlock(next_node)) {
          setAtStart(next_node);
        } // Just place marker.
        else {
          $(next_node).before(FroalaEditor.MARKERS);
        }

        return true;
      } // Use current node.
      else if (use_current_node) {
        // Current node is block, set selection at end.
        if (editor.node.isBlock(node)) {
          setAtEnd(node);
        } // Just place markers.
        else {
          $(node).after(FroalaEditor.MARKERS);
        }

        return true;
      }

      return false;
    }

    return {
      text: text,
      get: get,
      ranges: ranges,
      clear: clear,
      element: element,
      endElement: endElement,
      save: save,
      restore: restore,
      isCollapsed: isCollapsed,
      isFull: isFull,
      inEditor: inEditor,
      remove: remove,
      blocks: blocks,
      info: info,
      setAtEnd: setAtEnd,
      setAtStart: setAtStart,
      setBefore: setBefore,
      setAfter: setAfter,
      rangeElement: rangeElement
    };
  };

  Object.assign(FroalaEditor.DEFAULTS, {
    language: null
  });
  FroalaEditor.LANGUAGE = {};

  FroalaEditor.MODULES.language = function (editor) {
    var lang;
    /**
     * Translate.
     */

    function translate(str) {
      if (lang && lang.translation[str] && lang.translation[str].length) {
        return lang.translation[str];
      }

      return str;
    }
    /* Initialize */


    function _init() {
      // Load lang.
      if (FroalaEditor.LANGUAGE) {
        lang = FroalaEditor.LANGUAGE[editor.opts.language];
      } // Set direction.


      if (lang && lang.direction) {
        editor.opts.direction = lang.direction;
      }
    }

    return {
      _init: _init,
      translate: translate
    };
  };

  Object.assign(FroalaEditor.DEFAULTS, {
    placeholderText: 'Type something'
  });

  FroalaEditor.MODULES.placeholder = function (editor) {
    var $ = editor.$;
    /* Show placeholder. */

    function show() {
      if (!editor.$placeholder) {
        _add();
      }

      var margin_offset = editor.opts.iframe ? editor.$iframe.prev().outerHeight(true) : editor.$el.prev().outerHeight(true); // Determine the placeholder position based on the first element inside editor.

      var margin_top = 0;
      var margin_left = 0;
      var margin_right = 0;
      var padding_top = 0;
      var padding_left = 0;
      var padding_right = 0;
      var contents = editor.node.contents(editor.el);
      var alignment = $(editor.selection.element()).css('text-align');

      if (contents.length && contents[0].nodeType === Node.ELEMENT_NODE) {
        var $first_node = $(contents[0]);

        if ((editor.$wp.prev().length > 0 || editor.$el.prev().length > 0) && editor.ready) {
          margin_top = editor.helpers.getPX($first_node.css('margin-top'));
          padding_top = editor.helpers.getPX($first_node.css('padding-top'));
          margin_left = editor.helpers.getPX($first_node.css('margin-left'));
          margin_right = editor.helpers.getPX($first_node.css('margin-right'));
          padding_left = editor.helpers.getPX($first_node.css('padding-left'));
          padding_right = editor.helpers.getPX($first_node.css('padding-right'));
        }

        editor.$placeholder.css('font-size', $first_node.css('font-size'));
        editor.$placeholder.css('line-height', $first_node.css('line-height'));
      } else {
        editor.$placeholder.css('font-size', editor.$el.css('font-size'));
        editor.$placeholder.css('line-height', editor.$el.css('line-height'));
      }

      editor.$wp.addClass('show-placeholder');
      editor.$placeholder.css({
        marginTop: Math.max(editor.helpers.getPX(editor.$el.css('margin-top')), margin_top) + (margin_offset ? margin_offset : 0),
        paddingTop: Math.max(editor.helpers.getPX(editor.$el.css('padding-top')), padding_top),
        paddingLeft: Math.max(editor.helpers.getPX(editor.$el.css('padding-left')), padding_left),
        marginLeft: Math.max(editor.helpers.getPX(editor.$el.css('margin-left')), margin_left),
        paddingRight: Math.max(editor.helpers.getPX(editor.$el.css('padding-right')), padding_right),
        marginRight: Math.max(editor.helpers.getPX(editor.$el.css('margin-right')), margin_right),
        textAlign: alignment
      }).text(editor.language.translate(editor.opts.placeholderText || editor.$oel.attr('placeholder') || ''));
      editor.$placeholder.html(editor.$placeholder.text().replace(/\n/g, '<br>'));
    }
    /* Hide placeholder. */


    function hide() {
      editor.$wp.removeClass('show-placeholder');
    }
    /* Check if placeholder is visible */


    function isVisible() {
      return !editor.$wp ? true : editor.node.hasClass(editor.$wp.get(0), 'show-placeholder');
    }
    /* Refresh placeholder. */


    function refresh() {
      if (!editor.$wp) {
        return false;
      }

      if (editor.core.isEmpty()) {
        show();
      } else {
        hide();
      }
    }

    function _add() {
      editor.$placeholder = $(editor.doc.createElement('SPAN')).addClass('fr-placeholder');
      editor.$wp.append(editor.$placeholder);
    }
    /* Initialize. */


    function _init() {
      if (!editor.$wp) {
        return false;
      }

      editor.events.on('init input keydown keyup contentChanged initialized', refresh);
    }

    return {
      _init: _init,
      show: show,
      hide: hide,
      refresh: refresh,
      isVisible: isVisible
    };
  };

  FroalaEditor.UNICODE_NBSP = String.fromCharCode(160); // Void Elements http://www.w3.org/html/wg/drafts/html/master/syntax.html#void-elements

  FroalaEditor.VOID_ELEMENTS = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'keygen', 'link', 'menuitem', 'meta', 'param', 'source', 'track', 'wbr'];
  FroalaEditor.BLOCK_TAGS = ['address', 'article', 'aside', 'audio', 'blockquote', 'canvas', 'details', 'dd', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'li', 'main', 'nav', 'noscript', 'ol', 'output', 'p', 'pre', 'section', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'ul', 'video']; // Extend defaults.

  Object.assign(FroalaEditor.DEFAULTS, {
    htmlAllowedEmptyTags: ['textarea', 'a', 'iframe', 'object', 'video', 'style', 'script', '.fa', '.fr-emoticon', '.fr-inner', 'path', 'line', 'hr'],
    htmlDoNotWrapTags: ['script', 'style'],
    htmlSimpleAmpersand: false,
    htmlIgnoreCSSProperties: [],
    htmlExecuteScripts: true
  });

  FroalaEditor.MODULES.html = function (editor) {
    var $ = editor.$;
    /**
     * Determine the default block tag.
     */

    function defaultTag() {
      if (editor.opts.enter === FroalaEditor.ENTER_P) {
        return 'p';
      }

      if (editor.opts.enter === FroalaEditor.ENTER_DIV) {
        return 'div';
      }

      if (editor.opts.enter === FroalaEditor.ENTER_BR) {
        return null;
      }
    }
    /**
     * Tells if the node keeps text formating.
     */


    function isPreformatted(node, look_up) {
      // Stop condition.
      if (!node || node === editor.el) {
        return false;
      } // Check only first level.


      if (!look_up) {
        // Is preformatted.
        return ['PRE', 'SCRIPT', 'STYLE'].indexOf(node.tagName) !== -1;
      } else {
        if (['PRE', 'SCRIPT', 'STYLE'].indexOf(node.tagName) != -1) {
          return true;
        }

        return isPreformatted(node.parentNode, look_up);
      }
    }
    /**
     * Get the empty blocs.
     */


    function emptyBlocks(around_markers) {
      var empty_blocks = [];
      var i; // Block tag elements.

      var els = [];

      if (around_markers) {
        var markers = editor.el.querySelectorAll('.fr-marker');

        for (i = 0; i < markers.length; i++) {
          var p_node = editor.node.blockParent(markers[i]) || markers[i];

          if (p_node) {
            var next_node = p_node.nextSibling;
            var prev_node = p_node.previousSibling; // Push current node, prev and next one.

            if (p_node && els.indexOf(p_node) < 0 && editor.node.isBlock(p_node)) {
              els.push(p_node);
            }

            if (prev_node && editor.node.isBlock(prev_node) && els.indexOf(prev_node) < 0) {
              els.push(prev_node);
            }

            if (next_node && editor.node.isBlock(next_node) && els.indexOf(next_node) < 0) {
              els.push(next_node);
            }
          }
        }
      } else {
        els = editor.el.querySelectorAll(blockTagsQuery());
      }

      var qr = blockTagsQuery();
      qr += ",".concat(FroalaEditor.VOID_ELEMENTS.join(','));
      qr += ', .fr-inner';
      qr += ",".concat(editor.opts.htmlAllowedEmptyTags.join(':not(.fr-marker),'), ":not(.fr-marker)"); // Check if there are empty block tags with markers.

      for (i = els.length - 1; i >= 0; i--) {
        // If the block tag has text content, ignore it.
        if (els[i].textContent && els[i].textContent.replace(/\u200B|\n/g, '').length > 0) {
          continue;
        }

        if (els[i].querySelectorAll(qr).length > 0) {
          continue;
        } // We're checking text from here on.


        var contents = editor.node.contents(els[i]);
        var found = false;

        for (var j = 0; j < contents.length; j++) {
          if (contents[j].nodeType === Node.COMMENT_NODE) {
            continue;
          } // Text node that is not empty.


          if (contents[j].textContent && contents[j].textContent.replace(/\u200B|\n/g, '').length > 0) {
            found = true;
            break;
          }
        } // Make sure we don't add TABLE and TD at the same time for instance.


        if (!found) {
          empty_blocks.push(els[i]);
        }
      }

      return empty_blocks;
    }
    /**
     * Create jQuery query for empty block tags.
     */


    function emptyBlockTagsQuery() {
      return "".concat(FroalaEditor.BLOCK_TAGS.join(':empty, '), ":empty");
    }
    /**
     * Create jQuery query for selecting block tags.
     */


    function blockTagsQuery() {
      return FroalaEditor.BLOCK_TAGS.join(', ');
    }
    /**
     * Remove empty elements that are not VOID elements.
     */


    function cleanEmptyTags(remove_blocks) {
      var els = $.merge([], FroalaEditor.VOID_ELEMENTS);
      els = $.merge(els, editor.opts.htmlAllowedEmptyTags);

      if (typeof remove_blocks === 'undefined') {
        els = $.merge(els, FroalaEditor.BLOCK_TAGS);
      } else {
        els = $.merge(els, FroalaEditor.NO_DELETE_TAGS);
      }

      var elms;
      var ok; //https://github.com/froala-labs/froala-editor-js-2/issues/1938

      elms = editor.el.querySelectorAll("*:empty:not(".concat(els.join('):not('), "):not(.fr-marker):not(template)"));

      do {
        ok = false; // Remove those elements that have no attributes.

        for (var i = 0; i < elms.length; i++) {
          if (elms[i].attributes.length === 0 || typeof elms[i].getAttribute('href') !== 'undefined') {
            elms[i].parentNode.removeChild(elms[i]);
            ok = true;
          }
        } //https://github.com/froala-labs/froala-editor-js-2/issues/1938


        elms = editor.el.querySelectorAll("*:empty:not(".concat(els.join('):not('), "):not(.fr-marker):not(template)"));
      } while (elms.length && ok);
    }
    /**
     * Wrap the content inside the element passed as argument.
     */


    function _wrapElement(el, temp) {
      var default_tag = defaultTag();

      if (temp) {
        default_tag = 'div';
      }

      if (default_tag) {
        // Rewrite the entire content.
        var main_doc = editor.doc.createDocumentFragment(); // Anchor.

        var anchor = null; // If we found anything inside the current anchor.

        var found = false;
        var node = el.firstChild;
        var changed = false; // Loop through contents.

        while (node) {
          var next_node = node.nextSibling; // Current node is a block node.
          // Or it is a do not wrap node and not a fr-marker.

          if (node.nodeType === Node.ELEMENT_NODE && (editor.node.isBlock(node) || editor.opts.htmlDoNotWrapTags.indexOf(node.tagName.toLowerCase()) >= 0 && !editor.node.hasClass(node, 'fr-marker'))) {
            anchor = null;
            main_doc.appendChild(node.cloneNode(true));
          } // Other node types than element and text.
          else if (node.nodeType !== Node.ELEMENT_NODE && node.nodeType !== Node.TEXT_NODE) {
            anchor = null;
            main_doc.appendChild(node.cloneNode(true));
          } // Current node is BR.
          else if (node.tagName === 'BR') {
            // There is no anchor.
            if (anchor === null) {
              anchor = editor.doc.createElement(default_tag);
              changed = true;

              if (temp) {
                anchor.setAttribute('class', 'fr-temp-div');
                anchor.setAttribute('data-empty', true);
              }

              anchor.appendChild(node.cloneNode(true));
              main_doc.appendChild(anchor);
            } // There is anchor. Just remove BR.
            // There is nothing else except markers and BR inside the new formed tag.
            else if (found === false) {
              anchor.appendChild(editor.doc.createElement('br'));

              if (temp) {
                anchor.setAttribute('class', 'fr-temp-div');
                anchor.setAttribute('data-empty', true);
              }
            }

            anchor = null;
          } // Text node or other node type.
          else {
            var txt = node.textContent; // Node is not text node.
            // Node is text node and it doesn't contain only spaces and NL.
            // There are empty spaces but no new lines.

            if (node.nodeType !== Node.TEXT_NODE || txt.replace(/\n/g, '').replace(/(^ *)|( *$)/g, '').length > 0 || txt.replace(/(^ *)|( *$)/g, '').length && txt.indexOf('\n') < 0) {
              // No anchor.
              if (anchor === null) {
                anchor = editor.doc.createElement(default_tag);
                changed = true;

                if (temp) {
                  anchor.setAttribute('class', 'fr-temp-div');
                }

                main_doc.appendChild(anchor);
                found = false;
              } // Add node to anchor.


              anchor.appendChild(node.cloneNode(true)); // Check if maybe we have a non empty node.

              if (!found && !editor.node.hasClass(node, 'fr-marker') && !(node.nodeType === Node.TEXT_NODE && txt.replace(/ /g, '').length === 0)) {
                found = true;
              }
            } else {
              changed = true;
            } // Else skip the node because it's empty.

          }

          node = next_node;
        }

        if (changed) {
          el.innerHTML = '';
          el.appendChild(main_doc);
        }
      }
    }

    function _wrapElements(els, temp) {
      for (var i = els.length - 1; i >= 0; i--) {
        _wrapElement(els[i], temp);
      }
    }
    /**
     * Wrap the direct content inside the default block tag.
     */


    function _wrap(temp, tables, blockquote, inner, li) {
      if (!editor.$wp) {
        return false;
      }

      if (typeof temp === 'undefined') {
        temp = false;
      }

      if (typeof tables === 'undefined') {
        tables = false;
      }

      if (typeof blockquote === 'undefined') {
        blockquote = false;
      }

      if (typeof inner === 'undefined') {
        inner = false;
      }

      if (typeof li === 'undefined') {
        li = false;
      } // Wrap element.


      var wp_st = editor.$wp.scrollTop();

      _wrapElement(editor.el, temp);

      if (inner) {
        _wrapElements(editor.el.querySelectorAll('.fr-inner'), temp);
      } // Wrap table contents.


      if (tables) {
        _wrapElements(editor.el.querySelectorAll('td, th'), temp);
      } // Wrap table contents.


      if (blockquote) {
        _wrapElements(editor.el.querySelectorAll('blockquote'), temp);
      }

      if (li) {
        _wrapElements(editor.el.querySelectorAll('li'), temp);
      }

      if (wp_st !== editor.$wp.scrollTop()) {
        editor.$wp.scrollTop(wp_st);
      }
    }
    /**
     * Unwrap temporary divs.
     */


    function unwrap() {
      editor.$el.find('div.fr-temp-div').each(function () {
        if (this.previousSibling && this.previousSibling.nodeType === Node.TEXT_NODE) {
          $(this).before('<br>');
        }

        if ($(this).attr('data-empty') || !this.nextSibling || editor.node.isBlock(this.nextSibling) && !$(this.nextSibling).hasClass('fr-temp-div')) {
          $(this).replaceWith($(this).html());
        } else {
          $(this).replaceWith("".concat($(this).html(), "<br>"));
        }
      }); // Remove temp class from other blocks.

      editor.$el.find('.fr-temp-div').removeClass('fr-temp-div').filter(function () {
        return $(this).attr('class') === '';
      }).removeAttr('class');
    }
    /**
     * Add BR inside empty elements.
     */


    function fillEmptyBlocks(around_markers) {
      var blocks = emptyBlocks(around_markers);

      if (editor.node.isEmpty(editor.el) && editor.opts.enter === FroalaEditor.ENTER_BR) {
        blocks.push(editor.el);
      }

      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];

        if (block.getAttribute('contenteditable') !== 'false' && !block.querySelector("".concat(editor.opts.htmlAllowedEmptyTags.join(':not(.fr-marker),'), ":not(.fr-marker)")) && !editor.node.isVoid(block)) {
          if (block.tagName !== 'TABLE' && block.tagName !== 'TBODY' && block.tagName !== 'TR' && block.tagName !== 'UL' && block.tagName !== 'OL') {
            block.appendChild(editor.doc.createElement('br'));
          }
        }
      } // Fix for https://github.com/froala/wysiwyg-editor/issues/1166#issuecomment-204549406.


      if (editor.browser.msie && editor.opts.enter === FroalaEditor.ENTER_BR) {
        var contents = editor.node.contents(editor.el);

        if (contents.length && contents[contents.length - 1].nodeType === Node.TEXT_NODE) {
          editor.$el.append('<br>');
        }
      }
    }
    /**
     * Get the blocks inside the editable area.
     */


    function blocks() {
      return editor.$el.get(0).querySelectorAll(blockTagsQuery());
    }
    /**
     * Clean the blank spaces between the block tags.
     */


    function cleanBlankSpaces(el) {
      if (typeof el === 'undefined') {
        el = editor.el;
      }

      if (el && ['SCRIPT', 'STYLE', 'PRE'].indexOf(el.tagName) >= 0) {
        return false;
      }

      var walker = editor.doc.createTreeWalker(el, NodeFilter.SHOW_TEXT, editor.node.filter(function (node) {
        return node.textContent.match(/([ \n]{2,})|(^[ \n]{1,})|([ \n]{1,}$)/g) !== null;
      }), false);

      while (walker.nextNode()) {
        var node = walker.currentNode;

        if (isPreformatted(node.parentNode, true)) {
          continue;
        }

        var is_block_or_element = editor.node.isBlock(node.parentNode) || editor.node.isElement(node.parentNode); // Remove middle spaces.
        // Replace new lines with spaces.
        // Replace begin/end spaces.

        var txt = node.textContent.replace(/(?!^)( ){2,}(?!$)/g, ' ').replace(/\n/g, ' ').replace(/^[ ]{2,}/g, ' ').replace(/[ ]{2,}$/g, ' ');

        if (is_block_or_element) {
          var p_node = node.previousSibling;
          var n_node = node.nextSibling;

          if (p_node && n_node && txt === ' ') {
            if (editor.node.isBlock(p_node) && editor.node.isBlock(n_node)) {
              txt = '';
            } else {
              txt = ' ';
            }
          } else {
            // No previous siblings.
            if (!p_node) {
              txt = txt.replace(/^ */, '');
            } // No next siblings.


            if (!n_node) {
              txt = txt.replace(/ *$/, '');
            }
          }
        }

        node.textContent = txt;
      }
    }
    /**
     * Extract a specific match for a RegEx.
     */


    function _extractMatch(html, re, id) {
      var reg_exp = new RegExp(re, 'gi');
      var matches = reg_exp.exec(html);

      if (matches) {
        return matches[id];
      }

      return null;
    }
    /**
     * Create new doctype.
     */


    function _newDoctype(string, doc) {
      var matches = string.match(/<!DOCTYPE ?([^ ]*) ?([^ ]*) ?"?([^"]*)"? ?"?([^"]*)"?>/i);

      if (matches) {
        return doc.implementation.createDocumentType(matches[1], matches[3], matches[4]);
      }

      return doc.implementation.createDocumentType('html');
    }
    /**
     * Get string doctype of a document.
     */


    function getDoctype(doc) {
      var node = doc.doctype;
      var doctype = '<!DOCTYPE html>';

      if (node) {
        doctype = "<!DOCTYPE ".concat(node.name).concat(node.publicId ? " PUBLIC \"".concat(node.publicId, "\"") : '').concat(!node.publicId && node.systemId ? ' SYSTEM' : '').concat(node.systemId ? " \"".concat(node.systemId, "\"") : '', ">");
      }

      return doctype;
    }

    function _processBR(br) {
      var parent_node = br.parentNode;

      if (parent_node && (editor.node.isBlock(parent_node) || editor.node.isElement(parent_node)) && ['TD', 'TH'].indexOf(parent_node.tagName) < 0) {
        var prev_node = br.previousSibling;
        var next_node = br.nextSibling; // Ignore non characters.

        while (prev_node && (prev_node.nodeType === Node.TEXT_NODE && prev_node.textContent.replace(/\n|\r/g, '').length === 0 || editor.node.hasClass(prev_node, 'fr-tmp'))) {
          prev_node = prev_node.previousSibling;
        }

        if (next_node) {
          return false;
        } // Previous node.
        // Previous node is not BR.
        // Previoues node is not block tag.
        // No next node.
        // Parent node has text.
        // Previous node has text.


        if (prev_node && parent_node && prev_node.tagName !== 'BR' && !editor.node.isBlock(prev_node) && !next_node && parent_node.textContent.replace(/\u200B/g, '').length > 0 && prev_node.textContent.length > 0 && !editor.node.hasClass(prev_node, 'fr-marker')) {
          // Fix for https://github.com/froala/wysiwyg-editor/issues/1166#issuecomment-204549406.
          if (!(editor.el === parent_node && !next_node && editor.opts.enter === FroalaEditor.ENTER_BR && editor.browser.msie)) {
            br.parentNode.removeChild(br);
          }
        }
      } // Regular node.
      else if (parent_node && !(editor.node.isBlock(parent_node) || editor.node.isElement(parent_node))) {
        // Check if we have something else than BR.
        if (!br.previousSibling && !br.nextSibling && editor.node.isDeletable(br.parentNode)) {
          _processBR(br.parentNode);
        }
      }
    }

    function cleanBRs() {
      var brs = editor.el.getElementsByTagName('br');

      for (var i = 0; i < brs.length; i++) {
        _processBR(brs[i]);
      }
    }
    /**
     * Normalize.
     */


    function _normalize() {
      if (!editor.opts.htmlUntouched) {
        // Remove empty tags.
        cleanEmptyTags(); // Wrap possible text.

        _wrap(); // Clean blank spaces.


        cleanBlankSpaces(); // Normalize spaces.

        editor.spaces.normalize(null, true); // Add BR tag where it is necessary.

        editor.html.fillEmptyBlocks(); // Clean lists.

        editor.clean.lists(); // Clean tables.

        editor.clean.tables(); // Convert to HTML5.

        editor.clean.toHTML5(); // Remove unecessary brs.

        editor.html.cleanBRs();
      } // Restore selection.


      editor.selection.restore(); // Check if editor is empty and add placeholder.

      checkIfEmpty(); // Refresh placeholder.

      editor.placeholder.refresh();
    }

    function checkIfEmpty() {
      if (editor.node.isEmpty(editor.el)) {
        if (defaultTag() !== null) {
          // There is no block tag inside the editor.
          if (!editor.el.querySelector(blockTagsQuery()) && !editor.el.querySelector("".concat(editor.opts.htmlDoNotWrapTags.join(':not(.fr-marker),'), ":not(.fr-marker)"))) {
            if (editor.core.hasFocus()) {
              editor.$el.html("<".concat(defaultTag(), ">").concat(FroalaEditor.MARKERS, "<br/></").concat(defaultTag(), ">"));
              editor.selection.restore();
            } else {
              editor.$el.html("<".concat(defaultTag(), "><br/></").concat(defaultTag(), ">"));
            }
          }
        } else {
          // There is nothing in the editor.
          if (!editor.el.querySelector('*:not(.fr-marker):not(br)')) {
            if (editor.core.hasFocus()) {
              editor.$el.html("".concat(FroalaEditor.MARKERS, "<br/>"));
              editor.selection.restore();
            } else {
              editor.$el.html('<br/>');
            }
          }
        }
      }
    }

    function extractNode(html, tag) {
      return _extractMatch(html, "<".concat(tag, "[^>]*?>([\\w\\W]*)</").concat(tag, ">"), 1);
    }

    function extractNodeAttrs(html, tag) {
      var $dv = $("<div ".concat(_extractMatch(html, "<".concat(tag, "([^>]*?)>"), 1) || '', ">"));
      return editor.node.rawAttributes($dv.get(0));
    }

    function extractDoctype(html) {
      return (_extractMatch(html, '<!DOCTYPE([^>]*?)>', 0) || '<!DOCTYPE html>').replace(/\n/g, ' ').replace(/ {2,}/g, ' ');
    }
    /*
     * Set html to node.
     */


    function _setHtml($node, html) {
      if (editor.opts.htmlExecuteScripts) {
        $node.html(html);
      } else {
        $node.get(0).innerHTML = html;
      }
    }
    /**
     * Set HTML.
     */


    function set(html) {
      var cleaned_html = editor.clean.html((html || '').trim(), [], [], editor.opts.fullPage); // https://github.com/froala-labs/froala-editor-js-2/issues/2810 - issue 3
      // not using decodeURI since we don't want to decode any html content. This fix is specific to decoding : symbol in th url.

      var re = new RegExp('%3A//', 'g');
      var clean_html = cleaned_html.replace(re, '://');

      if (!editor.opts.fullPage) {
        _setHtml(editor.$el, clean_html);
      } else {
        // Get BODY data.
        var body_html = extractNode(clean_html, 'body') || (clean_html.indexOf('<body') >= 0 ? '' : clean_html);
        var body_attrs = extractNodeAttrs(clean_html, 'body'); // Get HEAD data.

        var head_html = extractNode(clean_html, 'head') || '<title></title>';
        var head_attrs = extractNodeAttrs(clean_html, 'head'); // Get HTML that might be in <head> other than meta tags.
        // https://github.com/froala/wysiwyg-editor/issues/1208

        var $dv = $('<div>');
        $dv.append(head_html).contents().each(function () {
          if (this.nodeType === Node.COMMENT_NODE || ['BASE', 'LINK', 'META', 'NOSCRIPT', 'SCRIPT', 'STYLE', 'TEMPLATE', 'TITLE'].indexOf(this.tagName) >= 0) {
            this.parentNode.removeChild(this);
          }
        });
        var head_bad_html = $dv.html().trim(); // Filter and keep only meta tags in <head>.
        // https://html.spec.whatwg.org/multipage/dom.html#metadata-content-2

        head_html = $('<div>').append(head_html).contents().map(function () {
          if (this.nodeType === Node.COMMENT_NODE) {
            return "<!--".concat(this.nodeValue, "-->");
          } else if (['BASE', 'LINK', 'META', 'NOSCRIPT', 'SCRIPT', 'STYLE', 'TEMPLATE', 'TITLE'].indexOf(this.tagName) >= 0) {
            return this.outerHTML;
          }

          return '';
        }).toArray().join(''); // Get DOCTYPE.

        var doctype = extractDoctype(clean_html); // Get HTML attributes.

        var html_attrs = extractNodeAttrs(clean_html, 'html');

        _setHtml(editor.$el, "".concat(head_bad_html, "\n").concat(body_html));

        editor.node.clearAttributes(editor.el);
        editor.$el.attr(body_attrs);
        editor.$el.addClass('fr-view');
        editor.$el.attr('spellcheck', editor.opts.spellcheck);
        editor.$el.attr('dir', editor.opts.direction);

        _setHtml(editor.$head, head_html);

        editor.node.clearAttributes(editor.$head.get(0));
        editor.$head.attr(head_attrs);
        editor.node.clearAttributes(editor.$html.get(0));
        editor.$html.attr(html_attrs);
        editor.iframe_document.doctype.parentNode.replaceChild(_newDoctype(doctype, editor.iframe_document), editor.iframe_document.doctype);
      } // Make sure the content is editable.


      var disabled = editor.edit.isDisabled();
      editor.edit.on();
      editor.core.injectStyle(editor.opts.iframeDefaultStyle + editor.opts.iframeStyle);

      _normalize();

      if (!editor.opts.useClasses) {
        // Restore orignal attributes if present.
        editor.$el.find('[fr-original-class]').each(function () {
          this.setAttribute('class', this.getAttribute('fr-original-class'));
          this.removeAttribute('fr-original-class');
        });
        editor.$el.find('[fr-original-style]').each(function () {
          this.setAttribute('style', this.getAttribute('fr-original-style'));
          this.removeAttribute('fr-original-style');
        });
      }

      if (disabled) {
        editor.edit.off();
      }

      editor.events.trigger('html.set'); //https://github.com/froala-labs/froala-editor-js-2/issues/1920

      editor.events.trigger('charCounter.update');
    }

    function _specifity(selector) {
      var idRegex = /(#[^\s+>~.[:]+)/g;
      var attributeRegex = /(\[[^]]+\])/g;
      var classRegex = /(\.[^\s+>~.[:]+)/g;
      var pseudoElementRegex = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi;
      var pseudoClassWithBracketsRegex = /(:[\w-]+\([^)]*\))/gi; // A regex for other pseudo classes, which don't have brackets

      var pseudoClassRegex = /(:[^\s+>~.[:]+)/g;
      var elementRegex = /([^\s+>~.[:]+)/g; // Remove the negation psuedo-class (:not) but leave its argument because specificity is calculated on its argument

      (function () {
        var regex = /:not\(([^)]*)\)/g;

        if (regex.test(selector)) {
          selector = selector.replace(regex, '     $1 ');
        }
      })();

      var s = (selector.match(idRegex) || []).length * 100 + (selector.match(attributeRegex) || []).length * 10 + (selector.match(classRegex) || []).length * 10 + (selector.match(pseudoClassWithBracketsRegex) || []).length * 10 + (selector.match(pseudoClassRegex) || []).length * 10 + (selector.match(pseudoElementRegex) || []).length; // Remove universal selector and separator characters

      selector = selector.replace(/[*\s+>~]/g, ' '); // Remove any stray dots or hashes which aren't attached to words
      // These may be present if the user is live-editing this selector

      selector = selector.replace(/[#.]/g, ' ');
      s += (selector.match(elementRegex) || []).length;
      return s;
    }
    /**
     * Do processing on the final html.
     */


    function _processOnGet(el) {
      editor.events.trigger('html.processGet', [el]); // Remove class attribute when empty.

      if (el && el.getAttribute && el.getAttribute('class') === '') {
        el.removeAttribute('class');
      }

      if (el && el.getAttribute && el.getAttribute('style') === '') {
        el.removeAttribute('style');
      } // Look at inner nodes that have no class set.


      if (el && el.nodeType === Node.ELEMENT_NODE) {
        var els = el.querySelectorAll('[class=""],[style=""]');
        var i;

        for (i = 0; i < els.length; i++) {
          var _el = els[i];

          if (_el.getAttribute('class') === '') {
            _el.removeAttribute('class');
          }

          if (_el.getAttribute('style') === '') {
            _el.removeAttribute('style');
          }
        }

        if (el.tagName === 'BR') {
          _processBR(el);
        } else {
          var brs = el.querySelectorAll('br');

          for (i = 0; i < brs.length; i++) {
            _processBR(brs[i]);
          }
        }
      }
    }
    /**
     * Sort elements by spec.
     */


    function _sortElementsBySpec(a, b) {
      return a[3] - b[3];
    }
    /**
     * Sync inputs when getting the HTML.
     */


    function syncInputs() {
      var inputs = editor.el.querySelectorAll('input, textarea');

      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].type === 'checkbox' || inputs[i].type === 'radio') {
          if (inputs[i].checked) {
            inputs[i].setAttribute('checked', inputs[i].checked);
          } else {
            editor.$(inputs[i]).removeAttr('checked');
          }
        }
        /**
         * if the input type has value attribute then only updating the value atrribute.
         * Submit and Reset buttons default value is type names
         */


        if (inputs[i].getAttribute('value')) {
          inputs[i].setAttribute('value', inputs[i].value);
        }
      }
    }
    /**
     * Get HTML.
     */


    function get(keep_markers, keep_classes) {
      if (!editor.$wp) {
        return editor.$oel.clone().removeClass('fr-view').removeAttr('contenteditable').get(0).outerHTML;
      }

      var html = '';
      editor.events.trigger('html.beforeGet'); // Convert STYLE from CSS files to inline style.

      var updated_elms = [];
      var elms_info = {};
      var i;
      var j;
      var elems_specs = [];
      syncInputs();

      if (!editor.opts.useClasses && !keep_classes) {
        var ignoreRegEx = new RegExp("^".concat(editor.opts.htmlIgnoreCSSProperties.join('$|^'), "$"), 'gi');

        for (i = 0; i < editor.doc.styleSheets.length; i++) {
          var rules = void 0;
          var head_style = 0;

          try {
            rules = editor.doc.styleSheets[i].cssRules;

            if (editor.doc.styleSheets[i].ownerNode && editor.doc.styleSheets[i].ownerNode.nodeType === 'STYLE') {
              head_style = 1;
            }
          } catch (ex) {// keep empty.
          }

          if (rules) {
            for (var idx = 0, len = rules.length; idx < len; idx++) {
              if (rules[idx].selectorText) {
                if (rules[idx].style.cssText.length > 0) {
                  var selector = rules[idx].selectorText.replace(/body |\.fr-view /g, '').replace(/::/g, ':');
                  var elms = void 0;

                  try {
                    elms = editor.el.querySelectorAll(selector);
                  } catch (ex) {
                    elms = [];
                  }

                  for (j = 0; j < elms.length; j++) {
                    // Save original style.
                    if (!elms[j].getAttribute('fr-original-style') && elms[j].getAttribute('style')) {
                      elms[j].setAttribute('fr-original-style', elms[j].getAttribute('style'));
                      updated_elms.push(elms[j]);
                    } else if (!elms[j].getAttribute('fr-original-style')) {
                      elms[j].setAttribute('fr-original-style', '');
                      updated_elms.push(elms[j]);
                    }

                    if (!elms_info[elms[j]]) {
                      elms_info[elms[j]] = {};
                    } // Compute specification.


                    var spec = head_style * 1000 + _specifity(rules[idx].selectorText); // Get CSS text of the rule.


                    var css_text = rules[idx].style.cssText.split(';'); // Get each rule.

                    for (var k = 0; k < css_text.length; k++) {
                      // Rule.
                      var rule = css_text[k].trim().split(':')[0];

                      if (!rule) {
                        continue;
                      } // Ignore the CSS rules we don't need.


                      if (rule.match(ignoreRegEx)) {
                        continue;
                      }

                      if (!elms_info[elms[j]][rule]) {
                        elms_info[elms[j]][rule] = 0;

                        if ((elms[j].getAttribute('fr-original-style') || '').indexOf("".concat(rule, ":")) >= 0) {
                          elms_info[elms[j]][rule] = 10000;
                        }
                      } // Current spec is higher than the existing one.


                      if (spec >= elms_info[elms[j]][rule]) {
                        elms_info[elms[j]][rule] = spec;

                        if (css_text[k].trim().length) {
                          var info = css_text[k].trim().split(':');
                          info.splice(0, 1); // Add elements with css values and spec. This will be sorted later.

                          elems_specs.push([elms[j], rule.trim(), info.join(':').trim(), spec]);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        } // Sort elements by spec.


        elems_specs.sort(_sortElementsBySpec); // Add style to elements in the order of specification.

        for (i = 0; i < elems_specs.length; i++) {
          var specs_elem = elems_specs[i];
          specs_elem[0].style[specs_elem[1]] = specs_elem[2];
        } // Save original class.


        for (i = 0; i < updated_elms.length; i++) {
          if (updated_elms[i].getAttribute('class')) {
            updated_elms[i].setAttribute('fr-original-class', updated_elms[i].getAttribute('class'));
            updated_elms[i].removeAttribute('class');
          } // Make sure that we have the inline style first.


          if ((updated_elms[i].getAttribute('fr-original-style') || '').trim().length > 0) {
            var original_rules = updated_elms[i].getAttribute('fr-original-style').split(';');

            for (j = 0; j < original_rules.length; j++) {
              if (original_rules[j].indexOf(':') > 0) {
                var splits = original_rules[j].split(':');
                var original_rule = splits[0];
                splits.splice(0, 1);
                updated_elms[i].style[original_rule.trim()] = splits.join(':').trim();
              }
            }
          }
        }
      } // If editor is not empty.


      if (!editor.node.isEmpty(editor.el)) {
        if (typeof keep_markers === 'undefined') {
          keep_markers = false;
        }

        if (!editor.opts.fullPage) {
          html = editor.$el.html();
        } else {
          html = getDoctype(editor.iframe_document);
          editor.$el.removeClass('fr-view');
          var heightMin = editor.opts.heightMin;
          var height = editor.opts.height;
          var heightMax = editor.opts.heightMax;
          editor.opts.heightMin = null;
          editor.opts.height = null;
          editor.opts.heightMax = null;
          editor.size.refresh();
          html += "<html".concat(editor.node.attributes(editor.$html.get(0)), ">").concat(editor.$html.html(), "</html>");
          editor.opts.heightMin = heightMin;
          editor.opts.height = height;
          editor.opts.heightMax = heightMax;
          editor.size.refresh();
          editor.$el.addClass('fr-view');
        }
      } else if (editor.opts.fullPage) {
        html = getDoctype(editor.iframe_document);
        html += "<html".concat(editor.node.attributes(editor.$html.get(0)), ">").concat(editor.$html.find('head').get(0).outerHTML, "<body></body></html>");
      } // Remove unwanted attributes.


      if (!editor.opts.useClasses && !keep_classes) {
        for (i = 0; i < updated_elms.length; i++) {
          if (updated_elms[i].getAttribute('fr-original-class')) {
            updated_elms[i].setAttribute('class', updated_elms[i].getAttribute('fr-original-class'));
            updated_elms[i].removeAttribute('fr-original-class');
          }

          if (updated_elms[i].getAttribute('fr-original-style') !== null && typeof updated_elms[i].getAttribute('fr-original-style') !== 'undefined') {
            if (updated_elms[i].getAttribute('fr-original-style').length !== 0) {
              updated_elms[i].setAttribute('style', updated_elms[i].getAttribute('fr-original-style'));
            } else {
              updated_elms[i].removeAttribute('style');
            }

            updated_elms[i].removeAttribute('fr-original-style');
          } else {
            updated_elms[i].removeAttribute('style');
          }
        }
      } // Clean helpers.


      if (editor.opts.fullPage) {
        html = html.replace(/<style data-fr-style="true">(?:[\w\W]*?)<\/style>/g, '');
        html = html.replace(/<link([^>]*)data-fr-style="true"([^>]*)>/g, '');
        html = html.replace(/<style(?:[\w\W]*?)class="firebugResetStyles"(?:[\w\W]*?)>(?:[\w\W]*?)<\/style>/g, '');
        html = html.replace(/<body((?:[\w\W]*?)) spellcheck="true"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, '<body$1$2>$3</body>');
        html = html.replace(/<body((?:[\w\W]*?)) contenteditable="(true|false)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, '<body$1$3>$4</body>');
        html = html.replace(/<body((?:[\w\W]*?)) dir="([\w]*)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, '<body$1$3>$4</body>');
        html = html.replace(/<body((?:[\w\W]*?))class="([\w\W]*?)(fr-rtl|fr-ltr)([\w\W]*?)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, '<body$1class="$2$4"$5>$6</body>');
        html = html.replace(/<body((?:[\w\W]*?)) class=""((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g, '<body$1$2>$3</body>');
      } // Ampersand fix.


      if (editor.opts.htmlSimpleAmpersand) {
        html = html.replace(/&amp;/gi, '&');
      }

      editor.events.trigger('html.afterGet'); // Remove markers.

      if (!keep_markers) {
        html = html.replace(/<span[^>]*? class\s*=\s*["']?fr-marker["']?[^>]+>\u200b<\/span>/gi, '');
      }

      html = editor.clean.invisibleSpaces(html);
      html = editor.clean.exec(html, _processOnGet);
      var new_html = editor.events.chainTrigger('html.get', html);

      if (typeof new_html === 'string') {
        html = new_html;
      } // Deal with pre.


      html = html.replace(/<pre(?:[\w\W]*?)>(?:[\w\W]*?)<\/pre>/g, function (str) {
        return str.replace(/<br>/g, '\n');
      }); // Keep META.

      html = html.replace(/<meta((?:[\w\W]*?)) data-fr-http-equiv="/g, '<meta$1 http-equiv="');
      return html;
    }
    /**
     * Get selected HTML.
     */


    function getSelected() {
      function wrapSelection(container, node) {
        // https://github.com/froala-labs/froala-editor-js-2/issues/3795
        while (node && (node.nodeType === Node.TEXT_NODE || !editor.node.isBlock(node)) && !editor.node.isElement(node) && !editor.node.hasClass(node, 'fr-inner') && !(node.nextSibling && (node.nextSibling.nodeName === 'BR' || editor.node.isBlock(node.nextSibling)) || node.previousSibling && (node.previousSibling.nodeName === 'BR' || editor.node.isBlock(node.previousSibling)) || editor.node.hasClass(node.parentNode, 'fr-view'))) {
          if (node && node.nodeType !== Node.TEXT_NODE) {
            $(container).wrapInner(editor.node.openTagString(node) + editor.node.closeTagString(node));
          }

          node = node.parentNode;
        } // else if is for https://github.com/froala/wysiwyg-editor/issues/3352


        if (node && container.innerHTML === node.innerHTML) {
          container.innerHTML = node.outerHTML;
        } else if (node.innerText && node.innerText.indexOf(container.innerHTML) != -1) {
          container.innerHTML = editor.node.openTagString(node) + node.innerHTML + editor.node.closeTagString(node);
        } else if (node.nextSibling && (node.nextSibling.nodeName === 'BR' || editor.node.isBlock(node.nextSibling)) || node.previousSibling && (node.previousSibling.nodeName === 'BR' || editor.node.isBlock(node.previousSibling)) && node.wholeText) {
          container.innerHTML = node.wholeText;
        }
      }

      function selectionParent() {
        var parent = null;
        var sel;

        if (editor.win.getSelection) {
          sel = editor.win.getSelection();

          if (sel && sel.rangeCount) {
            parent = sel.getRangeAt(0).commonAncestorContainer;

            if (parent.nodeType !== Node.ELEMENT_NODE && editor.opts.enter !== FroalaEditor.ENTER_BR) {
              parent = parent.parentNode;
            }
          }
        } else if ((sel = editor.doc.selection) && sel.type !== 'Control') {
          parent = sel.createRange().parentElement();
        }

        if (parent !== null && ($(parent).parents().toArray().indexOf(editor.el) >= 0 || parent === editor.el)) {
          return parent;
        }

        return null;
      }

      var html = '';

      if (typeof editor.win.getSelection !== 'undefined') {
        // Multiple ranges hack.
        if (editor.browser.mozilla) {
          editor.selection.save();

          if (editor.$el.find('.fr-marker[data-type="false"]').length > 1) {
            editor.$el.find('.fr-marker[data-type="false"][data-id="0"]').remove();
            editor.$el.find('.fr-marker[data-type="false"]:last').attr('data-id', '0');
            editor.$el.find('.fr-marker').not('[data-id="0"]').remove();
          }

          editor.selection.restore();
        }

        var ranges = editor.selection.ranges();

        for (var i = 0; i < ranges.length; i++) {
          var container = document.createElement('div');
          container.appendChild(ranges[i].cloneContents());
          wrapSelection(container, selectionParent()); // Fix for https://github.com/froala/wysiwyg-editor/issues/1010.

          if ($(container).find('.fr-element').length > 0) {
            container = editor.el;
          }

          html += container.innerHTML;
        }
      } else if (typeof editor.doc.selection !== 'undefined') {
        if (editor.doc.selection.type === 'Text') {
          html = editor.doc.selection.createRange().htmlText;
        }
      }

      return html;
    }

    function _hasBlockTags(html) {
      var tmp = editor.doc.createElement('div');
      tmp.innerHTML = html;
      return tmp.querySelector(blockTagsQuery()) !== null;
    }

    function _setCursorAtEnd(html) {
      var tmp = editor.doc.createElement('div');
      tmp.innerHTML = html;
      editor.selection.setAtEnd(tmp, true);
      return tmp.innerHTML;
    }

    function escapeEntities(str) {
      return str.replace(/</gi, '&lt;').replace(/>/gi, '&gt;').replace(/"/gi, '&quot;').replace(/'/gi, '&#39;');
    }

    function _unwrapForLists(html) {
      if (!editor.html.defaultTag()) {
        return html;
      }

      var tmp = editor.doc.createElement('div');
      tmp.innerHTML = html; // https://github.com/froala/wysiwyg-editor/issues/1553. Unwrap default tags from lists.

      var default_tag_els = tmp.querySelectorAll(":scope > ".concat(editor.html.defaultTag()));

      for (var i = default_tag_els.length - 1; i >= 0; i--) {
        var el = default_tag_els[i];

        if (!editor.node.isBlock(el.previousSibling)) {
          // Check previous sibling in order to add br.
          if (el.previousSibling && !editor.node.isEmpty(el)) {
            $('<br>').insertAfter(el.previousSibling);
          } // Unwrap.


          el.outerHTML = el.innerHTML;
        }
      }

      return tmp.innerHTML;
    }

    function isCustomPopupInsert() {
      var range = editor.selection.ranges(0);
      var container = range.commonAncestorContainer; // Check if selection is inside editor.

      if (container !== editor.el && !editor.$el.contains(container)) {
        return true;
      }

      return false;
    }
    /**
     * Insert HTML.
     */


    function insert(dirty_html, clean, do_split) {
      // There is no selection.
      if (!editor.selection.isCollapsed()) {
        editor.selection.remove();
      }

      var clean_html;

      if (!clean) {
        clean_html = editor.clean.html(dirty_html);
      } else {
        clean_html = dirty_html;
      }

      if (dirty_html.indexOf('<i class="fa ') === 0) {
        clean_html = "<span>&nbsp;".concat(clean_html, "</span>");
      }

      if (dirty_html.indexOf('class="fr-marker"') < 0) {
        clean_html = _setCursorAtEnd(clean_html);
      } // Editor is empty and there are block tags in the pasted HTML.


      if (editor.node.isEmpty(editor.el) && !editor.opts.keepFormatOnDelete && _hasBlockTags(clean_html)) {
        if (editor.opts.trackChangesEnabled) {
          editor.track_changes.pasteInEmptyEdior(clean_html);
        } else {
          editor.el.innerHTML = clean_html;
        }
      } else {
        // https://github.com/froala-labs/froala-editor-js-2/issues/3394
        // add extra marker if the custom popup has input box which causes selection lost
        if (isCustomPopupInsert()) {
          editor.selection.restore();
        } // Insert a marker.


        var marker = editor.markers.insert();

        if (!marker) {
          editor.el.innerHTML += clean_html;
        } else {
          if (editor.opts.trackChangesEnabled) {
            editor.track_changes.pasteInEdior(clean_html);
          } else {
            // Do not insert html inside emoticon.
            if (editor.node.isLastSibling(marker) && $(marker).parent().hasClass('fr-deletable')) {
              $(marker).insertAfter($(marker).parent());
            } // Check if HTML contains block tags and if so then break the current HTML.


            var block_parent = editor.node.blockParent(marker);

            if ((_hasBlockTags(clean_html) || do_split) && (editor.node.deepestParent(marker) || block_parent && block_parent.tagName === 'LI')) {
              if (block_parent && block_parent.tagName === 'LI') {
                clean_html = _unwrapForLists(clean_html);
              }

              marker = editor.markers.split();

              if (!marker) {
                return false;
              }

              marker.outerHTML = clean_html;
            } else {
              marker.outerHTML = clean_html;
            }
          }
        }
      }

      _normalize();

      editor.keys.positionCaret();
      editor.events.trigger('html.inserted');
    }
    /**
     * Clean those tags that have an invisible space inside.
     */


    function cleanWhiteTags(ignore_selection) {
      var current_el = null;

      if (typeof ignore_selection === 'undefined') {
        current_el = editor.selection.element();
      }

      if (editor.opts.keepFormatOnDelete) {
        return false;
      }

      var current_white = current_el ? (current_el.textContent.match(/\u200B/g) || []).length - current_el.querySelectorAll('.fr-marker').length : 0;
      var total_white = (editor.el.textContent.match(/\u200B/g) || []).length - editor.el.querySelectorAll('.fr-marker').length;

      if (total_white === current_white) {
        return false;
      }

      var possible_elements;
      var removed;

      do {
        removed = false;
        possible_elements = editor.el.querySelectorAll('*:not(.fr-marker)');

        for (var i = 0; i < possible_elements.length; i++) {
          var el = possible_elements[i];

          if (current_el === el) {
            continue;
          }

          var text = el.textContent;

          if (el.children.length === 0 && text.length === 1 && text.charCodeAt(0) === 8203 && el.tagName !== 'TD') {
            $(el).remove();
            removed = true;
          }
        }
      } while (removed);
    }

    function _cleanTags() {
      cleanWhiteTags();

      if (editor.placeholder) {
        setTimeout(editor.placeholder.refresh, 0);
      }
    }
    /**
     * Initialization.
     */


    function _init() {
      editor.events.$on(editor.$el, 'mousemove', 'span.fr-word-select', function (e) {
        var selection = window.getSelection();
        selection = window.getSelection();
        var range = document.createRange();
        range.selectNodeContents(e.target);
        selection.removeAllRanges();
        selection.addRange(range);
      });

      if (editor.$wp) {
        editor.events.on('mouseup', _cleanTags);
        editor.events.on('keydown', _cleanTags);
        editor.events.on('contentChanged', checkIfEmpty);
      }
    }

    return {
      defaultTag: defaultTag,
      isPreformatted: isPreformatted,
      emptyBlocks: emptyBlocks,
      emptyBlockTagsQuery: emptyBlockTagsQuery,
      blockTagsQuery: blockTagsQuery,
      fillEmptyBlocks: fillEmptyBlocks,
      cleanEmptyTags: cleanEmptyTags,
      cleanWhiteTags: cleanWhiteTags,
      cleanBlankSpaces: cleanBlankSpaces,
      blocks: blocks,
      getDoctype: getDoctype,
      set: set,
      syncInputs: syncInputs,
      get: get,
      getSelected: getSelected,
      insert: insert,
      wrap: _wrap,
      unwrap: unwrap,
      escapeEntities: escapeEntities,
      checkIfEmpty: checkIfEmpty,
      extractNode: extractNode,
      extractNodeAttrs: extractNodeAttrs,
      extractDoctype: extractDoctype,
      cleanBRs: cleanBRs,
      _init: _init,
      _setHtml: _setHtml
    };
  };

  FroalaEditor.ENTER_P = 0;
  FroalaEditor.ENTER_DIV = 1;
  FroalaEditor.ENTER_BR = 2;
  FroalaEditor.KEYCODE = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40,
    DELETE: 46,
    ZERO: 48,
    ONE: 49,
    TWO: 50,
    THREE: 51,
    FOUR: 52,
    FIVE: 53,
    SIX: 54,
    SEVEN: 55,
    EIGHT: 56,
    NINE: 57,
    FF_SEMICOLON: 59,
    // Firefox (Gecko) fires this for semicolon instead of 186
    FF_EQUALS: 61,
    // Firefox (Gecko) fires this for equals instead of 187
    QUESTION_MARK: 63,
    // needs localization
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    META: 91,
    NUM_ZERO: 96,
    NUM_ONE: 97,
    NUM_TWO: 98,
    NUM_THREE: 99,
    NUM_FOUR: 100,
    NUM_FIVE: 101,
    NUM_SIX: 102,
    NUM_SEVEN: 103,
    NUM_EIGHT: 104,
    NUM_NINE: 105,
    NUM_MULTIPLY: 106,
    NUM_PLUS: 107,
    NUM_MINUS: 109,
    NUM_PERIOD: 110,
    NUM_DIVISION: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    FF_HYPHEN: 173,
    // Firefox (Gecko) fires this for hyphen instead of 189s
    SEMICOLON: 186,
    // needs localization
    DASH: 189,
    // needs localization
    EQUALS: 187,
    // needs localization
    COMMA: 188,
    // needs localization
    HYPHEN: 189,
    // needs localization
    PERIOD: 190,
    // needs localization
    SLASH: 191,
    // needs localization
    APOSTROPHE: 192,
    // needs localization
    TILDE: 192,
    // needs localization
    SINGLE_QUOTE: 222,
    // needs localization
    OPEN_SQUARE_BRACKET: 219,
    // needs localization
    BACKSLASH: 220,
    // needs localization
    CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    IME: 229
  }; // Extend defaults.

  Object.assign(FroalaEditor.DEFAULTS, {
    enter: FroalaEditor.ENTER_P,
    multiLine: true,
    tabSpaces: 0
  });

  FroalaEditor.MODULES.keys = function (editor) {
    var $ = editor.$;
    var IME = false;
    /**
     * ENTER.
     */

    function _enter(e) {
      if (!editor.opts.multiLine) {
        e.preventDefault();
        e.stopPropagation();
      } // Not iOS.
      else {
        // Do not prevent default on IOS.
        if (!editor.helpers.isIOS()) {
          e.preventDefault();
          e.stopPropagation();
        }

        if (!editor.selection.isCollapsed()) {
          editor.selection.remove();
        }

        editor.cursor.enter();
      }
    }
    /**
     * SHIFT ENTER.
     */


    function _shiftEnter(e) {
      e.preventDefault();
      e.stopPropagation();

      if (editor.opts.multiLine) {
        if (!editor.selection.isCollapsed()) {
          editor.selection.remove();
        }

        editor.cursor.enter(true);
      }
    }
    /**
     * Control/Command Backspace.
     */


    function _ctlBackspace() {
      setTimeout(function () {
        editor.events.disableBlur();
        editor.events.focus();
      }, 0);
    }
    /**
     * BACKSPACE.
     */


    function _backspace(e) {
      // There is no selection.
      if (editor.selection.isCollapsed()) {
        if (['INPUT', 'BUTTON', 'TEXTAREA'].indexOf(e.target && e.target.tagName) < 0) {
          editor.cursor.backspace();
        }

        if (editor.helpers.isIOS()) {
          var range = editor.selection.ranges(0);
          range.deleteContents();
          range.insertNode(document.createTextNode("\u200B"));
          var sel = editor.selection.get();
          sel.modify('move', 'forward', 'character');
        } else {
          if (['INPUT', 'BUTTON', 'TEXTAREA'].indexOf(e.target && e.target.tagName) < 0) {
            e.preventDefault();
          }

          e.stopPropagation();
        }
      } // We have text selected.
      else {
        e.preventDefault();
        e.stopPropagation();
        editor.selection.remove();
      }

      editor.placeholder.refresh();
    }
    /**
     * DELETE
     */


    function _del(e) {
      if (['INPUT', 'BUTTON', 'TEXTAREA'].indexOf(e.target && e.target.tagName) < 0) {
        e.preventDefault();
      }

      e.stopPropagation(); // There is no selection or only image selection.
      // https://github.com/froala/wysiwyg-editor/issues/3342
      // https://github.com/froala-labs/froala-editor-js-2/issues/3198

      if (editor.selection.text() === '' && !(editor.selection.element().hasAttribute('contenteditable') && editor.selection.element().getAttribute('contenteditable') === 'false') && (editor.selection.isCollapsed() || editor.selection.element().tagName != 'IMG')) {
        editor.cursor.del();
      } // We have text selected.
      else {
        editor.selection.remove();
      }

      editor.placeholder.refresh();
    }
    /**
     * SPACE
     */


    function _space(e) {
      var el = editor.selection.element(); // Do nothing on mobile.
      // Browser is Mozilla or we're inside a link tag.

      if (!editor.helpers.isMobile() && el && el.tagName === 'A') {
        e.preventDefault();
        e.stopPropagation();

        if (!editor.selection.isCollapsed()) {
          editor.selection.remove();
        }

        var marker = editor.markers.insert();

        if (marker) {
          var prev_node = marker.previousSibling;
          var next_node = marker.nextSibling;

          if (!next_node && marker.parentNode && marker.parentNode.tagName === 'A') {
            marker.parentNode.insertAdjacentHTML('afterend', "&nbsp;".concat(FroalaEditor.MARKERS));
            marker.parentNode.removeChild(marker);
          } else {
            if (prev_node && prev_node.nodeType === Node.TEXT_NODE && prev_node.textContent.length === 1 && prev_node.textContent.charCodeAt(0) === 160) {
              prev_node.textContent += ' ';
            } else {
              marker.insertAdjacentHTML('beforebegin', '&nbsp;');
            }

            marker.outerHTML = FroalaEditor.MARKERS;
          }

          editor.selection.restore();
        }
      }
    }
    /**
     * Handle typing in Korean for FF.
     */


    function _input() {
      // Select is collapsed and we're not using IME.
      if (editor.browser.mozilla && editor.selection.isCollapsed() && !IME) {
        var range = editor.selection.ranges(0);
        var start_container = range.startContainer;
        var start_offset = range.startOffset; // Start container is text and last char before cursor is space.

        if (start_container && start_container.nodeType === Node.TEXT_NODE && start_offset <= start_container.textContent.length && start_offset > 0 && start_container.textContent.charCodeAt(start_offset - 1) === 32) {
          editor.selection.save();
          editor.spaces.normalize();
          editor.selection.restore();
        }
      }
    }
    /**
     * Cut.
     */


    function _cut() {
      if (editor.selection.isFull()) {
        setTimeout(function () {
          var default_tag = editor.html.defaultTag();

          if (default_tag) {
            editor.$el.html("<".concat(default_tag, ">").concat(FroalaEditor.MARKERS, "<br/></").concat(default_tag, ">"));
          } else {
            editor.$el.html("".concat(FroalaEditor.MARKERS, "<br/>"));
          }

          editor.selection.restore();
          editor.placeholder.refresh();
          editor.button.bulkRefresh();
          editor.undo.saveStep();
        }, 0);
      }
    }
    /**
     * Tab.
     */


    function _tab(e) {
      if (editor.opts.tabSpaces > 0) {
        if (editor.selection.isCollapsed()) {
          editor.undo.saveStep();
          e.preventDefault();
          e.stopPropagation();
          var str = '';

          for (var i = 0; i < editor.opts.tabSpaces; i++) {
            str += '&nbsp;';
          }

          editor.html.insert(str);
          editor.placeholder.refresh();
          editor.undo.saveStep();
        } else {
          e.preventDefault();
          e.stopPropagation();

          if (!e.shiftKey) {
            editor.commands.indent();
          } else {
            editor.commands.outdent();
          }
        }
      }
    }
    /**
     * Map keyPress actions.
     */


    function _mapKeyPress() {
      IME = false;
    }

    function _clearIME() {
      IME = false;
    }
    /**
     * If is IME.
     */


    function isIME() {
      return IME;
    }

    var key_down_code;

    function _empty() {
      var default_tag = editor.html.defaultTag();

      if (default_tag) {
        editor.$el.html("<".concat(default_tag, ">").concat(FroalaEditor.MARKERS, "<br/></").concat(default_tag, ">"));
      } else {
        editor.$el.html("".concat(FroalaEditor.MARKERS, "<br/>"));
      }

      editor.selection.restore();
    }
    /**
     * https://github.com/froala-labs/froala-editor-js-2/issues/1864
     * Extra Space after Image in list (ul, ol).
     */


    function ImageCaptionSpace(sel_el, e) {
      if (sel_el.parentElement && (sel_el.innerHTML.indexOf('<span') > -1 || sel_el.parentElement.innerHTML.indexOf('<span') > -1 || sel_el.parentElement.parentElement.innerHTML.indexOf('<span') > -1)) {
        if (sel_el.classList.contains('fr-img-space-wrap') || sel_el.parentElement.classList.contains('fr-img-space-wrap') || sel_el.parentElement.parentElement.classList.contains('fr-img-space-wrap')) {
          if ($(sel_el.parentElement).is('p')) {
            var strHTML = sel_el.parentElement.innerHTML;
            strHTML = strHTML.replace(/<br>/g, '');

            if (strHTML.length < 1) {
              sel_el.parentElement.insertAdjacentHTML('afterbegin', '&nbsp;');
            } else if (strHTML != '&nbsp;' && strHTML != ' ' && e.key == 'Backspace') {
              _backspace(e);
            } else if (strHTML != '&nbsp;' && strHTML != ' ' && e.key == 'Delete') {
              _del(e);
            }

            return true;
          } else if ($(sel_el).is('p')) {
            var orgStr = sel_el.innerHTML;

            var _strHTML = orgStr.replace(/<br>/g, '');

            if (_strHTML.length < 1) {
              sel_el.insertAdjacentHTML('afterbegin', '&nbsp;');
            } else if (_strHTML != '&nbsp;' && _strHTML != ' ' && e.key == 'Backspace') {
              _backspace(e);
            } else if (_strHTML != '&nbsp;' && _strHTML != ' ' && e.key == 'Delete') {
              _del(e);
            }

            return true;
          }
        }
      }

      return false;
    }
    /**
     * Map keyDown actions.
     */


    function _mapKeyDown(e) {
      var sel_el = editor.selection.element();

      if (sel_el && ['INPUT', 'TEXTAREA'].indexOf(sel_el.tagName) >= 0) {
        return true;
      }

      if (e && isArrow(e.which)) {
        return true;
      }

      editor.events.disableBlur();
      var key_code = e.which;

      if (key_code === 16) {
        return true;
      }

      key_down_code = key_code; // Handle Japanese typing.

      if (key_code === FroalaEditor.KEYCODE.IME) {
        IME = true;
        return true;
      }

      IME = false;
      if (ctrlKey(e)) return true;
      var char_key = isCharacter(key_code) && !ctrlKey(e) && !e.altKey;
      var del_key = key_code === FroalaEditor.KEYCODE.BACKSPACE || key_code === FroalaEditor.KEYCODE.DELETE; // 1. Selection is full.
      // 2. Del key is hit, editor is empty and there is keepFormatOnDelete.

      if (editor.selection.isFull() && !editor.opts.keepFormatOnDelete && !editor.placeholder.isVisible() || del_key && editor.placeholder.isVisible() && editor.opts.keepFormatOnDelete) {
        if (char_key || del_key) {
          _empty();

          if (!isCharacter(key_code)) {
            e.preventDefault();
            return true;
          }
        }
      } // ENTER.


      if (key_code === FroalaEditor.KEYCODE.ENTER) {
        //code edited https://github.com/froala-labs/froala-editor-js-2/issues/1864
        // added code for fr-inner class check
        if (!editor.helpers.isIOS() && e.shiftKey || sel_el.classList.contains('fr-inner') || sel_el.parentElement.classList.contains('fr-inner')) {
          _shiftEnter(e);
        } else {
          _enter(e);
        }
      } // Ctrl/Command Backspace.
      else if (key_code === FroalaEditor.KEYCODE.BACKSPACE && (e.metaKey || e.ctrlKey)) {
        _ctlBackspace();
      } // Backspace.
      else if (key_code === FroalaEditor.KEYCODE.BACKSPACE && !ctrlKey(e) && !e.altKey) {
        // https://github.com/froala-labs/froala-editor-js-2/issues/1864
        if (ImageCaptionSpace(sel_el, e)) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        if (!editor.placeholder.isVisible()) {
          _backspace(e);
        } else {
          if (!editor.opts.keepFormatOnDelete) {
            _empty();
          }

          e.preventDefault();
          e.stopPropagation();
        }
      } // Delete.
      else if (key_code === FroalaEditor.KEYCODE.DELETE && !ctrlKey(e) && !e.altKey && !e.shiftKey) {
        // https://github.com/froala-labs/froala-editor-js-2/issues/1864
        if (ImageCaptionSpace(sel_el, e)) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        if (!editor.placeholder.isVisible()) {
          _del(e);
        } else {
          if (!editor.opts.keepFormatOnDelete) {
            _empty();
          }

          e.preventDefault();
          e.stopPropagation();
        }
      } // Space.
      else if (key_code === FroalaEditor.KEYCODE.SPACE) {
        _space(e);
      } // Tab.
      else if (key_code === FroalaEditor.KEYCODE.TAB) {
        _tab(e);
      } // Char key.
      else if (!ctrlKey(e) && isCharacter(e.which) && !editor.selection.isCollapsed() && !e.ctrlKey && !e.altKey) {
        editor.selection.remove();
      }

      editor.events.enableBlur();
    }
    /**
     * Remove U200B.
     */


    function _replaceU200B(el) {
      // https://github.com/froala-labs/froala-editor-js-2/issues/3855
      var ele = el;

      if (['STRONG', 'U', 'EM'].indexOf(el.nodeName) > -1 && el.parentNode) {
        ele = el.parentNode;
      }

      var walker = editor.doc.createTreeWalker(ele, NodeFilter.SHOW_TEXT, editor.node.filter(function (node) {
        return /\u200B/gi.test(node.textContent);
      }), false);

      while (walker.nextNode()) {
        var node = walker.currentNode;
        node.textContent = node.textContent.replace(/\u200B/gi, '');
      }
    }

    function positionCaret() {
      if (!editor.$wp) {
        return true;
      }

      var info;

      if (!editor.opts.height && !editor.opts.heightMax) {
        // Make sure we scroll bottom.
        info = editor.position.getBoundingRect().top; // https://github.com/froala/wysiwyg-editor/issues/834.

        if (editor.opts.toolbarBottom) {
          info += editor.opts.toolbarStickyOffset;
        }

        if (editor.helpers.isIOS() || editor.helpers.isAndroid()) {
          info -= editor.helpers.scrollTop();
        }

        if (editor.opts.iframe) {
          info += editor.$iframe.offset().top; // https://github.com/froala-labs/froala-editor-js-2/issues/432 . getBoundingRect will return different results in iframe because the viewport.

          info -= editor.helpers.scrollTop();
        }

        info += editor.opts.toolbarStickyOffset;

        if (info > editor.o_win.innerHeight - 20) {
          $(editor.o_win).scrollTop(info + editor.helpers.scrollTop() - editor.o_win.innerHeight + 20);
        } // Make sure we scroll top.


        info = editor.position.getBoundingRect().top; // https://github.com/froala/wysiwyg-editor/issues/834.

        if (!editor.opts.toolbarBottom) {
          info -= editor.opts.toolbarStickyOffset;
        }

        if (editor.helpers.isIOS() || editor.helpers.isAndroid()) {
          info -= editor.helpers.scrollTop();
        }

        if (editor.opts.iframe) {
          info += editor.$iframe.offset().top; // https://github.com/froala-labs/froala-editor-js-2/issues/432 . getBoundingRect will return different results in iframe because the viewport.

          info -= editor.helpers.scrollTop();
        }

        if (info < 100) {
          $(editor.o_win).scrollTop(info + editor.helpers.scrollTop() - 100);
        }
      } else {
        // Make sure we scroll bottom.
        info = editor.position.getBoundingRect().top;

        if (editor.helpers.isIOS() || editor.helpers.isAndroid()) {
          info -= editor.helpers.scrollTop();
        }

        if (editor.opts.iframe) {
          info += editor.$iframe.offset().top;
        } // https://github.com/froala-labs/froala-editor-js-2/issues/2075


        var current_block = editor.selection.blocks();
        var offsetTop = null;

        if (current_block && current_block.length > 0 && current_block[0].offsetTop) {
          offsetTop = current_block[0].getBoundingClientRect().top;
        }

        if (!editor.opts.iframe && info > editor.$wp.offset().top - editor.helpers.scrollTop() + editor.$wp.height() - 20) {
          editor.$wp.scrollTop(info + editor.$wp.scrollTop() - (editor.$wp.height() + editor.$wp.offset().top) + editor.helpers.scrollTop() + 20);
        } else if (editor.opts.iframe && offsetTop > editor.$wp.height() && offsetTop) {
          editor.$wp.scrollTop(offsetTop - editor.$wp.height() + 80);
        }
      }
    }
    /**
     * Map keyUp actions.
     */


    function _mapKeyUp(e) {
      var sel_el = editor.selection.element();

      if (sel_el && ['INPUT', 'TEXTAREA'].indexOf(sel_el.tagName) >= 0) {
        return true;
      } // When using iOS soft keyboard, in keyup we get 0 for keycode,
      // therefore, we are using the one we got on keydown.


      if (e && e.which === 0 && key_down_code) {
        e.which = key_down_code;
      }

      if (editor.helpers.isAndroid() && editor.browser.mozilla) {
        return true;
      } // IME IE.


      if (IME) {
        return false;
      } // Revert ios default ENTER.


      if (e && editor.helpers.isIOS() && e.which === FroalaEditor.KEYCODE.ENTER) {
        editor.doc.execCommand('undo');
      }

      if (!editor.selection.isCollapsed()) {
        return true;
      }

      if (e && (e.which === FroalaEditor.KEYCODE.META || e.which === FroalaEditor.KEYCODE.CTRL)) {
        return true;
      }

      if (e && isArrow(e.which)) {
        return true;
      }

      if (e && !editor.helpers.isIOS() && (e.which === FroalaEditor.KEYCODE.ENTER || e.which === FroalaEditor.KEYCODE.BACKSPACE || e.which >= 37 && e.which <= 40 && !editor.browser.msie)) {
        try {
          positionCaret();
        } catch (ex) {// ok.
        }
      } // Remove invisible space where possible.


      function has_invisible(node) {
        if (!node) {
          return false;
        }

        var text = node.innerHTML;
        text = text.replace(/<span[^>]*? class\s*=\s*["']?fr-marker["']?[^>]+>\u200b<\/span>/gi, '');

        if (text && /\u200B/.test(text) && text.replace(/\u200B/gi, '').length > 0) {
          return true;
        }

        return false;
      }

      function ios_CJK(el) {
        var CJKRegEx = /[\u3041-\u3096\u30A0-\u30FF\u4E00-\u9FFF\u3130-\u318F\uAC00-\uD7AF]/gi;
        return !editor.helpers.isIOS() || ((el.textContent || '').match(CJKRegEx) || []).length === 0;
      } // Get the selection element.


      var el = editor.selection.element();

      if (has_invisible(el) && !editor.node.hasClass(el, 'fr-marker') && el.tagName !== 'IFRAME' && ios_CJK(el)) {
        editor.selection.save();

        _replaceU200B(el);

        editor.selection.restore();
      }
    } // Check if we should consider that CTRL key is pressed.


    function ctrlKey(e) {
      if (navigator.userAgent.indexOf('Mac OS X') !== -1) {
        if (e.metaKey && !e.altKey) {
          return true;
        }
      } else if (e.ctrlKey && !e.altKey) {
        return true;
      }

      return false;
    }

    function isArrow(key_code) {
      if (key_code >= FroalaEditor.KEYCODE.ARROW_LEFT && key_code <= FroalaEditor.KEYCODE.ARROW_DOWN) {
        return true;
      }
    }

    function isCharacter(key_code) {
      if (key_code >= FroalaEditor.KEYCODE.ZERO && key_code <= FroalaEditor.KEYCODE.NINE) {
        return true;
      }

      if (key_code >= FroalaEditor.KEYCODE.NUM_ZERO && key_code <= FroalaEditor.KEYCODE.NUM_MULTIPLY) {
        return true;
      }

      if (key_code >= FroalaEditor.KEYCODE.A && key_code <= FroalaEditor.KEYCODE.Z) {
        return true;
      } // Safari sends zero key code for non-latin characters.


      if (editor.browser.webkit && key_code === 0) {
        return true;
      }

      switch (key_code) {
        case FroalaEditor.KEYCODE.SPACE:
        case FroalaEditor.KEYCODE.QUESTION_MARK:
        case FroalaEditor.KEYCODE.NUM_PLUS:
        case FroalaEditor.KEYCODE.NUM_MINUS:
        case FroalaEditor.KEYCODE.NUM_PERIOD:
        case FroalaEditor.KEYCODE.NUM_DIVISION:
        case FroalaEditor.KEYCODE.SEMICOLON:
        case FroalaEditor.KEYCODE.FF_SEMICOLON:
        case FroalaEditor.KEYCODE.DASH:
        case FroalaEditor.KEYCODE.EQUALS:
        case FroalaEditor.KEYCODE.FF_EQUALS:
        case FroalaEditor.KEYCODE.COMMA:
        case FroalaEditor.KEYCODE.PERIOD:
        case FroalaEditor.KEYCODE.SLASH:
        case FroalaEditor.KEYCODE.APOSTROPHE:
        case FroalaEditor.KEYCODE.SINGLE_QUOTE:
        case FroalaEditor.KEYCODE.OPEN_SQUARE_BRACKET:
        case FroalaEditor.KEYCODE.BACKSLASH:
        case FroalaEditor.KEYCODE.CLOSE_SQUARE_BRACKET:
          return true;

        default:
          return false;
      }
    }

    var _typing_timeout;

    var _temp_snapshot;

    function _typingKeyDown(e) {
      var keycode = e.which;

      if (ctrlKey(e) || keycode >= 37 && keycode <= 40 || !isCharacter(keycode) && keycode !== FroalaEditor.KEYCODE.DELETE && keycode !== FroalaEditor.KEYCODE.BACKSPACE && keycode !== FroalaEditor.KEYCODE.ENTER && keycode !== FroalaEditor.KEYCODE.IME) {
        return true;
      }

      if (!_typing_timeout) {
        _temp_snapshot = editor.snapshot.get();

        if (!editor.undo.canDo()) {
          editor.undo.saveStep();
        }
      }

      clearTimeout(_typing_timeout);
      _typing_timeout = setTimeout(function () {
        _typing_timeout = null;
        editor.undo.saveStep();
      }, Math.max(250, editor.opts.typingTimer));
    }

    function _typingKeyUp(e) {
      var keycode = e.which;

      if (ctrlKey(e) || keycode >= 37 && keycode <= 40) {
        return true;
      }

      if (_temp_snapshot && _typing_timeout) {
        editor.undo.saveStep(_temp_snapshot);
        _temp_snapshot = null;
      } // iOS choosing suggestion.
      else if ((typeof keycode === 'undefined' || keycode === 0) && !_temp_snapshot && !_typing_timeout) {
        editor.undo.saveStep();
      }
    }

    function forceUndo() {
      if (_typing_timeout) {
        clearTimeout(_typing_timeout);
        editor.undo.saveStep();
        _temp_snapshot = null;
      }
    }
    /**
     * Check if key event is part of browser accessibility.
     */


    function isBrowserAction(e) {
      var keycode = e.which;
      return ctrlKey(e) || keycode === FroalaEditor.KEYCODE.F5;
    } // Node doesn't have a BR or text inside it.


    function _isEmpty(node) {
      if (node && node.tagName === 'BR') {
        return false;
      } // No text and no BR.
      // Special case for image caption / video.


      try {
        return (node.textContent || '').length === 0 && node.querySelector && !node.querySelector(':scope > br') || node.childNodes && node.childNodes.length === 1 && node.childNodes[0].getAttribute && (node.childNodes[0].getAttribute('contenteditable') === 'false' || editor.node.hasClass(node.childNodes[0], 'fr-img-caption'));
      } catch (ex) {
        return false;
      }
    }
    /**
     * Allow typing after/before last element.
     */


    function _allowTypingOnEdges(e) {
      var childs = editor.el.childNodes;
      var dt = editor.html.defaultTag();
      var deep_parent = editor.node.blockParent(editor.selection.blocks()[0]); // https://github.com/froala-labs/froala-editor-js-2/issues/1571

      if (deep_parent && deep_parent.tagName == 'TR' && deep_parent.getAttribute('contenteditable') == undefined) {
        deep_parent = deep_parent.closest('table');
      } // https://github.com/CelestialSystem/froala-editor-js-2/tree/1303
      // get the selected text block parent as deep_parent
      // Check for content editable:false node and disable toolbar


      if (!editor.node.isEditable(e.target) || deep_parent && deep_parent.getAttribute('contenteditable') === 'false') {
        editor.toolbar.disable();
      } else {
        editor.toolbar.enable();
      }

      if (e.target && e.target !== editor.el) {
        return true;
      } // No childs.


      if (childs.length === 0) {
        return true;
      } // At the bottom.
      // https://github.com/froala/wysiwyg-editor/issues/3397


      if (childs[0].offsetHeight + childs[0].offsetTop <= e.offsetY) {
        if (_isEmpty(childs[childs.length - 1])) {
          if (dt) {
            editor.$el.append("<".concat(dt, ">").concat(FroalaEditor.MARKERS, "<br></").concat(dt, ">"));
          } else {
            editor.$el.append("".concat(FroalaEditor.MARKERS, "<br>"));
          } // Restore selection and scroll.


          editor.selection.restore();
          positionCaret();
        }
      } // At the top
      else if (e.offsetY <= 10) {
        if (_isEmpty(childs[0])) {
          if (dt) {
            editor.$el.prepend("<".concat(dt, ">").concat(FroalaEditor.MARKERS, "<br></").concat(dt, ">"));
          } else {
            editor.$el.prepend("".concat(FroalaEditor.MARKERS, "<br>"));
          } // Restore selection and scroll.


          editor.selection.restore();
          positionCaret();
        }
      }
    }

    function _clearTypingTimer() {
      if (_typing_timeout) {
        clearTimeout(_typing_timeout);
      }
    }
    /**
     * Tear up.
     */


    function _init() {
      editor.events.on('keydown', _typingKeyDown);
      editor.events.on('input', _input);
      editor.events.on('mousedown', _clearIME);
      editor.events.on('keyup input', _typingKeyUp); // Register for handling.

      editor.events.on('keypress', _mapKeyPress);
      editor.events.on('keydown', _mapKeyDown);
      editor.events.on('keyup', _mapKeyUp);
      editor.events.on('destroy', _clearTypingTimer);
      editor.events.on('html.inserted', _mapKeyUp); // Handle cut.

      editor.events.on('cut', _cut); // Click in editor at beginning / end.

      if (editor.opts.multiLine) {
        editor.events.on('click', _allowTypingOnEdges);
      }
    }

    return {
      _init: _init,
      ctrlKey: ctrlKey,
      isCharacter: isCharacter,
      isArrow: isArrow,
      forceUndo: forceUndo,
      isIME: isIME,
      isBrowserAction: isBrowserAction,
      positionCaret: positionCaret
    };
  };

  Object.assign(FroalaEditor.DEFAULTS, {
    pastePlain: false,
    pasteDeniedTags: ['colgroup', 'col', 'meta'],
    pasteDeniedAttrs: ['class', 'id'],
    pasteAllowedStyleProps: ['.*'],
    pasteAllowLocalImages: false
  });

  FroalaEditor.MODULES.paste = function (editor) {
    var $ = editor.$;
    var clipboard_html;
    var clipboard_rtf;
    var clipboard_txt;
    var clipboard_types;
    var $paste_div;
    var snapshot;

    function saveCopiedText(html, plain) {
      try {
        editor.win.localStorage.setItem('fr-copied-html', html);
        editor.win.localStorage.setItem('fr-copied-text', plain);
      } catch (ex) {// do no matter what
      }
    }
    /**
     * Handle copy and cut.
     */


    function _handleCopy(e) {
      var copied_html = editor.html.getSelected();
      saveCopiedText(copied_html, $(editor.doc.createElement('div')).html(copied_html).text());

      if (e.type === 'cut') {
        editor.undo.saveStep();
        setTimeout(function () {
          editor.selection.save();
          editor.html.wrap();
          editor.selection.restore();
          editor.events.focus();
          editor.undo.saveStep();
        }, 0);
      }
    }
    /**
     * Handle pasting.
     */


    var stop_paste = false;

    function _handlePaste(e) {
      // if content is copied in input tag do the normal paste.
      if (e.target.nodeName === 'INPUT' && e.target.type === 'text') {
        return true;
      }

      if (editor.edit.isDisabled()) {
        return false;
      } // https://github.com/froala-labs/froala-editor-js-2/issues/2067


      if (isContetnEditable(e.target)) {
        return false;
      }

      if (stop_paste) {
        return false;
      }

      if (e.originalEvent) {
        e = e.originalEvent;
      }

      if (e && e.clipboardData && e.clipboardData.getData) {
        var dT = e.clipboardData || window.clipboardData;
        var html = dT.getData('text/html') || '';

        if (html.match('content="Microsoft OneNote')) {
          return false;
        }
      }

      if (editor.events.trigger('paste.before', [e]) === false) {
        e.preventDefault();
        return false;
      } // Read data from clipboard.


      if (e && e.clipboardData && e.clipboardData.getData) {
        var types = '';
        clipboard_types = e.clipboardData.types;

        if (editor.helpers.isArray(clipboard_types)) {
          for (var i = 0; i < clipboard_types.length; i++) {
            types += "".concat(clipboard_types[i], ";");
          }
        } else {
          types = clipboard_types;
        }

        clipboard_html = ''; // Get rtf clipboard.

        if (/text\/rtf/.test(types)) {
          clipboard_rtf = e.clipboardData.getData('text/rtf');
        } // HTML.


        if (/text\/html/.test(types) && !editor.browser.safari) {
          clipboard_html = e.clipboardData.getData('text/html');
        } // Safari HTML.
        else if (/text\/rtf/.test(types) && editor.browser.safari) {
          clipboard_html = clipboard_rtf;
        } // Safari HTML for iOS.
        else if (/public.rtf/.test(types) && editor.browser.safari) {
          clipboard_html = e.clipboardData.getData('text/rtf');
        }

        clipboard_txt = e.clipboardData.getData('text');

        if (clipboard_html !== '') {
          _processPaste();

          if (e.preventDefault) {
            e.stopPropagation();
            e.preventDefault();
          }

          return false;
        }

        clipboard_html = null;
      } // Normal paste.


      _beforePaste();

      return false;
    }
    /**
     * check for contentEditable.
     */


    function isContetnEditable(el) {
      return el && el.contentEditable === 'false';
    }
    /**
     * Handle dropping content in the editor.
     */


    function _dropPaste(e) {
      if (e.originalEvent) {
        e = e.originalEvent;
      } // https://github.com/froala-labs/froala-editor-js-2/issues/2067


      if (isContetnEditable(e.target)) {
        return false;
      } // Read data from clipboard.


      if (e && e.dataTransfer && e.dataTransfer.getData) {
        var types = '';
        clipboard_types = e.dataTransfer.types;

        if (editor.helpers.isArray(clipboard_types)) {
          for (var i = 0; i < clipboard_types.length; i++) {
            types += "".concat(clipboard_types[i], ";");
          }
        } else {
          types = clipboard_types;
        }

        clipboard_html = ''; // Get rtf clipboard.

        if (/text\/rtf/.test(types)) {
          clipboard_rtf = e.dataTransfer.getData('text/rtf');
        } // HTML.


        if (/text\/html/.test(types)) {
          clipboard_html = e.dataTransfer.getData('text/html');
        } // Safari HTML.
        else if (/text\/rtf/.test(types) && editor.browser.safari) {
          clipboard_html = clipboard_rtf;
        } else if (/text\/plain/.test(types) && !this.browser.mozilla) {
          clipboard_html = editor.html.escapeEntities(e.dataTransfer.getData('text/plain')).replace(/\n/g, '<br>');
        }

        if (clipboard_html !== '') {
          editor.keys.forceUndo();
          snapshot = editor.snapshot.get(); // Save selection, but change markers class so that we can restore it later.

          editor.selection.save();
          editor.$el.find('.fr-marker').removeClass('fr-marker').addClass('fr-marker-helper'); // Insert marker point helper and change class to restore it later.

          var ok = editor.markers.insertAtPoint(e);
          editor.$el.find('.fr-marker').removeClass('fr-marker').addClass('fr-marker-placeholder'); // Restore selection and remove it.

          editor.$el.find('.fr-marker-helper').addClass('fr-marker').removeClass('fr-marker-helper');
          editor.selection.restore();
          editor.selection.remove(); // Restore marker point helper.

          editor.$el.find('.fr-marker-placeholder').addClass('fr-marker').removeClass('fr-marker-placeholder');

          if (ok !== false) {
            // Insert markers.
            var marker = editor.el.querySelector('.fr-marker');
            $(marker).replaceWith(FroalaEditor.MARKERS);
            editor.selection.restore();

            _processPaste();

            if (e.preventDefault) {
              e.stopPropagation();
              e.preventDefault();
            }

            return false;
          }
        } else {
          clipboard_html = null;
        }
      }
    } // https://github.com/froala-labs/froala-editor-js-2/issues/3895


    function getOffset(el) {
      if (el.nodeType === Node.TEXT_NODE) return el.parentNode.offsetTop;
      return el.offsetTop;
    }
    /**
     * Before starting to paste.
     */


    function _beforePaste() {
      // Save selection
      editor.selection.save();
      editor.events.disableBlur(); // Set clipboard HTML.

      clipboard_html = null; // Remove and store the editable content

      if (!$paste_div) {
        // https://github.com/froala-labs/froala-editor-js-2/issues/3895
        var bodyStyle = document.getElementsByTagName('BODY')[0];
        var styleData = window.getComputedStyle(bodyStyle).transform;

        if (styleData !== 'none') {
          var top = getOffset(editor.selection.get().anchorNode) + editor.$wp.offset().top;
          $paste_div = $('<div contenteditable="true" style="position: fixed; top: ' + top + 'px; left: -9999px; height: 100%; width: 0; word-break: break-all; overflow:hidden; z-index: 2147483647; line-height: 140%; -moz-user-select: text; -webkit-user-select: text; -ms-user-select: text; user-select: text;" tabIndex="-1"></div>');
        } else {
          $paste_div = $('<div contenteditable="true" style="position: fixed; top: 0; left: -9999px; height: 100%; width: 0; word-break: break-all; overflow:hidden; z-index: 2147483647; line-height: 140%; -moz-user-select: text; -webkit-user-select: text; -ms-user-select: text; user-select: text;" tabIndex="-1"></div>');
        } // Sketch app fix. https://github.com/froala/wysiwyg-editor/issues/2042
        // Also: when using iframe Safari needs to have focus in the same window.


        if (editor.browser.webkit || editor.browser.mozilla) {
          if (styleData === 'none') {
            $paste_div.css('top', editor.$sc.scrollTop());
          }

          editor.$el.after($paste_div);
        } else if (editor.browser.edge && editor.opts.iframe) {
          editor.$el.append($paste_div);
        } else {
          editor.$box.after($paste_div);
        }

        editor.events.on('destroy', function () {
          $paste_div.remove();
        });
      } else {
        $paste_div.html('');

        var _top = getOffset(editor.selection.get().anchorNode) + editor.$wp.offset().top;

        $paste_div.css('top', _top);

        if (editor.browser.edge && editor.opts.iframe) {
          editor.$el.append($paste_div);
        }
      }

      var st; // Prevent iOS scroll.

      if (editor.helpers.isIOS() && editor.$sc) {
        st = editor.$sc.scrollTop();
      } // Focus on the pasted div.


      if (editor.opts.iframe) {
        editor.$el.attr('contenteditable', 'false');
      }

      $paste_div.focus(); // Prevent iOS scroll.

      if (editor.helpers.isIOS() && editor.$sc) {
        editor.$sc.scrollTop(st);
      } // Process paste soon.


      editor.win.setTimeout(_processPaste, 1);
    }
    /**
     * Clean HTML that was pasted from Word.
     */


    function _wordClean(html) {
      var i; // Single item list.

      html = html.replace(/<p(.*?)class="?'?MsoListParagraph"?'? ([\s\S]*?)>([\s\S]*?)<\/p>/gi, '<ul><li>$3</li></ul>');
      html = html.replace(/<p(.*?)class="?'?NumberedText"?'? ([\s\S]*?)>([\s\S]*?)<\/p>/gi, '<ol><li>$3</li></ol>'); // List start.

      html = html.replace(/<p(.*?)class="?'?MsoListParagraphCxSpFirst"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, '<ul><li$3>$5</li>');
      html = html.replace(/<p(.*?)class="?'?NumberedTextCxSpFirst"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, '<ol><li$3>$5</li>'); // List middle.

      html = html.replace(/<p(.*?)class="?'?MsoListParagraphCxSpMiddle"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, '<li$3>$5</li>');
      html = html.replace(/<p(.*?)class="?'?NumberedTextCxSpMiddle"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, '<li$3>$5</li>');
      html = html.replace(/<p(.*?)class="?'?MsoListBullet"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, '<li$3>$5</li>'); // List end.

      html = html.replace(/<p(.*?)class="?'?MsoListParagraphCxSpLast"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, '<li$3>$5</li></ul>');
      html = html.replace(/<p(.*?)class="?'?NumberedTextCxSpLast"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi, '<li$3>$5</li></ol>'); // Clean list bullets.

      html = html.replace(/<span([^<]*?)style="?'?mso-list:Ignore"?'?([\s\S]*?)>([\s\S]*?)<span/gi, '<span><span'); // Webkit clean list bullets.

      html = html.replace(/<!--\[if !supportLists\]-->([\s\S]*?)<!--\[endif\]-->/gi, '');
      html = html.replace(/<!\[if !supportLists\]>([\s\S]*?)<!\[endif\]>/gi, ''); // Remove mso classes.

      html = html.replace(/(\n|\r| class=(")?Mso[a-zA-Z0-9]+(")?)/gi, ' '); // Remove comments.

      html = html.replace(/<!--[\s\S]*?-->/gi, ''); // Remove tags but keep content.

      html = html.replace(/<(\/)*(meta|link|span|\\?xml:|st1:|o:|font)(.*?)>/gi, ''); // Remove no needed tags.

      var word_tags = ['style', 'script', 'applet', 'embed', 'noframes', 'noscript'];

      for (i = 0; i < word_tags.length; i++) {
        var regex = new RegExp("<".concat(word_tags[i], ".*?").concat(word_tags[i], "(.*?)>"), 'gi');
        html = html.replace(regex, '');
      } // Remove spaces.


      html = html.replace(/&nbsp;/gi, ' '); // Keep empty TH and TD.

      html = html.replace(/<td([^>]*)><\/td>/g, '<td$1><br></td>');
      html = html.replace(/<th([^>]*)><\/th>/g, '<th$1><br></th>'); // Remove empty tags.

      var oldHTML;

      do {
        oldHTML = html;
        html = html.replace(/<[^/>][^>]*><\/[^>]+>/gi, '');
      } while (html !== oldHTML); // Process list indentation.


      html = html.replace(/<lilevel([^1])([^>]*)>/gi, '<li data-indent="true"$2>');
      html = html.replace(/<lilevel1([^>]*)>/gi, '<li$1>'); // Clean HTML.

      html = editor.clean.html(html, editor.opts.pasteDeniedTags, editor.opts.pasteDeniedAttrs); // Clean empty links.

      html = html.replace(/<a>(.[^<]+)<\/a>/gi, '$1'); // https://github.com/froala/wysiwyg-editor/issues/1364.

      html = html.replace(/<br> */g, '<br>'); // Process list indent.

      var div = editor.o_doc.createElement('div');
      div.innerHTML = html;
      var lis = div.querySelectorAll('li[data-indent]');

      for (i = 0; i < lis.length; i++) {
        var li = lis[i];
        var p_li = li.previousElementSibling;

        if (p_li && p_li.tagName === 'LI') {
          var list = p_li.querySelector(':scope > ul, :scope > ol');

          if (!list) {
            list = document.createElement('ul');
            p_li.appendChild(list);
          }

          list.appendChild(li);
        } else {
          li.removeAttribute('data-indent');
        }
      }

      editor.html.cleanBlankSpaces(div);
      html = div.innerHTML;
      return html;
    }
    /**
     * Plain clean.
     */


    function _plainPasteClean(html) {
      var el = null;
      var i;
      var div = editor.doc.createElement('div');
      div.innerHTML = html;
      var els = div.querySelectorAll('p, div, h1, h2, h3, h4, h5, h6, pre, blockquote');

      for (i = 0; i < els.length; i++) {
        el = els[i];

        if (el.innerText) {
          el.outerHTML = "<".concat(editor.html.defaultTag() || 'DIV', ">").concat(el.innerText, "</").concat(editor.html.defaultTag() || 'DIV', ">");
        }
      }

      els = div.querySelectorAll("*:not(".concat('p, div, h1, h2, h3, h4, h5, h6, pre, blockquote, ul, ol, li, table, tbody, thead, tr, td, br, img'.split(',').join('):not('), ")"));

      for (i = els.length - 1; i >= 0; i--) {
        el = els[i];
        el.outerHTML = el.innerHTML;
      } // Remove comments.


      function cleanComments(node) {
        var contents = editor.node.contents(node);

        for (var _i = 0; _i < contents.length; _i++) {
          if (contents[_i].nodeType !== Node.TEXT_NODE && contents[_i].nodeType !== Node.ELEMENT_NODE) {
            contents[_i].parentNode.removeChild(contents[_i]);
          } else {
            cleanComments(contents[_i]);
          }
        }
      }

      cleanComments(div);
      return div.innerHTML;
    }
    /**
     * Process the pasted HTML.
     */


    function _processPaste() {
      if (editor.opts.iframe) {
        editor.$el.attr('contenteditable', 'true');
      }

      if (editor.browser.edge && editor.opts.iframe) {
        editor.$box.after($paste_div);
      } // Save undo snapshot.


      if (!snapshot) {
        editor.keys.forceUndo();
        snapshot = editor.snapshot.get();
      } // Cannot read from clipboard.


      if (!clipboard_html) {
        clipboard_html = $paste_div.get(0).innerHTML;
        clipboard_txt = $paste_div.text();
        editor.selection.restore();
        editor.events.enableBlur();
      }

      var is_word = clipboard_html.match(/(class="?Mso|class='?Mso|class="?Xl|class='?Xl|class=Xl|style="[^"]*\bmso-|style='[^']*\bmso-|w:WordDocument|LibreOffice)/gi); // Trigger chain cleanp.

      var response = editor.events.chainTrigger('paste.beforeCleanup', clipboard_html);

      if (response && typeof response === 'string') {
        clipboard_html = response;
      } // Clean non-word or word if no plugin processed the paste.


      if (!is_word || is_word && editor.events.trigger('paste.wordPaste', [clipboard_html]) !== false) {
        clean(clipboard_html, is_word);
      }
    }
    /**
     * Check if pasted content comes from the editor.
     */


    function _isFromEditor() {
      var possible_text = null;

      try {
        possible_text = editor.win.localStorage.getItem('fr-copied-text');
      } catch (ex) {// continue no matter what.a
      } // Updated to handle the whitespace mismatches while comparing.
      // if pasted as "paste and match style" then html content will not be there
      // https://github.com/froala-labs/froala-editor-js-2/issues/4075


      if (possible_text && clipboard_txt && (!clipboard_types || clipboard_types.indexOf('text/html') !== -1) && (clipboard_txt.replace(/\u00A0/gi, ' ').replace(/\r|\n/gi, '') === possible_text.replace(/\u00A0/gi, ' ').replace(/\r|\n/gi, '') || clipboard_txt.replace(/\s/g, '') === possible_text.replace(/\s/g, ''))) {
        return true;
      }

      return false;
    }

    function _buildTabs(len) {
      var tabs = '';
      var i = 0;

      while (i++ < len) {
        tabs += '&nbsp;';
      }

      return tabs;
    }
    /**
     * Clean clipboard html.
     */


    function clean(clipboard_html, is_word, keep_formatting) {
      var els = null;
      var el = null;
      var i; // Keep only body if there is.

      if (clipboard_html.toLowerCase().indexOf('<body') >= 0) {
        var style = '';

        if (clipboard_html.indexOf('<style') >= 0) {
          style = clipboard_html.replace(/[.\s\S\w\W<>]*(<style[^>]*>[\s]*[.\s\S\w\W<>]*[\s]*<\/style>)[.\s\S\w\W<>]*/gi, '$1');
        }

        clipboard_html = style + clipboard_html.replace(/[.\s\S\w\W<>]*<body[^>]*>[\s]*([.\s\S\w\W<>]*)[\s]*<\/body>[.\s\S\w\W<>]*/gi, '$1'); // Replace \n within <pre> tag with <br /> to retain the formatting

        clipboard_html = clipboard_html.replace(/<pre(?:[\w\W]*?)>(?:[\w\W]*?)<\/pre>/g, function (str) {
          return str.replace(/\n/g, '<br />');
        });
        clipboard_html = clipboard_html.replace(/ \n/g, ' ').replace(/\n /g, ' ').replace(/([^>])\n([^<])/g, '$1 $2');
      } // Google Docs paste.


      var is_gdocs = false;

      if (clipboard_html.indexOf('id="docs-internal-guid') >= 0) {
        clipboard_html = clipboard_html.replace(/^[\w\W\s\S]* id="docs-internal-guid[^>]*>([\w\W\s\S]*)<\/b>[\w\W\s\S]*$/g, '$1');
        is_gdocs = true;
      } // https://github.com/froala-labs/froala-editor-js-2/issues/2851


      if (clipboard_html.indexOf('content="Sheets"') >= 0 || clipboard_html.indexOf('google-sheets-html-origin') >= 0) {
        clipboard_html = clipboard_html.replace(/width:0px;/g, '');
      } // Not word paste.


      var is_editor_content = false;

      if (!is_word) {
        is_editor_content = _isFromEditor(); // Remove pasting token.

        if (is_editor_content) {
          clipboard_html = editor.win.localStorage.getItem('fr-copied-html');
        }

        if (!is_editor_content) {
          // Remove comments.
          var htmlAllowedStylePropsCopy = editor.opts.htmlAllowedStyleProps;
          editor.opts.htmlAllowedStyleProps = editor.opts.pasteAllowedStyleProps;
          editor.opts.htmlAllowComments = false; // Pasting from Apple Notes.

          clipboard_html = clipboard_html.replace(/<span class="Apple-tab-span">\s*<\/span>/g, _buildTabs(editor.opts.tabSpaces || 4));
          clipboard_html = clipboard_html.replace(/<span class="Apple-tab-span" style="white-space:pre">(\t*)<\/span>/g, function (str, x) {
            return _buildTabs(x.length * (editor.opts.tabSpaces || 4));
          }); // Pasting from other sources with tabs.

          clipboard_html = clipboard_html.replace(/\t/g, _buildTabs(editor.opts.tabSpaces || 4));
          clipboard_html = editor.clean.html(clipboard_html, editor.opts.pasteDeniedTags, editor.opts.pasteDeniedAttrs);
          editor.opts.htmlAllowedStyleProps = htmlAllowedStylePropsCopy;
          editor.opts.htmlAllowComments = true; // Remove empty tags.

          if (!editor.html.defaultTag() || editor.html.defaultTag() !== 'div') {
            clipboard_html = cleanEmptyTagsAndDivs(clipboard_html);
          } // Do not keep entities that are not HTML compatible.


          clipboard_html = clipboard_html.replace(/\r/g, ''); // Trail ending and starting spaces.

          clipboard_html = clipboard_html.replace(/^ */g, '').replace(/ *$/g, '');
        } else {
          clipboard_html = editor.clean.html(clipboard_html, editor.opts.pasteDeniedTags, editor.opts.pasteDeniedAttrs);
        }
      } // Word paste cleanup when word plugin is not used.


      if (is_word && (!editor.wordPaste || !keep_formatting)) {
        // Strip spaces at the beginning.
        clipboard_html = clipboard_html.replace(/^\n*/g, '').replace(/^ /g, ''); // Firefox paste.

        if (clipboard_html.indexOf('<colgroup>') === 0) {
          clipboard_html = "<table>".concat(clipboard_html, "</table>");
        }

        clipboard_html = _wordClean(clipboard_html);
        clipboard_html = cleanEmptyTagsAndDivs(clipboard_html);
      } // Do plain paste cleanup.


      if (editor.opts.pastePlain) {
        clipboard_html = _plainPasteClean(clipboard_html);
      } // After paste cleanup event.


      var response = editor.events.chainTrigger('paste.afterCleanup', clipboard_html);

      if (typeof response === 'string') {
        clipboard_html = response;
      } // Check if there is anything to clean.


      if (clipboard_html !== '') {
        // Normalize spaces.
        var tmp = editor.o_doc.createElement('div');
        tmp.innerHTML = clipboard_html; // https://github.com/froala/wysiwyg-editor/issues/2632.

        if (clipboard_html.indexOf('<body>') >= 0) {
          editor.html.cleanBlankSpaces(tmp);
          editor.spaces.normalize(tmp, true);
        } else {
          editor.spaces.normalize(tmp);
        } // Remove all spans.


        var spans = tmp.getElementsByTagName('span');

        for (i = spans.length - 1; i >= 0; i--) {
          var span = spans[i];

          if (span.attributes.length === 0) {
            span.outerHTML = span.innerHTML;
          }
        } // Check for a tags linkAlwaysBlank.


        if (editor.opts.linkAlwaysBlank === true) {
          var aTags = tmp.getElementsByTagName('a');

          for (i = aTags.length - 1; i >= 0; i--) {
            var aTag = aTags[i];

            if (!aTag.getAttribute('target')) {
              aTag.setAttribute('target', '_blank');
            }
          }
        } // Check if we're inside a list.


        var selection_el = editor.selection.element();
        var in_list = false;

        if (selection_el && $(selection_el).parentsUntil(editor.el, 'ul, ol').length) {
          in_list = true;
        } // Unwrap lists if they are the only thing in the pasted HTML.


        if (in_list) {
          var list = tmp.children;

          if (list.length === 1 && ['OL', 'UL'].indexOf(list[0].tagName) >= 0) {
            list[0].outerHTML = list[0].innerHTML;
          }
        } // Remove unecessary new_lines.


        if (!is_gdocs) {
          var brs = tmp.getElementsByTagName('br');

          for (i = brs.length - 1; i >= 0; i--) {
            var br = brs[i];

            if (editor.node.isBlock(br.previousSibling)) {
              br.parentNode.removeChild(br);
            }
          }
        } // https://github.com/froala/wysiwyg-editor/issues/1493


        if (editor.opts.enter === FroalaEditor.ENTER_BR) {
          els = tmp.querySelectorAll('p, div');

          for (i = els.length - 1; i >= 0; i--) {
            el = els[i]; // Fixes https://github.com/froala/wysiwyg-editor/issues/1895.

            if (el.attributes.length === 0) {
              el.outerHTML = el.innerHTML + (el.nextSibling && !editor.node.isEmpty(el) ? '<br>' : '');
            }
          }
        } else if (editor.opts.enter === FroalaEditor.ENTER_DIV) {
          els = tmp.getElementsByTagName('p');

          for (i = els.length - 1; i >= 0; i--) {
            el = els[i];

            if (el.attributes.length === 0) {
              el.outerHTML = "<div>".concat(el.innerHTML, "</div>");
            }
          }
        } else if (editor.opts.enter === FroalaEditor.ENTER_P) {
          if (tmp.childNodes.length === 1 && tmp.childNodes[0].tagName === 'P' && tmp.childNodes[0].attributes.length === 0) {
            tmp.childNodes[0].outerHTML = tmp.childNodes[0].innerHTML;
          }
        } // Add id to element so as to distinguish between pasted text and typed text


        if (tmp.children && tmp.children.length > 0) {
          if (editor.opts.trackChangesEnabled) {
            // set id attribue isPasted on all child in track changes enable
            for (var _i2 = 0; _i2 < tmp.children.length; _i2++) {
              tmp.children[_i2].setAttribute('id', 'isPasted');
            }
          } else {
            tmp.children[0].setAttribute('id', 'isPasted');
          }
        }

        clipboard_html = tmp.innerHTML;

        if (is_editor_content) {
          clipboard_html = removeEmptyTags(clipboard_html);
        } // Insert HTML.


        editor.html.insert(clipboard_html, true);
      }

      _afterPaste();

      editor.undo.saveStep(snapshot);
      snapshot = null;
      editor.undo.saveStep();
    }
    /**
     * After pasting.
     */


    function _afterPaste() {
      editor.events.trigger('paste.after');
    }
    /*
     * Get clipboard in RTF format.
     */


    function getRtfClipboard() {
      return clipboard_rtf;
    }
    /*
     * Remove those nodes with attrs.
     */


    function _filterNoAttrs(arry) {
      for (var t = arry.length - 1; t >= 0; t--) {
        if (arry[t].attributes && arry[t].attributes.length) {
          arry.splice(t, 1);
        }
      }

      return arry;
    }

    function cleanEmptyTagsAndDivs(html) {
      var i;
      var div = editor.o_doc.createElement('div');
      div.innerHTML = html; // Workaround for Nodepad paste.

      var divs = _filterNoAttrs(Array.prototype.slice.call(div.querySelectorAll(':scope > div:not([style]), td > div:not([style]), th > div:not([style]), li > div:not([style])')));

      while (divs.length) {
        var dv = divs[divs.length - 1];

        if (editor.html.defaultTag() && editor.html.defaultTag() !== 'div') {
          // If we have nested block tags unwrap them.
          if (dv.querySelector(editor.html.blockTagsQuery())) {
            dv.outerHTML = dv.innerHTML;
          } else {
            dv.outerHTML = "<".concat(editor.html.defaultTag(), ">").concat(dv.innerHTML, "</").concat(editor.html.defaultTag(), ">");
          }
        } else {
          var els = dv.querySelectorAll('*'); // Node has some other content than BR.

          if (!els.length || els[els.length - 1].tagName !== 'BR' && dv.innerText.length === 0) {
            dv.outerHTML = dv.innerHTML + (dv.nextSibling ? '<br>' : '');
          } // Last node is not BR.
          else if (!(els.length && els[els.length - 1].tagName === 'BR' && !els[els.length - 1].nextSibling)) {
            dv.outerHTML = dv.innerHTML + (dv.nextSibling ? '<br>' : '');
          } else {
            dv.outerHTML = dv.innerHTML;
          }
        }

        divs = _filterNoAttrs(Array.prototype.slice.call(div.querySelectorAll(':scope > div:not([style]), td > div:not([style]), th > div:not([style]), li > div:not([style])')));
      } // Remove divs.


      divs = _filterNoAttrs(Array.prototype.slice.call(div.querySelectorAll('div:not([style])')));

      while (divs.length) {
        for (i = 0; i < divs.length; i++) {
          var el = divs[i];
          var text = el.innerHTML.replace(/\u0009/gi, '').trim();
          el.outerHTML = text;
        }

        divs = _filterNoAttrs(Array.prototype.slice.call(div.querySelectorAll('div:not([style])')));
      }

      return div.innerHTML;
    }
    /**
     * Remove possible empty tags in pasted HTML.
     */


    function removeEmptyTags(html) {
      var i;
      var div = editor.o_doc.createElement('div');
      div.innerHTML = html; // Clean empty tags.

      var empty_tags = div.querySelectorAll("*:empty:not(td):not(th):not(tr):not(iframe):not(svg):not(".concat(FroalaEditor.VOID_ELEMENTS.join('):not('), "):not(").concat(editor.opts.htmlAllowedEmptyTags.join('):not('), ")"));

      while (empty_tags.length) {
        for (i = 0; i < empty_tags.length; i++) {
          empty_tags[i].parentNode.removeChild(empty_tags[i]);
        }

        empty_tags = div.querySelectorAll("*:empty:not(td):not(th):not(tr):not(iframe):not(svg):not(".concat(FroalaEditor.VOID_ELEMENTS.join('):not('), "):not(").concat(editor.opts.htmlAllowedEmptyTags.join('):not('), ")"));
      }

      return div.innerHTML;
    }
    /**
     * Initialize.
     */


    function _init() {
      editor.el.addEventListener('copy', _handleCopy);
      editor.el.addEventListener('cut', _handleCopy);
      editor.el.addEventListener('paste', _handlePaste, {
        capture: true
      });
      editor.events.on('drop', _dropPaste);

      if (editor.browser.msie && editor.browser.version < 11) {
        editor.events.on('mouseup', function (e) {
          if (e.button === 2) {
            setTimeout(function () {
              stop_paste = false;
            }, 50);
            stop_paste = true;
          }
        }, true);
        editor.events.on('beforepaste', _handlePaste);
      }

      editor.events.on('destroy', _destroy);
    }

    function _destroy() {
      editor.el.removeEventListener('copy', _handleCopy);
      editor.el.removeEventListener('cut', _handleCopy);
      editor.el.removeEventListener('paste', _handlePaste);
    }

    return {
      _init: _init,
      cleanEmptyTagsAndDivs: cleanEmptyTagsAndDivs,
      getRtfClipboard: getRtfClipboard,
      saveCopiedText: saveCopiedText,
      clean: clean
    };
  };

  Object.assign(FroalaEditor.DEFAULTS, {
    shortcutsEnabled: [],
    shortcutsHint: true
  });
  FroalaEditor.SHORTCUTS_MAP = {};

  FroalaEditor.RegisterShortcut = function (key, cmd, val, letter, shift, option) {
    FroalaEditor.SHORTCUTS_MAP[(shift ? '^' : '') + (option ? '@' : '') + key] = {
      cmd: cmd,
      val: val,
      letter: letter,
      shift: shift,
      option: option
    };
    FroalaEditor.DEFAULTS.shortcutsEnabled.push(cmd);
  };

  FroalaEditor.RegisterShortcut(FroalaEditor.KEYCODE.E, 'show', null, 'E', false, false);
  FroalaEditor.RegisterShortcut(FroalaEditor.KEYCODE.B, 'bold', null, 'B', false, false);
  FroalaEditor.RegisterShortcut(FroalaEditor.KEYCODE.I, 'italic', null, 'I', false, false);
  FroalaEditor.RegisterShortcut(FroalaEditor.KEYCODE.U, 'underline', null, 'U', false, false);
  FroalaEditor.RegisterShortcut(FroalaEditor.KEYCODE.S, 'strikeThrough', null, 'S', false, false);
  FroalaEditor.RegisterShortcut(FroalaEditor.KEYCODE.CLOSE_SQUARE_BRACKET, 'indent', null, ']', false, false);
  FroalaEditor.RegisterShortcut(FroalaEditor.KEYCODE.OPEN_SQUARE_BRACKET, 'outdent', null, '[', false, false);
  FroalaEditor.RegisterShortcut(FroalaEditor.KEYCODE.Z, 'undo', null, 'Z', false, false);
  FroalaEditor.RegisterShortcut(FroalaEditor.KEYCODE.Z, 'redo', null, 'Z', true, false);
  FroalaEditor.RegisterShortcut(FroalaEditor.KEYCODE.Y, 'redo', null, 'Y', false, false);

  FroalaEditor.MODULES.shortcuts = function (editor) {
    var inverse_map = null;

    function get(cmd) {
      if (!editor.opts.shortcutsHint) {
        return null;
      }

      if (!inverse_map) {
        inverse_map = {};

        for (var key in FroalaEditor.SHORTCUTS_MAP) {
          if (Object.prototype.hasOwnProperty.call(FroalaEditor.SHORTCUTS_MAP, key) && editor.opts.shortcutsEnabled.indexOf(FroalaEditor.SHORTCUTS_MAP[key].cmd) >= 0) {
            inverse_map["".concat(FroalaEditor.SHORTCUTS_MAP[key].cmd, ".").concat(FroalaEditor.SHORTCUTS_MAP[key].val || '')] = {
              shift: FroalaEditor.SHORTCUTS_MAP[key].shift,
              option: FroalaEditor.SHORTCUTS_MAP[key].option,
              letter: FroalaEditor.SHORTCUTS_MAP[key].letter
            };
          }
        }
      }

      var srct = inverse_map[cmd];

      if (!srct) {
        return null;
      }

      return (editor.helpers.isMac() ? String.fromCharCode(8984) : "".concat(editor.language.translate('Ctrl'), "+")) + (srct.shift ? editor.helpers.isMac() ? String.fromCharCode(8679) : "".concat(editor.language.translate('Shift'), "+") : '') + (srct.option ? editor.helpers.isMac() ? String.fromCharCode(8997) : "".concat(editor.language.translate('Alt'), "+") : '') + srct.letter;
    }

    var active = false;
    /**
     * Execute shortcut.
     */

    function exec(e) {
      if (!editor.core.hasFocus()) {
        return true;
      }

      var keycode = e.which;
      var ctrlKey = navigator.userAgent.indexOf('Mac OS X') !== -1 ? e.metaKey : e.ctrlKey;

      if (e.type === 'keyup' && active) {
        if (keycode !== FroalaEditor.KEYCODE.META) {
          active = false;
          return false;
        }
      }

      if (e.type === 'keydown') {
        active = false;
      } // Build shortcuts map.


      var map_key = (e.shiftKey ? '^' : '') + (e.altKey ? '@' : '') + keycode;
      var deep_parent = editor.node.blockParent(editor.selection.blocks()[0]); // https://github.com/froala-labs/froala-editor-js-2/issues/1571

      if (deep_parent && deep_parent.tagName == 'TR' && deep_parent.getAttribute('contenteditable') == undefined) {
        deep_parent = deep_parent.closest('table');
      } // https://github.com/CelestialSystem/froala-editor-js-2/tree/1303
      // Check for content editable:false node and do not allow short-cuts


      if (ctrlKey && FroalaEditor.SHORTCUTS_MAP[map_key] && !(deep_parent && deep_parent.getAttribute('contenteditable') === 'false')) {
        var cmd = FroalaEditor.SHORTCUTS_MAP[map_key].cmd; // Check if shortcut is enabled.

        if (cmd && editor.opts.shortcutsEnabled.indexOf(cmd) >= 0) {
          var val = FroalaEditor.SHORTCUTS_MAP[map_key].val;

          if (editor.events.trigger('shortcut', [e, cmd, val]) !== false) {
            // Search for command.
            if (cmd && (editor.commands[cmd] || FroalaEditor.COMMANDS[cmd] && FroalaEditor.COMMANDS[cmd].callback)) {
              e.preventDefault();
              e.stopPropagation();

              if (e.type === 'keydown') {
                (editor.commands[cmd] || FroalaEditor.COMMANDS[cmd].callback)();
                active = true;
              }

              return false;
            }
          } else {
            active = true;
            return false;
          }
        }
      }
    }
    /**
     * Initialize.
     */


    function _init() {
      editor.events.on('keydown', exec, true);
      editor.events.on('keyup', exec, true);
    }

    return {
      _init: _init,
      get: get
    };
  };

  FroalaEditor.MODULES.snapshot = function (editor) {
    /**
     * Get the index of a node inside it's parent.
     */
    function _getNodeIndex(node) {
      var childNodes = node.parentNode.childNodes;
      var idx = 0;
      var prevNode = null;

      for (var i = 0; i < childNodes.length; i++) {
        if (prevNode) {
          // Current node is text and it is empty.
          var isEmptyText = childNodes[i].nodeType === Node.TEXT_NODE && childNodes[i].textContent === ''; // Previous node is text, current node is text.

          var twoTexts = prevNode.nodeType === Node.TEXT_NODE && childNodes[i].nodeType === Node.TEXT_NODE; // Empty prev node.

          var emptyPrevNode = prevNode.nodeType === Node.TEXT_NODE && prevNode.textContent === '';

          if (!isEmptyText && !twoTexts && !emptyPrevNode) {
            idx++;
          }
        }

        if (childNodes[i] === node) {
          return idx;
        }

        prevNode = childNodes[i];
      }
    }
    /**
     * Determine the location of the node inside the element.
     */


    function _getNodeLocation(node) {
      var loc = [];

      if (!node.parentNode) {
        return [];
      }

      while (!editor.node.isElement(node)) {
        loc.push(_getNodeIndex(node));
        node = node.parentNode;
      }

      return loc.reverse();
    }
    /**
     * Get the range offset inside the node.
     */


    function _getRealNodeOffset(node, offset) {
      while (node && node.nodeType === Node.TEXT_NODE) {
        var prevNode = node.previousSibling;

        if (prevNode && prevNode.nodeType === Node.TEXT_NODE) {
          offset += prevNode.textContent.length;
        }

        node = prevNode;
      }

      return offset;
    }
    /**
     * Codify each range.
     */


    function _getRange(range) {
      return {
        scLoc: _getNodeLocation(range.startContainer),
        scOffset: _getRealNodeOffset(range.startContainer, range.startOffset),
        ecLoc: _getNodeLocation(range.endContainer),
        ecOffset: _getRealNodeOffset(range.endContainer, range.endOffset)
      };
    }
    /**
     * Get the current snapshot.
     */


    function get() {
      var snapshot = {};
      editor.events.trigger('snapshot.before');
      snapshot.html = (editor.$wp ? editor.$el.html() : editor.$oel.get(0).outerHTML).replace(/ style=""/g, '');
      snapshot.ranges = [];

      if (editor.$wp && editor.selection.inEditor() && editor.core.hasFocus()) {
        var ranges = editor.selection.ranges();

        for (var i = 0; i < ranges.length; i++) {
          snapshot.ranges.push(_getRange(ranges[i]));
        }
      }

      editor.events.trigger('snapshot.after', [snapshot]);
      return snapshot;
    }
    /**
     * Determine node by its location in the main element.
     */


    function _getNodeByLocation(loc) {
      var node = editor.el;

      for (var i = 0; i < loc.length; i++) {
        node = node.childNodes[loc[i]];
      }

      return node;
    }
    /**
     * Restore range from snapshot.
     */


    function _restoreRange(sel, range_snapshot) {
      try {
        // Get range info.
        var startNode = _getNodeByLocation(range_snapshot.scLoc);

        var startOffset = range_snapshot.scOffset;

        var endNode = _getNodeByLocation(range_snapshot.ecLoc);

        var endOffset = range_snapshot.ecOffset; // Restore range.

        var range = editor.doc.createRange();
        range.setStart(startNode, startOffset);
        range.setEnd(endNode, endOffset);
        sel.addRange(range);
      } catch (ex) {// continue regardless of error
      }
    }
    /**
     * Restore snapshot.
     */


    function restore(snapshot) {
      // Restore HTML.
      if (editor.$el.html() !== snapshot.html) {
        if (editor.opts.htmlExecuteScripts) {
          editor.$el.html(snapshot.html);
        } else {
          editor.el.innerHTML = snapshot.html;
        }
      } // Get selection.


      var sel = editor.selection.get(); // Make sure to clear current selection.

      editor.selection.clear(); // Focus.

      editor.events.focus(true); // Restore Ranges.

      for (var i = 0; i < snapshot.ranges.length; i++) {
        _restoreRange(sel, snapshot.ranges[i]);
      }
    }
    /**
     * Compare two snapshots.
     */


    function equal(s1, s2) {
      if (s1.html !== s2.html) {
        return false;
      }

      if (editor.core.hasFocus() && JSON.stringify(s1.ranges) !== JSON.stringify(s2.ranges)) {
        return false;
      }

      return true;
    }

    return {
      get: get,
      restore: restore,
      equal: equal
    };
  };

  FroalaEditor.MODULES.undo = function (editor) {
    /**
     * Disable the default browser undo.
     */
    function _disableBrowserUndo(e) {
      var keyCode = e.which;
      var ctrlKey = editor.keys.ctrlKey(e); // Ctrl Key.

      if (ctrlKey) {
        if (keyCode === FroalaEditor.KEYCODE.Z && e.shiftKey) {
          e.preventDefault();
        }

        if (keyCode === FroalaEditor.KEYCODE.Z) {
          e.preventDefault();
        }
      }
    }

    function canDo() {
      if (editor.undo_stack.length === 0 || editor.undo_index <= 1) {
        return false;
      }

      return true;
    }

    function canRedo() {
      if (editor.undo_index === editor.undo_stack.length) {
        return false;
      }

      return true;
    }

    function isSameHtml(prev_html, new_html) {
      // clean table select css
      var newHtml = new_html.split('fr-selected-cell').join(''); // remove empty classes

      newHtml = newHtml.split(' class=""').join(''); // clean table select css

      var prevHtml = prev_html.split('fr-selected-cell').join(''); // remove empty classes

      prevHtml = prevHtml.split(' class=""').join('');

      if (newHtml === prevHtml) {
        return true;
      }

      return false;
    }

    var last_html = null;

    function saveStep(snapshot) {
      if (!editor.undo_stack || editor.undoing || editor.el.querySelector('.fr-marker')) {
        return;
      }

      if (typeof snapshot === 'undefined') {
        snapshot = editor.snapshot.get();
        if (snapshot && snapshot.html && editor.undo_stack[editor.undo_stack.length - 1] && snapshot.html === editor.undo_stack[editor.undo_stack.length - 1].html) return;

        if (!editor.undo_stack[editor.undo_index - 1] || !editor.snapshot.equal(editor.undo_stack[editor.undo_index - 1], snapshot)) {
          dropRedo();
          editor.undo_stack.push(snapshot);
          editor.undo_index++;

          if (!isSameHtml(last_html, snapshot.html)) {
            editor.events.trigger('contentChanged');
            last_html = snapshot.html;
          }
        }
      } else {
        dropRedo();

        if (editor.undo_index > 0) {
          editor.undo_stack[editor.undo_index - 1] = snapshot;
        } else {
          editor.undo_stack.push(snapshot);
          editor.undo_index++;
        }
      }
    }

    function dropRedo() {
      if (!editor.undo_stack || editor.undoing) {
        return;
      }

      while (editor.undo_stack.length > editor.undo_index) {
        editor.undo_stack.pop();
      }
    }

    function _do() {
      if (editor.undo_index > 1) {
        editor.undoing = true; // Get snapshot.

        var snapshot = editor.undo_stack[--editor.undo_index - 1]; // Clear any existing content changed timers.

        clearTimeout(editor._content_changed_timer); // Restore snapshot.

        editor.snapshot.restore(snapshot);
        last_html = snapshot.html; // Hide popups.

        editor.popups.hideAll(); // Enable toolbar.

        editor.toolbar.enable(); // Call content changed.

        editor.events.trigger('contentChanged');
        editor.events.trigger('commands.undo');
        editor.undoing = false;
        editor.selection.restore();
      }
    }

    function _redo() {
      if (editor.undo_index < editor.undo_stack.length) {
        editor.undoing = true; // Get snapshot.

        var snapshot = editor.undo_stack[editor.undo_index++]; // Clear any existing content changed timers.

        clearTimeout(editor._content_changed_timer); // Restore snapshot.

        editor.snapshot.restore(snapshot);
        last_html = snapshot.html; // Hide popups.

        editor.popups.hideAll(); // Enable toolbar.

        editor.toolbar.enable(); // Call content changed.

        editor.events.trigger('contentChanged');
        editor.events.trigger('commands.redo');
        editor.undoing = false;
      }
    }

    function reset() {
      editor.undo_index = 0;
      editor.undo_stack = [];
    }

    function _destroy() {
      editor.undo_stack = [];
    }
    /**
     * Initialize
     */


    function _init() {
      reset();
      editor.events.on('initialized', function () {
        last_html = (editor.$wp ? editor.$el.html() : editor.$oel.get(0).outerHTML).replace(/ style=""/g, '');
      });
      editor.events.on('blur', function () {
        if (!editor.el.querySelector('.fr-dragging')) {
          editor.undo.saveStep();
        }
      });
      editor.events.on('keydown', _disableBrowserUndo);
      editor.events.on('destroy', _destroy);
    }

    return {
      _init: _init,
      run: _do,
      redo: _redo,
      canDo: canDo,
      canRedo: canRedo,
      dropRedo: dropRedo,
      reset: reset,
      saveStep: saveStep
    };
  };

  Object.assign(FroalaEditor.DEFAULTS, {
    height: null,
    heightMax: null,
    heightMin: null,
    width: null
  });

  FroalaEditor.MODULES.size = function (editor) {
    function syncIframe() {
      refresh();

      if (editor.opts.height) {
        editor.$el.css('minHeight', editor.opts.height - editor.helpers.getPX(editor.$el.css('padding-top')) - editor.helpers.getPX(editor.$el.css('padding-bottom')));
      }

      var isVh = false; // https://github.com/froala-labs/froala-editor-js-2/issues/3098

      if (editor.opts.fullPage) {
        var items = editor.$el.find('span,p,div');

        for (var i = 0; i < items.length; i++) {
          if (items[i].style.height && items[i].style.height.includes('vh')) {
            isVh = true;
            break;
          }
        }
      }

      if (editor.opts.fullPage && isVh) {
        if (editor.opts.heightMin) {
          editor.$iframe.css('minHeight', editor.opts.heightMin);
        }

        if (editor.opts.heightMax) {
          editor.$iframe.css('maxHeight', editor.opts.heightMax);
        }

        editor.$el.css('overflow-y', 'auto');
      }

      editor.$iframe.height(editor.$el.outerHeight(true));
    }

    function refresh() {
      if (editor.opts.heightMin) {
        editor.$el.css('minHeight', editor.opts.heightMin);
      } else {
        editor.$el.css('minHeight', '');
      }

      if (editor.opts.heightMax) {
        editor.$wp.css('maxHeight', editor.opts.heightMax);
        editor.$wp.css('overflow', 'auto');
      } else {
        editor.$wp.css('maxHeight', '');
        editor.$wp.css('overflow', '');
      } // Set height.


      if (editor.opts.height) {
        editor.$wp.css('height', editor.opts.height);
        editor.$wp.css('overflow', 'auto');
        editor.$el.css('minHeight', editor.opts.height - editor.helpers.getPX(editor.$el.css('padding-top')) - editor.helpers.getPX(editor.$el.css('padding-bottom')));
      } else {
        editor.$wp.css('height', '');

        if (!editor.opts.heightMin) {
          editor.$el.css('minHeight', '');
        }

        if (!editor.opts.heightMax) {
          editor.$wp.css('overflow', '');
        }
      }

      if (editor.opts.width) {
        editor.$box.width(editor.opts.width);
      }
    }

    function _init() {
      if (!editor.$wp) {
        return false;
      }

      refresh(); // Sync iframe height.

      if (editor.$iframe) {
        editor.events.on('keyup keydown', function () {
          setTimeout(syncIframe, 0);
        }, true);
        editor.events.on('commands.after html.set init initialized paste.after', syncIframe);
      }
    }

    return {
      _init: _init,
      syncIframe: syncIframe,
      refresh: refresh
    };
  };

  Object.assign(FroalaEditor.DEFAULTS, {
    documentReady: false,
    editorClass: null,
    typingTimer: 500,
    iframe: false,
    requestWithCORS: true,
    requestWithCredentials: false,
    requestHeaders: {},
    useClasses: true,
    spellcheck: true,
    iframeDefaultStyle: 'html{margin:0px;height:auto;}body{height:auto;padding:20px;background:transparent;color:#000000;position:relative;z-index: 2;-webkit-user-select:auto;margin:0px;overflow:hidden;min-height:20px;}body:after{content:"";display:block;clear:both;}body::-moz-selection{background:#b5d6fd;color:#000;}body::selection{background:#b5d6fd;color:#000;}',
    iframeStyle: '',
    iframeStyleFiles: [],
    direction: 'auto',
    zIndex: 1,
    tabIndex: null,
    disableRightClick: false,
    scrollableContainer: 'body',
    keepFormatOnDelete: false,
    theme: null
  });

  FroalaEditor.MODULES.core = function (editor) {
    var $ = editor.$;

    function injectStyle(style) {
      if (editor.opts.iframe) {
        editor.$head.find('style[data-fr-style], link[data-fr-style]').remove();
        editor.$head.append("<style data-fr-style=\"true\">".concat(style, "</style>"));

        for (var i = 0; i < editor.opts.iframeStyleFiles.length; i++) {
          var $link = $("<link data-fr-style=\"true\" rel=\"stylesheet\" href=\"".concat(editor.opts.iframeStyleFiles[i], "\">")); // Listen to the load event in order to sync iframe.

          $link.get(0).addEventListener('load', editor.size.syncIframe); // Append to the head.

          editor.$head.append($link);
        }
      }
    }

    function _initElementStyle() {
      if (!editor.opts.iframe) {
        editor.$el.addClass('fr-element fr-view');
      }
    }
    /**
     * Init the editor style.
     */


    function _initStyle() {
      editor.$box.addClass("fr-box".concat(editor.opts.editorClass ? " ".concat(editor.opts.editorClass) : ''));
      editor.$box.attr('role', 'application');
      editor.$wp.addClass('fr-wrapper');

      if (editor.opts.documentReady) {
        editor.$box.addClass('fr-document');
      }

      _initElementStyle();

      if (editor.opts.iframe) {
        editor.$iframe.addClass('fr-iframe');
        editor.$el.addClass('fr-view');

        for (var i = 0; i < editor.o_doc.styleSheets.length; i++) {
          var rules = void 0;

          try {
            rules = editor.o_doc.styleSheets[i].cssRules;
          } catch (ex) {// ok.
          }

          if (rules) {
            for (var idx = 0, len = rules.length; idx < len; idx++) {
              if (rules[idx].selectorText && (rules[idx].selectorText.indexOf('.fr-view') === 0 || rules[idx].selectorText.indexOf('.fr-element') === 0)) {
                if (rules[idx].style.cssText.length > 0) {
                  if (rules[idx].selectorText.indexOf('.fr-view') === 0) {
                    editor.opts.iframeStyle += "".concat(rules[idx].selectorText.replace(/\.fr-view/g, 'body'), "{").concat(rules[idx].style.cssText, "}");
                  } else {
                    editor.opts.iframeStyle += "".concat(rules[idx].selectorText.replace(/\.fr-element/g, 'body'), "{").concat(rules[idx].style.cssText, "}");
                  }
                }
              }
            }
          }
        }
      }

      if (editor.opts.direction !== 'auto') {
        editor.$box.removeClass('fr-ltr fr-rtl').addClass("fr-".concat(editor.opts.direction));
      }

      editor.$el.attr('dir', editor.opts.direction);
      editor.$wp.attr('dir', editor.opts.direction);

      if (editor.opts.zIndex > 1) {
        editor.$box.css('z-index', editor.opts.zIndex);
      }

      if (editor.opts.theme) {
        editor.$box.addClass("".concat(editor.opts.theme, "-theme"));
      } // Set tabIndex option.


      editor.opts.tabIndex = editor.opts.tabIndex || editor.$oel.attr('tabIndex');

      if (editor.opts.tabIndex) {
        editor.$el.attr('tabIndex', editor.opts.tabIndex);
      }
    }
    /**
     * Determine if the editor is empty.
     */


    function isEmpty() {
      return editor.node.isEmpty(editor.el);
    }
    /**
     * Check if the browser allows drag and init it.
     */


    function _initDrag() {
      // Drag and drop support.
      editor.drag_support = {
        filereader: typeof FileReader !== 'undefined',
        formdata: Boolean(editor.win.FormData),
        progress: 'upload' in new XMLHttpRequest()
      };
    }
    /**
     * Return an XHR object.
     */


    function getXHR(url, method) {
      var xhr = new XMLHttpRequest(); // Make it async.

      xhr.open(method, url, true); // Set with credentials.

      if (editor.opts.requestWithCredentials) {
        xhr.withCredentials = true;
      } // Set headers.


      for (var header in editor.opts.requestHeaders) {
        if (Object.prototype.hasOwnProperty.call(editor.opts.requestHeaders, header)) {
          xhr.setRequestHeader(header, editor.opts.requestHeaders[header]);
        }
      }

      return xhr;
    }

    function _destroy(html) {
      if (editor.$oel.get(0).tagName === 'TEXTAREA') {
        editor.$oel.val(html);
      }

      if (editor.$box) {
        editor.$box.removeAttr('role');
      }

      if (editor.$wp) {
        if (editor.$oel.get(0).tagName === 'TEXTAREA') {
          editor.$el.html('');
          editor.$wp.html('');
          editor.$box.replaceWith(editor.$oel);
          editor.$oel.show();
        } else {
          editor.$wp.replaceWith(html);
          editor.$el.html('');
          editor.$box.removeClass("fr-view fr-ltr fr-box ".concat(editor.opts.editorClass || ''));

          if (editor.opts.theme) {
            editor.$box.addClass("".concat(editor.opts.theme, "-theme"));
          }
        }
      }

      this.$wp = null;
      this.$el = null;
      this.el = null;
      this.$box = null;
    }

    function hasFocus() {
      if (editor.browser.mozilla && editor.helpers.isMobile()) {
        return editor.selection.inEditor();
      }

      return editor.node.hasFocus(editor.el) || editor.$el.find('*:focus').length > 0;
    }

    function sameInstance($obj) {
      if (!$obj) {
        return false;
      }

      var inst = $obj.data('instance');
      return inst ? inst.id === editor.id : false;
    }
    /**
     * Tear up.
     */


    function _init() {
      FroalaEditor.INSTANCES.push(editor);

      _initDrag(); // Call initialization methods.


      if (editor.$wp) {
        _initStyle();

        editor.html.set(editor._original_html); // Set spellcheck.

        editor.$el.attr('spellcheck', editor.opts.spellcheck); // Disable autocomplete.

        if (editor.helpers.isMobile()) {
          editor.$el.attr('autocomplete', editor.opts.spellcheck ? 'on' : 'off');
          editor.$el.attr('autocorrect', editor.opts.spellcheck ? 'on' : 'off');
          editor.$el.attr('autocapitalize', editor.opts.spellcheck ? 'on' : 'off');
        } // Disable right click.


        if (editor.opts.disableRightClick) {
          editor.events.$on(editor.$el, 'contextmenu', function (e) {
            if (e.button === 2) {
              // https://github.com/froala-labs/froala-editor-js-2/issues/2150
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          });
        }

        try {
          editor.doc.execCommand('styleWithCSS', false, false);
        } catch (ex) {// ok.
        }
      }

      if (editor.$oel.get(0).tagName === 'TEXTAREA') {
        // Sync on contentChanged.
        editor.events.on('contentChanged', function () {
          editor.$oel.val(editor.html.get());
        }); // Set HTML on form submit.

        editor.events.on('form.submit', function () {
          editor.$oel.val(editor.html.get());
        });
        editor.events.on('form.reset', function () {
          editor.html.set(editor._original_html);
        });
        editor.$oel.val(editor.html.get());
      } // iOS focus fix.


      if (editor.helpers.isIOS()) {
        editor.events.$on(editor.$doc, 'selectionchange', function () {
          if (!editor.$doc.get(0).hasFocus()) {
            editor.$win.get(0).focus();
          }
        });
      }

      editor.events.trigger('init'); // Autofocus.

      if (editor.opts.autofocus && !editor.opts.initOnClick && editor.$wp) {
        editor.events.on('initialized', function () {
          editor.events.focus(true);
        });
      }
    }

    return {
      _init: _init,
      destroy: _destroy,
      isEmpty: isEmpty,
      getXHR: getXHR,
      injectStyle: injectStyle,
      hasFocus: hasFocus,
      sameInstance: sameInstance
    };
  };

  FroalaEditor.POPUP_TEMPLATES = {
    'text.edit': '[_EDIT_]'
  };

  FroalaEditor.RegisterTemplate = function (name, template) {
    FroalaEditor.POPUP_TEMPLATES[name] = template;
  };

  FroalaEditor.MODULES.popups = function (editor) {
    var $ = editor.$;
    var screenHeightofBrowser;

    if (!editor.shared.popups) {
      editor.shared.popups = {};
    }

    var popups = editor.shared.popups; // To store active popup buttons

    var $btnActivePopups;

    function setContainer(id, $container) {
      if (!$container.isVisible()) {
        $container = editor.$sc;
      }

      if (!$container.is(popups[id].data('container'))) {
        popups[id].data('container', $container);
        $container.append(popups[id]);
      }
    }

    function setFileListHeight($popup) {
      $popup.find('.fr-upload-progress').addClass('fr-height-set');
      $popup.find('.fr-upload-progress').removeClass('fr-height-auto');
      editor.popups.get('filesManager.insert').removeClass('fr-height-auto');
      var activeLayerIndex;
      $popup.find('.fr-files-upload-layer').hasClass('fr-active') ? activeLayerIndex = 1 : '';
      $popup.find('.fr-files-by-url-layer').hasClass('fr-active') ? activeLayerIndex = 2 : '';
      $popup.find('.fr-files-embed-layer').hasClass('fr-active') ? activeLayerIndex = 3 : '';

      if ($popup.find('.fr-upload-progress-layer').get(0).clientHeight + 10 < $popup.find('.fr-upload-progress').get(0).clientHeight) {
        $popup.find('.fr-upload-progress').addClass('fr-height-auto');
      }

      if ($popup[0].clientHeight > 400) $popup[0].childNodes[4].style.height = "".concat($popup[0].clientHeight - ($popup[0].childNodes[0].clientHeight + $popup[0].childNodes[activeLayerIndex].clientHeight) - 80, "px");
    }

    var prevHeight = 2000;

    function setPopupDimensions($popup, isDelete) {
      if (isDelete && $popup.find('.fr-upload-progress-layer').get(0).clientHeight < prevHeight) {
        $popup.find('.fr-upload-progress').addClass('fr-height-auto');
        editor.popups.get('filesManager.insert').addClass('fr-height-auto');
        $popup.find('.fr-upload-progress').removeClass('fr-height-set');
        prevHeight = 2000;
      }

      if ($popup.get(0).clientHeight > window.innerHeight / 2) {
        if (window.innerWidth < 500) {
          if ($popup.get(0).clientHeight > screenHeightofBrowser * 0.6) {
            setFileListHeight($popup);
          }
        } else {
          if ($popup.get(0).clientHeight > 400) {
            setFileListHeight($popup);
          }
        }

        prevHeight = $popup.find('.fr-upload-progress-layer').get(0).clientHeight;
      }

      var width = window.innerWidth;

      switch (true) {
        case width <= 320:
          $popup.width(200);
          break;

        case width <= 420:
          $popup.width(250);
          break;

        case width <= 520:
          $popup.width(300);
          break;

        case width <= 720:
          $popup.width(400);
          break;

        case width > 720:
          $popup.width(530);
          break;
      }
    }

    function refreshContainer(id, $container) {
      if (!$container.isVisible()) {
        $container = editor.$sc;
      }

      if (!$container.contains([popups[id].get(0)])) {
        $container.append(popups[id]);
      }
    }
    /**
    * Handles focus event on input boxes
    */


    function _inputRefreshEmptyOnFocus() {
      $(this).toggleClass('fr-not-empty', true);
    }
    /**
    * Handles blur event on input boxes
    */


    function _inputRefreshEmptyOnBlur() {
      var $elm = $(this);
      $elm.toggleClass('fr-not-empty', $elm.val() !== '');
    }
    /**
    * Remove placeholder and attach label next to input box for focus and blur transitions
    */


    function _addLabel($inputElms) {
      for (var i = 0; i < $inputElms.length; i++) {
        var elm = $inputElms[i];
        var $elm = $(elm); // Attach a label in place of placeholder for input box transition

        var $label = $elm.next();

        if ($label.length === 0 && $elm.attr('placeholder')) {
          $elm.after("<label for=\"".concat($elm.attr('id'), "\">").concat($elm.attr('placeholder'), "</label>")); // Remove placeholder

          $elm.attr('placeholder', '');
        }
      }
    }
    /**
     * Show popup at a specific position.
     */


    function show(id, left, top, obj_height, applyLeftOffset) {
      // Restore selection on show if it is there.
      if (!isVisible(id)) {
        if (areVisible() && editor.$el.find('.fr-marker').length > 0) {
          editor.events.disableBlur();
          editor.selection.restore();
        } else if (!areVisible()) {
          // We must have focus into editor because we may want to save selection.
          editor.events.disableBlur();
          editor.events.focus();
          editor.events.enableBlur();
        }
      }

      hideAll([id]);

      if (!popups[id]) {
        return false;
      } // Hide active dropdowns.


      var $active_dropdowns = editor.button.getButtons('.fr-dropdown.fr-active');
      $active_dropdowns.removeClass('fr-active').attr('aria-expanded', false).parents('.fr-toolbar').css('zIndex', '').find('> .fr-dropdown-wrapper').css('height', '');
      $active_dropdowns.next().attr('aria-hidden', true).css('overflow', '').find('> .fr-dropdown-wrapper').css('height', ''); // Set the current instance for the popup.

      popups[id].data('instance', editor);

      if (editor.$tb) {
        editor.$tb.data('instance', editor);
      }

      var is_visible = isVisible(id);
      popups[id].addClass('fr-active').removeClass('fr-hidden').find('input, textarea').removeAttr('disabled');
      var $container = popups[id].data('container');
      refreshContainer(id, $container); // Inline mode when container is toolbar.

      if (editor.opts.toolbarInline && $container && editor.$tb && $container.get(0) === editor.$tb.get(0)) {
        setContainer(id, editor.$sc);
        top = editor.$tb.offset().top - editor.helpers.getPX(editor.$tb.css('margin-top'));
        left = editor.$tb.offset().left + editor.$tb.outerWidth() / 2;

        if (editor.node.hasClass(editor.$tb.get(0), 'fr-above') && top) {
          top += editor.$tb.outerHeight();
        }

        obj_height = 0;
      } // Apply iframe correction.


      $container = popups[id].data('container');

      if (editor.opts.iframe && !obj_height && !is_visible) {
        var iframePaddingTop = editor.helpers.getPX(editor.$wp.find('.fr-iframe').css('padding-top'));
        var iframePaddingLeft = editor.helpers.getPX(editor.$wp.find('.fr-iframe').css('padding-left'));

        if (left) {
          left -= editor.$iframe.offset().left + iframePaddingLeft;
        }

        if (top) {
          top -= editor.$iframe.offset().top + iframePaddingTop;
        }
      } // If container is toolbar then increase zindex.


      if ($container.is(editor.$tb)) {
        editor.$tb.css('zIndex', (editor.opts.zIndex || 1) + 4);
      } else {
        popups[id].css('zIndex', (editor.opts.zIndex || 1) + 3);
      } // Toolbar at the bottom and container is toolbar.


      if (editor.opts.toolbarBottom && $container && editor.$tb && $container.get(0) === editor.$tb.get(0)) {
        popups[id].addClass('fr-above');

        if (top) {
          top -= popups[id].outerHeight();
        }
      } // Add popup offset left offset based on the popup width


      if (applyLeftOffset) {
        left -= popups[id].width() / 2;
      } // Check if it exceeds window on the right.


      if (left + popups[id].outerWidth() > editor.$sc.offset().left + editor.$sc.width()) {
        left -= left + popups[id].outerWidth() - editor.$sc.offset().left - editor.$sc.width();
      } // Check if it exceeds window on the left.


      if (left < editor.$sc.offset().left && editor.opts.direction === 'rtl') {
        left = editor.$sc.offset().left;
      } // Position editor.


      popups[id].removeClass('fr-active');
      editor.position.at(left, top, popups[id], obj_height || 0); //check if set to contenteditable

      var content_parent = editor.node.blockParent(editor.selection.blocks()[0]);

      if (content_parent && content_parent.getAttribute('contenteditable') === 'false') {
        popups[id].removeClass('fr-active');
      } else {
        var parentContent = editor.selection.element().parentElement.getAttribute('contenteditable');

        if (parentContent && parentContent === 'false') {
          popups[id].removeClass('fr-active');
        } else {
          popups[id].addClass('fr-active');
        }
      }

      if (!is_visible) {
        editor.accessibility.focusPopup(popups[id]);
      }

      if (editor.opts.toolbarInline) {
        editor.toolbar.hide();
      } // Update the button for active popup


      if (editor.$tb) {
        $btnActivePopups = editor.$tb.find('.fr-btn-active-popup');
      }

      editor.events.trigger("popups.show.".concat(id)); // https://github.com/froala/wysiwyg-editor/issues/1248

      _events(id)._repositionPopup();

      _unmarkExit();
    }

    function onShow(id, callback) {
      editor.events.on("popups.show.".concat(id), callback);
    }
    /**
     * Find visible popup.
     */


    function isVisible(id) {
      return popups[id] && editor.node.hasClass(popups[id], 'fr-active') && editor.core.sameInstance(popups[id]) || false;
    }
    /**
     * Check if there is any popup visible.
     */


    function areVisible(new_instance) {
      for (var id in popups) {
        if (Object.prototype.hasOwnProperty.call(popups, id)) {
          if (isVisible(id) && (typeof new_instance === 'undefined' || popups[id].data('instance') === new_instance)) {
            return popups[id];
          }
        }
      }

      return false;
    }
    /**
     * Hide popup.
     */


    function hide(id) {
      var $popup = null;

      if (typeof id !== 'string') {
        $popup = id;
      } else {
        $popup = popups[id];
      }

      if (id === 'filesManager.insert' && editor.filesManager !== undefined && editor.filesManager.isChildWindowOpen()) {
        return false;
      }

      if ($popup && editor.node.hasClass($popup, 'fr-active')) {
        $popup.removeClass('fr-active fr-above');
        editor.events.trigger("popups.hide.".concat(id)); // Reset toolbar zIndex.

        if (editor.$tb) {
          if (editor.opts.zIndex > 1) {
            editor.$tb.css('zIndex', editor.opts.zIndex + 1);
          } else {
            editor.$tb.css('zIndex', '');
          }
        }

        editor.events.disableBlur();
        $popup.find('input, textarea, button').each(function () {
          if (this === this.ownerDocument.activeElement) {
            this.blur();
          }
        }); // Mark the input boxes as empty

        $popup.find('input, textarea').attr('disabled', 'disabled'); // Remove styling from active popup buttons when popup is closed

        if ($btnActivePopups) {
          for (var index = 0; index < $btnActivePopups.length; index++) {
            $($btnActivePopups[index]).removeClass('fr-btn-active-popup');
          }
        }
      }
    }
    /**
     * Assign an event for hiding.
     */


    function onHide(id, callback) {
      editor.events.on("popups.hide.".concat(id), callback);
    }
    /**
     * Get the popup with the specific id.
     */


    function get(id) {
      var $popup = popups[id];

      if ($popup && !$popup.data("inst".concat(editor.id))) {
        var ev = _events(id);

        _bindInstanceEvents(ev, id);
      }

      return $popup;
    }

    function onRefresh(id, callback) {
      editor.events.on("popups.refresh.".concat(id), callback);
    }
    /**
     * Refresh content inside the popup.
     */


    function refresh(id) {
      // Set the instance id for the popup.
      popups[id].data('instance', editor);
      editor.events.trigger("popups.refresh.".concat(id));
      var btns = popups[id].find('.fr-command');

      for (var i = 0; i < btns.length; i++) {
        var $btn = $(btns[i]);

        if ($btn.parents('.fr-dropdown-menu').length === 0) {
          editor.button.refresh($btn);
        }
      }
    }
    /**
     * Hide all popups.
     */


    function hideAll(except) {
      if (typeof except === 'undefined') {
        except = [];
      }

      for (var id in popups) {
        if (Object.prototype.hasOwnProperty.call(popups, id)) {
          if (except.indexOf(id) < 0) {
            hide(id);
          }
        }
      }
    }

    editor.shared.exit_flag = false;

    function _markExit() {
      editor.shared.exit_flag = true;
    }

    function _unmarkExit() {
      editor.shared.exit_flag = false;
    }

    function _canExit() {
      return editor.shared.exit_flag;
    }

    function _buildTemplate(id, template) {
      // Load template.
      var html = FroalaEditor.POPUP_TEMPLATES[id];

      if (!html) {
        return null;
      }

      if (typeof html === 'function') {
        html = html.apply(editor);
      }

      for (var nm in template) {
        if (Object.prototype.hasOwnProperty.call(template, nm)) {
          html = html.replace("[_".concat(nm.toUpperCase(), "_]"), template[nm]);
        }
      }

      return html;
    }

    function _build(id, template) {
      var $container;

      var html = _buildTemplate(id, template);

      var $popup = $(editor.doc.createElement('DIV'));

      if (!html) {
        if (id === 'filesManager.insert') {
          $popup.addClass('fr-popup fr-files-manager fr-empty');
        } else {
          $popup.addClass('fr-popup fr-empty');
        }

        $container = $('body').first();
        $container.append($popup);
        $popup.data('container', $container);
        popups[id] = $popup;
        return $popup;
      }

      if (id === 'filesManager.insert') {
        $popup.addClass("fr-popup fr-files-manager".concat(editor.helpers.isMobile() ? ' fr-mobile' : ' fr-desktop').concat(editor.opts.toolbarInline ? ' fr-inline' : ''));
      } else {
        $popup.addClass("fr-popup".concat(editor.helpers.isMobile() ? ' fr-mobile' : ' fr-desktop').concat(editor.opts.toolbarInline ? ' fr-inline' : ''));
      }

      $popup.html(html);

      if (editor.opts.theme) {
        $popup.addClass("".concat(editor.opts.theme, "-theme"));
      }

      if (editor.opts.zIndex > 1) {
        if (!editor.opts.editInPopup && editor.$tb) {
          editor.$tb.css('z-index', editor.opts.zIndex + 2);
        } else {
          $popup.css('z-index', editor.opts.zIndex + 2);
        }
      }

      if (editor.opts.direction !== 'auto') {
        $popup.removeClass('fr-ltr fr-rtl').addClass("fr-".concat(editor.opts.direction));
      }

      $popup.find('input, textarea').attr('dir', editor.opts.direction).attr('disabled', 'disabled');
      $container = $('body').first();
      $container.append($popup);
      $popup.data('container', $container);
      popups[id] = $popup;
      var $colorHexLayer = $popup.find('.fr-color-hex-layer');

      if ($colorHexLayer.length > 0) {
        var spanWidth = editor.helpers.getPX($popup.find('.fr-color-set > span').css('width'));
        var paddingLeft = editor.helpers.getPX($colorHexLayer.css('paddingLeft'));
        var paddingRight = editor.helpers.getPX($colorHexLayer.css('paddingRight'));
        $colorHexLayer.css('width', spanWidth * editor.opts.colorsStep + paddingLeft + paddingRight);
      } // Bind commands from the popup.


      editor.button.bindCommands($popup, false);
      return $popup;
    }

    function _events(id) {
      var $popup = popups[id];
      return {
        /**
         * Resize window.
         */
        _windowResize: function _windowResize() {
          var inst = $popup.data('instance') || editor;

          if (!inst.helpers.isMobile() && $popup.isVisible()) {
            // https://github.com/froala-labs/froala-editor-js-2/issues/3434
            var progressBar = $popup.find('.fr-file-progress-bar-layer');

            if (id === 'file.insert' && progressBar.length > 0 && progressBar.hasClass('fr-active')) {
              var $btn = editor.$tb.find('.fr-command[data-cmd="insertFile"]');
              inst.events.disableBlur();

              var _editor$button$getPos = editor.button.getPosition($btn),
                  left = _editor$button$getPos.left,
                  top = _editor$button$getPos.top;

              editor.position.at(left, top, popups[id], 0);
              inst.events.enableBlur();
            } else {
              inst.events.disableBlur();
              inst.popups.hide(id);
              inst.events.enableBlur();
            }
          }
        },

        /**
         * Focus on an input.
         */
        _inputFocus: function _inputFocus(e) {
          var inst = $popup.data('instance') || editor;
          var $target = $(e.currentTarget);

          if ($target.is('input:file')) {
            $target.closest('.fr-layer').addClass('fr-input-focus');
          }

          e.preventDefault();
          e.stopPropagation(); // IE workaround.

          setTimeout(function () {
            inst.events.enableBlur();
          }, 100); // Reposition scroll on mobile to the original one.

          if (inst.helpers.isMobile()) {
            var t = $(inst.o_win).scrollTop();
            setTimeout(function () {
              $(inst.o_win).scrollTop(t);
            }, 0);
          }
        },

        /**
         * Blur on an input.
         */
        _inputBlur: function _inputBlur(e) {
          var inst = $popup.data('instance') || editor;
          var $target = $(e.currentTarget);

          if ($target.is('input:file')) {
            $target.closest('.fr-layer').removeClass('fr-input-focus');
          } // Do not do blur on window change.


          if (document.activeElement !== this && $(this).isVisible()) {
            if (inst.events.blurActive()) {
              inst.events.trigger('blur');
            }

            inst.events.enableBlur();
          }
        },

        /**
         * Editor keydown.
         */
        _editorKeydown: function _editorKeydown(e) {
          var inst = $popup.data('instance') || editor; // ESC.

          if (!inst.keys.ctrlKey(e) && e.which !== FroalaEditor.KEYCODE.ALT && e.which !== FroalaEditor.KEYCODE.ESC) {
            if (isVisible(id) && $popup.findVisible('.fr-back').length) {
              inst.button.exec($popup.findVisible('.fr-back').first());
            } // Don't hide if alt alone is pressed to allow Alt + F10 shortcut for accessibility.
            else if (e.which !== FroalaEditor.KEYCODE.ALT) {
              inst.popups.hide(id);
            }
          }
        },

        /**
         * Handling hitting the popup elements with the mouse.
         */
        _preventFocus: function _preventFocus(e) {
          var inst = $popup.data('instance') || editor; // Get the original target.

          var originalTarget = e.originalEvent ? e.originalEvent.target || e.originalEvent.originalTarget : null; // Do not disable blur on mouseup because it is the last event in the chain.

          if (e.type !== 'mouseup' && !$(originalTarget).is(':focus')) {
            inst.events.disableBlur();
          } // Hide popup's active dropdowns on mouseup.


          if (e.type === 'mouseup' && !($(originalTarget).hasClass('fr-command') || $(originalTarget).parents('.fr-command').length > 0) && !$(originalTarget).hasClass('fr-dropdown-content')) {
            editor.button.hideActiveDropdowns($popup);
          } // https://github.com/froala/wysiwyg-editor/issues/1733
          // https://github.com/froala/wysiwyg-editor/issues/1838 . Firefox: with Jquery > 2 $(originalTarget).is(':focus') returns the oposite to Jquery < 2.


          if ((editor.browser.safari || editor.browser.mozilla) && e.type === 'mousedown' && $(originalTarget).is('input[type=file]')) {
            inst.events.disableBlur();
          } // Define the input selector.


          var input_selector = 'input, textarea, button, select, label, .fr-command'; // Click was not made inside an input.

          if (originalTarget && !$(originalTarget).is(input_selector) && $(originalTarget).parents(input_selector).length === 0) {
            e.stopPropagation();
            return false;
          } // Click was made on another input inside popup. Prevent propagation of the event.
          else if (originalTarget && $(originalTarget).is(input_selector)) {
            e.stopPropagation();
          }

          _unmarkExit();
        },

        /**
         * Mouseup inside the editor.
         */
        _editorMouseup: function _editorMouseup() {
          // Check if popup is visible and we can exit.
          if ($popup.isVisible() && _canExit()) {
            // If we have an input focused, then disable blur.
            if ($popup.findVisible('input:focus, textarea:focus, button:focus, select:focus').length > 0) {
              editor.events.disableBlur();
            }
          }
        },

        /**
         * Mouseup on window.
         */
        _windowMouseup: function _windowMouseup(e) {
          if (!editor.core.sameInstance($popup)) {
            return true;
          }

          var inst = $popup.data('instance') || editor;

          if ($popup.isVisible() && _canExit()) {
            e.stopPropagation();
            inst.markers.remove();
            inst.popups.hide(id);

            _unmarkExit();
          }
        },

        /**
         * Keydown on window.
         */
        _windowKeydown: function _windowKeydown(e) {
          if (!editor.core.sameInstance($popup)) {
            return true;
          }

          var inst = $popup.data('instance') || editor;
          var key_code = e.which; // ESC.

          if (FroalaEditor.KEYCODE.ESC === key_code) {
            if (inst.popups.isVisible(id) && inst.opts.toolbarInline) {
              e.stopPropagation();

              if (inst.popups.isVisible(id)) {
                if ($popup.findVisible('.fr-back').length) {
                  inst.button.exec($popup.findVisible('.fr-back').first()); // Focus back popup button.

                  inst.accessibility.focusPopupButton($popup);
                } else if ($popup.findVisible('.fr-dismiss').length) {
                  inst.button.exec($popup.findVisible('.fr-dismiss').first());
                } else {
                  inst.popups.hide(id);
                  inst.toolbar.showInline(null, true); // Focus back popup button.

                  inst.accessibility.focusPopupButton($popup);
                }
              }

              return false;
            } else if (inst.popups.isVisible(id)) {
              if ($popup.findVisible('.fr-back').length) {
                inst.button.exec($popup.findVisible('.fr-back').first); // Focus back popup button.

                inst.accessibility.focusPopupButton($popup);
              } else if ($popup.findVisible('.fr-dismiss').length) {
                inst.button.exec($popup.findVisible('.fr-dismiss').first());
              } else {
                inst.popups.hide(id); // Focus back popup button.

                inst.accessibility.focusPopupButton($popup);
              }

              return false;
            }
          }
        },

        /**
         * Reposition popup.
         */
        _repositionPopup: function _repositionPopup() {
          // No height set or toolbar inline.
          if (!(editor.opts.height || editor.opts.heightMax) || editor.opts.toolbarInline) {
            return true;
          }

          if (editor.$wp && isVisible(id) && $popup.parent().get(0) === editor.$sc.get(0)) {
            // Popup top - wrapper top.
            var p_top = $popup.offset().top - editor.$wp.offset().top; // Wrapper height.

            var w_height = editor.$wp.outerHeight();

            if (editor.node.hasClass($popup.get(0), 'fr-above')) {
              p_top += $popup.outerHeight();
            } // https://github.com/froala-labs/froala-editor-js-2/issues/3825
            // https://github.com/froala-labs/froala-editor-js-2/issues/3860
            // https://github.com/froala-labs/froala-editor-js-2/issues/3802


            if (p_top > w_height || p_top < 0) {
              $popup.addClass('fr-hidden');
            } else {
              $popup.removeClass('fr-hidden');
            }
          }
        },
        handleWindowClick: function handleWindowClick(e) {
          if (!editor.core.sameInstance($popup)) {
            return true;
          }

          var inst = $popup.data('instance') || editor;

          if ($popup.isVisible() && e.target && ($(e.target).find('body').length > 0 || $(e.target)[0].tagName === 'BODY')) {
            e.stopPropagation();
            inst.popups.hide(id);
          }
        }
      };
    }

    function _bindInstanceEvents(ev, id) {
      // Editor mouseup.
      editor.events.on('mouseup', ev._editorMouseup, true);

      if (editor.$wp) {
        editor.events.on('keydown', ev._editorKeydown);
      } // Remove popup class on focus as pop up will be hidden on focus of editor


      editor.events.on('focus', function () {
        popups[id].removeClass('focused');
      }); // Hide all popups on blur.

      editor.events.on('blur', function () {
        if (areVisible()) {
          editor.markers.remove();
        } // https://github.com/froala-labs/froala-editor-js-2/issues/2044


        if (editor.helpers.isMobile()) {
          if (popups[id].hasClass('focused')) {
            hideAll();
            popups[id].removeClass('focused');
          } else {
            popups[id].addClass('focused');
          }
        } else {
          // https://github.com/froala-labs/froala-editor-js-2/issues/858
          if (!popups[id].find('iframe').length) {
            hideAll();
          }
        }
      }); // Update the position of the popup.

      if (editor.$wp && !editor.helpers.isMobile()) {
        editor.events.$on(editor.$wp, "scroll.popup".concat(id), ev._repositionPopup);
      }

      editor.events.on('window.mouseup', ev._windowMouseup, true);
      editor.events.on('window.keydown', ev._windowKeydown, true); // https://github.com/froala-labs/froala-editor-js-2/issues/3059

      if (editor.opts.iframe) {
        window.addEventListener('click', ev.handleWindowClick);
      }

      popups[id].data("inst".concat(editor.id), true);
      editor.events.on('destroy', function () {
        if (editor.core.sameInstance(popups[id])) {
          $('body').first().append(popups[id]);
          popups[id].removeClass('fr-active');
        }
      }, true);
    }
    /**
     * Handles a checkbox label click event
     */


    function _checkboxLabelClick() {
      // Get checkbox next to the label
      var $checkbox = $(this).prev().children().first(); // Toggle the checkbox

      $checkbox.attr('checked', !$checkbox.attr('checked'));
    }
    /**
     * Create a popup.
     */


    function create(id, template) {
      var $popup = _build(id, template); // Build events.


      var ev = _events(id); // Events binded here should be assigned in every instace.


      _bindInstanceEvents(ev, id); // Input Focus / Blur / Keydown.


      editor.events.$on($popup, 'mousedown mouseup touchstart touchend touch', '*', ev._preventFocus, true);
      editor.events.$on($popup, 'focus', 'input, textarea, button, select', ev._inputFocus, true);
      editor.events.$on($popup, 'blur', 'input, textarea, button, select', ev._inputBlur, true); // Attach focus and blur events for transitions

      var $labelElms = $popup.find('input, textarea');

      _addLabel($labelElms);

      editor.events.$on($labelElms, 'focus', _inputRefreshEmptyOnFocus);
      editor.events.$on($labelElms, 'blur change', _inputRefreshEmptyOnBlur); // Toggle the checkbox on click on label

      editor.events.$on($popup, 'click', '.fr-checkbox + label', _checkboxLabelClick); // Register popup to handle keyboard accessibility.

      editor.accessibility.registerPopup(id); // Toggle checkbox.

      if (editor.helpers.isIOS()) {
        editor.events.$on($popup, 'touchend', 'label', function () {
          $("#".concat($(this).attr('for'))).prop('checked', function (i, val) {
            return !val;
          });
        }, true);
      } // Window mouseup.


      editor.events.$on($(editor.o_win), 'resize', ev._windowResize, true);

      if (id === 'filesManager.insert') {
        popups['filesManager.insert'].css('zIndex', 2147483641);
      }

      return $popup;
    }
    /**
     * Destroy.
     */


    function _destroy() {
      for (var id in popups) {
        if (Object.prototype.hasOwnProperty.call(popups, id)) {
          var $popup = popups[id];

          if ($popup) {
            $popup.html('').removeData().remove();
            popups[id] = null;
          }
        }
      }

      popups = [];
    }
    /**
     * Initialization.
     */


    function _init() {
      screenHeightofBrowser = window.innerHeight;
      editor.events.on('shared.destroy', _destroy, true);
      editor.events.on('window.mousedown', _markExit);
      editor.events.on('window.touchmove', _unmarkExit); // Prevent hiding popups while we scroll.

      editor.events.$on($(editor.o_win), 'scroll', _unmarkExit);
      editor.events.on('mousedown', function (e) {
        if (areVisible()) {
          e.stopPropagation(); // Remove markers.

          editor.$el.find('.fr-marker').remove(); // Prepare for exit.

          _markExit(); // Disable blur.


          editor.events.disableBlur();
        }
      });
    }

    return {
      _init: _init,
      create: create,
      get: get,
      show: show,
      hide: hide,
      onHide: onHide,
      hideAll: hideAll,
      setContainer: setContainer,
      refresh: refresh,
      onRefresh: onRefresh,
      onShow: onShow,
      isVisible: isVisible,
      setFileListHeight: setFileListHeight,
      areVisible: areVisible,
      setPopupDimensions: setPopupDimensions
    };
  };

  FroalaEditor.MODULES.accessibility = function (editor) {
    var $ = editor.$; // Flag to tell if mouseenter can blur popup elements with tabindex. This is in case that popup shows over the cursor so mouseenter should not blur immediately.
    // FireFox issue.

    var can_blur = true;
    /*
     * Focus an element.
     */

    function focusToolbarElement($el) {
      var contenteditableEl = editor.$el.find('[contenteditable="true"]');
      var focusedEditableEl = false;
      var ind = 0; // Check if there is a contenteditable element in focus.

      while (contenteditableEl.get(ind)) {
        if ($(contenteditableEl.get(ind)).is(':focus')) {
          focusedEditableEl = true;
        }

        ind++;
      } // Check if it is empty.
      // https://github.com/froala/wysiwyg-editor/issues/2427.


      if (!$el || !$el.length || focusedEditableEl) {
        return;
      } // Add blur event handler on the element that do not reside on a popup.


      if (!$el.data('blur-event-set') && !$el.parents('.fr-popup').length) {
        // Set shared event for blur on element because it resides in a popup.
        editor.events.$on($el, 'blur', function () {
          // Get current instance.
          var inst = $el.parents('.fr-toolbar, .fr-popup').data('instance') || editor; // Check if we should actually trigger blur.

          if (inst.events.blurActive() && !editor.core.hasFocus()) {
            inst.events.trigger('blur');
          } // Allow blur.
          // IE hack.


          setTimeout(function () {
            inst.events.enableBlur();
          }, 100);
        }, true);
        $el.data('blur-event-set', true);
      } // Get current instance.


      var inst = $el.parents('.fr-toolbar, .fr-popup').data('instance') || editor; // https://github.com/froala-labs/froala-editor-js-2/issues/2577

      if (editor.browser.safari) {
        editor.shared.safariSelection = editor.selection.get().getRangeAt(0).cloneRange();
      } // Do not allow blur on the editor until element focus.


      inst.events.disableBlur();
      $el.get(0).focus(); // Store it as the current focused element.

      editor.shared.$f_el = $el;
    }
    /*
     * Focus first or last toolbar button.
     */


    function focusToolbar($tb, last) {
      var position = last ? 'last' : 'first'; // Get all toobar buttons.
      // Re-order the toolbar buttons

      var $btn = _reorderToolbarButtons(_getVisibleToolbarButtons($tb))[position]();

      if ($btn.length) {
        focusToolbarElement($btn);
        return true;
      }
    }
    /*
     * Focus a popup content element.
     */


    function focusContentElement($el) {
      // Save editor selection only if the element we want to focus is input text or textarea.
      if ($el.is('input, textarea, select')) {
        saveSelection();
      }

      editor.events.disableBlur();
      $el.get(0).focus();
      return true;
    }
    /*
     * Focus popup's content.
     */


    function focusContent($content, backward) {
      // First input.
      var $first_input = $content.find('input, textarea, button, select').filter(function () {
        return $(this).isVisible();
      }).not(':disabled');
      $first_input = backward ? $first_input.last() : $first_input.first();

      if ($first_input.length) {
        return focusContentElement($first_input);
      }

      if (editor.shared.with_kb) {
        // Active item.
        var $active_item = $content.findVisible('.fr-active-item').first();

        if ($active_item.length) {
          return focusContentElement($active_item);
        } // First element with tabindex.


        var $first_tab_index = $content.findVisible('[tabIndex]').first();

        if ($first_tab_index.length) {
          return focusContentElement($first_tab_index);
        }
      }
    }

    function saveSelection() {
      if (editor.$el.find('.fr-marker').length === 0 && editor.core.hasFocus()) {
        editor.selection.save();
      }
    }

    function restoreSelection() {
      // Restore selection.
      if (editor.$el.find('.fr-marker').length) {
        editor.events.disableBlur();
        editor.selection.restore();
        editor.events.enableBlur();
      }
    }
    /*
     * Focus popup.
     */


    function focusPopup($popup) {
      // Get popup content without fr-buttons toolbar.
      var $popup_content = $popup.children().not('.fr-buttons'); // Blur popup on mouseenter.

      if (!$popup_content.data('mouseenter-event-set')) {
        editor.events.$on($popup_content, 'mouseenter', '[tabIndex]', function (e) {
          var inst = $popup.data('instance') || editor; // FireFox issue.

          if (!can_blur) {
            // Popup showed over the cursor.
            e.stopPropagation();
            e.preventDefault();
            return;
          }

          var $focused_item = $popup_content.find(':focus').first();

          if ($focused_item.length && !$focused_item.is('input, button, textarea, select')) {
            inst.events.disableBlur();
            $focused_item.blur();
            inst.events.disableBlur();
            inst.events.focus();
          }
        });
        $popup_content.data('mouseenter-event-set', true);
      } // Focus content if possible, else focus toolbar if the popup is opened with keyboard.


      if (!focusContent($popup_content) && editor.shared.with_kb) {
        focusToolbar($popup.find('.fr-buttons'));
      }
    }
    /*
     * Focus modal.
     */


    function focusModal($modal) {
      // Make sure we have focus on editing area.
      if (!editor.core.hasFocus()) {
        editor.events.disableBlur();
        editor.events.focus();
      } // Save selection.


      editor.accessibility.saveSelection();
      editor.events.disableBlur(); // Blur editor and clear selection to enable arrow keys scrolling.

      editor.el.blur();
      editor.selection.clear();
      editor.events.disableBlur();

      if (editor.shared.with_kb) {
        $modal.find('.fr-command[tabIndex], [tabIndex]').first().focus();
      } else {
        $modal.find('[tabIndex]').first().focus();
      }
    }
    /*
     * Focus popup toolbar or main toolbar.
     */


    function focusToolbars() {
      // Look for active popup.
      var $popup = editor.popups.areVisible();

      if ($popup) {
        var $tb = $popup.find('.fr-buttons');

        if (!$tb.find('button:focus, .fr-group span:focus').length) {
          return !focusToolbar($tb);
        }

        return !focusToolbar($popup.data('instance').$tb);
      } // Focus main toolbar if no others were found.


      return !focusToolbar(editor.$tb);
    }
    /*
     * Get the dropdown button that is active and is focused or is active and its commands are focused.
     */


    function _getActiveFocusedDropdown() {
      var $activeDropdown = null; // Is active and focused.

      if (editor.shared.$f_el.is('.fr-dropdown.fr-active')) {
        $activeDropdown = editor.shared.$f_el;
      } // Is active and its commands are focused. editor.shared.$f_el is a dropdown command.
      else if (editor.shared.$f_el.closest('.fr-dropdown-menu').prev().is('.fr-dropdown.fr-active')) {
        $activeDropdown = editor.shared.$f_el.closest('.fr-dropdown-menu').prev();
      }

      return $activeDropdown;
    }
    /**
     * Insert the more toolbar buttons after its corresponding more button
     */


    function _reorderToolbarButtons($buttons) {
      // Get the more button position
      var moreBtnIndex = -1;

      for (var i = 0; i < $buttons.length; i++) {
        if ($($buttons[i]).hasClass('fr-open')) {
          moreBtnIndex = i;
        }
      } // Get first open more toolbar button position


      var firstMoreToolbarBtnIndex = $buttons.index(editor.$tb.find('.fr-more-toolbar.fr-expanded > button.fr-command').first()); // If atleast one more toolbar is expanded

      if (firstMoreToolbarBtnIndex > 0 && moreBtnIndex !== -1) {
        // Insert the more toolbar buttons after its more button
        var $moreToolbarBtns = $buttons.slice(firstMoreToolbarBtnIndex, $buttons.length);
        $buttons = $buttons.slice(0, firstMoreToolbarBtnIndex);
        var left = $buttons.slice(0, moreBtnIndex + 1);
        var right = $buttons.slice(moreBtnIndex + 1, $buttons.length);
        $buttons = left;

        for (var _i = 0; _i < $moreToolbarBtns.length; _i++) {
          $buttons.push($moreToolbarBtns[_i]);
        }

        for (var _i2 = 0; _i2 < right.length; _i2++) {
          $buttons.push(right[_i2]);
        }
      }

      return $buttons;
    }
    /**
     * Returns the visible toolbar buttons
     */


    function _getVisibleToolbarButtons($tb) {
      return $tb.findVisible('button:not(.fr-disabled), .fr-group span.fr-command').filter(function (btn) {
        var $moreToolbar = $(btn).parents('.fr-more-toolbar'); // Remove all the buttons which are not part of the open more toolbar

        return $moreToolbar.length === 0 || $moreToolbar.length > 0 && $moreToolbar.hasClass('fr-expanded');
      });
    }

    function _moveHorizontally($tb, tab_key, forward) {
      if (editor.shared.$f_el) {
        var $activeDropdown = _getActiveFocusedDropdown(); // A focused active dropdown button.


        if ($activeDropdown) {
          // Unclick.
          editor.button.click($activeDropdown);
          editor.shared.$f_el = $activeDropdown;
        } // Focus the next/previous button.
        // Get all toobar buttons.
        // Re-order the toolbar buttons


        var $buttons = _reorderToolbarButtons(_getVisibleToolbarButtons($tb)); // Get focused button position.


        var index = $buttons.index(editor.shared.$f_el); // Last or first button reached.

        if (index === 0 && !forward || index === $buttons.length - 1 && forward) {
          var status; // Focus content if last or first toolbar button is reached.

          if (tab_key) {
            if ($tb.parent().is('.fr-popup')) {
              var $popup_content = $tb.parent().children().not('.fr-buttons');
              status = !focusContent($popup_content, !forward);
            }

            if (status === false) {
              editor.shared.$f_el = null;
            }
          } // Arrow used or popup listeners were not active.


          if (!tab_key || status !== false) {
            // Focus to the opposite side button of the toolbar.
            focusToolbar($tb, !forward);
          }
        } else {
          // Focus next or previous button.
          focusToolbarElement($($buttons.get(index + (forward ? 1 : -1))));
        }

        return false;
      }
    }

    function moveForward($tb, tab_key) {
      return _moveHorizontally($tb, tab_key, true);
    }

    function moveBackward($tb, tab_key) {
      return _moveHorizontally($tb, tab_key);
    }

    function _moveVertically(down) {
      if (editor.shared.$f_el) {
        var $destination; // Dropdown button.

        if (editor.shared.$f_el.is('.fr-dropdown.fr-active')) {
          // Focus the first/last dropdown command.
          if (down) {
            $destination = editor.shared.$f_el.next().find('.fr-command:not(.fr-disabled)').first();
          } else {
            $destination = editor.shared.$f_el.next().find('.fr-command:not(.fr-disabled)').last();
          }

          focusToolbarElement($destination);
          return false;
        } // Dropdown command.
        else if (editor.shared.$f_el.is('a.fr-command')) {
          // Focus the previous/next dropdown command.
          if (down) {
            $destination = editor.shared.$f_el.closest('li').nextAllVisible().first().find('.fr-command:not(.fr-disabled)').first();
          } else {
            $destination = editor.shared.$f_el.closest('li').prevAllVisible().first().find('.fr-command:not(.fr-disabled)').first();
          } // Last or first button reached: Focus to the opposite side element of the dropdown.


          if (!$destination.length) {
            if (down) {
              $destination = editor.shared.$f_el.closest('.fr-dropdown-menu').find('.fr-command:not(.fr-disabled)').first();
            } else {
              $destination = editor.shared.$f_el.closest('.fr-dropdown-menu').find('.fr-command:not(.fr-disabled)').last();
            }
          }

          focusToolbarElement($destination);
          return false;
        }
      }
    }

    function moveDown() {
      // Also enable dropdown opening on arrow down.
      if (editor.shared.$f_el && editor.shared.$f_el.is('.fr-dropdown:not(.fr-active)')) {
        return enter();
      }

      return _moveVertically(true);
    }

    function moveUp() {
      return _moveVertically();
    }

    function enter() {
      if (editor.shared.$f_el) {
        // Check if the focused element is a dropdown button.
        if (editor.shared.$f_el.hasClass('fr-dropdown')) {
          // Do click and focus the first dropdown item.
          editor.button.click(editor.shared.$f_el);
        } else if (editor.shared.$f_el.is('button.fr-back')) {
          if (editor.opts.toolbarInline) {
            editor.events.disableBlur();
            editor.events.focus();
          }

          var $popup = editor.popups.areVisible(editor); // Previous popup will show up so we need to not default focus the popup because back popup button have to be focused.

          if ($popup) {
            editor.shared.with_kb = false;
          }

          editor.button.click(editor.shared.$f_el); // Focus back popup button.

          focusPopupButton($popup);
        } else {
          editor.events.disableBlur();
          editor.button.click(editor.shared.$f_el); // If it is a more button

          if (editor.shared.$f_el.attr('data-group-name')) {
            // Focus the first active button in the more toolbar only if the more toolbar is open
            var $moreToolbar = editor.$tb.find(".fr-more-toolbar[data-name=\"".concat(editor.shared.$f_el.attr('data-group-name'), "\"]"));
            var $btn = editor.shared.$f_el;

            if ($moreToolbar.hasClass('fr-expanded')) {
              $btn = $moreToolbar.findVisible('button:not(.fr-disabled)')['first']();
            }

            if ($btn) {
              focusToolbarElement($btn);
            }
          } else if (editor.shared.$f_el.attr('data-popup')) {
            // Attach button to visible popup.
            var $visible_popup = editor.popups.areVisible(editor);

            if ($visible_popup) {
              $visible_popup.data('popup-button', editor.shared.$f_el);
            }
          } else if (editor.shared.$f_el.attr('data-modal')) {
            // Attach button to visible modal.
            var $visible_modal = editor.modals.areVisible(editor);

            if ($visible_modal) {
              $visible_modal.data('modal-button', editor.shared.$f_el);
            }
          }

          editor.shared.$f_el = null;
        }

        return false;
      }
    }

    function focusEditor() {
      if (editor.shared.$f_el) {
        editor.events.disableBlur();
        editor.shared.$f_el.blur();
        editor.shared.$f_el = null;
      } // Trigger custom behavior.


      if (editor.events.trigger('toolbar.focusEditor') === false) {
        return;
      }

      editor.events.disableBlur();
      editor.$el.get(0).focus();
      editor.events.focus();
    }

    function esc($tb) {
      if (editor.shared.$f_el) {
        var $activeDropdown = _getActiveFocusedDropdown(); // Active focused dropdown.


        if ($activeDropdown) {
          // Unclick.
          editor.button.click($activeDropdown); // Focus the unactive dropdown.

          focusToolbarElement($activeDropdown);
        } // Toolbar contains a back button.
        else if ($tb.parent().findVisible('.fr-back').length) {
          editor.shared.with_kb = false;

          if (editor.opts.toolbarInline) {
            // Toolbar inline needs focus in order to show up.
            editor.events.disableBlur();
            editor.events.focus();
          }

          editor.button.exec($tb.parent().findVisible('.fr-back')).first(); // Focus back popup button.

          focusPopupButton($tb.parent());
        } // A toolbar that gets opened from the editable area.
        else if (editor.shared.$f_el.is('button, .fr-group span')) {
          if ($tb.parent().is('.fr-popup')) {
            // Restore selection.
            editor.accessibility.restoreSelection();
            editor.shared.$f_el = null; // Trigger custom behaviour.

            if (editor.events.trigger('toolbar.esc') !== false) {
              // Default behaviour.
              // Hide popup.
              editor.popups.hide($tb.parent()); // Show inline toolbar.

              if (editor.opts.toolbarInline) {
                editor.toolbar.showInline(null, true);
              } // Focus back popup button.


              focusPopupButton($tb.parent());
            }
          } else {
            focusEditor();
          }
        }

        return false;
      }
    }
    /*
     * Execute shortcut.
     */


    function exec(e, $tb) {
      var ctrlKey = navigator.userAgent.indexOf('Mac OS X') !== -1 ? e.metaKey : e.ctrlKey;
      var keycode = e.which;
      var status = false; // Tab.

      if (keycode === FroalaEditor.KEYCODE.TAB && !ctrlKey && !e.shiftKey && !e.altKey) {
        status = moveForward($tb, true);
      } // Arrow right -> .
      else if (keycode === FroalaEditor.KEYCODE.ARROW_RIGHT && !ctrlKey && !e.shiftKey && !e.altKey) {
        status = moveForward($tb);
      } // Shift + Tab.
      else if (keycode === FroalaEditor.KEYCODE.TAB && !ctrlKey && e.shiftKey && !e.altKey) {
        status = moveBackward($tb, true);
      } // Arrow left <- .
      else if (keycode === FroalaEditor.KEYCODE.ARROW_LEFT && !ctrlKey && !e.shiftKey && !e.altKey) {
        status = moveBackward($tb);
      } // Arrow up.
      else if (keycode === FroalaEditor.KEYCODE.ARROW_UP && !ctrlKey && !e.shiftKey && !e.altKey) {
        status = moveUp();
      } // Arrow down.
      else if (keycode === FroalaEditor.KEYCODE.ARROW_DOWN && !ctrlKey && !e.shiftKey && !e.altKey) {
        status = moveDown();
      } // Enter.
      else if ((keycode === FroalaEditor.KEYCODE.ENTER || keycode === FroalaEditor.KEYCODE.SPACE) && !ctrlKey && !e.shiftKey && !e.altKey) {
        status = enter();
      } // Esc.
      else if (keycode === FroalaEditor.KEYCODE.ESC && !ctrlKey && !e.shiftKey && !e.altKey) {
        status = esc($tb);
      } // Alt + F10.
      else if (keycode === FroalaEditor.KEYCODE.F10 && !ctrlKey && !e.shiftKey && e.altKey) {
        status = focusToolbars();
      } // No focused element and no action done. Eg: popup is opened.


      if (!editor.shared.$f_el && typeof status === 'undefined') {
        status = true;
      } // Check if key event is a browser action. Eg: Ctrl + R.


      if (!status && editor.keys.isBrowserAction(e)) {
        status = true;
      } // Propagate to the next key listeners.


      if (status) {
        return true;
      }

      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    /*
     * Register a toolbar to keydown event.
     */


    function registerToolbar($tb) {
      if (!$tb || !$tb.length) {
        return;
      } // Hitting keydown on toolbar.


      editor.events.$on($tb, 'keydown', function (e) {
        // Allow only buttons.fr-command.
        if (!$(e.target).is('a.fr-command, button.fr-command, .fr-group span.fr-command')) {
          return true;
        } // Get the current editor instance for the popup.


        var inst = $tb.parents('.fr-popup').data('instance') || $tb.data('instance') || editor; // Keyboard used.

        editor.shared.with_kb = true; // https://github.com/froala-labs/froala-editor-js-2/issues/2577
        // set selection again for safari as it get lost on alt + f10

        if (editor.browser.safari && editor.shared.safariSelection) {
          var _editor$shared$safari = editor.shared.safariSelection,
              startContainer = _editor$shared$safari.startContainer,
              endContainer = _editor$shared$safari.endContainer,
              startOffset = _editor$shared$safari.startOffset,
              endOffset = _editor$shared$safari.endOffset;
          var tmprange = editor.doc.createRange();
          tmprange.setStart(startContainer, startOffset);
          tmprange.setEnd(endContainer, endOffset);
          editor.selection.get().addRange(tmprange);
        }

        var status = inst.accessibility.exec(e, $tb);
        editor.shared.with_kb = false;
        return status;
      }, true); // Unfocus the toolbar on mouseenter.

      editor.events.$on($tb, 'mouseenter', '[tabIndex]', function (e) {
        var inst = $tb.parents('.fr-popup').data('instance') || $tb.data('instance') || editor; // FireFox issue.

        if (!can_blur) {
          // Popup showed over the cursor.
          e.stopPropagation();
          e.preventDefault();
          return;
        }

        var $hovered_el = $(e.currentTarget);

        if (inst.shared.$f_el && inst.shared.$f_el.not($hovered_el)) {
          inst.accessibility.focusEditor();
        }
      }, true); // Update the focused shared variable after every transition

      if (editor.$tb) {
        editor.events.$on(editor.$tb, 'transitionend', '.fr-more-toolbar', function () {
          editor.shared.$f_el = $(document.activeElement);
        });
      }
    }
    /*
     * Register a popup to a keydown event.
     */


    function registerPopup(id) {
      var $popup = editor.popups.get(id);

      var ev = _getPopupEvents(id); // Register popup toolbar.


      registerToolbar($popup.find('.fr-buttons')); // Clear popup button on mouseenter.

      editor.events.$on($popup, 'mouseenter', 'tabIndex', ev._tiMouseenter, true); // Keydown handler on every element that has tabIndex.

      editor.events.$on($popup.children().not('.fr-buttons'), 'keydown', '[tabIndex]', ev._tiKeydown, true); // Restore selection on popups hide for the current active popup.

      editor.popups.onHide(id, function () {
        var inst = $popup.data('instance') || editor;
        inst.accessibility.restoreSelection();
      }); // FireFox issue: Prevent immediate popup bluring. Popup could show up over the cursor.

      editor.popups.onShow(id, function () {
        can_blur = false;
        setTimeout(function () {
          can_blur = true;
        }, 0);
      });
    }
    /*
     * Get popup events.
     */


    function _getPopupEvents(id) {
      var $popup = editor.popups.get(id);
      return {
        /**
         * Keydown on an input.
         */
        _tiKeydown: function _tiKeydown(e) {
          var inst = $popup.data('instance') || editor; // See if plugins listeners are active.

          if (inst.events.trigger('popup.tab', [e]) === false) {
            return false;
          }

          var key_code = e.which;
          var $focused_item = $popup.find(':focus').first(); // Tabbing.

          if (FroalaEditor.KEYCODE.TAB === key_code) {
            e.preventDefault(); // Focus next/previous input.

            var $popup_content = $popup.children().not('.fr-buttons');
            var inputs = $popup_content.findVisible('input, textarea, button, select').not('.fr-no-touch input, .fr-no-touch textarea, .fr-no-touch button, .fr-no-touch select, :disabled').toArray();
            var idx = inputs.indexOf(this) + (e.shiftKey ? -1 : 1);

            if (idx >= 0 && idx < inputs.length) {
              inst.events.disableBlur();
              $(inputs[idx]).focus();
              e.stopPropagation();
              return false;
            } // Focus toolbar.


            var $tb = $popup.find('.fr-buttons');

            if ($tb.length && focusToolbar($tb, Boolean(e.shiftKey))) {
              e.stopPropagation();
              return false;
            } // Focus content.


            if (focusContent($popup_content)) {
              e.stopPropagation();
              return false;
            }
          } // ENTER.
          else if (FroalaEditor.KEYCODE.ENTER === key_code && e.target && e.target.tagName !== 'TEXTAREA') {
            var $active_button = null;

            if ($popup.findVisible('.fr-submit').length > 0) {
              $active_button = $popup.findVisible('.fr-submit').first();
            } else if ($popup.findVisible('.fr-dismiss').length) {
              $active_button = $popup.findVisible('.fr-dismiss').first();
            }

            if ($active_button) {
              e.preventDefault();
              e.stopPropagation();
              inst.events.disableBlur();
              inst.button.exec($active_button);
            }
          } // ESC.
          else if (FroalaEditor.KEYCODE.ESC === key_code) {
            e.preventDefault();
            e.stopPropagation(); // Restore selection.

            inst.accessibility.restoreSelection();

            if (inst.popups.isVisible(id) && $popup.findVisible('.fr-back').length) {
              if (inst.opts.toolbarInline) {
                // Toolbar inline needs focus in order to show up.
                inst.events.disableBlur();
                inst.events.focus();
              }

              inst.button.exec($popup.findVisible('.fr-back').first()); // Focus back popup button.

              focusPopupButton($popup);
            } else if (inst.popups.isVisible(id) && $popup.findVisible('.fr-dismiss').length) {
              inst.button.exec($popup.findVisible('.fr-dismiss').first());
            } else {
              inst.popups.hide(id);

              if (inst.opts.toolbarInline) {
                inst.toolbar.showInline(null, true);
              } // Focus back popup button.


              focusPopupButton($popup);
            }

            return false;
          } // Allow space.
          else if (FroalaEditor.KEYCODE.SPACE === key_code && ($focused_item.is('.fr-submit') || $focused_item.is('.fr-dismiss'))) {
            e.preventDefault();
            e.stopPropagation();
            inst.events.disableBlur();
            inst.button.exec($focused_item);
            return true;
          } // Other KEY. Stop propagation to the window.
          else {
            // Check if key event is a browser action. Eg: Ctrl + R.
            if (inst.keys.isBrowserAction(e)) {
              e.stopPropagation();
              return;
            }

            if ($focused_item.is('input[type=text], textarea')) {
              e.stopPropagation();
              return;
            }

            if (FroalaEditor.KEYCODE.SPACE === key_code && ($focused_item.is('.fr-link-attr') || $focused_item.is('input[type=file]'))) {
              e.stopPropagation();
              return;
            }

            e.stopPropagation();
            e.preventDefault();
            return false;
          }
        },
        _tiMouseenter: function _tiMouseenter() {
          var inst = $popup.data('instance') || editor;

          _clearPopupButton(inst);
        }
      };
    }
    /*
     * Focus the button from which the popup was showed.
     */


    function focusPopupButton($popup) {
      var $popup_button = $popup.data('popup-button');

      if ($popup_button) {
        setTimeout(function () {
          focusToolbarElement($popup_button);
          $popup.data('popup-button', null);
        }, 0);
      }
    }
    /*
     * Focus the button from which the modal was showed.
     */


    function focusModalButton($modal) {
      var $modal_button = $modal.data('modal-button');

      if ($modal_button) {
        setTimeout(function () {
          focusToolbarElement($modal_button);
          $modal.data('modal-button', null);
        }, 0);
      }
    }

    function hasFocus() {
      return editor.shared.$f_el !== null;
    }

    function _clearPopupButton(inst) {
      var $visible_popup = editor.popups.areVisible(inst);

      if ($visible_popup) {
        $visible_popup.data('popup-button', null);
      }
    }

    function _editorKeydownHandler(e) {
      var ctrlKey = navigator.userAgent.indexOf('Mac OS X') !== -1 ? e.metaKey : e.ctrlKey;
      var keycode = e.which; // Alt + F10.

      if (keycode === FroalaEditor.KEYCODE.F10 && !ctrlKey && !e.shiftKey && e.altKey) {
        // Keyboard used.
        editor.shared.with_kb = true; // Focus active popup content inside the current editor if possible, else focus an available toolbar.

        var $visible_popup = editor.popups.areVisible(editor);
        var focused_content = false;

        if ($visible_popup) {
          focused_content = focusContent($visible_popup.children().not('.fr-buttons'));
        }

        if (!focused_content) {
          focusToolbars();
        }

        editor.shared.with_kb = false;
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      return true;
    }
    /**
     * Initialize.
     */


    function _init() {
      // Key down on the editing area.
      if (editor.$wp) {
        editor.events.on('keydown', _editorKeydownHandler, true);
      } else {
        editor.events.$on(editor.$win, 'keydown', _editorKeydownHandler, true);
      } // Mousedown on the editing area.


      editor.events.on('mousedown', function (e) {
        _clearPopupButton(editor);

        if (editor.shared.$f_el && editor.el.isSameNode(editor.shared.$f_el[0])) {
          editor.accessibility.restoreSelection();
          e.stopPropagation();
          editor.events.disableBlur();
          editor.shared.$f_el = null;
        }
      }, true); // Blur on the editing area.

      editor.events.on('blur', function () {
        editor.shared.$f_el = null;

        _clearPopupButton(editor);
      }, true);
    }

    return {
      _init: _init,
      registerPopup: registerPopup,
      registerToolbar: registerToolbar,
      focusToolbarElement: focusToolbarElement,
      focusToolbar: focusToolbar,
      focusContent: focusContent,
      focusPopup: focusPopup,
      focusModal: focusModal,
      focusEditor: focusEditor,
      focusPopupButton: focusPopupButton,
      focusModalButton: focusModalButton,
      hasFocus: hasFocus,
      exec: exec,
      saveSelection: saveSelection,
      restoreSelection: restoreSelection
    };
  };

  Object.assign(FroalaEditor.DEFAULTS, {
    tooltips: true
  });

  FroalaEditor.MODULES.tooltip = function (editor) {
    var $ = editor.$;

    function hide() {
      if (editor.helpers.isMobile()) {
        return;
      } // Position fixed for: https://github.com/froala/wysiwyg-editor/issues/1247.


      if (editor.$tooltip) {
        editor.$tooltip.removeClass('fr-visible').css('left', '-3000px').css('position', 'fixed');
      }
    }

    function to($el, above) {
      if (editor.helpers.isMobile()) {
        return;
      }

      var id = $el.attr('id') && $el.attr('id').split('-')[0],
          title = $el.attr('title');
      var isTrackChangesEnabledForActiveInstance = editor.opts.trackChangesEnabled;
      var isShowChangesEnabledForActiveInstance = editor.opts.showChangesEnabled; // https://github.com/froala-labs/froala-editor-js-2/issues/3980
      // check in editor instance if it is active then get its trackChangesEnabled and showChangesEnabled values
      // otherwise if the editor is not active then get the current button active state to show as tooltip

      if (editor.opts.toolbarContainer) {
        var editorHasFocus = false;

        for (var i = 0; i < FroalaEditor.INSTANCES.length; i++) {
          if (FroalaEditor.INSTANCES[i].core.hasFocus()) {
            isTrackChangesEnabledForActiveInstance = FroalaEditor.INSTANCES[i].opts.trackChangesEnabled;
            isShowChangesEnabledForActiveInstance = FroalaEditor.INSTANCES[i].opts.showChangesEnabled;
            editorHasFocus = true;
            break;
          }
        }

        if (!editorHasFocus) {
          isShowChangesEnabledForActiveInstance = isTrackChangesEnabledForActiveInstance = $el.hasClass('fr-active');
        }
      } // For track changes button


      if (id === 'trackChanges') {
        title = isTrackChangesEnabledForActiveInstance ? 'Disable Track Changes' : 'Enable Track Changes';
      } // For show changes button
      else if (id === 'showChanges') {
        title = isShowChangesEnabledForActiveInstance ? 'Hide Changes' : 'Show Changes';
      } // No tooltip will be there if accept and reject changes buttons are enabled
      else if ((id === 'applyAll' || id === 'removeAll' || id === 'applyLast' || id === 'removeLast') && editor.track_changes.getPendingChanges().length === 0) {
        return;
      }

      $el.data('title', title);

      if (!$el.data('title')) {
        return;
      }

      if (!editor.$tooltip) {
        _init();
      }

      $el.removeAttr('title');
      editor.$tooltip.text(editor.language.translate($el.data('title')));
      editor.$tooltip.addClass('fr-visible');
      var left = $el.offset().left + ($el.outerWidth() - editor.$tooltip.outerWidth()) / 2; // Normalize screen position.

      if (left < 0) {
        left = 0;
      }

      if (left + editor.$tooltip.outerWidth() > $(editor.o_win).width()) {
        left = $(editor.o_win).width() - editor.$tooltip.outerWidth();
      }

      if (typeof above === 'undefined') {
        above = editor.opts.toolbarBottom;
      }

      if ($el.offset().top - $(window).scrollTop() + $el.outerHeight() + 10 >= $(window).height()) {
        above = true;
      }

      var top = !above ? $el.offset().top + $el.outerHeight() : $el.offset().top - editor.$tooltip.height();
      editor.$tooltip.css('position', '');
      editor.$tooltip.css('left', left);
      editor.$tooltip.css('top', Math.ceil(top));

      if ($(editor.o_doc).find('body').first().css('position') !== 'static') {
        editor.$tooltip.css('margin-left', -$(editor.o_doc).find('body').first().offset().left);
        editor.$tooltip.css('margin-top', -$(editor.o_doc).find('body').first().offset().top);
      } else {
        editor.$tooltip.css('margin-left', '');
        editor.$tooltip.css('margin-top', '');
      }
    }

    function bind($el, selector, above) {
      if (editor.opts.tooltips && !editor.helpers.isMobile()) {
        editor.events.$on($el, 'mouseover', selector, function (e) {
          if (!editor.node.hasClass(e.currentTarget, 'fr-disabled') && !editor.edit.isDisabled()) {
            to($(e.currentTarget), above);
          }
        }, true);
        editor.events.$on($el, "mouseout ".concat(editor._mousedown, " ").concat(editor._mouseup), selector, function () {
          hide();
        }, true);
      }
    }

    function _init() {
      if (editor.opts.tooltips && !editor.helpers.isMobile()) {
        if (!editor.shared.$tooltip) {
          editor.shared.$tooltip = $(editor.doc.createElement('DIV')).addClass('fr-tooltip');
          editor.$tooltip = editor.shared.$tooltip;

          if (editor.opts.theme) {
            editor.$tooltip.addClass("".concat(editor.opts.theme, "-theme"));
          }

          $(editor.o_doc).find('body').first().append(editor.$tooltip);
        } else {
          editor.$tooltip = editor.shared.$tooltip;
        }

        editor.events.on('shared.destroy', function () {
          editor.$tooltip.html('').removeData().remove();
          editor.$tooltip = null;
        }, true);
      }
    }

    return {
      hide: hide,
      to: to,
      bind: bind
    };
  };

  FroalaEditor.TOOLBAR_VISIBLE_BUTTONS = 3;

  FroalaEditor.MODULES.button = function (editor) {
    var $ = editor.$;
    var buttons = [];

    if (editor.opts.toolbarInline || editor.opts.toolbarContainer) {
      if (!editor.shared.buttons) {
        editor.shared.buttons = [];
      }

      buttons = editor.shared.buttons;
    }

    var popup_buttons = [];

    if (!editor.shared.popup_buttons) {
      editor.shared.popup_buttons = [];
    }

    popup_buttons = editor.shared.popup_buttons;
    /**
     * Add a new button to the buttons list
     */

    function addButtons($btns) {
      for (var i = 0; i < $btns.length; i++) {
        buttons.push($btns[i]);
      }
    }
    /*
     * Filter buttons based on a specified selector.
     */


    function _filterButtons(butons_list, selector, search_dropdowns) {
      var $filtered_buttons = $();

      for (var i = 0; i < butons_list.length; i++) {
        var $button = $(butons_list[i]);

        if ($button.is(selector)) {
          $filtered_buttons = $filtered_buttons.add($button);
        } // Search for dropdowns menuitems


        if (search_dropdowns && $button.is('.fr-dropdown')) {
          var $dropdown_menu_items = $button.next().find(selector);
          $filtered_buttons = $filtered_buttons.add($dropdown_menu_items);
        }
      }

      return $filtered_buttons;
    }
    /*
     * Get all buttons from page based on a specified selector.
     */


    function getButtons(selector, search_dropdowns) {
      var $buttons = $();
      var id;

      if (!selector) {
        return $buttons;
      } // Search all toolbar buttons.


      $buttons = $buttons.add(_filterButtons(buttons, selector, search_dropdowns)); // Search all popups buttons.

      $buttons = $buttons.add(_filterButtons(popup_buttons, selector, search_dropdowns)); // Look in popup's content.

      for (id in editor.shared.popups) {
        if (Object.prototype.hasOwnProperty.call(editor.shared.popups, id)) {
          var $popup = editor.shared.popups[id];
          var $popup_buttons = $popup.children().find(selector);
          $buttons = $buttons.add($popup_buttons);
        }
      } // Look in modal's content.


      for (id in editor.shared.modals) {
        if (Object.prototype.hasOwnProperty.call(editor.shared.modals, id)) {
          var $modal_hash = editor.shared.modals[id];
          var $modal_buttons = $modal_hash.$modal.find(selector);
          $buttons = $buttons.add($modal_buttons);
        }
      }

      return $buttons;
    }
    /*
    To get popup position with respect to element
    */


    function getPosition($elm) {
      var left = $elm.offset().left;
      var toolbarBottomOffset = 10;
      var topOffset = editor.opts.toolbarBottom ? toolbarBottomOffset : $elm.outerHeight() - toolbarBottomOffset;
      var top = $elm.offset().top + topOffset;
      return {
        left: left,
        top: top
      };
    }
    /**
     * Expands the dropdown
     */


    function _expandDropdown($dropdownWrapper, height, maxHeight) {
      // Show scroll only when height of the dropdown is more than max height
      if (height >= maxHeight) {
        $dropdownWrapper.parent().css('overflow', 'auto');
        $dropdownWrapper.parent().css('overflow-x', 'hidden');
      } // Height of the dropdown is minimum of its content height and dropdown max height


      $dropdownWrapper.css('height', Math.min(height, maxHeight));
    }
    /**
     * Click was made on a dropdown button.
     */


    function _dropdownButtonClick($btn) {
      var $dropdown = $btn.next();
      var active = editor.node.hasClass($btn.get(0), 'fr-active');
      var $active_dropdowns = getButtons('.fr-dropdown.fr-active').not($btn);
      var inst = $btn.parents('.fr-toolbar, .fr-popup').data('instance') || editor; // Hide keyboard. We need the entire space.

      if (inst.helpers.isIOS() && !inst.el.querySelector('.fr-marker')) {
        inst.selection.save();
        inst.selection.clear();
        inst.selection.restore();
      }

      $dropdown.parents('.fr-more-toolbar').addClass('fr-overflow-visible');
      var ht = 0;
      var dropdownMaxHeight = 0;
      var $dropdownWrapper = $dropdown.find('> .fr-dropdown-wrapper'); // Dropdown is not active.

      if (!active) {
        // Call refresh on show.
        var cmd = $btn.data('cmd');
        $dropdown.find('.fr-command').removeClass('fr-active').attr('aria-selected', false);

        if (FroalaEditor.COMMANDS[cmd] && FroalaEditor.COMMANDS[cmd].refreshOnShow) {
          FroalaEditor.COMMANDS[cmd].refreshOnShow.apply(inst, [$btn, $dropdown]);
        }

        $dropdown.css('left', $btn.offset().left - $btn.parents('.fr-btn-wrap, .fr-toolbar, .fr-buttons').offset().left - (editor.opts.direction === 'rtl' ? $dropdown.width() - $btn.outerWidth() : 0)); // Test height.

        $dropdown.addClass('test-height');
        ht = $dropdown.outerHeight();
        dropdownMaxHeight = editor.helpers.getPX($dropdownWrapper.css('max-height'));
        $dropdown.removeClass('test-height'); // Reset top and bottom.

        $dropdown.css('top', '').css('bottom', ''); // Just to overlap the button with the dropdown by a bit

        var dropdownOffsetTop = $btn.outerHeight() / 10; // Toolbar top or dropdown is exceeding the window.

        if (!editor.opts.toolbarBottom && $dropdown.offset().top + $btn.outerHeight() + ht < $(editor.o_doc).height()) {
          $dropdown.css('top', $btn.position().top + $btn.outerHeight() - dropdownOffsetTop);
        } else {
          var moreToolbarHeight = 0;
          var $moreToolbar = $btn.parents('.fr-more-toolbar');

          if ($moreToolbar.length > 0) {
            moreToolbarHeight = $moreToolbar.first().height();
          }

          $dropdown.css('bottom', $btn.parents('.fr-popup, .fr-toolbar').first().height() - moreToolbarHeight - $btn.position().top);
        }
      } // Blink and activate.


      $btn.addClass('fr-blink').toggleClass('fr-active');

      if ($btn.hasClass('fr-options')) {
        var $prevBtn = $btn.prev();
        $prevBtn.toggleClass('fr-expanded');
      }

      if ($btn.hasClass('fr-active')) {
        $dropdown.attr('aria-hidden', false);
        $btn.attr('aria-expanded', true); // Expand the dropdown

        _expandDropdown($dropdownWrapper, ht, dropdownMaxHeight);
      } else {
        $dropdown.attr('aria-hidden', true).css('overflow', '');
        $btn.attr('aria-expanded', false); // Close active dropdowns

        $dropdownWrapper.css('height', '');
      }

      setTimeout(function () {
        $btn.removeClass('fr-blink');
      }, 300); // Reset left margin for dropdown.

      $dropdown.css('margin-left', ''); // Check if it exceeds window on the right.

      if ($dropdown.offset().left + $dropdown.outerWidth() > editor.$sc.offset().left + editor.$sc.width()) {
        $dropdown.css('margin-left', -($dropdown.offset().left + $dropdown.outerWidth() - editor.$sc.offset().left - editor.$sc.width()));
      } // Check if it exceeds window on the left.


      if ($dropdown.offset().left < editor.$sc.offset().left && editor.opts.direction === 'rtl') {
        $dropdown.css('margin-left', editor.$sc.offset().left);
      } // Hide dropdowns that might be active.
      // Close active dropdowns


      $active_dropdowns.removeClass('fr-active').attr('aria-expanded', false).next().attr('aria-hidden', true).css('overflow', '').find('> .fr-dropdown-wrapper').css('height', '');
      $active_dropdowns.prev('.fr-expanded').removeClass('fr-expanded');
      $active_dropdowns.parents('.fr-toolbar:not(.fr-inline)').css('zIndex', '');

      if ($btn.parents('.fr-popup').length === 0 && !editor.opts.toolbarInline) {
        if (editor.node.hasClass($btn.get(0), 'fr-active')) {
          editor.$tb.css('zIndex', (editor.opts.zIndex || 1) + 4);
        } else {
          editor.$tb.css('zIndex', '');
        }
      } // Focus the active element or the dropdown button to enable accessibility.


      var $active_element = $dropdown.find('a.fr-command.fr-active').first(); // We do not need to focus on mobile.

      if (!editor.helpers.isMobile()) {
        if ($active_element.length) {
          editor.accessibility.focusToolbarElement($active_element); // Scroll the selected element to the middle

          $dropdownWrapper.scrollTop(Math.abs($active_element.parents('.fr-dropdown-content').offset().top - $active_element.offset().top) - $active_element.offset().top);
        } else {
          editor.accessibility.focusToolbarElement($btn);
          $dropdownWrapper.scrollTop(0);
        }
      }
    }

    function exec($btn) {
      // Blink.
      $btn.addClass('fr-blink');
      setTimeout(function () {
        $btn.removeClass('fr-blink');
      }, 500); // Get command, value and additional params.

      var cmd = $btn.data('cmd');
      var params = [];

      while (typeof $btn.data("param".concat(params.length + 1)) !== 'undefined') {
        params.push($btn.data("param".concat(params.length + 1)));
      } // Hide dropdowns that might be active including the current one.


      var $active_dropdowns = getButtons('.fr-dropdown.fr-active');

      if ($active_dropdowns.length) {
        $active_dropdowns.removeClass('fr-active').attr('aria-expanded', false).next().attr('aria-hidden', true).css('overflow', '').find('> .fr-dropdown-wrapper').css('height', '');
        $active_dropdowns.prev('.fr-expanded').removeClass('fr-expanded');
        $active_dropdowns.parents('.fr-toolbar:not(.fr-inline)').css('zIndex', '');
      } // Call the command.


      $btn.parents('.fr-popup, .fr-toolbar').data('instance').commands.exec(cmd, params);
    }
    /**
     * Click was made on a command button.
     */


    function _commandButtonClick($btn) {
      exec($btn);
    }

    function click($btn) {
      // Get current editor instance
      var inst = $btn.parents('.fr-popup, .fr-toolbar').data('instance'); // Active popup button only if it is not active

      if ($btn.parents('.fr-popup').length === 0 && $btn.data('popup') && !$btn.hasClass('fr-btn-active-popup')) {
        $btn.addClass('fr-btn-active-popup');
      }

      if ($btn.parents('.fr-popup').length === 0 && !$btn.data('popup')) {
        inst.popups.hideAll();
      } // Popups are visible, but not in the current instance.


      if (inst.popups.areVisible() && !inst.popups.areVisible(inst)) {
        // Hide markers in other instances.
        for (var i = 0; i < FroalaEditor.INSTANCES.length; i++) {
          if (FroalaEditor.INSTANCES[i] !== inst && FroalaEditor.INSTANCES[i].popups && FroalaEditor.INSTANCES[i].popups.areVisible()) {
            FroalaEditor.INSTANCES[i].$el.find('.fr-marker').remove();
          }
        }

        inst.popups.hideAll();
      } // Dropdown button.


      if (editor.node.hasClass($btn.get(0), 'fr-dropdown')) {
        _dropdownButtonClick($btn);
      } // Regular button.
      else {
        _commandButtonClick($btn);

        if (FroalaEditor.COMMANDS[$btn.data('cmd')] && FroalaEditor.COMMANDS[$btn.data('cmd')].refreshAfterCallback !== false) {
          inst.button.bulkRefresh();
        }
      }
    }

    function _click(e) {
      var $btn = $(e.currentTarget);
      click($btn);
    }

    function hideActiveDropdowns($el) {
      var $active_dropdowns = $el.find('.fr-dropdown.fr-active');

      if ($active_dropdowns.length) {
        $active_dropdowns.removeClass('fr-active').attr('aria-expanded', false).next().attr('aria-hidden', true).css('overflow', '').find('> .fr-dropdown-wrapper').css('height', '');
        $active_dropdowns.parents('.fr-toolbar:not(.fr-inline)').css('zIndex', '');
        $active_dropdowns.prev().removeClass('fr-expanded');
      }
    }

    function hideActivePopup($el) {
      var $active_popup = $el.find('.fr-popup.fr-active');

      if ($active_popup.length) {
        $active_popup.removeClass('fr-active').attr('aria-expanded', false).next().attr('aria-hidden', true).css('overflow', '').find('> .fr-dropdown-wrapper').css('height', '');
        $active_popup.parents('.fr-toolbar:not(.fr-inline)').css('zIndex', '');
        $active_popup.prev().removeClass('fr-expanded');
        var $btnActivePopups = editor.$tb.find('.fr-btn-active-popup');
        $($btnActivePopups[0]).removeClass('fr-btn-active-popup');
      }
    }
    /**
     * Click in the dropdown menu.
     */


    function _dropdownMenuClick(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    /**
     * Click on the dropdown wrapper.
     */


    function _dropdownWrapperClick(e) {
      e.stopPropagation(); // Prevent blurring.

      if (!editor.helpers.isMobile()) {
        return false;
      }
    }
    /**
     * Bind callbacks for commands.
     */


    function bindCommands($el, tooltipAbove) {
      editor.events.bindClick($el, '.fr-command:not(.fr-disabled)', _click); // Click on the dropdown menu.

      editor.events.$on($el, "".concat(editor._mousedown, " ").concat(editor._mouseup, " ").concat(editor._move), '.fr-dropdown-menu', _dropdownMenuClick, true); // Click on the dropdown wrapper.

      editor.events.$on($el, "".concat(editor._mousedown, " ").concat(editor._mouseup, " ").concat(editor._move), '.fr-dropdown-menu .fr-dropdown-wrapper', _dropdownWrapperClick, true); // Hide dropdowns that might be active.

      var _document = $el.get(0).ownerDocument;

      var _window = 'defaultView' in _document ? _document.defaultView : _document.parentWindow;

      function hideDropdowns(e) {
        if (!e || e.type === editor._mouseup && e.target !== $('html').get(0) || e.type === 'keydown' && (editor.keys.isCharacter(e.which) && !editor.keys.ctrlKey(e) || e.which === FroalaEditor.KEYCODE.ESC)) {
          hideActiveDropdowns($el); // https://github.com/froala-labs/froala-editor-js-2/issues/3059

          if (editor.opts.iframe) {
            hideActivePopup($el);
          }
        }
      }

      editor.events.$on($(_window), "".concat(editor._mouseup, " resize keydown"), hideDropdowns, true);

      if (editor.opts.iframe) {
        editor.events.$on(editor.$win, editor._mouseup, hideDropdowns, true);
      } // Add refresh.


      if (editor.node.hasClass($el.get(0), 'fr-popup')) {
        $.merge(popup_buttons, $el.find('.fr-btn').toArray());
      } else {
        $.merge(buttons, $el.find('.fr-btn').toArray());
      } // Assing tooltips to buttons.


      editor.tooltip.bind($el, '.fr-btn, .fr-title', tooltipAbove);
    }
    /**
     * Create the content for dropdown.
     */


    function _content(command, info) {
      var c = '';

      if (info.html) {
        if (typeof info.html === 'function') {
          c += info.html.call(editor);
        } else {
          c += info.html;
        }
      } else {
        var options = info.options;

        if (typeof options === 'function') {
          options = options();
        }

        c += '<ul class="fr-dropdown-list" role="presentation">';

        for (var val in options) {
          if (Object.prototype.hasOwnProperty.call(options, val)) {
            var shortcut = editor.shortcuts.get("".concat(command, ".").concat(val));

            if (shortcut) {
              shortcut = "<span class=\"fr-shortcut\">".concat(shortcut, "</span>");
            } else {
              shortcut = '';
            }

            c += "<li role=\"presentation\"><a class=\"fr-command\" tabIndex=\"-1\" role=\"option\" data-cmd=\"".concat(info.type === 'options' ? command.replace(/Options/g, '') : command, "\" data-param1=\"").concat(val, "\" title=\"").concat(options[val], "\">").concat(editor.language.translate(options[val]), "</a></li>");
          }
        }

        c += '</ul>';
      }

      return c;
    }
    /**
     * Create button.
     */


    function build(command) {
      var info = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var visible = arguments.length > 2 ? arguments[2] : undefined;

      if (editor.helpers.isMobile() && info.showOnMobile === false) {
        return '';
      }

      var display_selection = info.displaySelection;

      if (typeof display_selection === 'function') {
        display_selection = display_selection(editor);
      }

      var icon = '';

      if (info.type !== 'options') {
        if (display_selection) {
          var default_selection = typeof info.defaultSelection === 'function' ? info.defaultSelection(editor) : info.defaultSelection;
          icon = "<span style=\"width:".concat(info.displaySelectionWidth || 100, "px\">").concat(editor.language.translate(default_selection || info.title), "</span>");
        } else {
          icon = editor.icon.create(info.icon || command); // Used instead of aria-label. The advantage is that it also display text when the css is disabled.

          icon += "<span class=\"fr-sr-only\">".concat(editor.language.translate(info.title) || '', "</span>");
        }
      }

      var popup = info.popup ? ' data-popup="true"' : '';
      var modal = info.modal ? ' data-modal="true"' : '';
      var shortcut = editor.shortcuts.get("".concat(command, "."));

      if (shortcut) {
        shortcut = " (".concat(shortcut, ")");
      } else {
        shortcut = '';
      } // Add custom id if present


      var button_id = "".concat(command, "-").concat(editor.id);
      var dropdown_id = "dropdown-menu-".concat(button_id);
      var btn = "<button id=\"".concat(button_id, "\"").concat(info.more_btn ? " data-group-name=\"".concat(button_id, "\" ") : '', "type=\"button\" tabIndex=\"-1\" role=\"button\"").concat(info.toggle ? ' aria-pressed="false"' : '').concat(info.type === 'dropdown' || info.type === 'options' ? " aria-controls=\"".concat(dropdown_id, "\" aria-expanded=\"false\" aria-haspopup=\"true\"") : '').concat(info.disabled ? ' aria-disabled="true"' : '', " title=\"").concat(editor.language.translate(info.title) || '').concat(shortcut, "\" class=\"fr-command fr-btn").concat(info.type === 'dropdown' || info.type == 'options' ? ' fr-dropdown' : '').concat(info.type == 'options' ? ' fr-options' : '').concat(info.type == 'more' ? ' fr-more' : '').concat(info.displaySelection ? ' fr-selection' : '').concat(info.back ? ' fr-back' : '').concat(info.disabled ? ' fr-disabled' : '').concat(!visible ? ' fr-hidden' : '', "\" data-cmd=\"").concat(command, "\"").concat(popup).concat(modal, ">").concat(icon, "</button>");

      if (info.type === 'dropdown' || info.type === 'options') {
        // Build dropdown.
        var dropdown = "<div id=\"".concat(dropdown_id, "\" class=\"fr-dropdown-menu\" role=\"listbox\" aria-labelledby=\"").concat(button_id, "\" aria-hidden=\"true\"><div class=\"fr-dropdown-wrapper\" role=\"presentation\"><div class=\"fr-dropdown-content\" role=\"presentation\">");
        dropdown += _content(command, info);
        dropdown += '</div></div></div>';
        btn += dropdown;
      }

      if (info.hasOptions && info.hasOptions.apply(editor)) {
        btn = "<div class=\"fr-btn-wrap\">".concat(btn, " ").concat(build(command + 'Options', Object.assign({}, info, {
          type: 'options',
          hasOptions: false
        }), visible), "  </div>");
      }

      return btn;
    }

    function buildList(buttons, visible_buttons) {
      var str = '';

      for (var i = 0; i < buttons.length; i++) {
        var cmd_name = buttons[i];
        var cmd_info = FroalaEditor.COMMANDS[cmd_name];

        if (cmd_info && typeof cmd_info.plugin !== 'undefined' && editor.opts.pluginsEnabled.indexOf(cmd_info.plugin) < 0) {
          continue;
        }

        if (cmd_info) {
          var visible = typeof visible_buttons !== 'undefined' ? visible_buttons.indexOf(cmd_name) >= 0 : true;
          str += build(cmd_name, cmd_info, visible);
        } else if (cmd_name === '|') {
          str += '<div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>';
        } else if (cmd_name === '-') {
          str += '<div class="fr-separator fr-hs" role="separator" aria-orientation="horizontal"></div>';
        }
      }

      return str;
    }
    /**
     * Build button groups html
     */


    function buildGroup(buttonGroups) {
      // Toolbar Groups HTML
      var mainToolbarGroupsHTML = '';
      var moreToolbarGroupsHTML = '';

      for (var groupName in buttonGroups) {
        var buttonGroup = buttonGroups[groupName]; // Ignore non-button groups

        if (!buttonGroup.buttons) {
          continue;
        } // Current button group Details


        var mainToolbarButtonsHTML = '';
        var moreToolbarButtonsHTML = '';
        var buttonCount = 0;
        var alignment = 'left';
        var visibleButtons = FroalaEditor.TOOLBAR_VISIBLE_BUTTONS;

        for (var i = 0; i < buttonGroup.buttons.length; i++) {
          // Get command name
          var cmdName = buttonGroup.buttons[i]; // Get command details

          var cmdInfo = FroalaEditor.COMMANDS[cmdName];

          if (!cmdInfo) {
            if (cmdName == '|') {
              mainToolbarButtonsHTML += '<div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>';
            } else if (cmdName == '-') {
              mainToolbarButtonsHTML += '<div class="fr-separator fr-hs" role="separator" aria-orientation="horizontal"></div>';
            }
          }

          if (!cmdInfo || cmdInfo && typeof cmdInfo.plugin !== 'undefined' && editor.opts.pluginsEnabled.indexOf(cmdInfo.plugin) < 0) {
            continue;
          } // If alignment of group is provided then use it


          if (buttonGroups[groupName].align !== undefined) {
            alignment = buttonGroups[groupName].align;
          } // If buttonsVisible is provided then use it


          if (buttonGroups[groupName].buttonsVisible !== undefined) {
            visibleButtons = buttonGroups[groupName].buttonsVisible;
          } // Build button groups from command details


          if (buttonGroups.showMoreButtons && buttonCount >= visibleButtons) {
            moreToolbarButtonsHTML += build(cmdName, cmdInfo, true);
          } else {
            mainToolbarButtonsHTML += build(cmdName, cmdInfo, true);
          }

          buttonCount++;
        } // If atleast one hidden group exists then add its corresponding more button


        if (buttonGroups.showMoreButtons && buttonCount > visibleButtons) {
          var _cmdName = groupName;
          var _cmdInfo = FroalaEditor.COMMANDS[_cmdName];
          _cmdInfo.more_btn = true;
          mainToolbarButtonsHTML += build(_cmdName, _cmdInfo, true);
        } // Add toolbar buttons html to the groups html
        // For trackChanges group, no need to create a primary button as it is already present in moreRich section


        if (groupName !== 'trackChanges') {
          mainToolbarGroupsHTML += "<div class=\"fr-btn-grp fr-float-".concat(alignment, "\">").concat(mainToolbarButtonsHTML, "</div>");
        }

        if (buttonGroups.showMoreButtons && moreToolbarButtonsHTML.length > 0) {
          moreToolbarGroupsHTML += "<div class=\"fr-more-toolbar\" data-name=\"".concat(groupName + '-' + editor.id, "\">").concat(moreToolbarButtonsHTML, "</div>");
        }
      } // Return toolbar button groups html


      if (editor.opts.toolbarBottom) {
        if (editor.helpers.isMobile()) {
          return "<div class=\"fr-bottom-extended\">".concat(moreToolbarGroupsHTML, "</div><div>").concat(mainToolbarGroupsHTML, "</div>");
        }

        return "".concat(moreToolbarGroupsHTML, "<div class=\"fr-newline\"></div>").concat(mainToolbarGroupsHTML);
      }

      return "".concat(mainToolbarGroupsHTML, "<div class=\"fr-newline\"></div>").concat(moreToolbarGroupsHTML);
    }

    function refresh($btn) {
      var inst = $btn.parents('.fr-popup, .fr-toolbar').data('instance') || editor;
      var cmd = $btn.data('cmd');
      var $dropdown;

      if (!editor.node.hasClass($btn.get(0), 'fr-dropdown')) {
        $btn.removeClass('fr-active');

        if ($btn.attr('aria-pressed')) {
          $btn.attr('aria-pressed', false);
        }
      } else {
        $dropdown = $btn.next();
      }

      if (FroalaEditor.COMMANDS[cmd] && FroalaEditor.COMMANDS[cmd].refresh) {
        FroalaEditor.COMMANDS[cmd].refresh.apply(inst, [$btn, $dropdown]);
      } else if (editor.refresh[cmd]) {
        inst.refresh[cmd]($btn, $dropdown);
      }
    }

    function _bulkRefresh(btns) {
      var inst = editor.$tb ? editor.$tb.data('instance') || editor : editor; // Check the refresh event.

      if (editor.events.trigger('buttons.refresh') === false) {
        return true;
      }

      setTimeout(function () {
        var focused = inst.selection.inEditor() && inst.core.hasFocus();

        for (var i = 0; i < btns.length; i++) {
          var $btn = $(btns[i]);
          var cmd = $btn.data('cmd');

          if ($btn.parents('.fr-popup').length === 0) {
            if (focused || FroalaEditor.COMMANDS[cmd] && FroalaEditor.COMMANDS[cmd].forcedRefresh) {
              inst.button.refresh($btn);
            } else if (!editor.node.hasClass($btn.get(0), 'fr-dropdown')) {
              $btn.removeClass('fr-active');

              if ($btn.attr('aria-pressed')) {
                $btn.attr('aria-pressed', false);
              }
            }
          } else if ($btn.parents('.fr-popup').isVisible()) {
            inst.button.refresh($btn);
          }
        }
      }, 0);
    }
    /**
     * Do buttons refresh.
     */


    function bulkRefresh() {
      _bulkRefresh(buttons);

      _bulkRefresh(popup_buttons);
    }

    function _destroy() {
      buttons = [];
      popup_buttons = [];
    }

    var refresh_timeout = null;

    function delayedBulkRefresh() {
      clearTimeout(refresh_timeout);
      refresh_timeout = setTimeout(bulkRefresh, 50);
    }
    /**
     * Initialize.
     */


    function _init() {
      // Assign refresh and do refresh.
      if (editor.opts.toolbarInline) {
        editor.events.on('toolbar.show', bulkRefresh);
      } else {
        editor.events.on('mouseup', delayedBulkRefresh);
        editor.events.on('keyup', delayedBulkRefresh);
        editor.events.on('blur', delayedBulkRefresh);
        editor.events.on('focus', delayedBulkRefresh);
        editor.events.on('contentChanged', delayedBulkRefresh);

        if (editor.helpers.isMobile()) {
          editor.events.$on(editor.$doc, 'selectionchange', bulkRefresh);
        }
      }

      editor.events.on('shared.destroy', _destroy);
    }

    return {
      _init: _init,
      build: build,
      buildList: buildList,
      buildGroup: buildGroup,
      bindCommands: bindCommands,
      refresh: refresh,
      bulkRefresh: bulkRefresh,
      exec: exec,
      click: click,
      hideActiveDropdowns: hideActiveDropdowns,
      addButtons: addButtons,
      getButtons: getButtons,
      getPosition: getPosition
    };
  };

  FroalaEditor.ICON_TEMPLATES = {
    font_awesome: '<i class="fa fa-[NAME]" aria-hidden="true"></i>',
    font_awesome_5: '<i class="fas fa-[FA5NAME]" aria-hidden="true"></i>',
    font_awesome_5r: '<i class="far fa-[FA5NAME]" aria-hidden="true"></i>',
    font_awesome_5l: '<i class="fal fa-[FA5NAME]" aria-hidden="true"></i>',
    font_awesome_5b: '<i class="fab fa-[FA5NAME]" aria-hidden="true"></i>',
    text: '<span style="text-align: center;">[NAME]</span>',
    image: '<img src=[SRC] alt=[ALT] />',
    svg: '<svg class="fr-svg" focusable="false" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="[PATH]"/></svg>',
    empty: ' '
  };
  FroalaEditor.ICONS = {
    bold: {
      NAME: 'bold',
      SVG_KEY: 'bold'
    },
    italic: {
      NAME: 'italic',
      SVG_KEY: 'italic'
    },
    underline: {
      NAME: 'underline',
      SVG_KEY: 'underline'
    },
    strikeThrough: {
      NAME: 'strikethrough',
      SVG_KEY: 'strikeThrough'
    },
    subscript: {
      NAME: 'subscript',
      SVG_KEY: 'subscript'
    },
    superscript: {
      NAME: 'superscript',
      SVG_KEY: 'superscript'
    },
    cancel: {
      NAME: 'cancel',
      SVG_KEY: 'cancel'
    },
    color: {
      NAME: 'tint',
      SVG_KEY: 'textColor'
    },
    outdent: {
      NAME: 'outdent',
      SVG_KEY: 'outdent'
    },
    indent: {
      NAME: 'indent',
      SVG_KEY: 'indent'
    },
    undo: {
      NAME: 'rotate-left',
      FA5NAME: 'undo',
      SVG_KEY: 'undo'
    },
    redo: {
      NAME: 'rotate-right',
      FA5NAME: 'redo',
      SVG_KEY: 'redo'
    },
    insert: {
      NAME: 'insert',
      SVG_KEY: 'insert'
    },
    insertAll: {
      NAME: 'insertAll',
      SVG_KEY: 'insertAll'
    },
    insertHR: {
      NAME: 'minus',
      SVG_KEY: 'horizontalLine'
    },
    clearFormatting: {
      NAME: 'eraser',
      SVG_KEY: 'clearFormatting'
    },
    selectAll: {
      NAME: 'mouse-pointer',
      SVG_KEY: 'selectAll'
    },
    minimize: {
      NAME: 'minimize',
      SVG_KEY: 'minimize'
    },
    moreText: {
      NAME: 'ellipsis-v',
      SVG_KEY: 'textMore'
    },
    moreParagraph: {
      NAME: 'ellipsis-v',
      SVG_KEY: 'paragraphMore'
    },
    moreRich: {
      NAME: 'ellipsis-v',
      SVG_KEY: 'insertMore'
    },
    moreMisc: {
      NAME: 'ellipsis-v',
      SVG_KEY: 'more'
    }
  };

  FroalaEditor.DefineIconTemplate = function (name, options) {
    FroalaEditor.ICON_TEMPLATES[name] = options;
  };

  FroalaEditor.DefineIcon = function (name, options) {
    FroalaEditor.ICONS[name] = options;
  };

  Object.assign(FroalaEditor.DEFAULTS, {
    iconsTemplate: 'svg'
  });

  FroalaEditor.MODULES.icon = function (editor) {
    function create(command) {
      var icon = null;
      var info = FroalaEditor.ICONS[command];

      if (typeof info !== 'undefined') {
        var template = info.template || FroalaEditor.ICON_DEFAULT_TEMPLATE || editor.opts.iconsTemplate;

        if (template && template.apply) {
          template = template.apply(editor);
        }

        if (!info.FA5NAME) {
          info.FA5NAME = info.NAME;
        }

        if (template === 'svg' && !info.PATH) {
          // https://github.com/froala-labs/froala-editor-js-2/issues/1812
          // if user doesn't specify `SVG_KEY`, pass it as string
          info.PATH = FroalaEditor.SVG[info.SVG_KEY] || '';
        }

        if (template && (template = FroalaEditor.ICON_TEMPLATES[template])) {
          icon = template.replace(/\[([a-zA-Z0-9]*)\]/g, function (str, a1) {
            if (a1 === 'NAME') {
              return info[a1] || command;
            }

            return info[a1];
          });
        }
      }

      return icon || command;
    }

    function getTemplate(command) {
      var info = FroalaEditor.ICONS[command];
      var template = editor.opts.iconsTemplate;

      if (typeof info !== 'undefined') {
        template = info.template || FroalaEditor.ICON_DEFAULT_TEMPLATE || editor.opts.iconsTemplate;
        return template;
      }

      return template;
    }

    function getFileIcon(command) {
      var info = FroalaEditor.FILEICONS[command];

      if (typeof info !== 'undefined') {
        return info;
      }

      return command;
    }

    return {
      create: create,
      getTemplate: getTemplate,
      getFileIcon: getFileIcon
    };
  };

  FroalaEditor.SVG = {
    add: 'M19,13h-6v6h-2v-6H5v-2h6V5h2v6h6V13z',
    advancedImageEditor: 'M3,17v2h6v-2H3z M3,5v2h10V5H3z M13,21v-2h8v-2h-8v-2h-2v6H13z M7,9v2H3v2h4v2h2V9H7z M21,13v-2H11v2H21z M15,9h2V7h4V5h-4  V3h-2V9z',
    alignCenter: 'M9,18h6v-2H9V18z M6,11v2h12v-2H6z M3,6v2h18V6H3z',
    alignJustify: 'M3,18h18v-2H3V18z M3,11v2h18v-2H3z M3,6v2h18V6H3z',
    alignLeft: 'M3,18h6v-2H3V18z M3,11v2h12v-2H3z M3,6v2h18V6H3z',
    alignRight: 'M15,18h6v-2h-6V18z M9,11v2h12v-2H9z M3,6v2h18V6H3z',
    anchors: 'M16,4h-4H8C6.9,4,6,4.9,6,6v4v10l6-2.6l6,2.6V10V6C18,4.9,17.1,4,16,4z M16,17l-4-1.8L8,17v-7V6h4h4v4V17z',
    autoplay: 'M 7.570312 0.292969 C 7.542969 0.292969 7.515625 0.292969 7.488281 0.296875 C 7.203125 0.324219 6.984375 0.539062 6.980469 0.792969 L 6.925781 3.535156 C 2.796875 3.808594 -0.0078125 6.425781 -0.0859375 10.09375 C -0.121094 11.96875 0.710938 13.6875 2.265625 14.921875 C 3.769531 16.117188 5.839844 16.796875 8.097656 16.828125 C 8.140625 16.828125 12.835938 16.898438 13.035156 16.886719 C 15.171875 16.796875 17.136719 16.128906 18.558594 15.003906 C 20.066406 13.816406 20.882812 12.226562 20.917969 10.40625 C 20.960938 8.410156 20.023438 6.605469 18.289062 5.335938 C 18.214844 5.277344 18.128906 5.230469 18.035156 5.203125 C 17.636719 5.074219 17.222656 5.199219 17 5.476562 L 15.546875 7.308594 C 15.304688 7.609375 15.363281 8.007812 15.664062 8.265625 C 16.351562 8.851562 16.707031 9.625 16.6875 10.5 C 16.652344 12.25 15.070312 13.390625 12.757812 13.535156 C 12.59375 13.539062 8.527344 13.472656 8.164062 13.464844 C 5.703125 13.429688 4.101562 12.191406 4.140625 10.3125 C 4.175781 8.570312 5.132812 7.46875 6.847656 7.199219 L 6.796875 9.738281 C 6.792969 9.992188 7 10.214844 7.285156 10.253906 C 7.3125 10.257812 7.339844 10.257812 7.367188 10.257812 C 7.503906 10.261719 7.632812 10.222656 7.738281 10.148438 L 14.039062 5.785156 C 14.171875 5.691406 14.253906 5.558594 14.253906 5.410156 C 14.257812 5.261719 14.1875 5.125 14.058594 5.027344 L 7.941406 0.414062 C 7.835938 0.335938 7.707031 0.292969 7.570312 0.292969 ',
    back: 'M20 11L7.83 11 11.425 7.405 10.01 5.991 5.416 10.586 5.414 10.584 4 11.998 4.002 12 4 12.002 5.414 13.416 5.416 13.414 10.01 18.009 11.425 16.595 7.83 13 20 13 20 13 20 11 20 11Z',
    backgroundColor: 'M9.91752,12.24082l7.74791-5.39017,1.17942,1.29591-6.094,7.20747L9.91752,12.24082M7.58741,12.652l4.53533,4.98327a.93412.93412,0,0,0,1.39531-.0909L20.96943,8.7314A.90827.90827,0,0,0,20.99075,7.533l-2.513-2.76116a.90827.90827,0,0,0-1.19509-.09132L7.809,11.27135A.93412.93412,0,0,0,7.58741,12.652ZM2.7939,18.52772,8.41126,19.5l1.47913-1.34617-3.02889-3.328Z',
    blockquote: 'M10.31788,5l.93817,1.3226A12.88271,12.88271,0,0,0,8.1653,9.40125a5.54242,5.54242,0,0,0-.998,3.07866v.33733q.36089-.04773.66067-.084a4.75723,4.75723,0,0,1,.56519-.03691,2.87044,2.87044,0,0,1,2.11693.8427,2.8416,2.8416,0,0,1,.8427,2.09274,3.37183,3.37183,0,0,1-.8898,2.453A3.143,3.143,0,0,1,8.10547,19,3.40532,3.40532,0,0,1,5.375,17.7245,4.91156,4.91156,0,0,1,4.30442,14.453,9.3672,9.3672,0,0,1,5.82051,9.32933,14.75716,14.75716,0,0,1,10.31788,5Zm8.39243,0,.9369,1.3226a12.88289,12.88289,0,0,0-3.09075,3.07865,5.54241,5.54241,0,0,0-.998,3.07866v.33733q.33606-.04773.63775-.084a4.91773,4.91773,0,0,1,.58938-.03691,2.8043,2.8043,0,0,1,2.1042.83,2.89952,2.89952,0,0,1,.80578,2.10547,3.42336,3.42336,0,0,1-.86561,2.453A3.06291,3.06291,0,0,1,16.49664,19,3.47924,3.47924,0,0,1,13.742,17.7245,4.846,4.846,0,0,1,12.64721,14.453,9.25867,9.25867,0,0,1,14.17476,9.3898,15.26076,15.26076,0,0,1,18.71031,5Z',
    bold: 'M15.25,11.8h0A3.68,3.68,0,0,0,17,9a3.93,3.93,0,0,0-3.86-4H6.65V19h7a3.74,3.74,0,0,0,3.7-3.78V15.1A3.64,3.64,0,0,0,15.25,11.8ZM8.65,7h4.2a2.09,2.09,0,0,1,2,1.3,2.09,2.09,0,0,1-1.37,2.61,2.23,2.23,0,0,1-.63.09H8.65Zm4.6,10H8.65V13h4.6a2.09,2.09,0,0,1,2,1.3,2.09,2.09,0,0,1-1.37,2.61A2.23,2.23,0,0,1,13.25,17Z',
    cancel: 'M13.4,12l5.6,5.6L17.6,19L12,13.4L6.4,19L5,17.6l5.6-5.6L5,6.4L6.4,5l5.6,5.6L17.6,5L19,6.4L13.4,12z',
    cellBackground: 'M16.6,12.4L7.6,3.5L6.2,4.9l2.4,2.4l-5.2,5.2c-0.6,0.6-0.6,1.5,0,2.1l5.5,5.5c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4  l5.5-5.5C17.2,14,17.2,13,16.6,12.4z M5.2,13.5L10,8.7l4.8,4.8H5.2z M19,15c0,0-2,2.2-2,3.5c0,1.1,0.9,2,2,2s2-0.9,2-2  C21,17.2,19,15,19,15z',
    cellBorderColor: 'M22,22H2v2h20V22z',
    cellOptions: 'M20,5H4C2.9,5,2,5.9,2,7v10c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C22,5.9,21.1,5,20,5z M9.5,6.5h5V9h-5V6.5z M8,17.5H4  c-0.3,0-0.5-0.2-0.5-0.4c0,0,0,0,0,0V17v-2H8V17.5z M8,13.5H3.5v-3H8V13.5z M8,9H3.5V7c0-0.3,0.2-0.5,0.4-0.5c0,0,0,0,0,0H8V9z   M14.5,17.5h-5V15h5V17.5z M20.5,17c0,0.3-0.2,0.5-0.4,0.5c0,0,0,0,0,0H16V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M20.5,9H16V6.5h4  c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0V9z',
    cellStyle: 'M20,19.9l0.9,3.6l-3.2-1.9l-3.3,1.9l0.8-3.6L12.3,17h3.8l1.7-3.5l1.4,3.5H23L20,19.9z M20,5H4C2.9,5,2,5.9,2,7v10  c0,1.1,0.9,2,2,2h7.5l-0.6-0.6L10,17.5H9.5V15h5.4l1.1-2.3v-2.2h4.5v3H20l0.6,1.5H22V7C22,5.9,21.1,5,20,5z M3.5,7  c0-0.3,0.2-0.5,0.4-0.5c0,0,0,0,0.1,0h4V9H3.5V7z M3.5,10.5H8v3H3.5V10.5z M4,17.5c-0.3,0-0.5-0.2-0.5-0.4c0,0,0,0,0-0.1v-2H8v2.5H4  z M14.5,9h-5V6.5h5V9z M20.5,9H16V6.5h4c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0.1V9z',
    clearFormatting: 'M11.48,10.09l-1.2-1.21L8.8,7.41,6.43,5,5.37,6.1,8.25,9,4.66,19h2l1.43-4h5.14l1.43,4h2l-.89-2.51L18.27,19l1.07-1.06L14.59,13.2ZM8.8,13l.92-2.56L12.27,13Zm.56-7.15L9.66,5h2l1.75,4.9Z',
    close: 'M13.4,12l5.6,5.6L17.6,19L12,13.4L6.4,19L5,17.6l5.6-5.6L5,6.4L6.4,5l5.6,5.6L17.6,5L19,6.4L13.4,12z',
    codeView: 'M9.4,16.6,4.8,12,9.4,7.4,8,6,2,12l6,6Zm5.2,0L19.2,12,14.6,7.4,16,6l6,6-6,6Z',
    cogs: 'M18.877 12.907a6.459 6.459 0 0 0 0 -1.814l1.952 -1.526a0.468 0.468 0 0 0 0.111 -0.593l-1.851 -3.2a0.461 0.461 0 0 0 -0.407 -0.231 0.421 0.421 0 0 0 -0.157 0.028l-2.3 0.925a6.755 6.755 0 0 0 -1.563 -0.907l-0.352 -2.452a0.451 0.451 0 0 0 -0.453 -0.388h-3.7a0.451 0.451 0 0 0 -0.454 0.388L9.347 5.588A7.077 7.077 0 0 0 7.783 6.5l-2.3 -0.925a0.508 0.508 0 0 0 -0.166 -0.028 0.457 0.457 0 0 0 -0.4 0.231l-1.851 3.2a0.457 0.457 0 0 0 0.111 0.593l1.952 1.526A7.348 7.348 0 0 0 5.063 12a7.348 7.348 0 0 0 0.064 0.907L3.175 14.433a0.468 0.468 0 0 0 -0.111 0.593l1.851 3.2a0.461 0.461 0 0 0 0.407 0.231 0.421 0.421 0 0 0 0.157 -0.028l2.3 -0.925a6.74 6.74 0 0 0 1.564 0.907L9.7 20.864a0.451 0.451 0 0 0 0.454 0.388h3.7a0.451 0.451 0 0 0 0.453 -0.388l0.352 -2.452a7.093 7.093 0 0 0 1.563 -0.907l2.3 0.925a0.513 0.513 0 0 0 0.167 0.028 0.457 0.457 0 0 0 0.4 -0.231l1.851 -3.2a0.468 0.468 0 0 0 -0.111 -0.593Zm-0.09 2.029l-0.854 1.476 -2.117 -0.852 -0.673 0.508a5.426 5.426 0 0 1 -1.164 0.679l-0.795 0.323 -0.33 2.269h-1.7l-0.32 -2.269 -0.793 -0.322a5.3 5.3 0 0 1 -1.147 -0.662L8.2 15.56l-2.133 0.86 -0.854 -1.475 1.806 -1.411 -0.1 -0.847c-0.028 -0.292 -0.046 -0.5 -0.046 -0.687s0.018 -0.4 0.045 -0.672l0.106 -0.854L5.217 9.064l0.854 -1.475 2.117 0.851 0.673 -0.508a5.426 5.426 0 0 1 1.164 -0.679l0.8 -0.323 0.331 -2.269h1.7l0.321 2.269 0.792 0.322a5.3 5.3 0 0 1 1.148 0.661l0.684 0.526 2.133 -0.859 0.853 1.473 -1.8 1.421 0.1 0.847a5 5 0 0 1 0.046 0.679c0 0.193 -0.018 0.4 -0.045 0.672l-0.106 0.853ZM12 14.544A2.544 2.544 0 1 1 14.546 12 2.552 2.552 0 0 1 12 14.544Z',
    columns: 'M20,5H4C2.9,5,2,5.9,2,7v10c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C22,5.9,21.1,5,20,5z M8,17.5H4c-0.3,0-0.5-0.2-0.5-0.4  c0,0,0,0,0,0V17v-2H8V17.5z M8,13.5H3.5v-3H8V13.5z M8,9H3.5V7c0-0.3,0.2-0.5,0.4-0.5c0,0,0,0,0,0H8V9z M20.5,17  c0,0.3-0.2,0.5-0.4,0.5c0,0,0,0,0,0H16V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M20.5,9H16V6.5h4c0.3,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0  V9z',
    edit: 'M17,11.2L12.8,7L5,14.8V19h4.2L17,11.2z M7,16.8v-1.5l5.6-5.6l1.4,1.5l-5.6,5.6H7z M13.5,6.3l0.7-0.7c0.8-0.8,2.1-0.8,2.8,0  c0,0,0,0,0,0L18.4,7c0.8,0.8,0.8,2,0,2.8l-0.7,0.7L13.5,6.3z',
    exitFullscreen: 'M5,16H8v3h2V14H5ZM8,8H5v2h5V5H8Zm6,11h2V16h3V14H14ZM16,8V5H14v5h5V8Z',
    fileInsert: 'M 8.09375 12.75 L 5.90625 12.75 C 5.542969 12.75 5.25 12.394531 5.25 11.953125 L 5.25 6.375 L 2.851562 6.375 C 2.367188 6.375 2.121094 5.660156 2.464844 5.242188 L 6.625 0.1875 C 6.832031 -0.0585938 7.167969 -0.0585938 7.371094 0.1875 L 11.535156 5.242188 C 11.878906 5.660156 11.632812 6.375 11.148438 6.375 L 8.75 6.375 L 8.75 11.953125 C 8.75 12.394531 8.457031 12.75 8.09375 12.75 Z M 14 12.484375 L 14 16.203125 C 14 16.644531 13.707031 17 13.34375 17 L 0.65625 17 C 0.292969 17 0 16.644531 0 16.203125 L 0 12.484375 C 0 12.042969 0.292969 11.6875 0.65625 11.6875 L 4.375 11.6875 L 4.375 11.953125 C 4.375 12.980469 5.0625 13.8125 5.90625 13.8125 L 8.09375 13.8125 C 8.9375 13.8125 9.625 12.980469 9.625 11.953125 L 9.625 11.6875 L 13.34375 11.6875 C 13.707031 11.6875 14 12.042969 14 12.484375 Z M 10.609375 15.40625 C 10.609375 15.039062 10.363281 14.742188 10.0625 14.742188 C 9.761719 14.742188 9.515625 15.039062 9.515625 15.40625 C 9.515625 15.773438 9.761719 16.070312 10.0625 16.070312 C 10.363281 16.070312 10.609375 15.773438 10.609375 15.40625 Z M 12.359375 15.40625 C 12.359375 15.039062 12.113281 14.742188 11.8125 14.742188 C 11.511719 14.742188 11.265625 15.039062 11.265625 15.40625 C 11.265625 15.773438 11.511719 16.070312 11.8125 16.070312 C 12.113281 16.070312 12.359375 15.773438 12.359375 15.40625 Z M 12.359375 15.40625 ',
    fileManager: 'M 0 5.625 L 20.996094 5.625 L 21 15.75 C 21 16.371094 20.410156 16.875 19.6875 16.875 L 1.3125 16.875 C 0.585938 16.875 0 16.371094 0 15.75 Z M 0 5.625 M 21 4.5 L 0 4.5 L 0 2.25 C 0 1.628906 0.585938 1.125 1.3125 1.125 L 6.921875 1.125 C 7.480469 1.125 8.015625 1.316406 8.40625 1.652344 L 9.800781 2.847656 C 10.195312 3.183594 10.730469 3.375 11.289062 3.375 L 19.6875 3.375 C 20.414062 3.375 21 3.878906 21 4.5 Z M 21 4.5',
    markdown: 'M5.55006 17.75V7.35L8.96006 16.89H10.7101L14.2301 7.37V14.0729C14.3951 14.1551 14.5499 14.265 14.6875 14.4026L14.7001 14.4151V11.64C14.7001 10.8583 15.2127 10.1963 15.9201 9.97171V5H13.6801L10.0401 14.86L6.51006 5H4.00006V17.75H5.55006ZM17.2001 11.64C17.2001 11.2258 16.8643 10.89 16.4501 10.89C16.0359 10.89 15.7001 11.2258 15.7001 11.64V16.8294L13.9804 15.1097C13.6875 14.8168 13.2126 14.8168 12.9197 15.1097C12.6269 15.4026 12.6269 15.8775 12.9197 16.1703L15.9197 19.1703C16.2126 19.4632 16.6875 19.4632 16.9804 19.1703L19.9804 16.1703C20.2733 15.8775 20.2733 15.4026 19.9804 15.1097C19.6875 14.8168 19.2126 14.8168 18.9197 15.1097L17.2001 16.8294V11.64Z',
    fontAwesome: 'M18.99018,13.98212V7.52679c-.08038-1.21875-1.33929-.683-1.33929-.683-2.933,1.39282-4.36274.61938-5.85938.15625a6.23272,6.23272,0,0,0-2.79376-.20062l-.00946.004A1.98777,1.98777,0,0,0,7.62189,5.106a.984.984,0,0,0-.17517-.05432c-.02447-.0055-.04882-.01032-.0736-.0149A.9565.9565,0,0,0,7.1908,5H6.82539a.9565.9565,0,0,0-.18232.0368c-.02472.00458-.04907.0094-.07348.01484a.985.985,0,0,0-.17523.05438,1.98585,1.98585,0,0,0-.573,3.49585v9.394A1.004,1.004,0,0,0,6.82539,19H7.1908a1.00406,1.00406,0,0,0,1.00409-1.00409V15.52234c3.64221-1.09827,5.19709.64282,7.09888.57587a5.57291,5.57291,0,0,0,3.25446-1.05805A1.2458,1.2458,0,0,0,18.99018,13.98212Z',
    fontFamily: 'M16,19h2L13,5H11L6,19H8l1.43-4h5.14Zm-5.86-6L12,7.8,13.86,13Z',
    fontSize: 'M20.75,19h1.5l-3-10h-1.5l-3,10h1.5L17,16.5h3Zm-3.3-4,1.05-3.5L19.55,15Zm-5.7,4h2l-5-14h-2l-5,14h2l1.43-4h5.14ZM5.89,13,7.75,7.8,9.61,13Z',
    fullscreen: 'M7,14H5v5h5V17H7ZM5,10H7V7h3V5H5Zm12,7H14v2h5V14H17ZM14,5V7h3v3h2V5Z',
    help: 'M11,17h2v2h-2V17z M12,5C9.8,5,8,6.8,8,9h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.7-3,5v1h2v-1c0-2.2,3-2.5,3-5  C16,6.8,14.2,5,12,5z',
    horizontalLine: 'M5,12h14 M19,11H5v2h14V11z',
    imageAltText: 'M19,7h-6v12h-2V7H5V5h6h2h6V7z',
    imageCaption: 'M14.2,11l3.8,5H6l3-3.9l2.1,2.7L14,11H14.2z M8.5,11c0.8,0,1.5-0.7,1.5-1.5S9.3,8,8.5,8S7,8.7,7,9.5C7,10.3,7.7,11,8.5,11z   M22,6v12c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,8.8V6H4v12h16V8.8z M22,22H2v2h20V22z',
    imageClass: 'M9.5,13.4l-2.9-2.9h3.8L12.2,7l1.4,3.5h3.8l-3,2.9l0.9,3.6L12,15.1L8.8,17L9.5,13.4z M22,6v12c0,1.1-0.9,2-2,2H4  c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,6H4v12h16V8.8V6z',
    imageDisplay: 'M3,5h18v2H3V5z M13,9h8v2h-8V9z M13,13h8v2h-8V13z M3,17h18v2H3V17z M3,9h8v6H3V9z',
    imageManager: 'M20,6h-7l-2-2H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8C22,6.9,21.1,6,20,6z M20,18H4V6h6.2l2,2H20V18z   M18,16l-3.8-5H14l-2.9,3.8L9,12.1L6,16H18z M10,9.5C10,8.7,9.3,8,8.5,8S7,8.7,7,9.5S7.7,11,8.5,11S10,10.3,10,9.5z',
    imageSize: 'M16.9,4c-0.3,0-0.5,0.2-0.8,0.3L3.3,13c-0.9,0.6-1.1,1.9-0.5,2.8l2.2,3.3c0.4,0.7,1.2,1,2,0.8c0.3,0,0.5-0.2,0.8-0.3  L20.7,11c0.9-0.6,1.1-1.9,0.5-2.8l-2.2-3.3C18.5,4.2,17.7,3.9,16.9,4L16.9,4z M16.9,9.9L18.1,9l-2-2.9L17,5.6c0.1,0,0.1-0.1,0.2-0.1  c0.2,0,0.4,0,0.5,0.2L19.9,9c0.2,0.2,0.1,0.5-0.1,0.7L7,18.4c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0-0.4,0-0.5-0.2L4.1,15  c-0.2-0.2-0.1-0.5,0.1-0.7L5,13.7l2,2.9l1.2-0.8l-2-2.9L7.5,12l1.1,1.7l1.2-0.8l-1.1-1.7l1.2-0.8l2,2.9l1.2-0.8l-2-2.9l1.2-0.8  l1.1,1.7l1.2-0.8l-1.1-1.7L14.9,7L16.9,9.9z',
    indent: 'M3,9v6l3-3L3,9z M3,19h18v-2H3V19z M3,7h18V5H3V7z M9,11h12V9H9V11z M9,15h12v-2H9V15z',
    inlineClass: 'M9.9,13.313A1.2,1.2,0,0,1,9.968,13H6.277l1.86-5.2,1.841,5.148A1.291,1.291,0,0,1,11.212,12h.426l-2.5-7h-2l-5,14h2l1.43-4H9.9Zm2.651,6.727a2.884,2.884,0,0,1-.655-2.018v-2.71A1.309,1.309,0,0,1,13.208,14h3.113a3.039,3.039,0,0,1,2,1.092s1.728,1.818,2.964,2.928a1.383,1.383,0,0,1,.318,1.931,1.44,1.44,0,0,1-.19.215l-3.347,3.31a1.309,1.309,0,0,1-1.832.258h0a1.282,1.282,0,0,1-.258-.257l-1.71-1.728Zm2.48-3.96a.773.773,0,1,0,.008,0Z',
    inlineStyle: 'M11.88,15h.7l.7-1.7-3-8.3h-2l-5,14h2l1.4-4Zm-4.4-2,1.9-5.2,1.9,5.2ZM15.4,21.545l3.246,1.949-.909-3.637L20.72,17H16.954l-1.429-3.506L13.837,17H10.071l2.857,2.857-.779,3.637Z',
    insert: 'M13.889,11.611c-0.17,0.17-0.443,0.17-0.612,0l-3.189-3.187l-3.363,3.36c-0.171,0.171-0.441,0.171-0.612,0c-0.172-0.169-0.172-0.443,0-0.611l3.667-3.669c0.17-0.17,0.445-0.172,0.614,0l3.496,3.493C14.058,11.167,14.061,11.443,13.889,11.611 M18.25,10c0,4.558-3.693,8.25-8.25,8.25c-4.557,0-8.25-3.692-8.25-8.25c0-4.557,3.693-8.25,8.25-8.25C14.557,1.75,18.25,5.443,18.25,10 M17.383,10c0-4.07-3.312-7.382-7.383-7.382S2.618,5.93,2.618,10S5.93,17.381,10,17.381S17.383,14.07,17.383,10',
    insertEmbed: 'M20.73889,15.45929a3.4768,3.4768,0,0,0-5.45965-.28662L9.5661,12.50861a3.49811,3.49811,0,0,0-.00873-1.01331l5.72174-2.66809a3.55783,3.55783,0,1,0-.84527-1.81262L8.70966,9.6839a3.50851,3.50851,0,1,0,.0111,4.63727l5.7132,2.66412a3.49763,3.49763,0,1,0,6.30493-1.526ZM18.00745,5.01056A1.49993,1.49993,0,1,1,16.39551,6.3894,1.49994,1.49994,0,0,1,18.00745,5.01056ZM5.99237,13.49536a1.49989,1.49989,0,1,1,1.61194-1.37878A1.49982,1.49982,0,0,1,5.99237,13.49536Zm11.78211,5.494a1.49993,1.49993,0,1,1,1.61193-1.37885A1.49987,1.49987,0,0,1,17.77448,18.98932Z',
    insertFile: 'M7,3C5.9,3,5,3.9,5,5v14c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V7.6L14.4,3H7z M17,19H7V5h6v4h4V19z',
    insertImage: 'M14.2,11l3.8,5H6l3-3.9l2.1,2.7L14,11H14.2z M8.5,11c0.8,0,1.5-0.7,1.5-1.5S9.3,8,8.5,8S7,8.7,7,9.5C7,10.3,7.7,11,8.5,11z   M22,6v12c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V6c0-1.1,0.9-2,2-2h16C21.1,4,22,4.9,22,6z M20,8.8V6H4v12h16V8.8z',
    insertLink: 'M11,17H7A5,5,0,0,1,7,7h4V9H7a3,3,0,0,0,0,6h4ZM17,7H13V9h4a3,3,0,0,1,0,6H13v2h4A5,5,0,0,0,17,7Zm-1,4H8v2h8Z',
    insertMore: 'M16.5,13h-6v6h-2V13h-6V11h6V5h2v6h6Zm5,4.5A1.5,1.5,0,1,1,20,16,1.5,1.5,0,0,1,21.5,17.5Zm0-4A1.5,1.5,0,1,1,20,12,1.5,1.5,0,0,1,21.5,13.5Zm0-4A1.5,1.5,0,1,1,20,8,1.5,1.5,0,0,1,21.5,9.5Z',
    insertTable: 'M20,5H4C2.9,5,2,5.9,2,7v2v1.5v3V15v2c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-2v-1.5v-3V9V7C22,5.9,21.1,5,20,5z M9.5,13.5v-3  h5v3H9.5z M14.5,15v2.5h-5V15H14.5z M9.5,9V6.5h5V9H9.5z M3.5,7c0-0.3,0.2-0.5,0.5-0.5h4V9H3.5V7z M3.5,10.5H8v3H3.5V10.5z M3.5,17  v-2H8v2.5H4C3.7,17.5,3.5,17.3,3.5,17z M20.5,17c0,0.3-0.2,0.5-0.5,0.5h-4V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M16,9V6.5h4  c0.3,0,0.5,0.2,0.5,0.5v2H16z',
    insertVideo: 'M15,8v8H5V8H15m2,2.5V7a1,1,0,0,0-1-1H4A1,1,0,0,0,3,7V17a1,1,0,0,0,1,1H16a1,1,0,0,0,1-1V13.5l2.29,2.29A1,1,0,0,0,21,15.08V8.91a1,1,0,0,0-1.71-.71Z',
    upload: 'M12 6.66667a4.87654 4.87654 0 0 1 4.77525 3.92342l0.29618 1.50268 1.52794 0.10578a2.57021 2.57021 0 0 1 -0.1827 5.13478H6.5a3.49774 3.49774 0 0 1 -0.3844 -6.97454l1.06682 -0.11341L7.678 9.29387A4.86024 4.86024 0 0 1 12 6.66667m0 -2A6.871 6.871 0 0 0 5.90417 8.37 5.49773 5.49773 0 0 0 6.5 19.33333H18.41667a4.57019 4.57019 0 0 0 0.32083 -9.13A6.86567 6.86567 0 0 0 12 4.66667Zm0.99976 7.2469h1.91406L11.99976 9 9.08618 11.91357h1.91358v3H11V16h2V14h-0.00024Z',
    uploadFiles: 'M12 6.66667a4.87654 4.87654 0 0 1 4.77525 3.92342l0.29618 1.50268 1.52794 0.10578a2.57021 2.57021 0 0 1 -0.1827 5.13478H6.5a3.49774 3.49774 0 0 1 -0.3844 -6.97454l1.06682 -0.11341L7.678 9.29387A4.86024 4.86024 0 0 1 12 6.66667m0 -2A6.871 6.871 0 0 0 5.90417 8.37 5.49773 5.49773 0 0 0 6.5 19.33333H18.41667a4.57019 4.57019 0 0 0 0.32083 -9.13A6.86567 6.86567 0 0 0 12 4.66667Zm0.99976 7.2469h1.91406L11.99976 9 9.08618 11.91357h1.91358v3H11V16h2V14h-0.00024Z',
    italic: 'M11.76,9h2l-2.2,10h-2Zm1.68-4a1,1,0,1,0,1,1,1,1,0,0,0-1-1Z',
    search: 'M15.5 14h-0.79l-0.28 -0.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09 -0.59 4.23 -1.57l0.27 0.28v0.79l5 4.99L20.49 19l-4.99 -5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z',
    lineHeight: 'M6.25,7h2.5L5.25,3.5,1.75,7h2.5V17H1.75l3.5,3.5L8.75,17H6.25Zm4-2V7h12V5Zm0,14h12V17h-12Zm0-6h12V11h-12Z',
    linkStyles: 'M19,17.9l0.9,3.6l-3.2-1.9l-3.3,1.9l0.8-3.6L11.3,15h3.8l1.7-3.5l1.4,3.5H22L19,17.9z M20,12c0,0.3-0.1,0.7-0.2,1h2.1  c0.1-0.3,0.1-0.6,0.1-1c0-2.8-2.2-5-5-5h-4v2h4C18.7,9,20,10.3,20,12z M14.8,11H8v2h3.3h2.5L14.8,11z M9.9,16.4L8.5,15H7  c-1.7,0-3-1.3-3-3s1.3-3,3-3h4V7H7c-2.8,0-5,2.2-5,5s2.2,5,5,5h3.5L9.9,16.4z',
    mention: 'M12.4,5c-4.1,0-7.5,3.4-7.5,7.5S8.3,20,12.4,20h3.8v-1.5h-3.8c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6v1.1  c0,0.6-0.5,1.2-1.1,1.2s-1.1-0.6-1.1-1.2v-1.1c0-2.1-1.7-3.8-3.8-3.8s-3.7,1.7-3.7,3.8s1.7,3.8,3.8,3.8c1,0,2-0.4,2.7-1.1  c0.5,0.7,1.3,1.1,2.2,1.1c1.5,0,2.6-1.2,2.6-2.7v-1.1C19.9,8.4,16.6,5,12.4,5z M12.4,14.7c-1.2,0-2.3-1-2.3-2.2s1-2.3,2.3-2.3  s2.3,1,2.3,2.3S13.6,14.7,12.4,14.7z',
    minimize: 'M5,12h14 M19,11H5v2h14V11z',
    more: 'M13.5,17c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5S13.5,16.2,13.5,17z M13.5,12c0,0.8-0.7,1.5-1.5,1.5 s-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5S13.5,11.2,13.5,12z M13.5,7c0,0.8-0.7,1.5-1.5,1.5S10.5,7.8,10.5,7s0.7-1.5,1.5-1.5 S13.5,6.2,13.5,7z',
    openLink: 'M17,17H7V7h3V5H7C6,5,5,6,5,7v10c0,1,1,2,2,2h10c1,0,2-1,2-2v-3h-2V17z M14,5v2h1.6l-5.8,5.8l1.4,1.4L17,8.4V10h2V5H14z',
    orderedList: 'M2.5,16h2v.5h-1v1h1V18h-2v1h3V15h-3Zm1-7h1V5h-2V6h1Zm-1,2H4.3L2.5,13.1V14h3V13H3.7l1.8-2.1V10h-3Zm5-5V8h14V6Zm0,12h14V16H7.5Zm0-5h14V11H7.5Z',
    outdent: 'M3,12l3,3V9L3,12z M3,19h18v-2H3V19z M3,7h18V5H3V7z M9,11h12V9H9V11z M9,15h12v-2H9V15z',
    pageBreaker: 'M3,9v6l3-3L3,9z M21,9H8V4h2v3h9V4h2V9z M21,20h-2v-3h-9v3H8v-5h13V20z M11,13H8v-2h3V13z M16,13h-3v-2h3V13z M21,13h-3v-2  h3V13z',
    paragraphFormat: 'M10.15,5A4.11,4.11,0,0,0,6.08,8.18,4,4,0,0,0,10,13v6h2V7h2V19h2V7h2V5ZM8,9a2,2,0,0,1,2-2v4A2,2,0,0,1,8,9Z',
    paragraphMore: 'M7.682,5a4.11,4.11,0,0,0-4.07,3.18,4,4,0,0,0,3.11,4.725h0l.027.005a3.766,3.766,0,0,0,.82.09v6h2V7h2V19h2V7h2V5ZM5.532,9a2,2,0,0,1,2-2v4A2,2,0,0,1,5.532,9Zm14.94,8.491a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.472,17.491Zm0-4a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.472,13.491Zm0-4a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.472,9.491Z',
    paragraphStyle: 'M4,9c0-1.1,0.9-2,2-2v4C4.9,11,4,10.1,4,9z M16.7,20.5l3.2,1.9L19,18.8l3-2.9h-3.7l-1.4-3.5L15.3,16h-3.8l2.9,2.9l-0.9,3.6  L16.7,20.5z M10,17.4V19h1.6L10,17.4z M6.1,5c-1.9,0-3.6,1.3-4,3.2c-0.5,2.1,0.8,4.2,2.9,4.7c0,0,0,0,0,0h0.2C5.5,13,5.8,13,6,13v6  h2V7h2v7h2V7h2V5H6.1z',
    pdfExport: 'M7,3C5.9,3,5,3.9,5,5v14c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V7.6L14.4,3H7z M17,19H7V5h6v4h4V19z M16.3,13.5  c-0.2-0.6-1.1-0.8-2.6-0.8c-0.1,0-0.1,0-0.2,0c-0.3-0.3-0.8-0.9-1-1.2c-0.2-0.2-0.3-0.3-0.4-0.6c0.2-0.7,0.2-1,0.3-1.5  c0.1-0.9,0-1.6-0.2-1.8c-0.4-0.2-0.7-0.2-0.9-0.2c-0.1,0-0.3,0.2-0.7,0.7c-0.2,0.7-0.1,1.8,0.6,2.8c-0.2,0.8-0.7,1.6-1,2.4  c-0.8,0.2-1.5,0.7-1.9,1.1c-0.7,0.7-0.9,1.1-0.7,1.6c0,0.3,0.2,0.6,0.7,0.6c0.3-0.1,0.3-0.2,0.7-0.3c0.6-0.3,1.2-1.7,1.7-2.4  c0.8-0.2,1.7-0.3,2-0.3c0.1,0,0.3,0,0.6,0c0.8,0.8,1.2,1.1,1.8,1.2c0.1,0,0.2,0,0.3,0c0.3,0,0.8-0.1,1-0.6  C16.4,14.1,16.4,13.9,16.3,13.5z M8.3,15.7c-0.1,0.1-0.2,0.1-0.2,0.1c0-0.1,0-0.3,0.6-0.8c0.2-0.2,0.6-0.3,0.9-0.7  C9,15,8.6,15.5,8.3,15.7z M11.3,9c0-0.1,0.1-0.2,0.1-0.2S11.6,9,11.5,10c0,0.1,0,0.3-0.1,0.7C11.3,10.1,11,9.5,11.3,9z M10.9,13.1  c0.2-0.6,0.6-1,0.7-1.5c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.2,0.3,0.7,0.7,0.9C12.2,12.8,11.6,13,10.9,13.1z M15.2,14.1  c-0.1,0-0.1,0-0.2,0c-0.2,0-0.7-0.2-1-0.7c1.1,0,1.6,0.2,1.6,0.6C15.5,14.1,15.4,14.1,15.2,14.1z',
    print: 'M16.1,17c0-0.6,0.4-1,1-1c0.6,0,1,0.4,1,1s-0.4,1-1,1C16.5,18,16.1,17.6,16.1,17z M22,15v4c0,1.1-0.9,2-2,2H4  c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h1V5c0-1.1,0.9-2,2-2h7.4L19,7.6V13h1C21.1,13,22,13.9,22,15z M7,13h10V9h-4V5H7V13z M20,15H4  v4h16V15z',
    redo: 'M13.6,9.4c1.7,0.3,3.2,0.9,4.6,2L21,8.5v7h-7l2.7-2.7C13,10.1,7.9,11,5.3,14.7c-0.2,0.3-0.4,0.5-0.5,0.8L3,14.6  C5.1,10.8,9.3,8.7,13.6,9.4z',
    removeTable: 'M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z',
    insertAll: 'M 9.25 12 L 6.75 12 C 6.335938 12 6 11.664062 6 11.25 L 6 6 L 3.257812 6 C 2.703125 6 2.425781 5.328125 2.820312 4.933594 L 7.570312 0.179688 C 7.804688 -0.0546875 8.191406 -0.0546875 8.425781 0.179688 L 13.179688 4.933594 C 13.574219 5.328125 13.296875 6 12.742188 6 L 10 6 L 10 11.25 C 10 11.664062 9.664062 12 9.25 12 Z M 16 11.75 L 16 15.25 C 16 15.664062 15.664062 16 15.25 16 L 0.75 16 C 0.335938 16 0 15.664062 0 15.25 L 0 11.75 C 0 11.335938 0.335938 11 0.75 11 L 5 11 L 5 11.25 C 5 12.214844 5.785156 13 6.75 13 L 9.25 13 C 10.214844 13 11 12.214844 11 11.25 L 11 11 L 15.25 11 C 15.664062 11 16 11.335938 16 11.75 Z M 12.125 14.5 C 12.125 14.15625 11.84375 13.875 11.5 13.875 C 11.15625 13.875 10.875 14.15625 10.875 14.5 C 10.875 14.84375 11.15625 15.125 11.5 15.125 C 11.84375 15.125 12.125 14.84375 12.125 14.5 Z M 14.125 14.5 C 14.125 14.15625 13.84375 13.875 13.5 13.875 C 13.15625 13.875 12.875 14.15625 12.875 14.5 C 12.875 14.84375 13.15625 15.125 13.5 15.125 C 13.84375 15.125 14.125 14.84375 14.125 14.5 Z M 14.125 14.5 ',
    remove: 'M15,10v8H9v-8H15 M14,4H9.9l-1,1H6v2h12V5h-3L14,4z M17,8H7v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V8z',
    replaceImage: 'M16,5v3H4v2h12v3l4-4L16,5z M8,19v-3h12v-2H8v-3l-4,4L8,19z',
    row: 'M20,5H4C2.9,5,2,5.9,2,7v2v1.5v3V15v2c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-2v-1.5v-3V9V7C22,5.9,21.1,5,20,5z M16,6.5h4  c0.3,0,0.5,0.2,0.5,0.5v2H16V6.5z M9.5,6.5h5V9h-5V6.5z M3.5,7c0-0.3,0.2-0.5,0.5-0.5h4V9H3.5V7z M8,17.5H4c-0.3,0-0.5-0.2-0.5-0.5  v-2H8V17.5z M14.5,17.5h-5V15h5V17.5z M20.5,17c0,0.3-0.2,0.5-0.5,0.5h-4V15h4.5V17z',
    selectAll: 'M5,7h2V5C5.9,5,5,5.9,5,7z M5,11h2V9H5V11z M9,19h2v-2H9V19z M5,11h2V9H5V11z M15,5h-2v2h2V5z M17,5v2h2C19,5.9,18.1,5,17,5  z M7,19v-2H5C5,18.1,5.9,19,7,19z M5,15h2v-2H5V15z M11,5H9v2h2V5z M13,19h2v-2h-2V19z M17,11h2V9h-2V11z M17,19c1.1,0,2-0.9,2-2h-2  V19z M17,11h2V9h-2V11z M17,15h2v-2h-2V15z M13,19h2v-2h-2V19z M13,7h2V5h-2V7z M9,15h6V9H9V15z M11,11h2v2h-2V11z',
    smile: 'M11.991,3A9,9,0,1,0,21,12,8.99557,8.99557,0,0,0,11.991,3ZM12,19a7,7,0,1,1,7-7A6.99808,6.99808,0,0,1,12,19Zm3.105-5.2h1.503a4.94542,4.94542,0,0,1-9.216,0H8.895a3.57808,3.57808,0,0,0,6.21,0ZM7.5,9.75A1.35,1.35,0,1,1,8.85,11.1,1.35,1.35,0,0,1,7.5,9.75Zm6.3,0a1.35,1.35,0,1,1,1.35,1.35A1.35,1.35,0,0,1,13.8,9.75Z',
    spellcheck: 'M19.1,13.6l-5.6,5.6l-2.7-2.7l-1.4,1.4l4.1,4.1l7-7L19.1,13.6z M10.8,13.7l2.7,2.7l0.8-0.8L10.5,5h-2l-5,14h2l1.4-4h2.6  L10.8,13.7z M9.5,7.8l1.9,5.2H7.6L9.5,7.8z',
    star: 'M12.1,7.7l1,2.5l0.4,0.9h1h2.4l-2.1,2l-0.6,0.6l0.2,0.9l0.6,2.3l-2.2-1.3L12,15.2l-0.8,0.5L9,17l0.5-2.5l0.1-0.8L9,13.1  l-2-2h2.5h0.9l0.4-0.8L12.1,7.7 M12.2,4L9.5,9.6H3.4L8,14.2L6.9,20l5.1-3.1l5.3,3.1l-1.5-5.8l4.8-4.6h-6.1L12.2,4L12.2,4z',
    strikeThrough: 'M3,12.20294H21v1.5H16.63422a3.59782,3.59782,0,0,1,.34942,1.5929,3.252,3.252,0,0,1-1.31427,2.6997A5.55082,5.55082,0,0,1,12.20251,19a6.4421,6.4421,0,0,1-2.62335-.539,4.46335,4.46335,0,0,1-1.89264-1.48816,3.668,3.668,0,0,1-.67016-2.15546V14.704h.28723v-.0011h.34149v.0011H9.02v.11334a2.18275,2.18275,0,0,0,.85413,1.83069,3.69,3.69,0,0,0,2.32836.67926,3.38778,3.38778,0,0,0,2.07666-.5462,1.73346,1.73346,0,0,0,.7013-1.46655,1.69749,1.69749,0,0,0-.647-1.43439,3.00525,3.00525,0,0,0-.27491-.17725H3ZM16.34473,7.05981A4.18163,4.18163,0,0,0,14.6236,5.5462,5.627,5.627,0,0,0,12.11072,5,5.16083,5.16083,0,0,0,8.74719,6.06213,3.36315,3.36315,0,0,0,7.44006,8.76855a3.22923,3.22923,0,0,0,.3216,1.42786h2.59668c-.08338-.05365-.18537-.10577-.25269-.16064a1.60652,1.60652,0,0,1-.65283-1.30036,1.79843,1.79843,0,0,1,.68842-1.5108,3.12971,3.12971,0,0,1,1.96948-.55243,3.04779,3.04779,0,0,1,2.106.6687,2.35066,2.35066,0,0,1,.736,1.83258v.11341h2.00317V9.17346A3.90013,3.90013,0,0,0,16.34473,7.05981Z',
    subscript: 'M10.4,12l3.6,3.6L12.6,17L9,13.4L5.4,17L4,15.6L7.6,12L4,8.4L5.4,7L9,10.6L12.6,7L14,8.4L10.4,12z M18.31234,19.674  l1.06812-1.1465c0.196-0.20141,0.37093-0.40739,0.5368-0.6088c0.15975-0.19418,0.30419-0.40046,0.432-0.617  c0.11969-0.20017,0.21776-0.41249,0.29255-0.6334c0.07103-0.21492,0.10703-0.43986,0.10662-0.66621  c0.00297-0.28137-0.04904-0.56062-0.1531-0.82206c-0.09855-0.24575-0.25264-0.46534-0.45022-0.6416  c-0.20984-0.18355-0.45523-0.32191-0.72089-0.40646c-0.63808-0.19005-1.3198-0.17443-1.94851,0.04465  c-0.28703,0.10845-0.54746,0.2772-0.76372,0.49487c-0.20881,0.20858-0.37069,0.45932-0.47483,0.73548  c-0.10002,0.26648-0.15276,0.54838-0.15585,0.833l-0.00364,0.237H17.617l0.00638-0.22692  c0.00158-0.12667,0.01966-0.25258,0.05377-0.37458c0.03337-0.10708,0.08655-0.20693,0.15679-0.29437  c0.07105-0.08037,0.15959-0.14335,0.25882-0.1841c0.22459-0.08899,0.47371-0.09417,0.7018-0.01458  c0.0822,0.03608,0.15559,0.08957,0.21509,0.15679c0.06076,0.07174,0.10745,0.15429,0.13761,0.24333  c0.03567,0.10824,0.05412,0.22141,0.05469,0.33538c-0.00111,0.08959-0.0118,0.17881-0.0319,0.26612  c-0.02913,0.10428-0.07076,0.20465-0.124,0.29893c-0.07733,0.13621-0.1654,0.26603-0.26338,0.38823  c-0.13438,0.17465-0.27767,0.34226-0.42929,0.50217l-2.15634,2.35315V21H21v-1.326H18.31234z',
    superscript: 'M10.4,12,14,15.6,12.6,17,9,13.4,5.4,17,4,15.6,7.6,12,4,8.4,5.4,7,9,10.6,12.6,7,14,8.4Zm8.91234-3.326,1.06812-1.1465c.196-.20141.37093-.40739.5368-.6088a4.85745,4.85745,0,0,0,.432-.617,3.29,3.29,0,0,0,.29255-.6334,2.11079,2.11079,0,0,0,.10662-.66621,2.16127,2.16127,0,0,0-.1531-.82206,1.7154,1.7154,0,0,0-.45022-.6416,2.03,2.03,0,0,0-.72089-.40646,3.17085,3.17085,0,0,0-1.94851.04465,2.14555,2.14555,0,0,0-.76372.49487,2.07379,2.07379,0,0,0-.47483.73548,2.446,2.446,0,0,0-.15585.833l-.00364.237H18.617L18.62338,5.25a1.45865,1.45865,0,0,1,.05377-.37458.89552.89552,0,0,1,.15679-.29437.70083.70083,0,0,1,.25882-.1841,1.00569,1.00569,0,0,1,.7018-.01458.62014.62014,0,0,1,.21509.15679.74752.74752,0,0,1,.13761.24333,1.08893,1.08893,0,0,1,.05469.33538,1.25556,1.25556,0,0,1-.0319.26612,1.34227,1.34227,0,0,1-.124.29893,2.94367,2.94367,0,0,1-.26338.38823,6.41629,6.41629,0,0,1-.42929.50217L17.19709,8.92642V10H22V8.674Z',
    symbols: 'M15.77493,16.98885a8.21343,8.21343,0,0,0,1.96753-2.57651,7.34824,7.34824,0,0,0,.6034-3.07618A6.09092,6.09092,0,0,0,11.99515,5a6.13347,6.13347,0,0,0-4.585,1.79187,6.417,6.417,0,0,0-1.756,4.69207,6.93955,6.93955,0,0,0,.622,2.97415,8.06587,8.06587,0,0,0,1.949,2.53076H5.41452V19h5.54114v-.04331h-.00147V16.84107a5.82825,5.82825,0,0,1-2.2052-2.2352A6.40513,6.40513,0,0,1,7.97672,11.447,4.68548,4.68548,0,0,1,9.07785,8.19191a3.73232,3.73232,0,0,1,2.9173-1.22462,3.76839,3.76839,0,0,1,2.91241,1.21489,4.482,4.482,0,0,1,1.11572,3.154,6.71141,6.71141,0,0,1-.75384,3.24732,5.83562,5.83562,0,0,1-2.22357,2.25759v2.11562H13.0444V19h5.54108V16.98885Z',
    tags: 'M8.9749 7.47489a1.5 1.5 0 1 1 -1.5 1.5A1.5 1.5 0 0 1 8.9749 7.47489Zm3.78866 -3.12713L16.5362 8.12041l0.33565 0.33564 2.77038 2.77038a2.01988 2.01988 0 0 1 0.59 1.42 1.95518 1.95518 0 0 1 -0.5854 1.40455l0.00044 0.00043 -5.59583 5.59583 -0.00043 -0.00044a1.95518 1.95518 0 0 1 -1.40455 0.5854 1.98762 1.98762 0 0 1 -1.41 -0.58L8.45605 16.87185l-0.33564 -0.33565L4.35777 12.77357a1.99576 1.99576 0 0 1 -0.59 -1.42V9.36358l0 -3.59582a2.00579 2.00579 0 0 1 2 -2l3.59582 0h1.98995A1.98762 1.98762 0 0 1 12.76356 4.34776ZM15.46186 9.866l-0.33564 -0.33564L11.36359 5.76776H5.76776v5.59583L9.866 15.46186l2.7794 2.7794 5.5878 -5.60385 -0.001 -0.001Z',
    tableHeader: 'M20,5H4C2.9,5,2,5.9,2,7v10c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C22,5.9,21.1,5,20,5z M8,17.5H4c-0.3,0-0.5-0.2-0.5-0.4  l0,0V17v-2H8V17.5z M8,13.5H3.5v-3H8V13.5z M14.5,17.5h-5V15h5V17.5z M14.5,13.5h-5v-3h5V13.5z M20.5,17c0,0.3-0.2,0.5-0.4,0.5l0,0  H16V15h4.5V17z M20.5,13.5H16v-3h4.5V13.5z M20.5,9h-4.4H16h-1.5h-5H8H7.9H3.5V7c0-0.3,0.2-0.5,0.4-0.5l0,0h4l0,0h8.2l0,0H20  c0.3,0,0.5,0.2,0.5,0.4l0,0V9z',
    tableStyle: 'M20.0171,19.89752l.9,3.6-3.2-1.9-3.3,1.9.8-3.6-2.9-2.9h3.8l1.7-3.5,1.4,3.5h3.8ZM20,5H4A2.00591,2.00591,0,0,0,2,7V17a2.00591,2.00591,0,0,0,2,2h7.49115l-.58826-.58826L9.99115,17.5H9.5V14.9975h5.36511L16,12.66089V10.5h4.5v3h-.52783l.599,1.4975H22V7A2.00591,2.00591,0,0,0,20,5ZM3.5,7A.4724.4724,0,0,1,4,6.5H8V9H3.5Zm0,3.5H8v3H3.5Zm.5,7a.4724.4724,0,0,1-.5-.5V15H8v2.5Zm10.5-4h-5v-3h5Zm0-4.5h-5V6.5h5Zm6,0H16V6.5h4a.4724.4724,0,0,1,.5.5Z',
    textColor: 'M15.2,13.494s-3.6,3.9-3.6,6.3a3.65,3.65,0,0,0,7.3.1v-.1C18.9,17.394,15.2,13.494,15.2,13.494Zm-1.47-1.357.669-.724L12.1,5h-2l-5,14h2l1.43-4h2.943A24.426,24.426,0,0,1,13.726,12.137ZM11.1,7.8l1.86,5.2H9.244Z',
    textMore: 'M13.55,19h2l-5-14h-2l-5,14h2l1.4-4h5.1Zm-5.9-6,1.9-5.2,1.9,5.2Zm12.8,4.5a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.45,17.5Zm0-4a1.5,1.5,0,1,1-1.5-1.5A1.5,1.5,0,0,1,20.45,13.5Zm0-4A1.5,1.5,0,1,1,18.95,8,1.5,1.5,0,0,1,20.45,9.5Z',
    underline: 'M19,20v2H5V20Zm-3-6.785a4,4,0,0,1-5.74,3.4A3.75,3.75,0,0,1,8,13.085V5.005H6v8.21a6,6,0,0,0,8,5.44,5.851,5.851,0,0,0,4-5.65v-8H16ZM16,5v0h2V5ZM8,5H6v0H8Z',
    undo: 'M10.4,9.4c-1.7,0.3-3.2,0.9-4.6,2L3,8.5v7h7l-2.7-2.7c3.7-2.6,8.8-1.8,11.5,1.9c0.2,0.3,0.4,0.5,0.5,0.8l1.8-0.9  C18.9,10.8,14.7,8.7,10.4,9.4z',
    unlink: 'M14.4,11l1.6,1.6V11H14.4z M17,7h-4v1.9h4c1.7,0,3.1,1.4,3.1,3.1c0,1.3-0.8,2.4-1.9,2.8l1.4,1.4C21,15.4,22,13.8,22,12  C22,9.2,19.8,7,17,7z M2,4.3l3.1,3.1C3.3,8.1,2,9.9,2,12c0,2.8,2.2,5,5,5h4v-1.9H7c-1.7,0-3.1-1.4-3.1-3.1c0-1.6,1.2-2.9,2.8-3.1  L8.7,11H8v2h2.7l2.3,2.3V17h1.7l4,4l1.4-1.4L3.4,2.9L2,4.3z',
    unorderedList: 'M4,10.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S4.8,10.5,4,10.5z M4,5.5C3.2,5.5,2.5,6.2,2.5,7  S3.2,8.5,4,8.5S5.5,7.8,5.5,7S4.8,5.5,4,5.5z M4,15.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S4.8,15.5,4,15.5z   M7.5,6v2h14V6H7.5z M7.5,18h14v-2h-14V18z M7.5,13h14v-2h-14V13z',
    verticalAlignBottom: 'M16,13h-3V3h-2v10H8l4,4L16,13z M3,19v2h18v-2H3z',
    verticalAlignMiddle: 'M3,11v2h18v-2H3z M8,18h3v3h2v-3h3l-4-4L8,18z M16,6h-3V3h-2v3H8l4,4L16,6z',
    verticalAlignTop: 'M8,11h3v10h2V11h3l-4-4L8,11z M21,5V3H3v2H21z',
    trackChanges: 'M17.2 20H12.4599L13.9938 19.2076L14.0305 19.1886L14.0616 19.1612C14.1036 19.1242 14.1373 19.0786 14.1603 19.0275C14.1806 18.9825 14.1923 18.9342 14.1948 18.885H14.2H14.3384L14.4364 18.7874L14.7049 18.52H15.45C15.5747 18.52 15.6942 18.4705 15.7823 18.3823C15.8705 18.2942 15.92 18.1746 15.92 18.05C15.92 17.9253 15.8705 17.8058 15.7823 17.7176C15.7351 17.6704 15.6789 17.6343 15.6177 17.6109L17.33 15.9056V19.87C17.33 19.8871 17.3266 19.904 17.3201 19.9197C17.3136 19.9355 17.304 19.9499 17.2919 19.9619C17.2799 19.974 17.2655 19.9836 17.2497 19.9901C17.234 19.9966 17.2171 20 17.2 20ZM4.13 20H11.2508C11.2396 19.9629 11.2337 19.9242 11.2337 19.885C11.2337 19.8133 11.2533 19.7431 11.29 19.6819L11.2739 19.6734L11.8838 18.52H5C4.87535 18.52 4.7558 18.4705 4.66766 18.3823C4.57952 18.2942 4.53 18.1746 4.53 18.05C4.53 17.9253 4.57952 17.8058 4.66766 17.7176C4.7558 17.6295 4.87535 17.58 5 17.58H12.3809L12.3925 17.5582L12.4187 17.5284C12.4558 17.4864 12.5014 17.4527 12.5525 17.4297C12.5836 17.4156 12.6163 17.4057 12.6498 17.4001C12.6522 17.3065 12.6877 17.2166 12.7503 17.1467L13 17.37C12.9902 17.381 12.9847 17.3952 12.9847 17.41C12.9847 17.4247 12.9902 17.439 13 17.45L14.13 18.55H14.2L19.09 13.68V13.6L17.99 12.5C17.979 12.4902 17.9647 12.4847 17.95 12.4847C17.9352 12.4847 17.921 12.4902 17.91 12.5L13 17.37L12.7641 17.1322L15.1759 14.74H5C4.87535 14.74 4.7558 14.6905 4.66766 14.6023C4.57952 14.5142 4.53 14.3946 4.53 14.27C4.53 14.1453 4.57952 14.0258 4.66766 13.9376C4.7558 13.8495 4.87535 13.8 5 13.8H15.45C15.5747 13.8 15.6942 13.8495 15.7823 13.9376C15.8169 13.9722 15.8454 14.0115 15.8675 14.0541L17.33 12.6034V9.3H13.28C13.207 9.30976 13.133 9.30976 13.06 9.3C12.7697 9.22119 12.5113 9.05343 12.3212 8.82027C12.1311 8.58711 12.0187 8.30026 12 8V4H4.13C4.09552 4 4.06246 4.0137 4.03808 4.03808C4.0137 4.06246 4 4.09552 4 4.13V19.87C4 19.9045 4.0137 19.9375 4.03808 19.9619C4.06246 19.9863 4.09552 20 4.13 20ZM11.7889 20H11.8785C11.8902 19.9746 11.898 19.9475 11.9015 19.9197L11.8661 19.9866L11.8117 19.9578L13.84 18.91C13.8464 18.9044 13.8515 18.8974 13.855 18.8897C13.8585 18.8819 13.8603 18.8735 13.8603 18.865C13.8603 18.8565 13.8585 18.8481 13.855 18.8403C13.8515 18.8325 13.8464 18.8256 13.84 18.82L12.76 17.75C12.7544 17.7436 12.7474 17.7385 12.7397 17.735C12.7319 17.7315 12.7235 17.7297 12.715 17.7297C12.7065 17.7297 12.6981 17.7315 12.6903 17.735C12.6825 17.7385 12.6756 17.7436 12.67 17.75L11.57 19.83L11.5023 19.7942L11.58 19.85C11.5727 19.8602 11.5687 19.8724 11.5687 19.885C11.5687 19.8975 11.5727 19.9098 11.58 19.92L11.67 20H11.73L11.7642 19.9823L11.7889 20ZM13.1 4.65L16.6 8.15C16.6212 8.17232 16.6355 8.20028 16.6412 8.23051C16.6469 8.26075 16.6437 8.29199 16.6321 8.32048C16.6205 8.34898 16.6009 8.37352 16.5757 8.39117C16.5505 8.40882 16.5207 8.41883 16.49 8.42H13.06L12.83 8.19V4.76C12.8312 4.72925 12.8412 4.6995 12.8588 4.67429C12.8765 4.64909 12.901 4.62951 12.9295 4.6179C12.958 4.6063 12.9893 4.60315 13.0195 4.60884C13.0497 4.61453 13.0777 4.62882 13.1 4.65ZM11 6.72C11.0027 6.66089 10.9937 6.60183 10.9735 6.54621C10.9534 6.49058 10.9224 6.43948 10.8825 6.39582C10.8425 6.35216 10.7944 6.31681 10.7408 6.29179C10.6871 6.26677 10.6291 6.25257 10.57 6.25H5C4.88239 6.25773 4.77251 6.3113 4.69397 6.39918C4.61543 6.48707 4.57451 6.60226 4.58 6.72C4.57451 6.83774 4.61543 6.95293 4.69397 7.04082C4.77251 7.12871 4.88239 7.18227 5 7.19H10.6C10.714 7.1774 10.8189 7.12173 10.8933 7.03438C10.9676 6.94702 11.0058 6.83457 11 6.72ZM11.1 8.14001H5C4.87535 8.14001 4.7558 8.18953 4.66766 8.27767C4.57952 8.36582 4.53 8.48536 4.53 8.61001C4.53 8.73467 4.57952 8.85421 4.66766 8.94236C4.7558 9.0305 4.87535 9.08001 5 9.08001H11.1C11.2247 9.08001 11.3442 9.0305 11.4323 8.94236C11.5205 8.85421 11.57 8.73467 11.57 8.61001C11.57 8.48536 11.5205 8.36582 11.4323 8.27767C11.3442 8.18953 11.2247 8.14001 11.1 8.14001ZM5 11H15.45C15.5826 11 15.7098 10.9473 15.8036 10.8536C15.8973 10.7598 15.95 10.6326 15.95 10.5C15.95 10.3674 15.8973 10.2402 15.8036 10.1464C15.7098 10.0527 15.5826 10 15.45 10H5C4.86739 10 4.74021 10.0527 4.64645 10.1464C4.55268 10.2402 4.5 10.3674 4.5 10.5C4.5 10.6326 4.55268 10.7598 4.64645 10.8536C4.74021 10.9473 4.86739 11 5 11ZM5 12.86H11.1C11.2211 12.8523 11.3346 12.798 11.4166 12.7085C11.4986 12.6191 11.5428 12.5013 11.54 12.38C11.5427 12.2597 11.4982 12.1431 11.4159 12.0552C11.3337 11.9673 11.2202 11.9152 11.1 11.91H5C4.94089 11.9126 4.88286 11.9268 4.82924 11.9518C4.77562 11.9768 4.72746 12.0122 4.68752 12.0558C4.64758 12.0995 4.61664 12.1506 4.59648 12.2062C4.57631 12.2618 4.56731 12.3209 4.57 12.38C4.56451 12.5004 4.60649 12.6181 4.6869 12.7079C4.76731 12.7976 4.87974 12.8523 5 12.86ZM11.1 16.63H5C4.87535 16.63 4.7558 16.5805 4.66766 16.4923C4.57952 16.4042 4.53 16.2846 4.53 16.16C4.53 16.0353 4.57952 15.9158 4.66766 15.8276C4.7558 15.7395 4.87535 15.69 5 15.69H11.1C11.2247 15.69 11.3442 15.7395 11.4323 15.8276C11.5205 15.9158 11.57 16.0353 11.57 16.16C11.57 16.2846 11.5205 16.4042 11.4323 16.4923C11.3442 16.5805 11.2247 16.63 11.1 16.63ZM18.8503 11.592C18.7991 11.6175 18.7545 11.6544 18.72 11.7L18.26 12.14C18.2501 12.151 18.2447 12.1652 18.2447 12.18C18.2447 12.1947 18.2501 12.209 18.26 12.22L19.37 13.32C19.381 13.3298 19.3952 13.3353 19.41 13.3353C19.4247 13.3353 19.439 13.3298 19.45 13.32L19.86 12.91C19.9057 12.867 19.9421 12.8151 19.967 12.7575C19.9919 12.6998 20.0047 12.6377 20.0047 12.575C20.0047 12.5122 19.9919 12.4501 19.967 12.3925C19.9421 12.3349 19.9057 12.283 19.86 12.24L19.31 11.7C19.2755 11.6544 19.2309 11.6175 19.1797 11.592C19.1285 11.5666 19.0721 11.5533 19.015 11.5533C18.9578 11.5533 18.9014 11.5666 18.8503 11.592Z',
    showTrackChanges: 'M17.2421 13.6048C17.2631 13.6136 17.2841 13.6226 17.305 13.6317V9.29505H13.2626C13.1897 9.30481 13.1159 9.30481 13.043 9.29505C12.7532 9.21632 12.4953 9.04872 12.3056 8.81577C12.1158 8.58283 12.0037 8.29625 11.985 7.99627V4H4.12976C4.09534 4 4.06234 4.01368 4.038 4.03804C4.01367 4.0624 4 4.09543 4 4.12988V19.8552C4 19.8896 4.01367 19.9227 4.038 19.947C4.06234 19.9714 4.09534 19.9851 4.12976 19.9851H13.4875C13.0501 19.8216 12.6281 19.6155 12.2277 19.3686C11.8529 19.1551 11.4911 18.9196 11.1442 18.6632C11.0697 18.6152 10.9982 18.5628 10.9302 18.5065H4.99812C4.87371 18.5065 4.75438 18.457 4.66641 18.3689C4.57843 18.2809 4.529 18.1614 4.529 18.0369C4.529 17.9124 4.57843 17.7929 4.66641 17.7049C4.75438 17.6168 4.87371 17.5673 4.99812 17.5673H10.4396C10.4472 17.4488 10.4756 17.3324 10.5235 17.2235C10.5939 17.017 10.6761 16.8149 10.7694 16.6182H4.99812C4.87371 16.6182 4.75438 16.5687 4.66641 16.4807C4.57843 16.3926 4.529 16.2732 4.529 16.1487C4.529 16.0241 4.57843 15.9047 4.66641 15.8166C4.75438 15.7286 4.87371 15.6791 4.99812 15.6791H11.0867C11.1576 15.6791 11.2268 15.6952 11.2895 15.7253C11.5204 15.361 11.7938 15.027 12.1033 14.73H4.99812C4.87371 14.73 4.75438 14.6805 4.66641 14.5924C4.57843 14.5044 4.529 14.385 4.529 14.2604C4.529 14.1359 4.57843 14.0164 4.66641 13.9284C4.75438 13.8403 4.87371 13.7909 4.99812 13.7909H13.4434C13.9833 13.525 14.5656 13.3516 15.166 13.2795L15.1923 13.2763H15.2189H15.4925C16.0923 13.2609 16.6886 13.3728 17.2421 13.6048ZM13.0829 4.64939L16.5764 8.14613C16.5975 8.16843 16.6118 8.19636 16.6174 8.22657C16.6231 8.25677 16.62 8.28798 16.6084 8.31645C16.5968 8.34492 16.5773 8.36944 16.5521 8.38707C16.527 8.40471 16.4973 8.41471 16.4666 8.41587H13.043L12.8134 8.18609V4.75929C12.8146 4.72857 12.8246 4.69884 12.8422 4.67366C12.8598 4.64849 12.8843 4.62893 12.9128 4.61733C12.9412 4.60573 12.9724 4.60259 13.0026 4.60827C13.0328 4.61396 13.0607 4.62824 13.0829 4.64939ZM10.9869 6.71746C10.9896 6.65841 10.9806 6.59941 10.9604 6.54383C10.9403 6.48825 10.9094 6.4372 10.8696 6.39358C10.8297 6.34997 10.7816 6.31465 10.7281 6.28965C10.6746 6.26466 10.6167 6.25047 10.5577 6.2479H4.99813C4.88074 6.25562 4.77106 6.30914 4.69267 6.39694C4.61428 6.48475 4.57343 6.59983 4.57891 6.71746C4.57343 6.83509 4.61428 6.95017 4.69267 7.03798C4.77106 7.12579 4.88074 7.1793 4.99813 7.18702H10.5876C10.7014 7.17444 10.8061 7.11882 10.8803 7.03154C10.9545 6.94427 10.9927 6.83192 10.9869 6.71746ZM11.0867 8.13614H4.99812C4.87371 8.13614 4.75438 8.18561 4.66641 8.27367C4.57843 8.36173 4.529 8.48116 4.529 8.6057C4.529 8.73023 4.57843 8.84967 4.66641 8.93773C4.75438 9.02579 4.87371 9.07526 4.99812 9.07526H11.0867C11.2111 9.07526 11.3304 9.02579 11.4184 8.93773C11.5064 8.84967 11.5558 8.73023 11.5558 8.6057C11.5558 8.48116 11.5064 8.36173 11.4184 8.27367C11.3304 8.18561 11.2111 8.13614 11.0867 8.13614ZM4.99812 10.9935H15.4285C15.5609 10.9935 15.6878 10.9408 15.7814 10.8472C15.875 10.7535 15.9276 10.6264 15.9276 10.4939C15.9276 10.3614 15.875 10.2344 15.7814 10.1407C15.6878 10.047 15.5609 9.9944 15.4285 9.9944H4.99812C4.86576 9.9944 4.73883 10.047 4.64523 10.1407C4.55164 10.2344 4.49906 10.3614 4.49906 10.4939C4.49906 10.6264 4.55164 10.7535 4.64523 10.8472C4.73883 10.9408 4.86576 10.9935 4.99812 10.9935ZM4.99812 12.8517H11.0867C11.2076 12.844 11.3208 12.7898 11.4027 12.7004C11.4845 12.611 11.5287 12.4934 11.5259 12.3722C11.5286 12.252 11.4841 12.1355 11.402 12.0477C11.3199 11.9599 11.2067 11.9078 11.0867 11.9026H4.99812C4.93912 11.9052 4.8812 11.9194 4.82769 11.9444C4.77417 11.9694 4.7261 12.0047 4.68623 12.0483C4.64637 12.0919 4.61549 12.143 4.59536 12.1985C4.57523 12.2541 4.56625 12.3131 4.56893 12.3722C4.56345 12.4925 4.60535 12.6101 4.68561 12.6998C4.76587 12.7894 4.87809 12.844 4.99812 12.8517ZM19.97 17.4974C19.5787 16.5636 19.0431 15.6971 18.383 14.9298C18.0152 14.5351 17.5679 14.2233 17.0706 14.0148C16.5732 13.8064 16.0373 13.7062 15.4984 13.7209H15.2189C14.4787 13.8098 13.7684 14.0666 13.1423 14.4717C12.5162 14.8769 11.9906 15.4196 11.6057 16.0587C11.3211 16.4677 11.0959 16.9151 10.937 17.3875C10.9006 17.464 10.8817 17.5476 10.8817 17.6323C10.8817 17.717 10.9006 17.8006 10.937 17.877C11.0642 18.0428 11.2196 18.1849 11.3961 18.2967C11.7346 18.5476 12.0879 18.7778 12.4541 18.986C13.4096 19.5767 14.497 19.92 15.6182 19.9851C16.4392 20.0504 17.2632 19.9005 18.0088 19.5501C18.7544 19.1998 19.3959 18.661 19.8702 17.9869C19.9311 17.923 19.9729 17.8432 19.9905 17.7566C20.0082 17.67 20.0011 17.5801 19.97 17.4974ZM15.9775 19.1758C14.3849 19.068 12.8507 18.5331 11.5358 17.6273C11.5788 17.5678 11.6255 17.5111 11.6756 17.4574C12.3061 16.569 13.1295 15.8359 14.0832 15.3126C13.8003 15.7406 13.6785 16.2566 13.7417 16.7681C13.7676 17.0339 13.8465 17.2918 13.9737 17.5265C14.1009 17.7613 14.2739 17.9681 14.4823 18.1348C14.6907 18.3016 14.9304 18.4248 15.1872 18.4972C15.4441 18.5696 15.7128 18.5897 15.9775 18.5564C16.305 18.4971 16.6137 18.3609 16.8785 18.159C17.1432 17.9572 17.3564 17.6954 17.5005 17.3951C17.6446 17.0949 17.7156 16.7647 17.7077 16.4317C17.6997 16.0987 17.613 15.7723 17.4547 15.4793C17.2614 15.3391 17.0533 15.2235 16.8351 15.1339C17.0715 15.226 17.2966 15.3485 17.5046 15.4993C18.0049 15.8976 18.4424 16.3691 18.8022 16.898L18.8927 17.0137L18.8927 17.0137C19.0823 17.2564 19.2729 17.5004 19.4709 17.7072C18.5404 18.6311 17.288 19.1576 15.9775 19.1758ZM16.3168 15.769C16.2085 15.8106 16.1171 15.8873 16.0574 15.9869C15.9977 16.0865 15.9731 16.2032 15.9875 16.3185C15.9949 16.3856 16.0156 16.4505 16.0483 16.5096C16.081 16.5686 16.1251 16.6206 16.178 16.6624C16.2309 16.7042 16.2916 16.7351 16.3566 16.7532C16.4216 16.7714 16.4895 16.7764 16.5564 16.7681H16.6063C16.5618 16.9495 16.4637 17.1132 16.3248 17.238C16.186 17.3627 16.0127 17.4427 15.8278 17.4674H15.6481C15.4335 17.4396 15.2337 17.3427 15.0789 17.1913C14.924 17.04 14.8226 16.8423 14.7897 16.6282C14.7628 16.3782 14.8311 16.1271 14.981 15.9253C15.1305 15.7238 15.3504 15.5861 15.5968 15.5395C15.3446 15.5862 15.12 15.7284 14.9697 15.9364C14.8191 16.1448 14.7547 16.4034 14.7897 16.6582C14.8226 16.8723 14.924 17.0699 15.0789 17.2213C15.2337 17.3727 15.4335 17.4696 15.6481 17.4974H15.8377C16.0209 17.4708 16.1919 17.39 16.3289 17.2654C16.4658 17.1408 16.5625 16.978 16.6063 16.7981C16.7293 16.7633 16.8359 16.686 16.9072 16.5799C16.9785 16.4737 17.0098 16.3457 16.9956 16.2186C16.9882 16.1515 16.9675 16.0865 16.9348 16.0275C16.9021 15.9685 16.858 15.9165 16.805 15.8747C16.7521 15.8329 16.6914 15.802 16.6264 15.7838C16.5615 15.7657 16.4936 15.7607 16.4266 15.769H16.3168Z',
    acceptAllChanges: 'M9.36499 16.7348C9.38499 16.7547 9.41212 16.7659 9.44041 16.7659H10.9881C10.9028 16.6008 10.9289 16.3933 11.0663 16.2541L11.7266 15.585H10.1444C10.0549 15.5701 9.97363 15.5238 9.91498 15.4547C9.85639 15.3856 9.82422 15.298 9.82422 15.2074C9.82422 15.1169 9.85639 15.0292 9.91498 14.9601C9.97363 14.891 10.0549 14.8448 10.1444 14.8298H12.4879C12.5584 14.785 12.6407 14.7607 12.7257 14.7607C12.8106 14.7607 12.893 14.785 12.9635 14.8298H16.5295L18.3303 13.0091C18.4135 12.925 18.5271 12.8776 18.6456 12.8777C18.7642 12.8777 18.8777 12.9252 18.9609 13.0094L20 14.0621V8.25532H16.8001C16.7301 8.27288 16.6568 8.27288 16.5868 8.25532C16.3485 8.1935 16.1367 8.0565 15.9829 7.86478C15.8292 7.67306 15.7416 7.43688 15.7335 7.19149V4H9.44041C9.41293 4.0024 9.38718 4.01437 9.36767 4.03383C9.34816 4.05329 9.33615 4.07897 9.33375 4.10638V16.6596C9.33375 16.6878 9.34499 16.7148 9.36499 16.7348ZM10.0744 17.2979H11.4803L12.259 18.0957H5.06727C5.01734 18.0957 4.96838 18.1057 4.9232 18.1246C4.8788 18.1431 4.83798 18.1702 4.80335 18.2048C4.7333 18.2746 4.69398 18.3693 4.69398 18.468C4.69398 18.5668 4.7333 18.6615 4.80335 18.7313C4.87333 18.8011 4.96832 18.8404 5.06727 18.8404H12.9857L13.7947 19.6693L14.0836 19.9574H4.10733C4.09291 19.9591 4.07829 19.9576 4.06457 19.9528C4.05085 19.9481 4.03838 19.9403 4.02812 19.9301C4.01785 19.9198 4.01004 19.9074 4.00529 19.8937C4.00054 19.88 3.99896 19.8654 4.00067 19.8511V7.29787C4.00067 7.26966 4.01191 7.2426 4.03191 7.22265C4.05192 7.2027 4.07905 7.19149 4.10733 7.19149H8.70447V9.05319H5.06727C4.97294 9.05867 4.88453 9.10069 4.8208 9.17019C4.757 9.23973 4.72302 9.33135 4.72594 9.42553C4.72289 9.52082 4.75654 9.61364 4.82002 9.6849C4.88356 9.75613 4.97203 9.80038 5.06727 9.8085H8.70447V10.5638H5.06727C5.01968 10.5652 4.97274 10.5759 4.92932 10.5954C4.88583 10.6148 4.84664 10.6426 4.8139 10.6772C4.78122 10.7118 4.7557 10.7525 4.73877 10.7969C4.72184 10.8413 4.7139 10.8887 4.71527 10.9361C4.7139 10.9837 4.72184 11.031 4.73877 11.0754C4.74424 11.0897 4.75055 11.1037 4.75778 11.1171C4.76162 11.1243 4.76566 11.1313 4.76995 11.1382C4.78265 11.1585 4.79736 11.1776 4.8139 11.1951C4.84664 11.2297 4.88583 11.2575 4.92932 11.2769C4.95491 11.2884 4.98173 11.2968 5.0092 11.3021C5.02834 11.3058 5.04774 11.3079 5.06727 11.3085H8.70447V12.0638H5.06734C4.97782 12.0789 4.89651 12.1251 4.83792 12.1942C4.77926 12.2633 4.7471 12.351 4.7471 12.4415C4.7471 12.5321 4.77926 12.6197 4.83792 12.6888C4.89651 12.758 4.97782 12.8041 5.06734 12.8192H8.70447V13.5745H5.06734C4.97782 13.5895 4.89651 13.6357 4.83792 13.7048C4.81383 13.7332 4.79424 13.7647 4.77946 13.7983C4.7583 13.8465 4.7471 13.8988 4.7471 13.9522C4.7471 14.0427 4.77926 14.1303 4.83792 14.1994C4.89651 14.2686 4.97782 14.3147 5.06734 14.3298H8.70447V15.0744H5.06727C4.97776 15.0895 4.89651 15.1357 4.83785 15.2048C4.77926 15.2739 4.7471 15.3616 4.7471 15.4521C4.7471 15.5043 4.75778 15.5556 4.77809 15.6029C4.793 15.6376 4.81305 15.6701 4.83785 15.6994C4.89651 15.7685 4.97776 15.8147 5.06727 15.8298H8.70447V16.5851H5.06727C4.97776 16.6001 4.89651 16.6463 4.83785 16.7154C4.79489 16.7661 4.76618 16.8267 4.75387 16.8912C4.74938 16.9146 4.7471 16.9386 4.7471 16.9628C4.7471 17.0533 4.77926 17.1409 4.83785 17.21C4.89651 17.2792 4.97776 17.3253 5.06727 17.3404H9.95241C9.99552 17.3331 10.0367 17.3187 10.0744 17.2979ZM20 15.3204L18.5709 16.7659H19.8933C19.9216 16.7659 19.9487 16.7547 19.9687 16.7348C19.9887 16.7148 20 16.6878 20 16.6596V15.3204ZM14.7526 16.6264L13.7248 15.585H15.7825L14.7526 16.6264ZM14.9498 6.08721C14.9465 6.06854 14.9416 6.05023 14.9353 6.03244C14.9202 5.98939 14.897 5.94929 14.8665 5.91442C14.8145 5.85488 14.7444 5.81394 14.6669 5.79787H10.1337C10.0348 5.79787 9.93978 5.83709 9.8698 5.90693C9.79975 5.97676 9.76043 6.07146 9.76043 6.17022C9.76043 6.19463 9.76283 6.21879 9.76752 6.24239C9.77462 6.2782 9.78692 6.31268 9.80398 6.34479C9.82123 6.37716 9.8433 6.40709 9.8698 6.43348C9.93978 6.50332 10.0348 6.54257 10.1337 6.54257H14.6669C14.6811 6.54023 14.6951 6.53702 14.7088 6.53299C14.7206 6.52955 14.7322 6.52549 14.7436 6.52082C14.7624 6.51309 14.7806 6.50371 14.7979 6.4928C14.8378 6.46764 14.8722 6.43468 14.8991 6.39599C14.9259 6.35729 14.9447 6.31359 14.9543 6.26749C14.9554 6.26232 14.9563 6.25716 14.9571 6.25197C14.9579 6.24739 14.9586 6.24281 14.9591 6.23824C14.9612 6.22129 14.962 6.20424 14.9616 6.18723C14.961 6.16727 14.9588 6.14733 14.9549 6.12766C14.9539 6.11406 14.9523 6.10055 14.9498 6.08721ZM15.0189 7.29788H10.1445C10.0549 7.31291 9.97363 7.35911 9.91504 7.42823C9.85639 7.49738 9.82422 7.585 9.82422 7.67555C9.82422 7.76609 9.85639 7.85369 9.91504 7.92284C9.97363 7.99196 10.0549 8.03815 10.1445 8.05319H15.0189C15.0321 8.05241 15.0451 8.05095 15.058 8.04877C15.0745 8.04601 15.0906 8.04212 15.1064 8.03718C15.1669 8.01822 15.2219 7.98361 15.2654 7.93618C15.3291 7.86664 15.3632 7.77502 15.3602 7.68084C15.3606 7.67392 15.3608 7.66701 15.3608 7.66009C15.3609 7.65087 15.3606 7.64165 15.3599 7.63247C15.3592 7.62263 15.358 7.61279 15.3565 7.60302C15.3532 7.58188 15.3479 7.56104 15.3409 7.54072C15.3254 7.49575 15.301 7.45426 15.2693 7.41868C15.2492 7.39621 15.2265 7.37638 15.2017 7.35959C15.1872 7.34979 15.172 7.34102 15.1562 7.33339C15.1132 7.31265 15.0665 7.3006 15.0189 7.29788ZM10.1445 9.56381H18.496C18.5856 9.54877 18.6669 9.50258 18.7255 9.43346C18.7841 9.3643 18.8163 9.27671 18.8163 9.18617C18.8163 9.09562 18.7841 9.008 18.7255 8.93884C18.6669 8.86973 18.5856 8.82353 18.496 8.8085H10.1445C10.0549 8.82353 9.97363 8.86973 9.91504 8.93884C9.85639 9.008 9.82422 9.09562 9.82422 9.18617C9.82422 9.24412 9.83738 9.30087 9.86224 9.35236C9.87624 9.38132 9.89395 9.40859 9.91504 9.43346C9.97363 9.50258 10.0549 9.54877 10.1445 9.56381ZM10.1445 11.0638H15.0189C15.1084 11.0488 15.1897 11.0026 15.2483 10.9335C15.2854 10.8898 15.3118 10.8387 15.3263 10.7842C15.3347 10.7525 15.3391 10.7195 15.3391 10.6861C15.3391 10.5956 15.3069 10.508 15.2483 10.4389C15.1897 10.3697 15.1084 10.3235 15.0189 10.3085H10.1445C10.0549 10.3235 9.97363 10.3697 9.91504 10.4389C9.85639 10.508 9.82422 10.5956 9.82422 10.6861C9.82422 10.7424 9.83666 10.7976 9.8601 10.8478C9.87442 10.8785 9.89284 10.9073 9.91504 10.9335C9.97363 11.0026 10.0549 11.0488 10.1445 11.0638ZM18.496 12.5745H10.1444C10.0549 12.5594 9.97363 12.5132 9.91498 12.4441C9.85639 12.3749 9.82422 12.2873 9.82422 12.1968C9.82422 12.1062 9.85639 12.0186 9.91498 11.9495C9.97363 11.8803 10.0549 11.8342 10.1444 11.8191H18.496C18.5856 11.8342 18.6669 11.8803 18.7255 11.9495C18.7841 12.0186 18.8163 12.1062 18.8163 12.1968C18.8163 12.2873 18.7841 12.3749 18.7255 12.4441C18.6971 12.4776 18.6633 12.5058 18.6259 12.5276C18.5861 12.5507 18.5421 12.5667 18.496 12.5745ZM15.0189 14.0744H10.1444C10.0968 14.0731 10.0499 14.0624 10.0064 14.0429C9.96296 14.0234 9.92376 13.9956 9.89102 13.961C9.85834 13.9265 9.83282 13.8857 9.81589 13.8413C9.79897 13.7969 9.79102 13.7496 9.79239 13.7021C9.79102 13.6546 9.79897 13.6073 9.81589 13.5628C9.83282 13.5184 9.85834 13.4778 9.89102 13.4432C9.92376 13.4086 9.96296 13.3808 10.0064 13.3613C10.0499 13.3419 10.0968 13.3311 10.1444 13.3297H15.0189C15.0661 13.3311 15.1125 13.3419 15.1554 13.3615C15.1983 13.381 15.2368 13.4091 15.2686 13.4438C15.3005 13.4785 15.325 13.5193 15.3407 13.5637C15.3564 13.608 15.363 13.6551 15.3602 13.7021C15.3631 13.7963 15.3291 13.8879 15.2653 13.9574C15.2016 14.027 15.1132 14.0689 15.0189 14.0744ZM16.6188 4.52128L19.4133 7.30852C19.4293 7.32624 19.4401 7.34808 19.4443 7.37157C19.4485 7.39506 19.446 7.41925 19.4371 7.4414C19.4282 7.46356 19.4133 7.48278 19.394 7.4969C19.3747 7.51102 19.3518 7.51947 19.328 7.52128H16.5868L16.4054 7.34043V4.60639C16.4073 4.5826 16.4157 4.55979 16.4299 4.54056C16.444 4.52133 16.4633 4.50644 16.4855 4.49757C16.5077 4.48871 16.532 4.48624 16.5556 4.49043C16.5791 4.49462 16.601 4.50531 16.6188 4.52128ZM18.6454 13.3192L20 14.6915L14.7522 20L14.7416 19.9894L14.1123 19.3617L13.3976 18.6277L11.3817 16.5638L12.7257 15.2021L14.7522 17.2553L18.6454 13.3192Z',
    rejectAllChanges: 'M9.54637 16.5847H8.96997V15.8295H12.786C12.8024 15.8265 12.8186 15.8223 12.8343 15.817C12.8535 15.8105 12.8719 15.8023 12.8897 15.7926C12.9315 15.7697 12.969 15.738 12.9997 15.6991C13.0268 15.6649 13.0478 15.6261 13.0621 15.5847H13.571V16.7656H9.79386C9.78396 16.7479 9.77269 16.731 9.76011 16.7151C9.70552 16.6459 9.62976 16.5998 9.54637 16.5847ZM13.4717 12.9573V13.3295H9.72523C9.6809 13.3309 9.63716 13.3416 9.59671 13.361C9.57578 13.3711 9.55595 13.3834 9.53745 13.3977C9.5201 13.411 9.50391 13.4262 9.48917 13.4429C9.45872 13.4775 9.43494 13.5182 9.41917 13.5626C9.41778 13.5664 9.41644 13.5703 9.41523 13.5742H8.96997V12.8189H12.786C12.8694 12.8039 12.9452 12.7577 12.9997 12.6886C13.0078 12.6784 13.0153 12.6677 13.0223 12.6568L13.029 12.6458L13.033 12.6389L13.0397 12.6266C13.0452 12.6157 13.0503 12.6046 13.055 12.5931C13.0576 12.5869 13.0599 12.5806 13.0621 12.5742H13.6872C13.6453 12.5965 13.607 12.6269 13.5746 12.6644C13.5059 12.7439 13.469 12.849 13.4717 12.9573ZM9.82598 14.0742H13.4758C13.4809 14.0932 13.4904 14.1108 13.5037 14.1251C13.5242 14.147 13.552 14.1593 13.581 14.1593H13.6008L13.571 14.1912V14.8295H9.72523C9.64183 14.8445 9.56614 14.8907 9.51149 14.9598C9.4845 14.994 9.46351 15.0328 9.4492 15.0741H8.96997V14.3295H9.54637C9.62976 14.3145 9.70552 14.2683 9.76011 14.1992C9.78947 14.162 9.81166 14.1195 9.82598 14.0742ZM18.9075 8.2552V12.5317H17.7846V12.323C17.7978 12.2827 17.8047 12.2399 17.8047 12.1965C17.8047 12.106 17.7747 12.0184 17.7201 11.9493C17.6655 11.8801 17.5897 11.834 17.5063 11.8189H9.72523C9.64183 11.834 9.56614 11.8801 9.51149 11.9493C9.48444 11.9835 9.46351 12.0222 9.4492 12.0636H8.96997V11.3083H9.54637C9.63425 11.3028 9.71662 11.2608 9.776 11.1913C9.80687 11.1551 9.83029 11.113 9.84527 11.0676L9.84654 11.0637H14.2667C14.3501 11.0486 14.4258 11.0024 14.4805 10.9333C14.5231 10.8794 14.5507 10.8142 14.5607 10.7452C14.5636 10.7258 14.565 10.706 14.565 10.686C14.565 10.6658 14.5635 10.6458 14.5606 10.626C14.5572 10.6026 14.5516 10.5796 14.5442 10.5573C14.5299 10.5144 14.5084 10.4741 14.4805 10.4387C14.4258 10.3696 14.3501 10.3234 14.2667 10.3083H9.72529C9.6832 10.3159 9.64299 10.3314 9.60653 10.3538C9.57081 10.3759 9.5386 10.4045 9.51155 10.4387C9.49639 10.4579 9.4831 10.4785 9.47182 10.5002C9.46133 10.5205 9.45259 10.5417 9.44568 10.5636H8.96997V9.80838H9.16873C9.25656 9.80286 9.33899 9.76085 9.39837 9.69131C9.45775 9.62177 9.48947 9.53022 9.48674 9.43601C9.48711 9.42951 9.48735 9.42302 9.48741 9.41653C9.48741 9.41049 9.48729 9.40445 9.48705 9.39848C9.49457 9.41055 9.50269 9.42218 9.51155 9.43334C9.56614 9.50249 9.64189 9.54866 9.72529 9.56372H17.5063C17.5897 9.54866 17.6655 9.50249 17.7201 9.43334C17.7747 9.36419 17.8047 9.2766 17.8047 9.18603C17.8047 9.09552 17.7747 9.00786 17.7201 8.93878C17.6655 8.86963 17.5897 8.82346 17.5063 8.8084H9.72529C9.64189 8.82346 9.56614 8.86963 9.51155 8.93878C9.4569 9.00786 9.42694 9.09552 9.42694 9.18603L9.427 9.19707L9.42754 9.20875C9.41972 9.19661 9.41123 9.18499 9.40201 9.17389C9.38478 9.15311 9.36537 9.1346 9.34427 9.11863C9.33735 9.11344 9.33026 9.1085 9.32298 9.10383C9.31855 9.10097 9.31406 9.09824 9.30951 9.09565L9.30424 9.09266L9.29659 9.08857C9.28792 9.08402 9.27906 9.07993 9.27009 9.07623C9.2616 9.07279 9.25298 9.06974 9.24431 9.06701C9.21974 9.05935 9.19439 9.05461 9.16873 9.05305H8.96997V4.10638C8.97221 4.07897 8.9834 4.05328 9.00157 4.03383C9.01975 4.01437 9.04374 4.0024 9.06935 4H14.9325V7.1914C14.9401 7.43679 15.0216 7.67296 15.1649 7.86468C15.3082 8.0564 15.5055 8.19338 15.7275 8.2552C15.7927 8.27277 15.861 8.27277 15.9262 8.2552H18.9075ZM13.571 17.2975V19.4251L13.5722 19.4615C13.5835 19.6376 13.6323 19.8068 13.7133 19.957H4.10061C4.08718 19.9587 4.07355 19.9571 4.06077 19.9524C4.04799 19.9477 4.03637 19.9399 4.02681 19.9296C4.01724 19.9194 4.00997 19.907 4.00554 19.8933C4.00111 19.8796 3.99964 19.865 4.00124 19.8506V7.29778C4.00124 7.26957 4.01171 7.24251 4.03034 7.22256C4.04898 7.20261 4.07426 7.1914 4.10061 7.1914H8.38368V9.05305H4.99497C4.90708 9.05857 4.82471 9.10052 4.76533 9.17006C4.70589 9.2396 4.67423 9.33121 4.67696 9.42536C4.67411 9.52067 4.70547 9.61346 4.76461 9.68475C4.8238 9.75598 4.90623 9.80026 4.99497 9.80838H8.38368V10.5636H4.99497C4.96682 10.5645 4.93898 10.5692 4.91199 10.5774C4.89647 10.5821 4.88124 10.588 4.86644 10.5952C4.8494 10.6034 4.83308 10.613 4.81762 10.6241C4.79627 10.6393 4.77655 10.657 4.7589 10.6771C4.72846 10.7116 4.70468 10.7523 4.68891 10.7967C4.67314 10.8411 4.66574 10.8885 4.66701 10.9359C4.66641 10.9597 4.66792 10.9834 4.67156 11.0067C4.6752 11.03 4.68102 11.053 4.68891 11.0752C4.70468 11.1196 4.72846 11.1603 4.7589 11.1949C4.7731 11.211 4.78862 11.2256 4.80524 11.2386C4.81452 11.2459 4.82417 11.2527 4.83417 11.259C4.84461 11.2655 4.85534 11.2714 4.86644 11.2767C4.9069 11.2962 4.95063 11.3069 4.99497 11.3083H8.38368V12.0636H4.99503C4.91163 12.0787 4.83587 12.1249 4.78128 12.194C4.7526 12.2303 4.7307 12.2717 4.71639 12.3159C4.70347 12.3559 4.69667 12.3983 4.69667 12.4413C4.69667 12.5318 4.72664 12.6194 4.78128 12.6886C4.809 12.7237 4.84218 12.7529 4.87906 12.7751C4.89416 12.7842 4.90993 12.7921 4.92619 12.7988C4.94833 12.8079 4.97137 12.8147 4.99503 12.8189H8.38368V13.5742H4.99503C4.95275 13.5819 4.91242 13.5975 4.87584 13.62C4.8403 13.642 4.80822 13.6705 4.78128 13.7046C4.72664 13.7737 4.69667 13.8613 4.69667 13.9519C4.69667 14.0424 4.72664 14.13 4.78128 14.1992C4.83587 14.2683 4.91163 14.3145 4.99503 14.3295H8.38368V15.0741H4.99497C4.94644 15.0829 4.90047 15.1022 4.85977 15.1304C4.83878 15.145 4.81919 15.162 4.80136 15.1811C4.79439 15.1885 4.78765 15.1964 4.78122 15.2045C4.77188 15.2163 4.76327 15.2287 4.75539 15.2416C4.74441 15.2594 4.73495 15.2781 4.727 15.2975C4.71924 15.3163 4.71293 15.3358 4.70808 15.3558C4.70407 15.3723 4.7011 15.389 4.69922 15.4061C4.69752 15.4212 4.69667 15.4364 4.69667 15.4518C4.69667 15.5423 4.72664 15.6299 4.78122 15.6991C4.83587 15.7682 4.91157 15.8144 4.99497 15.8295H8.38368V16.5847H4.99497C4.91157 16.5998 4.83587 16.6459 4.78122 16.7151C4.72664 16.7842 4.69667 16.8718 4.69667 16.9624C4.69667 17.0529 4.72664 17.1405 4.78122 17.2097C4.83587 17.2788 4.91157 17.325 4.99497 17.34H9.54637C9.58655 17.3328 9.62496 17.3183 9.66008 17.2975H13.571ZM15.7573 4.52124L18.3609 7.30839C18.3758 7.32612 18.3858 7.34796 18.3897 7.37145C18.3937 7.39493 18.3914 7.41913 18.3831 7.44128C18.3748 7.46343 18.3609 7.48266 18.3429 7.49678C18.325 7.51089 18.3036 7.51934 18.2814 7.52115H15.7275L15.5585 7.34031V4.60634C15.5602 4.58255 15.5681 4.55975 15.5813 4.54051C15.5945 4.52128 15.6125 4.50639 15.6332 4.49753C15.6539 4.48867 15.6765 4.48619 15.6984 4.49038C15.7203 4.49457 15.7407 4.50526 15.7573 4.52124ZM14.1248 5.91437C14.1732 5.97391 14.2021 6.04884 14.2071 6.1276C14.2157 6.17377 14.2155 6.22129 14.2065 6.26739C14.2045 6.27778 14.2021 6.28804 14.1992 6.29817L14.1944 6.31388C14.1847 6.34291 14.1715 6.3705 14.1551 6.39595C14.13 6.43465 14.098 6.46757 14.0608 6.49276C14.0354 6.5099 14.008 6.52328 13.9794 6.53244C13.9661 6.53672 13.9525 6.5401 13.9387 6.5425H9.71529C9.62309 6.5425 9.5346 6.50328 9.4694 6.43342C9.40413 6.36362 9.3675 6.26889 9.3675 6.17013C9.3675 6.07144 9.40413 5.97671 9.4694 5.90691C9.5346 5.83704 9.62309 5.79783 9.71529 5.79783H13.9387C13.9718 5.80516 14.0034 5.81769 14.0326 5.83484C14.0672 5.85522 14.0984 5.88204 14.1248 5.91437ZM14.2667 7.29776H9.72529C9.69606 7.30302 9.66773 7.31211 9.64092 7.3247C9.62612 7.33171 9.61175 7.33977 9.59798 7.34879C9.56565 7.36996 9.53642 7.39664 9.51155 7.42813C9.4569 7.49722 9.42694 7.58487 9.42694 7.67538C9.42694 7.70155 9.42942 7.72752 9.43434 7.75285C9.44635 7.81505 9.47273 7.87355 9.51155 7.9227C9.55292 7.9751 9.60647 8.01432 9.66628 8.03678C9.67762 8.04107 9.6892 8.04477 9.70097 8.04775C9.70898 8.04983 9.71711 8.05158 9.72529 8.05308H14.2667C14.3546 8.04756 14.437 8.00555 14.4964 7.93601C14.5558 7.86647 14.5875 7.77492 14.5847 7.68071C14.5874 7.63318 14.5813 7.58559 14.5667 7.54059C14.5522 7.4956 14.5296 7.45417 14.5 7.41859C14.4704 7.38301 14.4346 7.35398 14.3946 7.33327C14.3546 7.31256 14.3111 7.30048 14.2667 7.29776ZM4.99497 18.84H12.786C12.8783 18.84 12.9667 18.8008 13.032 18.731C13.0972 18.6611 13.1338 18.5664 13.1338 18.4677C13.1338 18.3689 13.0972 18.2742 13.032 18.2044C12.9667 18.1346 12.8783 18.0954 12.786 18.0954H4.99497C4.90277 18.0954 4.81428 18.1346 4.74908 18.2044C4.68381 18.2742 4.64718 18.3689 4.64718 18.4677C4.64718 18.5664 4.68381 18.6611 4.74908 18.731C4.81428 18.8008 4.90277 18.84 4.99497 18.84ZM17.5858 12.7444H19.5733H19.623C19.7249 12.7499 19.821 12.7971 19.8913 12.8764C19.9616 12.9556 20.0007 13.0607 20.0006 13.17V13.8295C20.0007 13.8458 19.9976 13.862 19.9914 13.8769C19.9853 13.8918 19.9764 13.9052 19.9652 13.9163C19.9539 13.9273 19.9407 13.9357 19.9262 13.9409C19.9118 13.9461 19.8965 13.948 19.8814 13.9465H13.7797C13.7507 13.9465 13.7229 13.9342 13.7024 13.9123C13.6819 13.8903 13.6704 13.8606 13.6704 13.8295V13.17C13.6677 13.0617 13.7046 12.9566 13.7733 12.8771C13.842 12.7976 13.9371 12.75 14.0381 12.7444H16.0256V12.5104C16.0352 12.439 16.0687 12.3737 16.1199 12.3268C16.1711 12.2798 16.2365 12.2544 16.3039 12.2551H17.2976C17.3667 12.2517 17.4345 12.276 17.4878 12.3232C17.541 12.3704 17.576 12.4371 17.5858 12.5104V12.7444ZM14.0679 19.4251V14.1912H19.5037V19.4251C19.4935 19.585 19.4256 19.7344 19.3143 19.8416C19.203 19.9488 19.0571 20.0055 18.9075 19.9996H14.6642C14.5146 20.0055 14.3687 19.9488 14.2574 19.8416C14.1461 19.7344 14.0781 19.585 14.0679 19.4251ZM15.5983 15.1593H15.2505C15.0969 15.1593 14.9723 15.2926 14.9723 15.4572V18.7336C14.9723 18.8981 15.0969 19.0315 15.2505 19.0315H15.5983C15.752 19.0315 15.8766 18.8981 15.8766 18.7336V15.4572C15.8766 15.2926 15.752 15.1593 15.5983 15.1593ZM16.9598 15.1593H16.612C16.4583 15.1593 16.3337 15.2926 16.3337 15.4572V18.7336C16.3337 18.8981 16.4583 19.0315 16.612 19.0315H16.9598C17.1135 19.0315 17.238 18.8981 17.238 18.7336V15.4572C17.238 15.2926 17.1135 15.1593 16.9598 15.1593ZM17.9635 15.1593H18.3113C18.465 15.1593 18.5895 15.2926 18.5895 15.4572V18.7336C18.5895 18.8981 18.465 19.0315 18.3113 19.0315H17.9635C17.8098 19.0315 17.6852 18.8981 17.6852 18.7336V15.4572C17.6852 15.2926 17.8098 15.1593 17.9635 15.1593Z',
    acceptSingleChange: 'M17.2 20H15.6628L17.33 18.3091V19.87C17.33 19.8871 17.3266 19.904 17.3201 19.9197C17.3136 19.9355 17.304 19.9499 17.2919 19.9619C17.2799 19.974 17.2655 19.9836 17.2497 19.9901C17.234 19.9966 17.2171 20 17.2 20ZM4.13 20H14.4978L14.1823 19.6791L13.5135 18.9904L13.5123 18.9891L13.0529 18.52H5C4.87537 18.52 4.75586 18.4705 4.66766 18.3823C4.57953 18.2942 4.53003 18.1747 4.53003 18.05C4.53003 17.9253 4.57953 17.8058 4.66766 17.7177C4.75586 17.6295 4.87537 17.58 5 17.58H12.1323L11.6235 17.0604L11.6231 16.48L12.8831 15.19L13.4765 15.1896L15.0807 16.8276L17.33 14.5413V9.3H13.28C13.207 9.30976 13.133 9.30976 13.06 9.3C12.7697 9.22119 12.5113 9.05343 12.3212 8.82027C12.1311 8.58711 12.0187 8.30026 12 8V4H4.13C4.09552 4 4.06246 4.0137 4.03808 4.03808C4.0137 4.06246 4 4.09552 4 4.13V19.87C4 19.9045 4.0137 19.9375 4.03808 19.9619C4.06246 19.9863 4.09552 20 4.13 20ZM13.1 4.65L16.6 8.15C16.6212 8.17232 16.6355 8.20028 16.6412 8.23051C16.6469 8.26075 16.6437 8.29199 16.6321 8.32048C16.6205 8.34898 16.6009 8.37352 16.5757 8.39117C16.5505 8.40882 16.5208 8.41883 16.49 8.42H13.06L12.83 8.19V4.76C12.8312 4.72925 12.8412 4.6995 12.8588 4.67429C12.8765 4.64909 12.901 4.62951 12.9295 4.6179C12.958 4.6063 12.9893 4.60315 13.0195 4.60884C13.0497 4.61453 13.0777 4.62882 13.1 4.65ZM11 6.72C11.0027 6.66089 10.9937 6.60184 10.9735 6.5462C10.9534 6.49057 10.9224 6.43948 10.8825 6.39581C10.8425 6.35217 10.7944 6.3168 10.7408 6.29178C10.6871 6.26678 10.6292 6.25256 10.57 6.25H5C4.88239 6.25772 4.77252 6.31131 4.69397 6.39917C4.61542 6.48706 4.57452 6.60226 4.58002 6.72C4.57452 6.83774 4.61542 6.95294 4.69397 7.04083C4.77252 7.12869 4.88239 7.18228 5 7.19H10.6C10.7141 7.1774 10.8189 7.12173 10.8933 7.03436C10.9677 6.94702 11.0058 6.83456 11 6.72ZM11.1 8.14001H5C4.87537 8.14001 4.75586 8.18954 4.66766 8.27768C4.57953 8.36581 4.53003 8.48535 4.53003 8.61002C4.53003 8.73468 4.57953 8.85422 4.66766 8.94235C4.71558 8.99023 4.77277 9.02673 4.83496 9.05008C4.86932 9.06296 4.90521 9.07184 4.94189 9.07642C4.96106 9.0788 4.98047 9.08002 5 9.08002H11.1C11.2247 9.08002 11.3442 9.03049 11.4324 8.94235C11.5205 8.85422 11.57 8.73468 11.57 8.61002C11.57 8.48535 11.5205 8.36581 11.4324 8.27768C11.3442 8.18954 11.2247 8.14001 11.1 8.14001ZM5 11H15.45C15.5826 11 15.7098 10.9473 15.8035 10.8535C15.8973 10.7598 15.95 10.6326 15.95 10.5C15.95 10.3674 15.8973 10.2402 15.8035 10.1465C15.7098 10.0527 15.5826 10 15.45 10H5C4.86737 10 4.74023 10.0527 4.64642 10.1465C4.55267 10.2402 4.5 10.3674 4.5 10.5C4.5 10.6326 4.55267 10.7598 4.64642 10.8535C4.74023 10.9473 4.86737 11 5 11ZM5 12.86H11.1C11.2211 12.8523 11.3346 12.798 11.4166 12.7085C11.4986 12.6191 11.5428 12.5013 11.54 12.38C11.5427 12.2597 11.4982 12.1431 11.416 12.0552C11.3337 11.9673 11.2203 11.9152 11.1 11.91H5C4.94086 11.9126 4.88287 11.9268 4.82922 11.9518C4.77563 11.9768 4.72748 12.0122 4.6875 12.0558C4.65833 12.0878 4.63391 12.1237 4.61505 12.1624C4.60809 12.1767 4.60193 12.1913 4.5965 12.2062C4.58264 12.2443 4.5741 12.2841 4.57092 12.3243C4.56946 12.3428 4.56915 12.3614 4.57001 12.38C4.56451 12.5004 4.60651 12.6181 4.68689 12.7079C4.76733 12.7976 4.87976 12.8523 5 12.86ZM15.45 14.74H5C4.87537 14.74 4.75586 14.6905 4.66766 14.6023C4.57953 14.5142 4.53003 14.3947 4.53003 14.27C4.53003 14.1453 4.57953 14.0258 4.66766 13.9377C4.75586 13.8495 4.87537 13.8 5 13.8H15.45C15.5747 13.8 15.6942 13.8495 15.7823 13.9377C15.8705 14.0258 15.92 14.1453 15.92 14.27C15.92 14.3947 15.8705 14.5142 15.7823 14.6023C15.6942 14.6905 15.5747 14.74 15.45 14.74ZM11.1 16.63H5C4.87537 16.63 4.75586 16.5805 4.66766 16.4923C4.57953 16.4042 4.53003 16.2846 4.53003 16.16C4.53003 16.0353 4.57953 15.9158 4.66766 15.8276C4.75586 15.7395 4.87537 15.69 5 15.69H11.1C11.2247 15.69 11.3442 15.7395 11.4324 15.8276C11.5205 15.9158 11.57 16.0353 11.57 16.16C11.57 16.2846 11.5205 16.4042 11.4324 16.4923C11.3442 16.5805 11.2247 16.63 11.1 16.63ZM18.73 13.71L20 15.01L15.08 20L15.07 19.99L14.48 19.39L13.81 18.7L11.92 16.77L13.18 15.48L15.08 17.42L18.73 13.71Z',
    rejectSingleChange: 'M17.0495 11.5C17.1461 11.5 17.241 11.5173 17.33 11.5501V9.3H13.28C13.207 9.30976 13.133 9.30976 13.06 9.3C12.7697 9.22119 12.5113 9.05343 12.3212 8.82027C12.1311 8.58711 12.0187 8.30026 12 8V4H4.13C4.09552 4 4.06246 4.0137 4.03808 4.03808C4.0137 4.06246 4 4.09552 4 4.13V19.87C4 19.9045 4.0137 19.9375 4.03808 19.9619C4.06246 19.9863 4.09552 20 4.13 20H13.2305C13.1075 19.8287 13.0338 19.6249 13.0205 19.4112L13.0195 19.3956V18.52H5C4.87537 18.52 4.75586 18.4705 4.66772 18.3823C4.57959 18.2942 4.53003 18.1747 4.53003 18.05C4.53003 18.0119 4.53467 17.9742 4.54358 17.9378C4.56396 17.8552 4.60657 17.7788 4.66772 17.7177C4.75586 17.6295 4.87537 17.58 5 17.58H13.0195V14.74H5C4.87537 14.74 4.75586 14.6905 4.66772 14.6023C4.57959 14.5142 4.53003 14.3947 4.53003 14.27C4.53003 14.1453 4.57959 14.0258 4.66772 13.9377C4.75586 13.8495 4.87537 13.8 5 13.8H12.8393C12.6229 13.6377 12.4998 13.3897 12.4998 13.1032C12.4997 12.8414 12.6008 12.5847 12.7513 12.3911C12.9 12.1998 13.1561 12 13.4994 12L15.2519 12C15.2928 11.8972 15.3589 11.7915 15.4649 11.6992C15.6135 11.5698 15.8041 11.499 16.0011 11.5H17.0495ZM13.1 4.65L16.6 8.15C16.6211 8.17232 16.6354 8.20028 16.6411 8.23051C16.6468 8.26075 16.6437 8.29199 16.6321 8.32048C16.6204 8.34898 16.6009 8.37352 16.5757 8.39117C16.5505 8.40882 16.5207 8.41883 16.49 8.42H13.06L12.83 8.19V4.76C12.8311 4.72925 12.8411 4.6995 12.8588 4.67429C12.8764 4.64909 12.901 4.62951 12.9295 4.6179C12.958 4.6063 12.9892 4.60315 13.0194 4.60884C13.0497 4.61453 13.0776 4.62882 13.1 4.65ZM11 6.72C11.0027 6.66089 10.9937 6.60184 10.9735 6.5462C10.9716 6.5408 10.9695 6.53543 10.9673 6.53012C10.9626 6.51852 10.9575 6.50717 10.9518 6.49603C10.9406 6.47391 10.9275 6.45273 10.9127 6.43274C10.9033 6.41992 10.8932 6.40759 10.8824 6.39581C10.8425 6.35217 10.7943 6.3168 10.7407 6.29178C10.6871 6.26678 10.629 6.25256 10.5699 6.25H5C4.88232 6.25772 4.77246 6.31131 4.69397 6.39917C4.61536 6.48706 4.57446 6.60226 4.57996 6.72C4.57715 6.7811 4.58679 6.84152 4.60767 6.8978C4.61523 6.91803 4.62415 6.93771 4.63452 6.9567C4.65088 6.98669 4.67078 7.01495 4.69397 7.04083C4.77246 7.12869 4.88232 7.18228 5 7.19H10.6C10.714 7.1774 10.8188 7.12173 10.8932 7.03436C10.922 7.00049 10.9454 6.96283 10.9629 6.92273C10.9725 6.9006 10.9805 6.87775 10.9865 6.8544C10.9933 6.82791 10.9977 6.80075 10.9995 6.77325C11.0001 6.76453 11.0004 6.75574 11.0005 6.74695C11.0006 6.73798 11.0005 6.729 11 6.72ZM11.1 8.14001H5C4.97534 8.14001 4.95081 8.14194 4.92676 8.14575C4.89587 8.15063 4.8656 8.15857 4.83643 8.1694C4.77368 8.19272 4.71606 8.2294 4.66772 8.27768C4.57959 8.36581 4.53003 8.48535 4.53003 8.61002C4.53003 8.73468 4.57959 8.85422 4.66772 8.94235C4.75586 9.03049 4.87537 9.08002 5 9.08002H11.1C11.2247 9.08002 11.3442 9.03049 11.4324 8.94235C11.4617 8.91306 11.4867 8.88028 11.5071 8.845C11.5349 8.79691 11.554 8.74414 11.5634 8.68915C11.5677 8.66318 11.5701 8.63672 11.5701 8.61002C11.5701 8.48535 11.5205 8.36581 11.4324 8.27768C11.3929 8.23831 11.3474 8.20663 11.2979 8.18365C11.2365 8.15518 11.1689 8.14001 11.1 8.14001ZM5 11H15.45C15.5826 11 15.7098 10.9473 15.8036 10.8535C15.8973 10.7598 15.95 10.6326 15.95 10.5C15.95 10.3674 15.8973 10.2402 15.8036 10.1465C15.7098 10.0527 15.5826 10 15.45 10H5C4.86743 10 4.74023 10.0527 4.64648 10.1465C4.55273 10.2402 4.5 10.3674 4.5 10.5C4.5 10.6326 4.55273 10.7598 4.64648 10.8535C4.74023 10.9473 4.86743 11 5 11ZM5 12.86H11.1C11.2211 12.8523 11.3346 12.798 11.4166 12.7085C11.4987 12.6191 11.5428 12.5013 11.54 12.38C11.5427 12.2597 11.4982 12.1431 11.4159 12.0552C11.3336 11.9673 11.2202 11.9152 11.1 11.91H5C4.94092 11.9126 4.88281 11.9268 4.82922 11.9518C4.77563 11.9768 4.72742 12.0122 4.6875 12.0558C4.64758 12.0995 4.6167 12.1506 4.59644 12.2062C4.58899 12.2266 4.58313 12.2475 4.57874 12.2687C4.57129 12.3052 4.56824 12.3426 4.56995 12.38C4.56445 12.5004 4.60645 12.6181 4.68689 12.7079C4.76733 12.7976 4.87976 12.8523 5 12.86ZM11.1 16.63H5C4.87537 16.63 4.75586 16.5805 4.66772 16.4923C4.57959 16.4042 4.53003 16.2846 4.53003 16.16C4.53003 16.0353 4.57959 15.9158 4.66772 15.8276C4.75586 15.7395 4.87537 15.69 5 15.69H11.1C11.2247 15.69 11.3442 15.7395 11.4324 15.8276C11.5205 15.9158 11.5701 16.0353 11.5701 16.16C11.5701 16.2846 11.5205 16.4042 11.4324 16.4923C11.3442 16.5805 11.2247 16.63 11.1 16.63ZM19.59 12.53H17.36V12.3C17.3574 12.2195 17.3236 12.1432 17.2657 12.0872C17.2078 12.0313 17.1305 12 17.05 12H16C15.9242 11.9994 15.8509 12.0265 15.7938 12.0762C15.7367 12.126 15.6997 12.1949 15.69 12.27V12.5H13.44C13.3768 12.4994 13.3142 12.5125 13.2565 12.5382C13.1988 12.564 13.1473 12.6019 13.1055 12.6493C13.0638 12.6968 13.0327 12.7526 13.0145 12.8132C12.9963 12.8737 12.9913 12.9374 13 13V13.67C13 13.6871 13.0033 13.704 13.0099 13.7198C13.0164 13.7355 13.026 13.7499 13.038 13.7619C13.0501 13.774 13.0644 13.7836 13.0802 13.7901C13.096 13.7966 13.1129 13.8 13.13 13.8H19.84C19.8611 13.8054 19.8834 13.8054 19.9045 13.8C19.9257 13.7946 19.9452 13.7839 19.9611 13.7689C19.9771 13.754 19.989 13.7352 19.9958 13.7144C20.0026 13.6937 20.004 13.6715 20 13.65V13C20.0028 12.8866 19.9617 12.7765 19.8853 12.6927C19.809 12.6088 19.7031 12.5577 19.59 12.55V12.53ZM13.52 14V19.38C13.5303 19.5454 13.6054 19.7 13.7289 19.8105C13.8525 19.9209 14.0145 19.9782 14.18 19.97H18.84C19.0055 19.9782 19.1676 19.9209 19.2911 19.8105C19.4146 19.7 19.4897 19.5454 19.5 19.38V14H13.52ZM15.52 18.67C15.52 18.7522 15.4874 18.8311 15.4292 18.8892C15.3711 18.9473 15.2922 18.98 15.21 18.98H14.83C14.7478 18.98 14.669 18.9473 14.6108 18.8892C14.5527 18.8311 14.52 18.7522 14.52 18.67V15.33C14.52 15.2893 14.528 15.249 14.5436 15.2114C14.5592 15.1738 14.582 15.1396 14.6108 15.1108C14.6396 15.082 14.6738 15.0592 14.7114 15.0436C14.749 15.028 14.7893 15.02 14.83 15.02H15.21C15.2507 15.02 15.291 15.028 15.3287 15.0436C15.3663 15.0592 15.4004 15.082 15.4292 15.1108C15.458 15.1396 15.4808 15.1738 15.4964 15.2114C15.512 15.249 15.52 15.2893 15.52 15.33V18.67ZM17.01 18.67C17.01 18.7522 16.9774 18.8311 16.9192 18.8892C16.8611 18.9473 16.7822 18.98 16.7 18.98H16.32C16.2798 18.98 16.2399 18.9719 16.2029 18.9562C16.1658 18.9405 16.1323 18.9176 16.1043 18.8886C16.0763 18.8597 16.0544 18.8254 16.0399 18.7879C16.0254 18.7503 16.0187 18.7102 16.02 18.67V15.33C16.0187 15.2898 16.0254 15.2497 16.0399 15.2121C16.0544 15.1746 16.0763 15.1403 16.1043 15.1114C16.1323 15.0824 16.1658 15.0595 16.2029 15.0438C16.2399 15.0281 16.2798 15.02 16.32 15.02H16.7C16.7407 15.02 16.781 15.028 16.8187 15.0436C16.8563 15.0592 16.8904 15.082 16.9192 15.1108C16.948 15.1396 16.9708 15.1738 16.9864 15.2114C17.002 15.249 17.01 15.2893 17.01 15.33V18.67ZM18.51 18.67C18.51 18.7107 18.502 18.751 18.4864 18.7886C18.4708 18.8262 18.448 18.8604 18.4192 18.8892C18.3904 18.918 18.3563 18.9408 18.3187 18.9564C18.281 18.972 18.2407 18.98 18.2 18.98H17.82C17.7378 18.98 17.659 18.9473 17.6008 18.8892C17.5427 18.8311 17.51 18.7522 17.51 18.67V15.33C17.51 15.2893 17.518 15.249 17.5336 15.2114C17.5492 15.1738 17.572 15.1396 17.6008 15.1108C17.6296 15.082 17.6638 15.0592 17.7014 15.0436C17.739 15.028 17.7793 15.02 17.82 15.02H18.2C18.2407 15.02 18.281 15.028 18.3187 15.0436C18.3563 15.0592 18.3904 15.082 18.4192 15.1108C18.448 15.1396 18.4708 15.1738 18.4864 15.2114C18.502 15.249 18.51 15.2893 18.51 15.33V18.67Z'
  };
  FroalaEditor.FILEICONS = {
    docIcon: {
      extension: '.doc',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 9.617188 46.875 C 13.234375 46.875 16.160156 43.929688 16.160156 40.292969 C 16.160156 36.695312 13.234375 33.75 9.617188 33.75 L 7.402344 33.75 C 6.820312 33.75 6.371094 34.199219 6.371094 34.78125 L 6.371094 45.84375 C 6.371094 46.335938 6.714844 46.757812 7.191406 46.855469 L 7.402344 46.875 Z M 9.617188 44.792969 L 8.453125 44.792969 L 8.453125 35.832031 L 9.617188 35.832031 C 12.089844 35.832031 14.078125 37.835938 14.078125 40.292969 C 14.078125 42.789062 12.089844 44.773438 9.617188 44.792969 Z M 24.816406 46.875 C 26.539062 46.875 28.191406 46.085938 29.296875 44.867188 C 30.460938 43.648438 31.191406 41.980469 31.191406 40.125 C 31.191406 38.269531 30.460938 36.617188 29.296875 35.382812 C 28.191406 34.144531 26.539062 33.375 24.816406 33.375 C 23.015625 33.375 21.367188 34.144531 20.222656 35.382812 C 19.058594 36.617188 18.367188 38.269531 18.367188 40.125 C 18.367188 41.980469 19.058594 43.648438 20.222656 44.867188 C 21.367188 46.085938 23.015625 46.875 24.816406 46.875 Z M 24.816406 44.738281 C 23.617188 44.738281 22.566406 44.230469 21.777344 43.386719 C 20.992188 42.582031 20.503906 41.398438 20.503906 40.125 C 20.503906 38.851562 20.992188 37.667969 21.777344 36.84375 C 22.566406 36 23.617188 35.511719 24.816406 35.511719 C 25.941406 35.511719 26.992188 36 27.777344 36.84375 C 28.546875 37.667969 29.054688 38.851562 29.054688 40.125 C 29.054688 41.398438 28.546875 42.582031 27.777344 43.386719 C 26.992188 44.230469 25.941406 44.738281 24.816406 44.738281 Z M 39.996094 46.875 C 41.648438 46.875 43.148438 46.332031 44.328125 45.414062 C 44.777344 45.054688 44.851562 44.382812 44.515625 43.914062 C 44.140625 43.460938 43.445312 43.386719 43.015625 43.707031 C 42.171875 44.382812 41.160156 44.738281 39.996094 44.738281 C 38.703125 44.738281 37.503906 44.210938 36.621094 43.386719 C 35.777344 42.5625 35.253906 41.398438 35.253906 40.125 C 35.253906 38.851562 35.777344 37.726562 36.621094 36.863281 C 37.503906 36.039062 38.703125 35.511719 39.996094 35.511719 C 41.160156 35.511719 42.191406 35.867188 43.015625 36.542969 C 43.445312 36.882812 44.140625 36.804688 44.515625 36.335938 C 44.851562 35.867188 44.777344 35.210938 44.328125 34.835938 C 43.148438 33.917969 41.648438 33.375 39.996094 33.375 C 36.246094 33.394531 33.132812 36.414062 33.117188 40.125 C 33.132812 43.855469 36.246094 46.875 39.996094 46.875 Z M 39.996094 46.875 \"/>\n      </g>"
    },
    gifIcon: {
      extension: '.gif',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 17.394531 46.875 C 18.988281 46.875 20.46875 46.332031 21.648438 45.414062 C 21.835938 45.28125 21.949219 45.132812 22.003906 44.960938 L 22.003906 44.945312 C 22.023438 44.90625 22.023438 44.886719 22.042969 44.851562 C 22.0625 44.738281 22.097656 44.664062 22.097656 44.53125 L 22.097656 40.386719 C 22.097656 39.789062 21.613281 39.335938 21.011719 39.335938 L 17.28125 39.335938 C 16.699219 39.335938 16.210938 39.789062 16.210938 40.386719 C 16.210938 40.96875 16.699219 41.457031 17.28125 41.457031 L 19.960938 41.457031 L 19.960938 44.023438 C 19.210938 44.457031 18.332031 44.738281 17.394531 44.738281 C 16.042969 44.738281 14.863281 44.230469 14.019531 43.367188 C 13.136719 42.523438 12.613281 41.382812 12.613281 40.144531 C 12.613281 38.867188 13.136719 37.726562 14.019531 36.882812 C 14.863281 36.019531 16.042969 35.511719 17.394531 35.511719 C 18.519531 35.511719 19.550781 35.90625 20.355469 36.523438 C 20.824219 36.898438 21.519531 36.804688 21.875 36.355469 C 22.230469 35.886719 22.15625 35.195312 21.667969 34.835938 C 20.503906 33.917969 18.988281 33.375 17.394531 33.375 C 13.585938 33.375 10.472656 36.375 10.472656 40.144531 C 10.472656 43.894531 13.585938 46.875 17.394531 46.875 Z M 26.945312 46.875 C 27.507812 46.875 27.996094 46.425781 27.996094 45.84375 L 27.996094 34.78125 C 27.996094 34.199219 27.507812 33.75 26.945312 33.75 C 26.363281 33.75 25.914062 34.199219 25.914062 34.78125 L 25.914062 45.84375 C 25.914062 46.425781 26.363281 46.875 26.945312 46.875 Z M 33.066406 46.875 C 33.648438 46.875 34.117188 46.40625 34.117188 45.84375 L 34.117188 41.34375 L 38.488281 41.34375 C 39.050781 41.34375 39.519531 40.875 39.519531 40.292969 C 39.519531 39.75 39.050781 39.261719 38.488281 39.261719 L 34.117188 39.261719 L 34.117188 35.832031 L 39.199219 35.832031 C 39.742188 35.832031 40.230469 35.363281 40.230469 34.78125 C 40.230469 34.21875 39.742188 33.75 39.199219 33.75 L 33.066406 33.75 C 32.488281 33.75 32.035156 34.21875 32.035156 34.78125 L 32.035156 45.84375 C 32.035156 46.40625 32.488281 46.875 33.066406 46.875 Z M 33.066406 46.875 \"/>\n      </g>"
    },
    jpegIcon: {
      extension: '.jpeg',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 9 43.75 C 11.140625 43.75 12.890625 42.015625 12.890625 39.875 L 12.890625 33.671875 C 12.890625 33.1875 12.5 32.8125 12.03125 32.8125 C 11.546875 32.8125 11.15625 33.1875 11.15625 33.671875 L 11.15625 39.875 C 11.15625 41.046875 10.1875 42.015625 9 42.015625 C 8.046875 42.015625 7.234375 41.390625 6.953125 40.53125 C 6.8125 40.078125 6.328125 39.828125 5.859375 39.984375 C 5.421875 40.109375 5.15625 40.59375 5.3125 41.0625 C 5.8125 42.625 7.28125 43.75 9 43.75 Z M 15.640625 43.75 C 16.125 43.75 16.515625 43.359375 16.515625 42.890625 L 16.515625 39.5 L 18.4375 39.5 C 20.296875 39.5 21.796875 38 21.796875 36.171875 C 21.796875 34.3125 20.296875 32.8125 18.4375 32.8125 L 15.640625 32.8125 C 15.171875 32.8125 14.78125 33.1875 14.78125 33.671875 L 14.78125 42.890625 C 14.78125 43.359375 15.171875 43.75 15.640625 43.75 Z M 18.4375 37.765625 L 16.515625 37.765625 L 16.515625 34.546875 L 18.4375 34.546875 C 19.34375 34.546875 20.046875 35.265625 20.0625 36.171875 C 20.046875 37.046875 19.34375 37.765625 18.4375 37.765625 Z M 29.234375 43.75 C 29.6875 43.75 30.09375 43.359375 30.09375 42.890625 C 30.09375 42.40625 29.6875 42.015625 29.234375 42.015625 L 25 42.015625 L 25 39.140625 L 28.640625 39.140625 C 29.109375 39.140625 29.5 38.75 29.5 38.265625 C 29.5 37.8125 29.109375 37.40625 28.640625 37.40625 L 25 37.40625 L 25 34.546875 L 29.234375 34.546875 C 29.6875 34.546875 30.09375 34.15625 30.09375 33.671875 C 30.09375 33.1875 29.6875 32.8125 29.234375 32.8125 L 24.125 32.8125 C 23.640625 32.8125 23.265625 33.1875 23.265625 33.671875 L 23.265625 42.890625 C 23.265625 43.359375 23.640625 43.75 24.125 43.75 C 24.125 43.75 24.140625 43.734375 24.140625 43.734375 C 24.140625 43.734375 24.140625 43.75 24.171875 43.75 Z M 37.1875 43.75 C 38.515625 43.75 39.75 43.296875 40.734375 42.53125 C 40.890625 42.421875 40.984375 42.296875 41.03125 42.15625 L 41.03125 42.140625 C 41.046875 42.109375 41.046875 42.09375 41.0625 42.0625 C 41.078125 41.96875 41.109375 41.90625 41.109375 41.796875 L 41.109375 38.34375 C 41.109375 37.914062 40.8125 37.578125 40.410156 37.492188 L 40.203125 37.46875 L 37.09375 37.46875 C 36.609375 37.46875 36.203125 37.84375 36.203125 38.34375 C 36.203125 38.828125 36.609375 39.234375 37.09375 39.234375 L 39.328125 39.234375 L 39.328125 41.375 C 38.703125 41.734375 37.96875 41.96875 37.1875 41.96875 C 36.0625 41.96875 35.078125 41.546875 34.375 40.828125 C 33.640625 40.125 33.203125 39.171875 33.203125 38.140625 C 33.203125 37.078125 33.640625 36.125 34.375 35.421875 C 35.078125 34.703125 36.0625 34.28125 37.1875 34.28125 C 38.125 34.28125 38.984375 34.609375 39.65625 35.125 C 40.046875 35.4375 40.625 35.359375 40.921875 34.984375 C 41.21875 34.59375 41.15625 34.015625 40.75 33.71875 C 39.78125 32.953125 38.515625 32.5 37.1875 32.5 C 34.015625 32.5 31.421875 35 31.421875 38.140625 C 31.421875 41.265625 34.015625 43.75 37.1875 43.75 Z M 37.1875 43.75 \"/>\n      </g>"
    },
    logIcon: {
      extension: '.log',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 13.542969 46.875 C 14.085938 46.875 14.574219 46.40625 14.574219 45.84375 C 14.574219 45.261719 14.085938 44.792969 13.542969 44.792969 L 8.460938 44.792969 L 8.460938 34.78125 C 8.460938 34.21875 7.992188 33.75 7.410156 33.75 C 6.828125 33.75 6.378906 34.21875 6.378906 34.78125 L 6.378906 45.84375 C 6.378906 46.40625 6.828125 46.875 7.410156 46.875 Z M 21.742188 46.875 C 23.46875 46.875 25.117188 46.085938 26.222656 44.867188 C 27.386719 43.648438 28.117188 41.980469 28.117188 40.125 C 28.117188 38.269531 27.386719 36.617188 26.222656 35.382812 C 25.117188 34.144531 23.46875 33.375 21.742188 33.375 C 19.941406 33.375 18.292969 34.144531 17.148438 35.382812 C 15.984375 36.617188 15.292969 38.269531 15.292969 40.125 C 15.292969 41.980469 15.984375 43.648438 17.148438 44.867188 C 18.292969 46.085938 19.941406 46.875 21.742188 46.875 Z M 21.742188 44.738281 C 20.542969 44.738281 19.492188 44.230469 18.703125 43.386719 C 17.917969 42.582031 17.429688 41.398438 17.429688 40.125 C 17.429688 38.851562 17.917969 37.667969 18.703125 36.84375 C 19.492188 36 20.542969 35.511719 21.742188 35.511719 C 22.867188 35.511719 23.917969 36 24.703125 36.84375 C 25.472656 37.667969 25.980469 38.851562 25.980469 40.125 C 25.980469 41.398438 25.472656 42.582031 24.703125 43.386719 C 23.917969 44.230469 22.867188 44.738281 21.742188 44.738281 Z M 37.300781 46.875 C 38.894531 46.875 40.375 46.332031 41.558594 45.414062 C 41.746094 45.28125 41.855469 45.132812 41.914062 44.960938 L 41.914062 44.945312 L 41.949219 44.851562 C 41.96875 44.738281 42.007812 44.664062 42.007812 44.53125 L 42.007812 40.386719 C 42.007812 39.789062 41.519531 39.335938 40.917969 39.335938 L 37.1875 39.335938 C 36.605469 39.335938 36.121094 39.789062 36.121094 40.386719 C 36.121094 40.96875 36.605469 41.457031 37.1875 41.457031 L 39.871094 41.457031 L 39.871094 44.023438 C 39.121094 44.457031 38.238281 44.738281 37.300781 44.738281 C 35.949219 44.738281 34.769531 44.230469 33.925781 43.367188 C 33.042969 42.523438 32.519531 41.382812 32.519531 40.144531 C 32.519531 38.867188 33.042969 37.726562 33.925781 36.882812 C 34.769531 36.019531 35.949219 35.511719 37.300781 35.511719 C 38.425781 35.511719 39.457031 35.90625 40.261719 36.523438 C 40.730469 36.898438 41.425781 36.804688 41.78125 36.355469 C 42.136719 35.886719 42.0625 35.195312 41.574219 34.835938 C 40.414062 33.917969 38.894531 33.375 37.300781 33.375 C 33.496094 33.375 30.382812 36.375 30.382812 40.144531 C 30.382812 43.894531 33.496094 46.875 37.300781 46.875 Z M 37.300781 46.875 \"/>\n      </g>"
    },
    movIcon: {
      extension: '.mov',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 15.472656 46.875 C 16.035156 46.875 16.523438 46.40625 16.523438 45.84375 L 16.523438 34.78125 C 16.523438 34.289062 16.152344 33.882812 15.679688 33.777344 L 15.472656 33.75 L 15.453125 33.75 C 15.117188 33.75 14.816406 33.898438 14.609375 34.179688 L 10.878906 39.355469 L 7.148438 34.179688 C 6.960938 33.898438 6.625 33.75 6.324219 33.75 L 6.265625 33.75 C 5.703125 33.75 5.234375 34.21875 5.234375 34.78125 L 5.234375 45.84375 C 5.234375 46.40625 5.703125 46.875 6.265625 46.875 C 6.847656 46.875 7.316406 46.40625 7.316406 45.84375 L 7.316406 37.949219 L 10 41.699219 C 10.203125 41.980469 10.523438 42.132812 10.859375 42.132812 L 10.898438 42.132812 C 11.234375 42.132812 11.535156 41.980469 11.742188 41.699219 L 14.441406 37.949219 L 14.441406 45.84375 C 14.441406 46.40625 14.890625 46.875 15.472656 46.875 Z M 25.460938 46.875 C 27.1875 46.875 28.835938 46.085938 29.941406 44.867188 C 31.105469 43.648438 31.835938 41.980469 31.835938 40.125 C 31.835938 38.269531 31.105469 36.617188 29.941406 35.382812 C 28.835938 34.144531 27.1875 33.375 25.460938 33.375 C 23.660156 33.375 22.011719 34.144531 20.867188 35.382812 C 19.703125 36.617188 19.011719 38.269531 19.011719 40.125 C 19.011719 41.980469 19.703125 43.648438 20.867188 44.867188 C 22.011719 46.085938 23.660156 46.875 25.460938 46.875 Z M 25.460938 44.738281 C 24.261719 44.738281 23.210938 44.230469 22.421875 43.386719 C 21.636719 42.582031 21.148438 41.398438 21.148438 40.125 C 21.148438 38.851562 21.636719 37.667969 22.421875 36.84375 C 23.210938 36 24.261719 35.511719 25.460938 35.511719 C 26.585938 35.511719 27.636719 36 28.421875 36.84375 C 29.191406 37.667969 29.699219 38.851562 29.699219 40.125 C 29.699219 41.398438 29.191406 42.582031 28.421875 43.386719 C 27.636719 44.230469 26.585938 44.738281 25.460938 44.738281 Z M 38.683594 46.855469 L 38.71875 46.855469 C 38.777344 46.835938 38.8125 46.820312 38.871094 46.820312 C 38.886719 46.800781 38.886719 46.800781 38.90625 46.800781 C 38.964844 46.78125 39.019531 46.726562 39.058594 46.707031 L 39.09375 46.6875 L 39.207031 46.59375 C 39.226562 46.574219 39.226562 46.574219 39.246094 46.539062 L 39.339844 46.425781 C 39.355469 46.425781 39.355469 46.425781 39.355469 46.40625 C 39.394531 46.367188 39.414062 46.292969 39.433594 46.257812 L 44.0625 35.304688 C 44.269531 34.800781 44.027344 34.179688 43.5 33.976562 C 42.996094 33.75 42.375 33.992188 42.152344 34.519531 L 38.496094 43.199219 L 34.839844 34.519531 C 34.613281 33.992188 34.011719 33.75 33.507812 33.976562 C 32.964844 34.179688 32.71875 34.800781 32.945312 35.304688 L 37.539062 46.257812 C 37.574219 46.292969 37.613281 46.367188 37.632812 46.40625 C 37.632812 46.425781 37.652344 46.425781 37.652344 46.425781 C 37.667969 46.460938 37.707031 46.5 37.746094 46.539062 C 37.746094 46.574219 37.761719 46.574219 37.761719 46.59375 C 37.820312 46.632812 37.855469 46.648438 37.894531 46.6875 L 37.914062 46.6875 C 37.96875 46.726562 38.042969 46.78125 38.082031 46.800781 L 38.101562 46.800781 C 38.101562 46.800781 38.121094 46.800781 38.121094 46.820312 C 38.15625 46.820312 38.230469 46.835938 38.269531 46.855469 L 38.308594 46.855469 L 38.402344 46.871094 L 38.496094 46.875 C 38.550781 46.875 38.605469 46.875 38.683594 46.855469 Z M 38.683594 46.855469 \"/>\n      </g>"
    },
    ogvIcon: {
      extension: '.ogv',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 11.511719 46.875 C 13.238281 46.875 14.886719 46.085938 15.996094 44.867188 C 17.15625 43.648438 17.886719 41.980469 17.886719 40.125 C 17.886719 38.269531 17.15625 36.617188 15.996094 35.382812 C 14.886719 34.144531 13.238281 33.375 11.511719 33.375 C 9.714844 33.375 8.0625 34.144531 6.917969 35.382812 C 5.757812 36.617188 5.0625 38.269531 5.0625 40.125 C 5.0625 41.980469 5.757812 43.648438 6.917969 44.867188 C 8.0625 46.085938 9.714844 46.875 11.511719 46.875 Z M 11.511719 44.738281 C 10.3125 44.738281 9.261719 44.230469 8.476562 43.386719 C 7.6875 42.582031 7.199219 41.398438 7.199219 40.125 C 7.199219 38.851562 7.6875 37.667969 8.476562 36.84375 C 9.261719 36 10.3125 35.511719 11.511719 35.511719 C 12.636719 35.511719 13.6875 36 14.476562 36.84375 C 15.246094 37.667969 15.75 38.851562 15.75 40.125 C 15.75 41.398438 15.246094 42.582031 14.476562 43.386719 C 13.6875 44.230469 12.636719 44.738281 11.511719 44.738281 Z M 27.25 46.875 C 28.84375 46.875 30.324219 46.332031 31.507812 45.414062 C 31.695312 45.28125 31.804688 45.132812 31.863281 44.960938 L 31.863281 44.945312 C 31.882812 44.90625 31.882812 44.886719 31.898438 44.851562 C 31.917969 44.738281 31.957031 44.664062 31.957031 44.53125 L 31.957031 40.386719 C 31.957031 39.789062 31.46875 39.335938 30.867188 39.335938 L 27.136719 39.335938 C 26.554688 39.335938 26.070312 39.789062 26.070312 40.386719 C 26.070312 40.96875 26.554688 41.457031 27.136719 41.457031 L 29.820312 41.457031 L 29.820312 44.023438 C 29.070312 44.457031 28.1875 44.738281 27.25 44.738281 C 25.898438 44.738281 24.71875 44.230469 23.875 43.367188 C 22.992188 42.523438 22.46875 41.382812 22.46875 40.144531 C 22.46875 38.867188 22.992188 37.726562 23.875 36.882812 C 24.71875 36.019531 25.898438 35.511719 27.25 35.511719 C 28.375 35.511719 29.40625 35.90625 30.210938 36.523438 C 30.679688 36.898438 31.375 36.804688 31.730469 36.355469 C 32.085938 35.886719 32.011719 35.195312 31.523438 34.835938 C 30.363281 33.917969 28.84375 33.375 27.25 33.375 C 23.445312 33.375 20.332031 36.375 20.332031 40.144531 C 20.332031 43.894531 23.445312 46.875 27.25 46.875 Z M 40.191406 46.855469 L 40.230469 46.855469 C 40.285156 46.835938 40.324219 46.820312 40.378906 46.820312 C 40.398438 46.800781 40.398438 46.800781 40.417969 46.800781 C 40.472656 46.78125 40.53125 46.726562 40.566406 46.707031 C 40.605469 46.6875 40.605469 46.6875 40.605469 46.6875 L 40.71875 46.59375 C 40.738281 46.574219 40.738281 46.574219 40.753906 46.539062 L 40.847656 46.425781 C 40.867188 46.425781 40.867188 46.425781 40.867188 46.40625 C 40.90625 46.367188 40.925781 46.292969 40.941406 46.257812 L 45.574219 35.304688 C 45.78125 34.800781 45.535156 34.179688 45.011719 33.976562 C 44.503906 33.75 43.886719 33.992188 43.660156 34.519531 L 40.003906 43.199219 L 36.347656 34.519531 C 36.125 33.992188 35.523438 33.75 35.019531 33.976562 C 34.472656 34.179688 34.230469 34.800781 34.457031 35.304688 L 39.050781 46.257812 C 39.085938 46.292969 39.125 46.367188 39.144531 46.40625 C 39.144531 46.425781 39.160156 46.425781 39.160156 46.425781 C 39.179688 46.460938 39.21875 46.5 39.253906 46.539062 C 39.253906 46.574219 39.273438 46.574219 39.273438 46.59375 C 39.332031 46.632812 39.367188 46.648438 39.40625 46.6875 L 39.425781 46.6875 C 39.480469 46.726562 39.554688 46.78125 39.59375 46.800781 L 39.613281 46.800781 C 39.613281 46.800781 39.628906 46.800781 39.628906 46.820312 C 39.667969 46.820312 39.742188 46.835938 39.78125 46.855469 L 39.816406 46.855469 L 39.910156 46.871094 L 40.003906 46.875 C 40.0625 46.875 40.117188 46.875 40.191406 46.855469 Z M 40.191406 46.855469 \"/>\n      </g>"
    },
    pngIcon: {
      extension: '.png',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 7.523438 46.875 C 8.105469 46.875 8.574219 46.40625 8.574219 45.84375 L 8.574219 41.773438 L 10.878906 41.773438 C 13.109375 41.773438 14.910156 39.976562 14.910156 37.78125 C 14.910156 35.550781 13.109375 33.75 10.878906 33.75 L 7.523438 33.75 C 6.960938 33.75 6.492188 34.199219 6.492188 34.78125 L 6.492188 45.84375 C 6.492188 46.40625 6.960938 46.875 7.523438 46.875 Z M 10.878906 39.695312 L 8.574219 39.695312 L 8.574219 35.832031 L 10.878906 35.832031 C 11.964844 35.832031 12.808594 36.695312 12.828125 37.78125 C 12.808594 38.832031 11.964844 39.695312 10.878906 39.695312 Z M 26.75 46.875 C 27.3125 46.875 27.78125 46.40625 27.78125 45.84375 L 27.78125 34.949219 C 27.78125 34.40625 27.3125 33.9375 26.75 33.9375 C 26.1875 33.9375 25.738281 34.40625 25.738281 34.949219 L 25.738281 42.675781 L 19.679688 34.292969 C 19.363281 33.84375 18.722656 33.75 18.253906 34.070312 C 17.972656 34.273438 17.824219 34.613281 17.84375 34.929688 L 17.84375 45.84375 C 17.84375 46.40625 18.292969 46.875 18.875 46.875 C 19.417969 46.875 19.886719 46.40625 19.886719 45.84375 L 19.886719 38.0625 L 25.886719 46.386719 C 25.90625 46.425781 25.941406 46.460938 25.980469 46.5 C 26.167969 46.726562 26.449219 46.875 26.75 46.875 Z M 38.082031 46.875 C 39.675781 46.875 41.15625 46.332031 42.339844 45.414062 C 42.527344 45.28125 42.636719 45.132812 42.695312 44.960938 L 42.695312 44.945312 C 42.714844 44.90625 42.714844 44.886719 42.730469 44.851562 C 42.75 44.738281 42.789062 44.664062 42.789062 44.53125 L 42.789062 40.386719 C 42.789062 39.789062 42.300781 39.335938 41.699219 39.335938 L 37.96875 39.335938 C 37.386719 39.335938 36.902344 39.789062 36.902344 40.386719 C 36.902344 40.96875 37.386719 41.457031 37.96875 41.457031 L 40.652344 41.457031 L 40.652344 44.023438 C 39.902344 44.457031 39.019531 44.738281 38.082031 44.738281 C 36.730469 44.738281 35.550781 44.230469 34.707031 43.367188 C 33.824219 42.523438 33.300781 41.382812 33.300781 40.144531 C 33.300781 38.867188 33.824219 37.726562 34.707031 36.882812 C 35.550781 36.019531 36.730469 35.511719 38.082031 35.511719 C 39.207031 35.511719 40.238281 35.90625 41.042969 36.523438 C 41.511719 36.898438 42.207031 36.804688 42.5625 36.355469 C 42.917969 35.886719 42.84375 35.195312 42.355469 34.835938 C 41.195312 33.917969 39.675781 33.375 38.082031 33.375 C 34.277344 33.375 31.164062 36.375 31.164062 40.144531 C 31.164062 43.894531 34.277344 46.875 38.082031 46.875 Z M 38.082031 46.875 \"/>\n      </g>"
    },
    txtIcon: {
      extension: '.txt',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 12.847656 46.875 C 13.429688 46.875 13.878906 46.425781 13.878906 45.84375 L 13.878906 35.832031 L 16.859375 35.832031 C 17.421875 35.832031 17.890625 35.34375 17.890625 34.78125 C 17.890625 34.199219 17.421875 33.75 16.859375 33.75 L 8.855469 33.75 C 8.273438 33.75 7.824219 34.199219 7.824219 34.78125 C 7.824219 35.34375 8.273438 35.832031 8.855469 35.832031 L 11.816406 35.832031 L 11.816406 45.84375 C 11.816406 46.425781 12.285156 46.875 12.847656 46.875 Z M 29.019531 46.875 C 29.222656 46.875 29.429688 46.800781 29.617188 46.667969 C 30.085938 46.351562 30.160156 45.695312 29.84375 45.242188 L 26.28125 40.367188 L 29.84375 35.53125 C 30.160156 35.0625 30.085938 34.425781 29.617188 34.105469 C 29.148438 33.75 28.53125 33.84375 28.175781 34.332031 L 25.023438 38.644531 L 21.855469 34.332031 C 21.535156 33.84375 20.878906 33.75 20.429688 34.105469 C 19.960938 34.425781 19.867188 35.0625 20.1875 35.53125 L 23.75 40.367188 L 20.1875 45.242188 C 19.867188 45.695312 19.960938 46.351562 20.429688 46.667969 C 20.597656 46.800781 20.804688 46.875 21.03125 46.875 C 21.347656 46.875 21.648438 46.707031 21.855469 46.445312 L 25.023438 42.113281 L 28.175781 46.445312 C 28.378906 46.707031 28.679688 46.875 29.019531 46.875 Z M 37.464844 46.875 C 38.042969 46.875 38.496094 46.425781 38.496094 45.84375 L 38.496094 35.832031 L 41.476562 35.832031 C 42.039062 35.832031 42.507812 35.34375 42.507812 34.78125 C 42.507812 34.199219 42.039062 33.75 41.476562 33.75 L 33.46875 33.75 C 32.886719 33.75 32.4375 34.199219 32.4375 34.78125 C 32.4375 35.34375 32.886719 35.832031 33.46875 35.832031 L 36.433594 35.832031 L 36.433594 45.84375 C 36.433594 46.425781 36.902344 46.875 37.464844 46.875 Z M 37.464844 46.875 \"/>\n      </g>"
    },
    webmIcon: {
      extension: '.webm',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 7.195312 43.734375 L 7.242188 43.734375 C 7.273438 43.71875 7.304688 43.703125 7.367188 43.703125 C 7.367188 43.6875 7.382812 43.6875 7.382812 43.6875 L 7.398438 43.6875 C 7.429688 43.671875 7.476562 43.625 7.523438 43.59375 L 7.554688 43.59375 C 7.585938 43.5625 7.617188 43.53125 7.648438 43.515625 C 7.648438 43.5 7.664062 43.5 7.664062 43.46875 L 7.757812 43.375 C 7.757812 43.375 7.757812 43.359375 7.773438 43.359375 C 7.789062 43.328125 7.820312 43.265625 7.835938 43.21875 L 9.882812 38.375 L 11.929688 43.21875 C 11.945312 43.265625 11.960938 43.328125 11.992188 43.359375 C 11.992188 43.359375 11.992188 43.375 12.023438 43.375 L 12.085938 43.46875 C 12.101562 43.5 12.101562 43.5 12.117188 43.515625 C 12.148438 43.53125 12.179688 43.5625 12.226562 43.59375 L 12.242188 43.59375 C 12.273438 43.625 12.320312 43.671875 12.382812 43.6875 C 12.398438 43.6875 12.398438 43.6875 12.414062 43.703125 C 12.445312 43.703125 12.476562 43.71875 12.523438 43.734375 L 12.570312 43.734375 L 12.640625 43.746094 L 12.710938 43.75 C 12.773438 43.75 12.820312 43.75 12.867188 43.734375 L 12.898438 43.734375 C 12.945312 43.71875 12.992188 43.703125 13.023438 43.703125 C 13.023438 43.6875 13.039062 43.6875 13.039062 43.6875 L 13.054688 43.6875 C 13.117188 43.671875 13.148438 43.625 13.195312 43.59375 L 13.210938 43.59375 C 13.242188 43.5625 13.289062 43.53125 13.320312 43.515625 C 13.320312 43.5 13.335938 43.5 13.335938 43.46875 C 13.367188 43.4375 13.398438 43.40625 13.414062 43.375 C 13.414062 43.375 13.429688 43.359375 13.429688 43.359375 C 13.460938 43.328125 13.492188 43.265625 13.507812 43.21875 L 17.335938 34.109375 C 17.523438 33.6875 17.320312 33.171875 16.898438 33 C 16.445312 32.8125 15.945312 33.015625 15.757812 33.453125 L 12.710938 40.6875 L 10.695312 35.890625 C 10.539062 35.546875 10.210938 35.359375 9.882812 35.359375 C 9.539062 35.359375 9.210938 35.546875 9.070312 35.890625 L 7.054688 40.6875 L 3.992188 33.453125 C 3.820312 33.015625 3.304688 32.8125 2.882812 33 C 2.429688 33.171875 2.242188 33.6875 2.414062 34.109375 L 6.257812 43.21875 C 6.289062 43.265625 6.304688 43.328125 6.335938 43.359375 L 6.335938 43.375 C 6.367188 43.40625 6.382812 43.4375 6.414062 43.46875 C 6.429688 43.5 6.429688 43.5 6.445312 43.515625 C 6.492188 43.53125 6.507812 43.5625 6.554688 43.59375 L 6.570312 43.59375 C 6.601562 43.625 6.664062 43.671875 6.710938 43.6875 C 6.726562 43.6875 6.726562 43.6875 6.742188 43.703125 C 6.773438 43.703125 6.804688 43.71875 6.851562 43.734375 L 6.898438 43.734375 L 6.976562 43.746094 L 7.054688 43.75 C 7.101562 43.75 7.148438 43.75 7.195312 43.734375 Z M 25.179688 43.75 C 25.632812 43.75 26.039062 43.359375 26.039062 42.890625 C 26.039062 42.40625 25.632812 42.015625 25.179688 42.015625 L 20.945312 42.015625 L 20.945312 39.140625 L 24.585938 39.140625 C 25.054688 39.140625 25.445312 38.75 25.445312 38.265625 C 25.445312 37.8125 25.054688 37.40625 24.585938 37.40625 L 20.945312 37.40625 L 20.945312 34.546875 L 25.179688 34.546875 C 25.632812 34.546875 26.039062 34.15625 26.039062 33.671875 C 26.039062 33.1875 25.632812 32.8125 25.179688 32.8125 L 20.070312 32.8125 C 19.585938 32.8125 19.210938 33.1875 19.210938 33.671875 L 19.210938 42.890625 C 19.210938 43.359375 19.585938 43.75 20.070312 43.75 C 20.070312 43.75 20.085938 43.734375 20.085938 43.734375 C 20.085938 43.734375 20.085938 43.75 20.117188 43.75 Z M 31.539062 43.75 C 33.382812 43.75 34.882812 42.25 34.882812 40.390625 C 34.882812 39.203125 34.242188 38.15625 33.304688 37.5625 C 33.679688 37.0625 33.898438 36.453125 33.898438 35.78125 C 33.898438 34.140625 32.570312 32.8125 30.929688 32.8125 L 28.710938 32.8125 C 28.242188 32.8125 27.851562 33.1875 27.851562 33.671875 L 27.851562 42.890625 C 27.851562 43.359375 28.242188 43.75 28.710938 43.75 L 28.757812 43.734375 C 28.757812 43.734375 28.757812 43.75 28.773438 43.75 Z M 30.929688 37.046875 L 29.585938 37.046875 L 29.585938 34.546875 L 30.929688 34.546875 C 31.617188 34.546875 32.164062 35.09375 32.164062 35.78125 C 32.164062 36.46875 31.617188 37.046875 30.929688 37.046875 Z M 31.539062 42.015625 L 29.585938 42.015625 L 29.585938 38.78125 L 31.539062 38.78125 C 32.429688 38.796875 33.148438 39.5 33.148438 40.390625 C 33.148438 41.296875 32.429688 42 31.539062 42.015625 Z M 45.664062 43.75 C 46.132812 43.75 46.539062 43.359375 46.539062 42.890625 L 46.539062 33.671875 C 46.539062 33.269531 46.242188 32.9375 45.859375 32.839844 L 45.664062 32.8125 L 45.648438 32.8125 C 45.367188 32.8125 45.117188 32.9375 44.945312 33.171875 L 41.835938 37.484375 L 38.726562 33.171875 C 38.570312 32.9375 38.289062 32.8125 38.039062 32.8125 L 37.992188 32.8125 C 37.523438 32.8125 37.132812 33.203125 37.132812 33.671875 L 37.132812 42.890625 C 37.132812 43.359375 37.523438 43.75 37.992188 43.75 C 38.476562 43.75 38.867188 43.359375 38.867188 42.890625 L 38.867188 36.3125 L 41.101562 39.4375 C 41.273438 39.671875 41.539062 39.796875 41.820312 39.796875 L 41.851562 39.796875 C 42.132812 39.796875 42.382812 39.671875 42.554688 39.4375 L 44.804688 36.3125 L 44.804688 42.890625 C 44.804688 43.359375 45.179688 43.75 45.664062 43.75 Z M 45.664062 43.75 \"/>\n      </g>"
    },
    webpIcon: {
      extension: '.webp',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 9.234375 43.734375 L 9.28125 43.734375 C 9.3125 43.71875 9.34375 43.703125 9.40625 43.703125 L 9.414062 43.6875 C 9.421875 43.6875 9.421875 43.6875 9.4375 43.6875 C 9.46875 43.671875 9.515625 43.625 9.5625 43.59375 L 9.59375 43.59375 C 9.625 43.5625 9.65625 43.53125 9.6875 43.515625 C 9.6875 43.5 9.703125 43.5 9.703125 43.46875 L 9.796875 43.375 C 9.796875 43.375 9.796875 43.359375 9.8125 43.359375 C 9.828125 43.328125 9.859375 43.265625 9.875 43.21875 L 11.921875 38.375 L 13.96875 43.21875 C 13.984375 43.265625 14 43.328125 14.03125 43.359375 C 14.03125 43.359375 14.03125 43.375 14.0625 43.375 L 14.125 43.46875 C 14.140625 43.5 14.140625 43.5 14.15625 43.515625 L 14.203125 43.546875 L 14.265625 43.59375 C 14.265625 43.59375 14.265625 43.59375 14.28125 43.59375 C 14.3125 43.625 14.359375 43.671875 14.421875 43.6875 C 14.4375 43.6875 14.4375 43.6875 14.453125 43.703125 C 14.484375 43.703125 14.515625 43.71875 14.5625 43.734375 L 14.609375 43.734375 L 14.679688 43.746094 L 14.75 43.75 C 14.8125 43.75 14.859375 43.75 14.90625 43.734375 L 14.9375 43.734375 C 14.984375 43.71875 15.03125 43.703125 15.0625 43.703125 C 15.0625 43.6875 15.078125 43.6875 15.078125 43.6875 L 15.09375 43.6875 C 15.15625 43.671875 15.1875 43.625 15.234375 43.59375 L 15.25 43.59375 C 15.28125 43.5625 15.328125 43.53125 15.359375 43.515625 C 15.359375 43.5 15.375 43.5 15.375 43.46875 C 15.40625 43.4375 15.4375 43.40625 15.453125 43.375 L 15.46875 43.359375 C 15.5 43.328125 15.53125 43.265625 15.546875 43.21875 L 19.375 34.109375 C 19.5625 33.6875 19.359375 33.171875 18.9375 33 C 18.484375 32.8125 17.984375 33.015625 17.796875 33.453125 L 14.75 40.6875 L 12.734375 35.890625 C 12.578125 35.546875 12.25 35.359375 11.921875 35.359375 C 11.578125 35.359375 11.25 35.546875 11.109375 35.890625 L 9.09375 40.6875 L 6.03125 33.453125 C 5.859375 33.015625 5.34375 32.8125 4.921875 33 C 4.46875 33.171875 4.28125 33.6875 4.453125 34.109375 L 8.296875 43.21875 C 8.328125 43.265625 8.34375 43.328125 8.375 43.359375 L 8.375 43.375 C 8.40625 43.40625 8.421875 43.4375 8.453125 43.46875 C 8.46875 43.5 8.46875 43.5 8.484375 43.515625 L 8.539062 43.546875 L 8.59375 43.59375 C 8.59375 43.59375 8.59375 43.59375 8.609375 43.59375 C 8.640625 43.625 8.703125 43.671875 8.75 43.6875 C 8.765625 43.6875 8.765625 43.6875 8.78125 43.703125 C 8.8125 43.703125 8.84375 43.71875 8.890625 43.734375 L 8.9375 43.734375 L 9.015625 43.746094 L 9.09375 43.75 C 9.140625 43.75 9.1875 43.75 9.234375 43.734375 Z M 27.21875 43.75 C 27.671875 43.75 28.078125 43.359375 28.078125 42.890625 C 28.078125 42.40625 27.671875 42.015625 27.21875 42.015625 L 22.984375 42.015625 L 22.984375 39.140625 L 26.625 39.140625 C 27.09375 39.140625 27.484375 38.75 27.484375 38.265625 C 27.484375 37.8125 27.09375 37.40625 26.625 37.40625 L 22.984375 37.40625 L 22.984375 34.546875 L 27.21875 34.546875 C 27.671875 34.546875 28.078125 34.15625 28.078125 33.671875 C 28.078125 33.1875 27.671875 32.8125 27.21875 32.8125 L 22.109375 32.8125 C 21.625 32.8125 21.25 33.1875 21.25 33.671875 L 21.25 42.890625 C 21.25 43.359375 21.625 43.75 22.109375 43.75 L 22.125 43.734375 C 22.125 43.734375 22.125 43.75 22.15625 43.75 Z M 33.578125 43.75 C 35.421875 43.75 36.921875 42.25 36.921875 40.390625 C 36.921875 39.203125 36.28125 38.15625 35.34375 37.5625 C 35.71875 37.0625 35.9375 36.453125 35.9375 35.78125 C 35.9375 34.140625 34.609375 32.8125 32.96875 32.8125 L 30.75 32.8125 C 30.28125 32.8125 29.890625 33.1875 29.890625 33.671875 L 29.890625 42.890625 C 29.890625 43.359375 30.28125 43.75 30.75 43.75 C 30.765625 43.75 30.765625 43.734375 30.796875 43.734375 C 30.796875 43.734375 30.796875 43.75 30.8125 43.75 Z M 32.96875 37.046875 L 31.625 37.046875 L 31.625 34.546875 L 32.96875 34.546875 C 33.65625 34.546875 34.203125 35.09375 34.203125 35.78125 C 34.203125 36.46875 33.65625 37.046875 32.96875 37.046875 Z M 33.578125 42.015625 L 31.625 42.015625 L 31.625 38.78125 L 33.578125 38.78125 C 34.46875 38.796875 35.1875 39.5 35.1875 40.390625 C 35.1875 41.296875 34.46875 42 33.578125 42.015625 Z M 40.03125 43.75 C 40.515625 43.75 40.90625 43.359375 40.90625 42.890625 L 40.90625 39.5 L 42.828125 39.5 C 44.6875 39.5 46.1875 38 46.1875 36.171875 C 46.1875 34.3125 44.6875 32.8125 42.828125 32.8125 L 40.03125 32.8125 C 39.5625 32.8125 39.171875 33.1875 39.171875 33.671875 L 39.171875 42.890625 C 39.171875 43.359375 39.5625 43.75 40.03125 43.75 Z M 42.828125 37.765625 L 40.90625 37.765625 L 40.90625 34.546875 L 42.828125 34.546875 C 43.734375 34.546875 44.4375 35.265625 44.453125 36.171875 C 44.4375 37.046875 43.734375 37.765625 42.828125 37.765625 Z M 42.828125 37.765625 \"/>\n      </g>"
    },
    wmvIcon: {
      extension: '.wmv',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 8.484375 43.734375 L 8.53125 43.734375 C 8.5625 43.71875 8.59375 43.703125 8.65625 43.703125 L 8.664062 43.6875 C 8.671875 43.6875 8.671875 43.6875 8.6875 43.6875 C 8.71875 43.671875 8.765625 43.625 8.8125 43.59375 L 8.84375 43.59375 C 8.875 43.5625 8.90625 43.53125 8.9375 43.515625 C 8.9375 43.5 8.953125 43.5 8.953125 43.46875 L 9.046875 43.375 C 9.046875 43.375 9.046875 43.359375 9.0625 43.359375 C 9.078125 43.328125 9.109375 43.265625 9.125 43.21875 L 11.171875 38.375 L 13.21875 43.21875 C 13.234375 43.265625 13.25 43.328125 13.28125 43.359375 C 13.28125 43.359375 13.28125 43.375 13.3125 43.375 L 13.375 43.46875 C 13.390625 43.5 13.390625 43.5 13.40625 43.515625 L 13.453125 43.546875 L 13.515625 43.59375 C 13.515625 43.59375 13.515625 43.59375 13.53125 43.59375 C 13.5625 43.625 13.609375 43.671875 13.671875 43.6875 C 13.6875 43.6875 13.6875 43.6875 13.703125 43.703125 C 13.734375 43.703125 13.765625 43.71875 13.8125 43.734375 L 13.859375 43.734375 L 13.929688 43.746094 L 14 43.75 C 14.0625 43.75 14.109375 43.75 14.15625 43.734375 L 14.1875 43.734375 C 14.234375 43.71875 14.28125 43.703125 14.3125 43.703125 C 14.3125 43.6875 14.328125 43.6875 14.328125 43.6875 L 14.34375 43.6875 C 14.40625 43.671875 14.4375 43.625 14.484375 43.59375 L 14.5 43.59375 C 14.53125 43.5625 14.578125 43.53125 14.609375 43.515625 C 14.609375 43.5 14.625 43.5 14.625 43.46875 C 14.65625 43.4375 14.6875 43.40625 14.703125 43.375 L 14.71875 43.359375 C 14.75 43.328125 14.78125 43.265625 14.796875 43.21875 L 18.625 34.109375 C 18.8125 33.6875 18.609375 33.171875 18.1875 33 C 17.734375 32.8125 17.234375 33.015625 17.046875 33.453125 L 14 40.6875 L 11.984375 35.890625 C 11.828125 35.546875 11.5 35.359375 11.171875 35.359375 C 10.828125 35.359375 10.5 35.546875 10.359375 35.890625 L 8.34375 40.6875 L 5.28125 33.453125 C 5.109375 33.015625 4.59375 32.8125 4.171875 33 C 3.71875 33.171875 3.53125 33.6875 3.703125 34.109375 L 7.546875 43.21875 C 7.578125 43.265625 7.59375 43.328125 7.625 43.359375 L 7.625 43.375 C 7.65625 43.40625 7.671875 43.4375 7.703125 43.46875 C 7.71875 43.5 7.71875 43.5 7.734375 43.515625 L 7.789062 43.546875 L 7.84375 43.59375 C 7.84375 43.59375 7.84375 43.59375 7.859375 43.59375 C 7.890625 43.625 7.953125 43.671875 8 43.6875 C 8.015625 43.6875 8.015625 43.6875 8.03125 43.703125 C 8.0625 43.703125 8.09375 43.71875 8.140625 43.734375 L 8.1875 43.734375 L 8.265625 43.746094 L 8.34375 43.75 C 8.390625 43.75 8.4375 43.75 8.484375 43.734375 Z M 29.03125 43.75 C 29.5 43.75 29.90625 43.359375 29.90625 42.890625 L 29.90625 33.671875 C 29.90625 33.269531 29.609375 32.9375 29.226562 32.839844 L 29.03125 32.8125 L 29.015625 32.8125 C 28.734375 32.8125 28.484375 32.9375 28.3125 33.171875 L 25.203125 37.484375 L 22.09375 33.171875 C 21.9375 32.9375 21.65625 32.8125 21.40625 32.8125 L 21.359375 32.8125 C 20.890625 32.8125 20.5 33.203125 20.5 33.671875 L 20.5 42.890625 C 20.5 43.359375 20.890625 43.75 21.359375 43.75 C 21.84375 43.75 22.234375 43.359375 22.234375 42.890625 L 22.234375 36.3125 L 24.46875 39.4375 C 24.640625 39.671875 24.90625 39.796875 25.1875 39.796875 L 25.21875 39.796875 C 25.5 39.796875 25.75 39.671875 25.921875 39.4375 L 28.171875 36.3125 L 28.171875 42.890625 C 28.171875 43.359375 28.546875 43.75 29.03125 43.75 Z M 37.015625 43.734375 L 37.0625 43.734375 C 37.09375 43.71875 37.125 43.703125 37.1875 43.703125 L 37.195312 43.6875 C 37.203125 43.6875 37.203125 43.6875 37.21875 43.6875 C 37.25 43.671875 37.296875 43.625 37.34375 43.59375 L 37.375 43.59375 C 37.40625 43.5625 37.4375 43.53125 37.46875 43.515625 C 37.46875 43.5 37.484375 43.5 37.484375 43.46875 L 37.578125 43.375 C 37.578125 43.375 37.578125 43.359375 37.59375 43.359375 C 37.609375 43.328125 37.640625 43.265625 37.65625 43.21875 L 39.703125 38.375 L 41.75 43.21875 C 41.765625 43.265625 41.78125 43.328125 41.8125 43.359375 C 41.8125 43.359375 41.8125 43.375 41.84375 43.375 L 41.90625 43.46875 C 41.921875 43.5 41.921875 43.5 41.9375 43.515625 L 41.984375 43.546875 L 42.046875 43.59375 C 42.046875 43.59375 42.046875 43.59375 42.0625 43.59375 C 42.09375 43.625 42.140625 43.671875 42.203125 43.6875 C 42.21875 43.6875 42.21875 43.6875 42.234375 43.703125 C 42.265625 43.703125 42.296875 43.71875 42.34375 43.734375 L 42.390625 43.734375 L 42.460938 43.746094 L 42.53125 43.75 C 42.59375 43.75 42.640625 43.75 42.6875 43.734375 L 42.71875 43.734375 C 42.765625 43.71875 42.8125 43.703125 42.84375 43.703125 C 42.84375 43.6875 42.859375 43.6875 42.859375 43.6875 L 42.875 43.6875 C 42.9375 43.671875 42.96875 43.625 43.015625 43.59375 L 43.03125 43.59375 C 43.0625 43.5625 43.109375 43.53125 43.140625 43.515625 C 43.140625 43.5 43.15625 43.5 43.15625 43.46875 C 43.1875 43.4375 43.21875 43.40625 43.234375 43.375 L 43.25 43.359375 C 43.28125 43.328125 43.3125 43.265625 43.328125 43.21875 L 47.15625 34.109375 C 47.34375 33.6875 47.140625 33.171875 46.71875 33 C 46.265625 32.8125 45.765625 33.015625 45.578125 33.453125 L 42.53125 40.6875 L 40.515625 35.890625 C 40.359375 35.546875 40.03125 35.359375 39.703125 35.359375 C 39.359375 35.359375 39.03125 35.546875 38.890625 35.890625 L 36.875 40.6875 L 33.8125 33.453125 C 33.640625 33.015625 33.125 32.8125 32.703125 33 C 32.25 33.171875 32.0625 33.6875 32.234375 34.109375 L 36.078125 43.21875 C 36.109375 43.265625 36.125 43.328125 36.15625 43.359375 L 36.15625 43.375 C 36.1875 43.40625 36.203125 43.4375 36.234375 43.46875 C 36.25 43.5 36.25 43.5 36.265625 43.515625 L 36.320312 43.546875 L 36.375 43.59375 C 36.375 43.59375 36.375 43.59375 36.390625 43.59375 C 36.421875 43.625 36.484375 43.671875 36.53125 43.6875 C 36.546875 43.6875 36.546875 43.6875 36.5625 43.703125 C 36.59375 43.703125 36.625 43.71875 36.671875 43.734375 L 36.71875 43.734375 L 36.796875 43.746094 L 36.875 43.75 C 36.921875 43.75 36.96875 43.75 37.015625 43.734375 Z M 37.015625 43.734375 \"/>\n      </g>"
    },
    xlsIcon: {
      extension: '.xls',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 17.21875 46.875 C 17.425781 46.875 17.632812 46.800781 17.820312 46.667969 C 18.289062 46.351562 18.363281 45.695312 18.042969 45.242188 L 14.480469 40.367188 L 18.042969 35.53125 C 18.363281 35.0625 18.289062 34.425781 17.820312 34.105469 C 17.351562 33.75 16.730469 33.84375 16.375 34.332031 L 13.226562 38.644531 L 10.054688 34.332031 C 9.738281 33.84375 9.082031 33.75 8.632812 34.105469 C 8.164062 34.425781 8.070312 35.0625 8.386719 35.53125 L 11.949219 40.367188 L 8.386719 45.242188 C 8.070312 45.695312 8.164062 46.351562 8.632812 46.667969 C 8.800781 46.800781 9.007812 46.875 9.230469 46.875 C 9.550781 46.875 9.851562 46.707031 10.054688 46.445312 L 13.226562 42.113281 L 16.375 46.445312 C 16.582031 46.707031 16.882812 46.875 17.21875 46.875 Z M 29.351562 46.875 C 29.894531 46.875 30.382812 46.40625 30.382812 45.84375 C 30.382812 45.261719 29.894531 44.792969 29.351562 44.792969 L 24.269531 44.792969 L 24.269531 34.78125 C 24.269531 34.21875 23.800781 33.75 23.21875 33.75 C 22.636719 33.75 22.1875 34.21875 22.1875 34.78125 L 22.1875 45.84375 C 22.1875 46.335938 22.53125 46.757812 23.007812 46.855469 L 23.222656 46.875 Z M 37.28125 46.855469 C 38.613281 46.855469 39.832031 46.460938 40.75 45.789062 C 41.6875 45.113281 42.363281 44.082031 42.363281 42.882812 C 42.363281 42.300781 42.195312 41.738281 41.914062 41.289062 C 41.480469 40.59375 40.804688 40.105469 40.039062 39.730469 C 39.289062 39.375 38.40625 39.132812 37.449219 38.945312 L 37.414062 38.945312 C 36.398438 38.757812 35.554688 38.457031 35.070312 38.117188 C 34.824219 37.949219 34.65625 37.78125 34.5625 37.632812 C 34.46875 37.480469 34.429688 37.332031 34.429688 37.105469 C 34.429688 36.710938 34.636719 36.300781 35.144531 35.925781 C 35.648438 35.550781 36.398438 35.289062 37.242188 35.289062 C 38.386719 35.289062 39.304688 35.851562 40.261719 36.488281 C 40.710938 36.789062 41.3125 36.65625 41.59375 36.207031 C 41.894531 35.773438 41.761719 35.175781 41.332031 34.875 C 40.375 34.257812 39.042969 33.375 37.242188 33.375 C 36.023438 33.375 34.882812 33.730469 34 34.367188 C 33.136719 35.007812 32.5 35.980469 32.5 37.105469 C 32.5 37.667969 32.648438 38.195312 32.929688 38.644531 C 33.34375 39.300781 33.960938 39.769531 34.675781 40.105469 C 35.386719 40.445312 36.210938 40.667969 37.09375 40.835938 L 37.132812 40.835938 C 38.238281 41.042969 39.15625 41.363281 39.699219 41.71875 C 39.980469 41.90625 40.148438 42.09375 40.261719 42.28125 C 40.375 42.46875 40.429688 42.636719 40.429688 42.882812 C 40.429688 43.351562 40.1875 43.820312 39.625 44.230469 C 39.0625 44.644531 38.21875 44.925781 37.28125 44.925781 C 35.949219 44.945312 34.523438 44.15625 33.699219 43.480469 C 33.289062 43.144531 32.667969 43.199219 32.332031 43.613281 C 32.011719 44.023438 32.070312 44.644531 32.480469 44.980469 C 33.550781 45.824219 35.257812 46.835938 37.28125 46.855469 Z M 37.28125 46.855469 \"/>\n      </g>"
    },
    xlsxIcon: {
      extension: '.xlsx',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 13.070312 43.75 C 13.242188 43.75 13.414062 43.6875 13.570312 43.578125 C 13.960938 43.3125 14.023438 42.765625 13.757812 42.390625 L 10.789062 38.328125 L 13.757812 34.296875 C 14.023438 33.90625 13.960938 33.375 13.570312 33.109375 C 13.179688 32.8125 12.664062 32.890625 12.367188 33.296875 L 9.742188 36.890625 L 7.101562 33.296875 C 6.835938 32.890625 6.289062 32.8125 5.914062 33.109375 C 5.523438 33.375 5.445312 33.90625 5.710938 34.296875 L 8.679688 38.328125 L 5.710938 42.390625 C 5.445312 42.765625 5.523438 43.3125 5.914062 43.578125 C 6.054688 43.6875 6.226562 43.75 6.414062 43.75 C 6.679688 43.75 6.929688 43.609375 7.101562 43.390625 L 9.742188 39.78125 L 12.367188 43.390625 C 12.539062 43.609375 12.789062 43.75 13.070312 43.75 Z M 23.179688 43.75 C 23.632812 43.75 24.039062 43.359375 24.039062 42.890625 C 24.039062 42.40625 23.632812 42.015625 23.179688 42.015625 L 18.945312 42.015625 L 18.945312 33.671875 C 18.945312 33.203125 18.554688 32.8125 18.070312 32.8125 C 17.585938 32.8125 17.210938 33.203125 17.210938 33.671875 L 17.210938 42.890625 C 17.210938 43.359375 17.585938 43.75 18.070312 43.75 Z M 29.789062 43.734375 C 30.898438 43.734375 31.914062 43.40625 32.679688 42.84375 C 33.460938 42.28125 34.023438 41.421875 34.023438 40.421875 C 34.023438 39.9375 33.882812 39.46875 33.648438 39.09375 C 33.289062 38.515625 32.726562 38.109375 32.085938 37.796875 C 31.460938 37.5 30.726562 37.296875 29.929688 37.140625 L 29.898438 37.140625 C 29.054688 36.984375 28.351562 36.734375 27.945312 36.453125 C 27.742188 36.3125 27.601562 36.171875 27.523438 36.046875 C 27.445312 35.921875 27.414062 35.796875 27.414062 35.609375 C 27.414062 35.28125 27.585938 34.9375 28.007812 34.625 C 28.429688 34.3125 29.054688 34.09375 29.757812 34.09375 C 30.710938 34.09375 31.476562 34.5625 32.273438 35.09375 C 32.648438 35.34375 33.148438 35.234375 33.382812 34.859375 C 33.632812 34.5 33.523438 34 33.164062 33.75 C 32.367188 33.234375 31.257812 32.5 29.757812 32.5 C 28.742188 32.5 27.789062 32.796875 27.054688 33.328125 C 26.335938 33.859375 25.804688 34.671875 25.804688 35.609375 C 25.804688 36.078125 25.929688 36.515625 26.164062 36.890625 C 26.507812 37.4375 27.023438 37.828125 27.617188 38.109375 C 28.210938 38.390625 28.898438 38.578125 29.632812 38.71875 L 29.664062 38.71875 C 30.585938 38.890625 31.351562 39.15625 31.804688 39.453125 C 32.039062 39.609375 32.179688 39.765625 32.273438 39.921875 C 32.367188 40.078125 32.414062 40.21875 32.414062 40.421875 C 32.414062 40.8125 32.210938 41.203125 31.742188 41.546875 C 31.273438 41.890625 30.570312 42.125 29.789062 42.125 C 28.679688 42.140625 27.492188 41.484375 26.804688 40.921875 C 26.460938 40.640625 25.945312 40.6875 25.664062 41.03125 C 25.398438 41.375 25.445312 41.890625 25.789062 42.171875 C 26.679688 42.875 28.101562 43.71875 29.789062 43.734375 Z M 43.179688 43.75 C 43.351562 43.75 43.523438 43.6875 43.679688 43.578125 C 44.070312 43.3125 44.132812 42.765625 43.867188 42.390625 L 40.898438 38.328125 L 43.867188 34.296875 C 44.132812 33.90625 44.070312 33.375 43.679688 33.109375 C 43.289062 32.8125 42.773438 32.890625 42.476562 33.296875 L 39.851562 36.890625 L 37.210938 33.296875 C 36.945312 32.890625 36.398438 32.8125 36.023438 33.109375 C 35.632812 33.375 35.554688 33.90625 35.820312 34.296875 L 38.789062 38.328125 L 35.820312 42.390625 C 35.554688 42.765625 35.632812 43.3125 36.023438 43.578125 C 36.164062 43.6875 36.335938 43.75 36.523438 43.75 C 36.789062 43.75 37.039062 43.609375 37.210938 43.390625 L 39.851562 39.78125 L 42.476562 43.390625 C 42.648438 43.609375 42.898438 43.75 43.179688 43.75 Z M 43.179688 43.75 \"/>\n      </g>"
    },
    zipIcon: {
      extension: '.zip',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 20.175781 46.875 C 20.855469 46.875 21.402344 46.351562 21.402344 45.671875 C 21.402344 44.992188 20.855469 44.445312 20.175781 44.445312 L 13.132812 44.445312 L 21.183594 33.488281 L 21.183594 33.445312 C 21.203125 33.421875 21.226562 33.378906 21.25 33.335938 C 21.269531 33.3125 21.269531 33.289062 21.292969 33.269531 C 21.3125 33.203125 21.3125 33.179688 21.335938 33.136719 C 21.335938 33.09375 21.378906 33.070312 21.378906 33.007812 C 21.378906 32.984375 21.378906 32.960938 21.402344 32.917969 L 21.402344 32.679688 C 21.402344 32.632812 21.402344 32.613281 21.378906 32.546875 C 21.378906 32.503906 21.378906 32.480469 21.335938 32.4375 C 21.335938 32.414062 21.3125 32.371094 21.3125 32.304688 C 21.292969 32.285156 21.269531 32.242188 21.269531 32.21875 C 21.25 32.195312 21.226562 32.152344 21.203125 32.109375 C 21.183594 32.066406 21.160156 32.042969 21.117188 32.023438 C 21.09375 32 21.074219 31.957031 21.050781 31.933594 C 21.03125 31.914062 21.007812 31.867188 20.964844 31.847656 C 20.941406 31.824219 20.941406 31.804688 20.898438 31.78125 L 20.875 31.78125 C 20.832031 31.757812 20.8125 31.738281 20.765625 31.714844 C 20.746094 31.695312 20.722656 31.648438 20.65625 31.648438 L 20.570312 31.605469 L 20.4375 31.585938 C 20.417969 31.585938 20.375 31.5625 20.351562 31.5625 L 10.75 31.5625 C 10.070312 31.5625 9.546875 32.085938 9.546875 32.765625 C 9.546875 33.421875 10.070312 33.992188 10.75 33.992188 L 17.8125 33.992188 L 9.785156 44.972656 L 9.765625 44.972656 C 9.742188 45.015625 9.71875 45.058594 9.699219 45.082031 C 9.699219 45.101562 9.675781 45.148438 9.632812 45.167969 C 9.632812 45.210938 9.609375 45.257812 9.609375 45.277344 C 9.589844 45.320312 9.589844 45.367188 9.566406 45.386719 L 9.566406 45.496094 C 9.546875 45.539062 9.546875 45.585938 9.546875 45.648438 L 9.546875 45.738281 C 9.546875 45.78125 9.566406 45.824219 9.566406 45.890625 C 9.566406 45.933594 9.589844 45.957031 9.589844 45.976562 L 9.632812 46.109375 C 9.632812 46.152344 9.675781 46.175781 9.699219 46.21875 C 9.699219 46.242188 9.71875 46.261719 9.742188 46.328125 C 9.765625 46.351562 9.785156 46.394531 9.808594 46.414062 C 9.828125 46.4375 9.851562 46.460938 9.894531 46.480469 L 9.9375 46.542969 L 9.984375 46.589844 C 10.003906 46.613281 10.027344 46.632812 10.046875 46.632812 L 10.046875 46.65625 C 10.070312 46.679688 10.09375 46.679688 10.136719 46.699219 C 10.179688 46.722656 10.222656 46.742188 10.246094 46.742188 C 10.265625 46.789062 10.289062 46.789062 10.3125 46.808594 C 10.375 46.808594 10.421875 46.832031 10.464844 46.832031 C 10.484375 46.851562 10.507812 46.851562 10.53125 46.851562 L 10.648438 46.871094 Z M 26.214844 46.875 C 26.871094 46.875 27.4375 46.351562 27.4375 45.671875 L 27.4375 32.765625 C 27.4375 32.085938 26.871094 31.5625 26.214844 31.5625 C 25.535156 31.5625 25.011719 32.085938 25.011719 32.765625 L 25.011719 45.671875 C 25.011719 46.351562 25.535156 46.875 26.214844 46.875 Z M 32.734375 46.875 C 33.410156 46.875 33.957031 46.328125 33.957031 45.671875 L 33.957031 40.925781 L 36.648438 40.925781 C 39.25 40.925781 41.351562 38.824219 41.351562 36.265625 C 41.351562 33.664062 39.25 31.5625 36.648438 31.5625 L 32.734375 31.5625 C 32.078125 31.5625 31.53125 32.085938 31.53125 32.765625 L 31.53125 45.671875 C 31.53125 46.328125 32.078125 46.875 32.734375 46.875 Z M 36.648438 38.496094 L 33.957031 38.496094 L 33.957031 33.992188 L 36.648438 33.992188 C 37.917969 33.992188 38.902344 34.996094 38.921875 36.265625 C 38.902344 37.492188 37.917969 38.496094 36.648438 38.496094 Z M 36.648438 38.496094 \"/>\n      </g>"
    },
    docxIcon: {
      extension: '.docx',
      path: "<g id=\"surface9\" clip-path=\"url(#clip1)\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      </g>\n      </defs>\n      <g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <use xlink:href=\"#surface9\" mask=\"url(#mask0)\"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 7.789062 43.75 C 9.589844 43.75 10.988281 43.269531 11.984375 42.304688 C 12.980469 41.339844 13.476562 39.984375 13.476562 38.234375 C 13.476562 36.496094 12.980469 35.144531 11.984375 34.179688 C 10.988281 33.214844 9.589844 32.734375 7.789062 32.734375 L 4.695312 32.734375 C 4.394531 32.734375 4.15625 32.816406 3.984375 32.984375 C 3.8125 33.152344 3.726562 33.386719 3.726562 33.6875 L 3.726562 42.796875 C 3.726562 43.097656 3.8125 43.332031 3.984375 43.5 C 4.15625 43.667969 4.394531 43.75 4.695312 43.75 Z M 7.664062 42.109375 L 5.742188 42.109375 L 5.742188 34.375 L 7.664062 34.375 C 10.195312 34.375 11.460938 35.660156 11.460938 38.234375 C 11.460938 40.816406 10.195312 42.109375 7.664062 42.109375 Z M 20.414062 43.890625 C 21.476562 43.890625 22.402344 43.660156 23.1875 43.203125 C 23.972656 42.746094 24.582031 42.089844 25.007812 41.234375 C 25.433594 40.378906 25.648438 39.378906 25.648438 38.234375 C 25.648438 37.089844 25.4375 36.089844 25.015625 35.242188 C 24.59375 34.394531 23.988281 33.738281 23.203125 33.28125 C 22.417969 32.824219 21.488281 32.59375 20.414062 32.59375 C 19.339844 32.59375 18.410156 32.824219 17.617188 33.28125 C 16.824219 33.738281 16.21875 34.394531 15.796875 35.242188 C 15.375 36.089844 15.164062 37.089844 15.164062 38.234375 C 15.164062 39.378906 15.378906 40.378906 15.804688 41.234375 C 16.230469 42.089844 16.839844 42.746094 17.625 43.203125 C 18.410156 43.660156 19.339844 43.890625 20.414062 43.890625 Z M 20.414062 42.28125 C 19.394531 42.28125 18.597656 41.933594 18.03125 41.234375 C 17.464844 40.535156 17.179688 39.535156 17.179688 38.234375 C 17.179688 36.933594 17.464844 35.933594 18.03125 35.242188 C 18.597656 34.550781 19.394531 34.203125 20.414062 34.203125 C 21.425781 34.203125 22.214844 34.550781 22.78125 35.242188 C 23.347656 35.933594 23.632812 36.933594 23.632812 38.234375 C 23.632812 39.535156 23.347656 40.535156 22.78125 41.234375 C 22.214844 41.933594 21.425781 42.28125 20.414062 42.28125 Z M 32.601562 43.890625 C 33.289062 43.890625 33.933594 43.789062 34.539062 43.585938 C 35.144531 43.382812 35.679688 43.089844 36.148438 42.703125 C 36.285156 42.597656 36.378906 42.488281 36.429688 42.367188 C 36.480469 42.246094 36.507812 42.109375 36.507812 41.953125 C 36.507812 41.722656 36.445312 41.53125 36.320312 41.375 C 36.195312 41.21875 36.042969 41.140625 35.867188 41.140625 C 35.753906 41.140625 35.644531 41.160156 35.539062 41.203125 C 35.433594 41.246094 35.332031 41.296875 35.226562 41.359375 C 34.746094 41.683594 34.316406 41.910156 33.9375 42.046875 C 33.558594 42.183594 33.144531 42.25 32.695312 42.25 C 31.613281 42.25 30.792969 41.910156 30.234375 41.234375 C 29.675781 40.558594 29.398438 39.558594 29.398438 38.234375 C 29.398438 36.921875 29.675781 35.925781 30.234375 35.25 C 30.792969 34.574219 31.613281 34.234375 32.695312 34.234375 C 33.164062 34.234375 33.589844 34.300781 33.976562 34.429688 C 34.363281 34.558594 34.777344 34.792969 35.226562 35.125 C 35.445312 35.269531 35.660156 35.34375 35.867188 35.34375 C 36.042969 35.34375 36.195312 35.265625 36.320312 35.109375 C 36.445312 34.953125 36.507812 34.761719 36.507812 34.53125 C 36.507812 34.363281 36.480469 34.222656 36.429688 34.109375 C 36.378906 33.996094 36.285156 33.886719 36.148438 33.78125 C 35.679688 33.394531 35.144531 33.101562 34.539062 32.898438 C 33.933594 32.695312 33.289062 32.59375 32.601562 32.59375 C 31.539062 32.59375 30.609375 32.824219 29.8125 33.28125 C 29.015625 33.738281 28.402344 34.394531 27.976562 35.242188 C 27.550781 36.089844 27.335938 37.089844 27.335938 38.234375 C 27.335938 39.378906 27.550781 40.378906 27.976562 41.234375 C 28.402344 42.089844 29.015625 42.746094 29.8125 43.203125 C 30.609375 43.660156 31.539062 43.890625 32.601562 43.890625 Z M 46.132812 43.84375 C 46.382812 43.84375 46.605469 43.75 46.796875 43.5625 C 46.988281 43.375 47.085938 43.15625 47.085938 42.90625 C 47.085938 42.707031 47.003906 42.511719 46.835938 42.3125 L 43.445312 38.15625 L 46.710938 34.171875 C 46.867188 34.003906 46.945312 33.808594 46.945312 33.578125 C 46.945312 33.328125 46.847656 33.113281 46.65625 32.929688 C 46.464844 32.746094 46.242188 32.65625 45.992188 32.65625 C 45.730469 32.65625 45.507812 32.769531 45.320312 33 L 42.273438 36.765625 L 39.226562 33 C 39.027344 32.769531 38.800781 32.65625 38.539062 32.65625 C 38.289062 32.65625 38.070312 32.746094 37.882812 32.929688 C 37.695312 33.113281 37.601562 33.328125 37.601562 33.578125 C 37.601562 33.808594 37.679688 34.003906 37.835938 34.171875 L 41.101562 38.15625 L 37.695312 42.3125 C 37.539062 42.5 37.460938 42.699219 37.460938 42.90625 C 37.460938 43.15625 37.558594 43.371094 37.75 43.554688 C 37.941406 43.738281 38.164062 43.828125 38.414062 43.828125 C 38.675781 43.828125 38.898438 43.71875 39.085938 43.5 L 42.273438 39.5625 L 45.445312 43.5 C 45.644531 43.730469 45.871094 43.84375 46.132812 43.84375 Z M 46.132812 43.84375 \"/>\n      </g>"
    },
    jpgIcon: {
      extension: '.jpg',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <use xlink:href=\"#surface9\" mask=\"url(#mask0)\"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 8.789062 47.007812 L 9.488281 46.960938 C 12.214844 46.757812 13.578125 45.277344 13.578125 42.523438 L 13.578125 32.742188 C 13.578125 32.320312 13.453125 31.980469 13.195312 31.726562 C 12.941406 31.472656 12.59375 31.34375 12.15625 31.34375 C 11.734375 31.34375 11.394531 31.472656 11.140625 31.726562 C 10.886719 31.980469 10.757812 32.320312 10.757812 32.742188 L 10.757812 42.523438 C 10.757812 43.238281 10.605469 43.769531 10.296875 44.117188 C 9.992188 44.46875 9.539062 44.660156 8.941406 44.6875 L 8.242188 44.730469 C 7.847656 44.761719 7.558594 44.867188 7.378906 45.046875 C 7.195312 45.230469 7.105469 45.496094 7.105469 45.847656 C 7.105469 46.664062 7.667969 47.050781 8.789062 47.007812 Z M 18.304688 47.007812 C 18.742188 47.007812 19.089844 46.878906 19.34375 46.625 C 19.597656 46.367188 19.726562 46.023438 19.726562 45.585938 L 19.726562 40.882812 L 23.640625 40.882812 C 25.289062 40.882812 26.574219 40.464844 27.492188 39.632812 C 28.410156 38.804688 28.871094 37.644531 28.871094 36.15625 C 28.871094 34.667969 28.410156 33.511719 27.492188 32.6875 C 26.574219 31.863281 25.289062 31.453125 23.640625 31.453125 L 18.261719 31.453125 C 17.839844 31.453125 17.507812 31.570312 17.265625 31.804688 C 17.023438 32.035156 16.90625 32.363281 16.90625 32.789062 L 16.90625 45.585938 C 16.90625 46.023438 17.03125 46.367188 17.289062 46.625 C 17.542969 46.878906 17.882812 47.007812 18.304688 47.007812 Z M 23.292969 38.714844 L 19.726562 38.714844 L 19.726562 33.640625 L 23.292969 33.640625 C 25.230469 33.640625 26.203125 34.488281 26.203125 36.179688 C 26.203125 37.871094 25.230469 38.714844 23.292969 38.714844 Z M 38.605469 47.070312 C 39.320312 47.070312 40.0625 47.011719 40.835938 46.898438 C 41.609375 46.78125 42.285156 46.621094 42.871094 46.414062 C 43.410156 46.242188 43.765625 46.015625 43.941406 45.738281 C 44.117188 45.460938 44.203125 44.988281 44.203125 44.316406 L 44.203125 39.613281 C 44.203125 39.292969 44.101562 39.03125 43.898438 38.835938 C 43.695312 38.640625 43.425781 38.539062 43.089844 38.539062 L 39.21875 38.539062 C 38.867188 38.539062 38.59375 38.628906 38.398438 38.804688 C 38.199219 38.976562 38.101562 39.226562 38.101562 39.546875 C 38.101562 39.867188 38.199219 40.117188 38.398438 40.289062 C 38.59375 40.464844 38.867188 40.554688 39.21875 40.554688 L 41.6875 40.554688 L 41.6875 44.425781 C 40.699219 44.703125 39.707031 44.839844 38.714844 44.839844 C 35.390625 44.839844 33.726562 42.945312 33.726562 39.152344 C 33.726562 37.300781 34.132812 35.90625 34.941406 34.964844 C 35.75 34.023438 36.949219 33.554688 38.539062 33.554688 C 39.238281 33.554688 39.867188 33.644531 40.421875 33.828125 C 40.972656 34.007812 41.574219 34.324219 42.214844 34.777344 C 42.390625 34.894531 42.542969 34.980469 42.671875 35.03125 C 42.804688 35.082031 42.949219 35.105469 43.109375 35.105469 C 43.359375 35.105469 43.570312 34.996094 43.746094 34.777344 C 43.921875 34.558594 44.007812 34.289062 44.007812 33.96875 C 44.007812 33.75 43.96875 33.558594 43.886719 33.398438 C 43.808594 33.238281 43.679688 33.078125 43.503906 32.917969 C 42.191406 31.808594 40.507812 31.257812 38.453125 31.257812 C 36.90625 31.257812 35.5625 31.574219 34.425781 32.207031 C 33.289062 32.84375 32.410156 33.753906 31.789062 34.941406 C 31.171875 36.128906 30.859375 37.535156 30.859375 39.152344 C 30.859375 40.800781 31.171875 42.21875 31.789062 43.40625 C 32.410156 44.597656 33.304688 45.503906 34.46875 46.132812 C 35.636719 46.757812 37.015625 47.070312 38.605469 47.070312 Z M 38.605469 47.070312 \"/>\n      </g>"
    },
    mp3Icon: {
      extension: '.mp3',
      path: "<g id=\"surface9\" clip-path=\"url(#clip1)\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 43.828125 43.710938 C 43.605469 44.28125 43.273438 44.804688 42.84375 45.265625 C 42.40625 45.730469 41.867188 46.113281 41.242188 46.398438 C 40.597656 46.699219 39.851562 46.855469 39.027344 46.855469 C 38.328125 46.855469 37.703125 46.757812 37.160156 46.570312 C 36.609375 46.378906 36.160156 46.136719 35.769531 45.839844 C 35.386719 45.550781 35.050781 45.210938 34.796875 44.832031 C 34.570312 44.507812 34.394531 44.195312 34.265625 43.890625 C 34.140625 43.59375 34.054688 43.335938 33.996094 43.101562 C 33.792969 42.261719 34.304688 41.417969 35.140625 41.210938 C 35.980469 41.007812 36.828125 41.519531 37.03125 42.355469 C 37.039062 42.390625 37.066406 42.488281 37.144531 42.671875 C 37.191406 42.777344 37.265625 42.914062 37.371094 43.0625 C 37.4375 43.160156 37.53125 43.257812 37.65625 43.351562 C 37.792969 43.453125 37.972656 43.542969 38.195312 43.625 C 38.332031 43.667969 38.59375 43.730469 39.027344 43.730469 C 39.390625 43.730469 39.695312 43.675781 39.925781 43.566406 C 40.1875 43.445312 40.398438 43.300781 40.558594 43.132812 C 40.71875 42.957031 40.839844 42.773438 40.914062 42.578125 C 40.996094 42.371094 41.03125 42.195312 41.03125 42.023438 C 41.03125 41.789062 41 41.585938 40.921875 41.398438 C 40.871094 41.257812 40.785156 41.148438 40.660156 41.039062 C 40.515625 40.910156 40.296875 40.792969 40.011719 40.699219 C 39.6875 40.59375 39.253906 40.539062 38.738281 40.535156 C 37.882812 40.527344 37.1875 39.832031 37.1875 38.972656 L 37.1875 38.832031 C 37.1875 37.984375 37.859375 37.292969 38.699219 37.265625 C 39.070312 37.257812 39.398438 37.195312 39.679688 37.101562 C 39.921875 37.011719 40.121094 36.902344 40.273438 36.773438 C 40.40625 36.652344 40.507812 36.519531 40.582031 36.359375 C 40.652344 36.210938 40.6875 36.027344 40.6875 35.8125 C 40.6875 35.523438 40.644531 35.289062 40.574219 35.125 C 40.5 34.96875 40.414062 34.847656 40.304688 34.757812 C 40.1875 34.660156 40.042969 34.582031 39.867188 34.53125 C 39.402344 34.386719 38.878906 34.398438 38.480469 34.542969 C 38.289062 34.617188 38.121094 34.714844 37.976562 34.84375 C 37.820312 34.984375 37.695312 35.148438 37.59375 35.339844 C 37.484375 35.550781 37.40625 35.773438 37.367188 36.039062 C 37.230469 36.890625 36.429688 37.472656 35.574219 37.335938 C 34.722656 37.195312 34.140625 36.398438 34.28125 35.542969 C 34.378906 34.9375 34.5625 34.378906 34.835938 33.871094 C 35.109375 33.355469 35.464844 32.898438 35.890625 32.519531 C 36.320312 32.132812 36.824219 31.828125 37.382812 31.617188 C 38.433594 31.226562 39.667969 31.199219 40.78125 31.539062 C 41.351562 31.714844 41.863281 31.992188 42.308594 32.355469 C 42.777344 32.753906 43.148438 33.242188 43.414062 33.824219 C 43.679688 34.402344 43.8125 35.070312 43.8125 35.8125 C 43.8125 36.476562 43.679688 37.097656 43.421875 37.660156 C 43.25 38.046875 43.023438 38.394531 42.746094 38.707031 C 43.242188 39.148438 43.609375 39.671875 43.835938 40.261719 C 44.046875 40.804688 44.15625 41.398438 44.15625 42.023438 C 44.15625 42.578125 44.046875 43.148438 43.828125 43.710938 Z M 31.445312 38.492188 C 31.148438 39.140625 30.734375 39.703125 30.199219 40.164062 C 29.6875 40.605469 29.078125 40.957031 28.390625 41.199219 C 27.71875 41.4375 26.976562 41.5625 26.191406 41.5625 L 25 41.5625 L 25 45 C 25 45.859375 24.296875 46.5625 23.4375 46.5625 C 22.578125 46.5625 21.875 45.859375 21.875 45 L 21.875 32.8125 C 21.875 31.945312 22.578125 31.25 23.4375 31.25 L 26.191406 31.25 C 27.890625 31.25 29.257812 31.667969 30.253906 32.5 C 31.339844 33.398438 31.886719 34.714844 31.886719 36.40625 C 31.886719 37.148438 31.738281 37.851562 31.445312 38.492188 Z M 18.730469 45.210938 C 18.730469 46.070312 18.03125 46.773438 17.167969 46.773438 C 16.300781 46.773438 15.605469 46.070312 15.605469 45.210938 L 15.605469 39.28125 L 14.015625 43.140625 C 14.007812 43.164062 13.996094 43.191406 13.984375 43.214844 C 13.71875 43.777344 13.15625 44.117188 12.566406 44.117188 L 12.53125 44.117188 C 11.9375 44.117188 11.375 43.777344 11.109375 43.214844 L 11.082031 43.160156 L 9.339844 39.101562 L 9.339844 45.210938 C 9.339844 46.070312 8.640625 46.773438 7.777344 46.773438 C 6.910156 46.773438 6.214844 46.070312 6.214844 45.210938 L 6.214844 32.824219 C 6.214844 31.960938 6.910156 31.261719 7.777344 31.261719 L 7.835938 31.261719 C 8.472656 31.261719 9.046875 31.617188 9.335938 32.1875 L 12.527344 39.09375 L 15.59375 32.207031 C 15.894531 31.617188 16.46875 31.261719 17.105469 31.261719 L 17.167969 31.261719 C 18.03125 31.261719 18.730469 31.960938 18.730469 32.824219 Z M 41.382812 28.125 L 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.136719 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.136719 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 41.382812 28.125 \"/>\n      </g>\n      </defs>\n      <g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <use xlink:href=\"#surface9\" mask=\"url(#mask0)\"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 28.257812 34.902344 C 27.835938 34.550781 27.140625 34.375 26.191406 34.375 L 25 34.375 L 25 38.4375 L 26.191406 38.4375 C 26.621094 38.4375 27.007812 38.375 27.34375 38.253906 C 27.667969 38.140625 27.929688 37.992188 28.148438 37.804688 C 28.34375 37.632812 28.492188 37.4375 28.601562 37.195312 C 28.710938 36.964844 28.757812 36.703125 28.757812 36.40625 C 28.757812 35.324219 28.382812 35.003906 28.257812 34.902344 \"/>\n      <path style=\"fill:none;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(99.607843%,99.607843%,99.607843%);stroke-opacity:1;stroke-miterlimit:4;\" d=\"M 11.34125 13.57875 C 11.345 13.5925 11.3525 13.62375 11.36375 13.67375 C 11.3775 13.7225 11.3975 13.78125 11.42625 13.85 C 11.45375 13.9175 11.49375 13.9875 11.54625 14.0625 C 11.5975 14.13875 11.66625 14.20875 11.75 14.27125 C 11.83375 14.33625 11.9375 14.38875 12.0575 14.43125 C 12.1775 14.4725 12.32 14.49375 12.4875 14.49375 C 12.67875 14.49375 12.845 14.46125 12.9875 14.39375 C 13.13 14.32875 13.24875 14.245 13.34375 14.1425 C 13.43875 14.0425 13.51125 13.93 13.55875 13.8075 C 13.6075 13.6825 13.63125 13.56375 13.63125 13.4475 C 13.63125 13.31125 13.6075 13.1825 13.5625 13.065 C 13.515 12.9475 13.4425 12.845 13.3425 12.7575 C 13.2425 12.67 13.115 12.6 12.96 12.55 C 12.805 12.49875 12.6175 12.4725 12.4 12.4725 L 12.4 12.42625 C 12.57 12.42 12.72375 12.3925 12.8625 12.34375 C 13.0025 12.29625 13.11875 12.2275 13.21625 12.14375 C 13.31375 12.05875 13.3875 11.96 13.44125 11.845 C 13.4925 11.7275 13.52 11.60125 13.52 11.46 C 13.52 11.29375 13.4925 11.1525 13.43875 11.0325 C 13.38375 10.91375 13.31125 10.81625 13.21875 10.74 C 13.1275 10.66375 13.0225 10.6075 12.90375 10.5725 C 12.78625 10.535 12.66375 10.5175 12.5375 10.5175 C 12.395 10.5175 12.26125 10.54 12.14 10.58625 C 12.0175 10.6325 11.91 10.69625 11.81875 10.77875 C 11.72625 10.8625 11.64875 10.96 11.5875 11.07375 C 11.5275 11.18875 11.48625 11.315 11.4625 11.45375 M 7.5 14.4 L 7.5 10.5 L 8.3825 10.5 C 8.8075 10.5 9.13375 10.595 9.3625 10.78375 C 9.59 10.975 9.7025 11.2625 9.7025 11.65 C 9.7025 11.81625 9.6725 11.97125 9.6075 12.11125 C 9.5425 12.2525 9.4525 12.37375 9.335 12.475 C 9.21875 12.5775 9.0775 12.65625 8.9175 12.71375 C 8.75625 12.77125 8.5775 12.8 8.3825 12.8 L 7.6 12.8 M 2.4875 14.4675 L 2.4875 10.50375 L 2.5075 10.50375 C 2.5225 10.50375 2.53375 10.5125 2.5425 10.52625 L 3.9925 13.58625 C 3.99875 13.5975 4.005 13.6075 4.00875 13.6175 M 4.02125 13.6175 C 4.02625 13.6075 4.03125 13.5975 4.0375 13.58625 L 5.44 10.52625 C 5.4475 10.5125 5.45875 10.50375 5.4725 10.50375 L 5.4925 10.50375 L 5.4925 14.4675 \" transform=\"matrix(3.125,0,0,3.125,0,0)\"/>\n      </g>"
    },
    mp4Icon: {
      extension: '.mp4',
      path: "<g id=\"surface6\" clip-path=\"url(#clip1)\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 36.898438 40.625 L 40.625 35.480469 L 40.625 40.625 Z M 28.761719 36.40625 C 28.761719 36.703125 28.707031 36.964844 28.605469 37.195312 C 28.496094 37.433594 28.347656 37.632812 28.148438 37.804688 C 27.929688 37.992188 27.667969 38.144531 27.34375 38.257812 C 27.003906 38.375 26.621094 38.4375 26.191406 38.4375 L 25 38.4375 L 25 34.375 L 26.191406 34.375 C 27.140625 34.375 27.835938 34.554688 28.253906 34.902344 C 28.378906 35.007812 28.761719 35.324219 28.761719 36.40625 Z M 44.6875 43.75 L 43.75 43.75 L 43.75 45.3125 C 43.75 46.175781 43.050781 46.875 42.1875 46.875 C 41.324219 46.875 40.625 46.175781 40.625 45.3125 L 40.625 43.75 L 34.066406 43.75 C 33.199219 43.75 32.503906 43.050781 32.503906 42.1875 L 32.503906 41.875 C 32.503906 41.546875 32.605469 41.226562 32.800781 40.957031 L 39.363281 31.898438 C 39.660156 31.492188 40.128906 31.25 40.628906 31.25 L 42.1875 31.25 C 43.050781 31.25 43.75 31.949219 43.75 32.8125 L 43.75 40.625 L 44.6875 40.625 C 45.550781 40.625 46.25 41.324219 46.25 42.1875 C 46.25 43.050781 45.550781 43.75 44.6875 43.75 Z M 31.445312 38.492188 C 31.148438 39.140625 30.730469 39.703125 30.195312 40.167969 C 29.6875 40.605469 29.082031 40.957031 28.390625 41.203125 C 27.71875 41.441406 26.976562 41.5625 26.191406 41.5625 L 25 41.5625 L 25 45 C 25 45.863281 24.300781 46.5625 23.4375 46.5625 C 22.578125 46.5625 21.875 45.863281 21.875 45 L 21.875 32.8125 C 21.875 31.949219 22.578125 31.25 23.4375 31.25 L 26.191406 31.25 C 27.890625 31.25 29.257812 31.671875 30.253906 32.5 C 31.339844 33.398438 31.886719 34.714844 31.886719 36.40625 C 31.886719 37.148438 31.738281 37.851562 31.445312 38.492188 Z M 18.730469 45.210938 C 18.730469 46.070312 18.027344 46.773438 17.167969 46.773438 C 16.300781 46.773438 15.605469 46.070312 15.605469 45.210938 L 15.605469 39.6875 L 14.035156 43.105469 C 14.019531 43.144531 14.003906 43.179688 13.984375 43.214844 C 13.71875 43.78125 13.15625 44.117188 12.566406 44.117188 L 12.53125 44.117188 C 11.941406 44.117188 11.378906 43.78125 11.113281 43.214844 C 11.097656 43.183594 11.078125 43.152344 11.066406 43.125 L 9.339844 39.484375 L 9.339844 45.210938 C 9.339844 46.070312 8.640625 46.773438 7.777344 46.773438 C 6.910156 46.773438 6.214844 46.070312 6.214844 45.210938 L 6.214844 32.824219 C 6.214844 31.960938 6.910156 31.261719 7.777344 31.261719 L 7.835938 31.261719 C 8.472656 31.261719 9.046875 31.617188 9.335938 32.191406 L 9.355469 32.226562 L 12.523438 38.90625 L 15.578125 32.242188 C 15.585938 32.226562 15.597656 32.210938 15.605469 32.191406 C 15.894531 31.617188 16.46875 31.261719 17.105469 31.261719 L 17.164062 31.261719 C 18.027344 31.261719 18.726562 31.960938 18.726562 32.824219 L 18.726562 45.210938 Z M 41.382812 28.125 L 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 41.382812 28.125 \"/>\n      </g>\n      </defs>\n      <g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <use xlink:href=\"#surface6\" mask=\"url(#mask0)\"/>\n      <path style=\"fill:none;stroke-width:1;stroke-linecap:round;stroke-linejoin:round;stroke:rgb(99.607843%,99.607843%,99.607843%);stroke-opacity:1;stroke-miterlimit:4;\" d=\"M 14.3 13.5 L 10.90125 13.5 L 10.90125 13.4 L 13.00125 10.5 L 13.5 10.5 L 13.5 14.5 M 7.5 14.4 L 7.5 10.5 L 8.3825 10.5 C 8.8075 10.5 9.13375 10.595 9.3625 10.78375 C 9.59 10.975 9.7025 11.2625 9.7025 11.65 C 9.7025 11.81625 9.6725 11.97125 9.6075 12.11125 C 9.5425 12.2525 9.4525 12.37375 9.335 12.47625 C 9.21875 12.5775 9.0775 12.65625 8.9175 12.71375 C 8.75625 12.77125 8.5775 12.8 8.3825 12.8 L 7.6 12.8 M 2.4875 14.4675 L 2.4875 10.50375 L 2.5075 10.50375 C 2.5225 10.50375 2.53375 10.5125 2.5425 10.52625 L 3.9925 13.58625 C 3.99875 13.5975 4.005 13.6075 4.00875 13.6175 M 4.02125 13.6175 C 4.02625 13.6075 4.03125 13.5975 4.0375 13.58625 L 5.44 10.52625 C 5.4475 10.5125 5.45875 10.50375 5.4725 10.50375 L 5.4925 10.50375 L 5.4925 14.4675 \" transform=\"matrix(3.125,0,0,3.125,0,0)\"/>\n      </g>"
    },
    oggIcon: {
      extension: '.ogg',
      path: "<g id=\"surface9\" clip-path=\"url(#clip1)\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.621094 28.125 C 3.859375 28.125 0 31.984375 0 36.742188 L 0 41.378906 C 0 46.140625 3.859375 50 8.621094 50 L 41.378906 50 C 46.140625 50 50 46.140625 50 41.382812 L 50 36.746094 C 50 31.984375 46.140625 28.125 41.382812 28.125 Z M 8.621094 28.125 \"/>\n      </g>\n      </defs>\n      <g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.578125 25 L 39.421875 25 C 41.53125 25 43.527344 25.492188 45.3125 26.367188 L 45.3125 15.367188 C 45.3125 13.90625 44.976562 13.097656 43.984375 12.109375 C 42.996094 11.121094 35.105469 3.226562 34.503906 2.628906 C 33.90625 2.027344 33.070312 1.5625 31.617188 1.5625 L 6.5625 1.5625 C 5.527344 1.5625 4.6875 2.402344 4.6875 3.4375 L 4.6875 26.367188 C 6.476562 25.492188 8.472656 25 10.578125 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.710938 L 42.164062 12.5 L 34.515625 12.5 C 34.464844 12.46875 34.414062 12.425781 34.375 12.390625 Z M 6.25 25.722656 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.25 13.980469 32.496094 15.210938 33.742188 15.539062 C 33.902344 15.59375 34.074219 15.625 34.257812 15.625 L 43.75 15.625 L 43.75 25.722656 C 44.859375 26.105469 45.910156 26.625 46.875 27.269531 L 46.875 15.363281 C 46.875 13.511719 46.375 12.289062 45.089844 11.003906 L 35.609375 1.523438 C 34.582031 0.496094 33.273438 0 31.617188 0 L 6.5625 0 C 4.667969 0 3.125 1.542969 3.125 3.4375 L 3.125 27.269531 C 4.089844 26.625 5.140625 26.105469 6.25 25.722656 Z M 6.25 25.722656 \"/>\n      <use xlink:href=\"#surface9\" mask=\"url(#mask0)\"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 8.976562 47.070312 C 10.464844 47.070312 11.757812 46.75 12.859375 46.109375 C 13.960938 45.46875 14.808594 44.550781 15.40625 43.351562 C 16.003906 42.15625 16.304688 40.757812 16.304688 39.152344 C 16.304688 37.550781 16.007812 36.152344 15.417969 34.964844 C 14.828125 33.777344 13.980469 32.859375 12.882812 32.21875 C 11.78125 31.578125 10.480469 31.257812 8.976562 31.257812 C 7.472656 31.257812 6.167969 31.578125 5.0625 32.21875 C 3.953125 32.859375 3.101562 33.777344 2.511719 34.964844 C 1.921875 36.152344 1.625 37.550781 1.625 39.152344 C 1.625 40.757812 1.925781 42.15625 2.523438 43.351562 C 3.121094 44.550781 3.972656 45.46875 5.070312 46.109375 C 6.171875 46.75 7.472656 47.070312 8.976562 47.070312 Z M 8.976562 44.820312 C 7.546875 44.820312 6.433594 44.332031 5.640625 43.351562 C 4.847656 42.375 4.449219 40.976562 4.449219 39.152344 C 4.449219 37.332031 4.847656 35.933594 5.640625 34.964844 C 6.433594 33.996094 7.546875 33.507812 8.976562 33.507812 C 10.390625 33.507812 11.496094 33.996094 12.289062 34.964844 C 13.085938 35.933594 13.484375 37.332031 13.484375 39.152344 C 13.484375 40.976562 13.085938 42.375 12.289062 43.351562 C 11.496094 44.332031 10.390625 44.820312 8.976562 44.820312 Z M 26.410156 47.070312 C 27.125 47.070312 27.871094 47.011719 28.640625 46.898438 C 29.414062 46.78125 30.09375 46.621094 30.675781 46.414062 C 31.214844 46.242188 31.574219 46.015625 31.75 45.738281 C 31.921875 45.460938 32.011719 44.988281 32.011719 44.316406 L 32.011719 39.613281 C 32.011719 39.292969 31.910156 39.03125 31.703125 38.835938 C 31.5 38.640625 31.230469 38.539062 30.894531 38.539062 L 27.023438 38.539062 C 26.671875 38.539062 26.398438 38.628906 26.203125 38.804688 C 26.007812 38.976562 25.90625 39.226562 25.90625 39.546875 C 25.90625 39.867188 26.007812 40.117188 26.203125 40.289062 C 26.398438 40.464844 26.671875 40.554688 27.023438 40.554688 L 29.496094 40.554688 L 29.496094 44.425781 C 28.503906 44.703125 27.511719 44.839844 26.519531 44.839844 C 23.195312 44.839844 21.53125 42.945312 21.53125 39.152344 C 21.53125 37.300781 21.9375 35.90625 22.746094 34.964844 C 23.554688 34.023438 24.753906 33.554688 26.34375 33.554688 C 27.046875 33.554688 27.671875 33.644531 28.226562 33.828125 C 28.78125 34.007812 29.378906 34.324219 30.019531 34.777344 C 30.195312 34.894531 30.347656 34.980469 30.480469 35.03125 C 30.609375 35.082031 30.757812 35.105469 30.917969 35.105469 C 31.164062 35.105469 31.375 34.996094 31.550781 34.777344 C 31.726562 34.558594 31.8125 34.289062 31.8125 33.96875 C 31.8125 33.75 31.773438 33.558594 31.695312 33.398438 C 31.613281 33.238281 31.484375 33.078125 31.3125 32.917969 C 30 31.808594 28.3125 31.257812 26.257812 31.257812 C 24.710938 31.257812 23.371094 31.574219 22.234375 32.207031 C 21.09375 32.84375 20.214844 33.753906 19.597656 34.941406 C 18.976562 36.128906 18.667969 37.535156 18.667969 39.152344 C 18.667969 40.800781 18.976562 42.21875 19.597656 43.40625 C 20.214844 44.597656 21.109375 45.503906 22.277344 46.132812 C 23.441406 46.757812 24.820312 47.070312 26.410156 47.070312 Z M 42.445312 47.070312 C 43.160156 47.070312 43.902344 47.011719 44.675781 46.898438 C 45.449219 46.78125 46.128906 46.621094 46.710938 46.414062 C 47.25 46.242188 47.609375 46.015625 47.78125 45.738281 C 47.957031 45.460938 48.046875 44.988281 48.046875 44.316406 L 48.046875 39.613281 C 48.046875 39.292969 47.941406 39.03125 47.738281 38.835938 C 47.535156 38.640625 47.265625 38.539062 46.929688 38.539062 L 43.058594 38.539062 C 42.707031 38.539062 42.433594 38.628906 42.238281 38.804688 C 42.039062 38.976562 41.941406 39.226562 41.941406 39.546875 C 41.941406 39.867188 42.039062 40.117188 42.238281 40.289062 C 42.433594 40.464844 42.707031 40.554688 43.058594 40.554688 L 45.53125 40.554688 L 45.53125 44.425781 C 44.539062 44.703125 43.546875 44.839844 42.554688 44.839844 C 39.230469 44.839844 37.566406 42.945312 37.566406 39.152344 C 37.566406 37.300781 37.972656 35.90625 38.78125 34.964844 C 39.589844 34.023438 40.789062 33.554688 42.378906 33.554688 C 43.078125 33.554688 43.707031 33.644531 44.261719 33.828125 C 44.816406 34.007812 45.414062 34.324219 46.054688 34.777344 C 46.230469 34.894531 46.382812 34.980469 46.515625 35.03125 C 46.644531 35.082031 46.792969 35.105469 46.953125 35.105469 C 47.199219 35.105469 47.410156 34.996094 47.585938 34.777344 C 47.761719 34.558594 47.847656 34.289062 47.847656 33.96875 C 47.847656 33.75 47.808594 33.558594 47.726562 33.398438 C 47.648438 33.238281 47.519531 33.078125 47.34375 32.917969 C 46.03125 31.808594 44.347656 31.257812 42.292969 31.257812 C 40.746094 31.257812 39.40625 31.574219 38.265625 32.207031 C 37.128906 32.84375 36.25 33.753906 35.632812 34.941406 C 35.011719 36.128906 34.703125 37.535156 34.703125 39.152344 C 34.703125 40.800781 35.011719 42.21875 35.632812 43.40625 C 36.25 44.597656 37.144531 45.503906 38.3125 46.132812 C 39.476562 46.757812 40.855469 47.070312 42.445312 47.070312 Z M 42.445312 47.070312 \"/>\n      </g>"
    },
    pdfIcon: {
      extension: '.pdf',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(99.607843%,99.607843%,99.607843%);fill-opacity:1;\" d=\"M 10.59375 25 L 39.4375 25 C 41.476562 25.003906 43.484375 25.472656 45.3125 26.375 L 45.3125 15.375 C 45.347656 14.191406 44.867188 13.054688 44 12.25 L 34.625 2.875 C 33.875 2.003906 32.773438 1.523438 31.625 1.5625 L 6.625 1.5625 C 5.589844 1.5625 4.75 2.402344 4.75 3.4375 L 4.75 26.375 C 6.566406 25.480469 8.566406 25.007812 10.59375 25 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 34.375 4.71875 L 42.15625 12.5 L 34.53125 12.5 C 34.480469 12.511719 34.425781 12.511719 34.375 12.5 Z M 6.25 25.71875 L 6.25 3.4375 C 6.25 3.265625 6.390625 3.125 6.5625 3.125 L 31.25 3.125 L 31.25 12.5 C 31.300781 13.980469 32.316406 15.253906 33.75 15.625 C 33.957031 15.675781 34.167969 15.675781 34.375 15.625 L 43.75 15.625 L 43.75 25.71875 C 44.859375 26.09375 45.910156 26.621094 46.875 27.28125 L 46.875 15.375 C 46.964844 13.722656 46.3125 12.117188 45.09375 11 L 35.71875 1.625 C 34.648438 0.523438 33.160156 -0.0664062 31.625 0 L 6.625 0 C 5.703125 -0.015625 4.8125 0.339844 4.152344 0.984375 C 3.496094 1.632812 3.125 2.515625 3.125 3.4375 L 3.125 27.28125 C 4.09375 26.625 5.144531 26.101562 6.25 25.71875 Z M 6.25 25.71875 \"/>\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 8.625 28.125 C 6.335938 28.117188 4.136719 29.023438 2.515625 30.640625 C 0.898438 32.261719 -0.0078125 34.460938 0 36.75 L 0 41.375 C 0 46.136719 3.863281 50 8.625 50 L 41.375 50 C 46.132812 49.984375 49.984375 46.132812 50 41.375 L 50 36.75 C 50 31.988281 46.136719 28.125 41.375 28.125 Z M 8.625 28.125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 14.40625 41.78125 L 12.09375 41.78125 L 12.09375 45.84375 C 12.003906 46.351562 11.5625 46.726562 11.046875 46.726562 C 10.53125 46.726562 10.089844 46.351562 10 45.84375 L 10 34.78125 C 10 34.210938 10.460938 33.75 11.03125 33.75 L 14.40625 33.75 C 15.925781 33.617188 17.390625 34.351562 18.191406 35.648438 C 18.992188 36.945312 18.992188 38.585938 18.191406 39.882812 C 17.390625 41.179688 15.925781 41.914062 14.40625 41.78125 Z M 12.09375 39.6875 L 14.40625 39.6875 C 15.152344 39.78125 15.882812 39.4375 16.289062 38.804688 C 16.691406 38.171875 16.691406 37.359375 16.289062 36.726562 C 15.882812 36.09375 15.152344 35.75 14.40625 35.84375 L 12.09375 35.84375 Z M 12.09375 39.6875 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 20.3125 45.84375 L 20.3125 34.78125 C 20.3125 34.210938 20.773438 33.75 21.34375 33.75 L 23.5625 33.75 C 27.1875 33.75 30.125 36.6875 30.125 40.3125 C 30.125 43.9375 27.1875 46.875 23.5625 46.875 L 21.34375 46.875 C 20.773438 46.875 20.3125 46.414062 20.3125 45.84375 Z M 22.40625 44.78125 L 23.5625 44.78125 C 26.03125 44.78125 28.03125 42.78125 28.03125 40.3125 C 28.03125 37.84375 26.03125 35.84375 23.5625 35.84375 L 22.40625 35.84375 Z M 22.40625 44.78125 \"/>\n      <path style=\" stroke:none;fill-rule:nonzero;fill:rgb(100%,100%,100%);fill-opacity:1;\" d=\"M 33.1875 45.84375 L 33.1875 34.78125 C 33.183594 34.476562 33.3125 34.1875 33.542969 33.992188 C 33.769531 33.792969 34.074219 33.703125 34.375 33.75 L 40.625 33.75 C 41.132812 33.839844 41.507812 34.28125 41.507812 34.796875 C 41.507812 35.3125 41.132812 35.753906 40.625 35.84375 L 35.25 35.84375 L 35.25 39.28125 L 39.625 39.28125 C 40.195312 39.28125 40.65625 39.742188 40.65625 40.3125 C 40.65625 40.882812 40.195312 41.34375 39.625 41.34375 L 35.25 41.34375 L 35.25 45.84375 C 35.257812 46.359375 34.882812 46.796875 34.375 46.875 C 34.074219 46.921875 33.769531 46.832031 33.542969 46.632812 C 33.3125 46.4375 33.183594 46.148438 33.1875 45.84375 Z M 33.1875 45.84375 \"/>\n      </g>"
    },
    defaultIcon: {
      extension: '.default',
      path: "<g id=\"surface1\">\n      <path style=\" stroke:none;fill-rule:evenodd;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 3.117188 44.777344 C 1.394531 44.777344 0 43.386719 0 41.671875 L 0 3.484375 C 0 1.769531 1.394531 0.378906 3.117188 0.378906 L 25.792969 0.378906 C 27.164062 0.304688 28.5 0.808594 29.480469 1.765625 L 37.980469 10.230469 C 39.144531 11.242188 39.769531 12.730469 39.683594 14.265625 L 39.683594 41.671875 C 39.683594 43.386719 38.289062 44.777344 36.5625 44.777344 Z M 25.511719 3.203125 L 3.117188 3.203125 C 2.960938 3.203125 2.832031 3.328125 2.832031 3.484375 L 2.832031 41.671875 C 2.832031 41.828125 2.960938 41.957031 3.117188 41.957031 L 36.5625 41.957031 C 36.679688 41.949219 36.785156 41.867188 36.820312 41.757812 L 36.820312 14.492188 L 28.34375 14.492188 C 28.160156 14.539062 27.964844 14.539062 27.777344 14.492188 C 26.480469 14.15625 25.554688 13.007812 25.511719 11.671875 Z M 28.34375 4.640625 L 28.34375 11.671875 C 28.390625 11.683594 28.441406 11.683594 28.488281 11.671875 L 35.402344 11.671875 Z M 28.34375 4.640625 \"/>\n      </g>"
    }
  };

  FroalaEditor.MODULES.modals = function (editor) {
    var $ = editor.$;

    if (!editor.shared.modals) {
      editor.shared.modals = {};
    }

    var modals = editor.shared.modals;
    var $overlay;
    /**
     * Get the modal with the specific id.
     */

    function get(id) {
      return modals[id];
    }
    /*
     *  Get modal html
     */


    function _modalHTML(head, body) {
      // Modal wrapper.
      var html = "<div tabIndex=\"-1\" class=\"fr-modal".concat(editor.opts.theme ? " ".concat(editor.opts.theme, "-theme") : '', "\"><div class=\"fr-modal-wrapper\">"); // Modal title.

      var close_button = "<button title=\"".concat(editor.language.translate('Cancel'), "\" class=\"fr-command fr-btn fr-modal-close\"><svg xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 24 24\"><path d=\"").concat(FroalaEditor.SVG.close, "\"/></svg></button>");
      html += "<div class=\"fr-modal-head\">".concat(head).concat(close_button, "</div>"); // Body.

      html += "<div tabIndex=\"-1\" class=\"fr-modal-body\">".concat(body, "</div>"); // End Modal.

      html += '</div></div>';
      var $tmp = $(editor.doc.createElement('DIV'));
      $tmp.html(html);
      return $tmp.find('> .fr-modal');
    }
    /*
     * Create modal.
     */


    function create(id, head, body) {
      // Wrap all head elements inside a div
      head = "<div class=\"fr-modal-head-line\">".concat(head, "</div>"); // Build modal overlay.

      if (!editor.shared.$overlay) {
        editor.shared.$overlay = $(editor.doc.createElement('DIV')).addClass('fr-overlay');
        $('body').first().append(editor.shared.$overlay);
      }

      $overlay = editor.shared.$overlay;

      if (editor.opts.theme) {
        $overlay.addClass("".concat(editor.opts.theme, "-theme"));
      } // Build modal.


      if (!modals[id]) {
        var $modal = _modalHTML(head, body);

        modals[id] = {
          $modal: $modal,
          $head: $modal.find('.fr-modal-head'),
          $body: $modal.find('.fr-modal-body')
        }; // Desktop or mobile device.

        if (!editor.helpers.isMobile()) {
          $modal.addClass('fr-desktop');
        } // Append modal to body.


        $('body').first().append($modal); // Click on close button.

        editor.events.$on($modal, 'click', '.fr-modal-close', function () {
          hide(id);
        }, true);
        modals[id].$body.css('margin-top', modals[id].$head.outerHeight()); // Keydown handler.

        editor.events.$on($modal, 'keydown', function (e) {
          var keycode = e.which; // Esc.

          if (keycode === FroalaEditor.KEYCODE.ESC) {
            hide(id);
            editor.accessibility.focusModalButton($modal);
            return false;
          } else if (!$(e.currentTarget).is('input[type=text], textarea') && keycode !== FroalaEditor.KEYCODE.ARROW_UP && keycode !== FroalaEditor.KEYCODE.ARROW_DOWN && !editor.keys.isBrowserAction(e)) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }

          return true;
        }, true);
        hide(id, true);
      }

      return modals[id];
    }
    /*
     * Destroy modals.
     */


    function destroy() {
      // Destroy all modals.
      for (var i in modals) {
        if (Object.prototype.hasOwnProperty.call(modals, i)) {
          var modalHash = modals[i];

          if (modalHash && modalHash.$modal) {
            modalHash.$modal.removeData().remove();
          }
        }
      }

      if ($overlay) {
        $overlay.removeData().remove();
      }

      modals = {};
    }
    /*
     * Show modal.
     */


    function show(id) {
      if (!modals[id]) {
        return;
      }

      var $modal = modals[id].$modal; // Set the current instance for the modal.

      $modal.data('instance', editor); // Show modal.

      $modal.show();
      $overlay.show(); // Prevent scrolling in page.

      $(editor.o_doc).find('body').first().addClass('fr-prevent-scroll'); // Mobile device

      if (editor.helpers.isMobile()) {
        $(editor.o_doc).find('body').first().addClass('fr-mobile');
      }

      $modal.addClass('fr-active');
      editor.accessibility.focusModal($modal);
    }
    /*
     * Hide modal.
     */


    function hide(id, init) {
      if (!modals[id]) {
        return;
      }

      var $modal = modals[id].$modal;
      var inst = $modal.data('instance') || editor;
      inst.events.enableBlur();
      $modal.hide();
      $overlay.hide();
      $(inst.o_doc).find('body').first().removeClass('fr-prevent-scroll fr-mobile');
      $modal.removeClass('fr-active');

      if (!init) {
        // Restore selection.
        inst.accessibility.restoreSelection();
        inst.events.trigger('modals.hide');
      }
    }
    /**
     *  Resize modal according to its body or editor heights.
     */


    function resize(id) {
      if (!modals[id]) {
        return;
      }

      var modalHash = modals[id];
      var $modal = modalHash.$modal;
      var $body = modalHash.$body;
      var height = editor.o_win.innerHeight; // The wrapper object.

      var $wrapper = $modal.find('.fr-modal-wrapper'); // Calculate max allowed height.

      var allWrapperHeight = $wrapper.outerHeight(true);
      var exteriorBodyHeight = $wrapper.height() - ($body.outerHeight(true) - $body.height());
      var maxHeight = height - allWrapperHeight + exteriorBodyHeight; // Get body content height.

      var body_content_height = $body.get(0).scrollHeight; // Calculate the new height.

      var newHeight = 'auto';

      if (body_content_height > maxHeight) {
        newHeight = maxHeight;
      }

      $body.height(newHeight);
    }
    /**
     * Find visible modal.
     */


    function isVisible(id) {
      var $modal; // By id.

      if (typeof id === 'string') {
        if (!modals[id]) {
          return;
        }

        $modal = modals[id].$modal;
      } // By modal object.
      else {
        $modal = id;
      }

      return $modal && editor.node.hasClass($modal, 'fr-active') && editor.core.sameInstance($modal) || false;
    }
    /**
     * Check if there is any modal visible.
     */


    function areVisible(new_instance) {
      for (var id in modals) {
        if (Object.prototype.hasOwnProperty.call(modals, id)) {
          if (isVisible(id) && (typeof new_instance === 'undefined' || modals[id].$modal.data('instance') === new_instance)) {
            return modals[id].$modal;
          }
        }
      }

      return false;
    }
    /**
     * Initialization.
     */


    function _init() {
      editor.events.on('shared.destroy', destroy, true);
    }

    return {
      _init: _init,
      get: get,
      create: create,
      show: show,
      hide: hide,
      resize: resize,
      isVisible: isVisible,
      areVisible: areVisible
    };
  };

  FroalaEditor.MODULES.position = function (editor) {
    var $ = editor.$;
    /**
    * Get bounding rect around selection.
    *
    */

    function getBoundingRect() {
      var range = editor.selection.ranges(0);
      var boundingRect = range.getBoundingClientRect();

      if (boundingRect.top === 0 && boundingRect.left === 0 && boundingRect.width === 0 || boundingRect.height === 0) {
        var remove = false;
        var isBrTag = range.startContainer && range.startContainer.firstChild && range.startContainer.firstChild.tagName === 'BR';

        if (editor.$el.find('.fr-marker').length === 0) {
          if (isBrTag) {
            $(range.startContainer.firstChild).after(FroalaEditor.MARKERS);
          } else {
            editor.selection.save();
          }

          remove = true;
        }

        var $marker = editor.$el.find('.fr-marker').first();
        $marker.css('display', 'inline');
        $marker.css('line-height', '');
        var offset = $marker.offset();
        var height = $marker.outerHeight();
        $marker.css('display', 'none');
        $marker.css('line-height', 0);
        boundingRect = {};
        boundingRect.left = offset && offset.left;
        boundingRect.width = 0;
        boundingRect.height = height;
        boundingRect.top = offset && offset.top - (editor.helpers.isMobile() && !editor.helpers.isIOS() || editor.opts.iframe ? 0 : editor.helpers.scrollTop());

        if ($marker && $marker.length > 0) {
          boundingRect.top -= $($marker.get(0).parentNode).height();
        }

        boundingRect.right = 1;
        boundingRect.bottom = 1;
        boundingRect.ok = true;

        if (remove) {
          if (isBrTag) {
            editor.$el.find('.fr-marker').remove();
          } else {
            editor.selection.restore();
          }
        }
      }

      return boundingRect;
    }
    /**
     * Normalize top positioning.
     */


    function _topNormalized($el, top, obj_height) {
      var height = $el.outerHeight(true);

      if (!editor.helpers.isMobile() && editor.$tb && $el.parent().get(0) !== editor.$tb.get(0)) {
        // Get the parent of the element.
        var p_offset = $el.parent().offset().top;
        var new_top = top - height - (obj_height || 0); // Parent is scrollable container.
        // Substract the top of the container.

        if ($el.parent().get(0) === editor.$sc.get(0)) {
          p_offset -= $el.parent().position().top;
        } // Scrollable container height.


        var s_height = editor.$sc.get(0).clientHeight; // 1. Parent offset + toolbar top + toolbar height > scrollableContainer height.
        // 2. Selection doesn't go above the screen.

        if (p_offset + top + height > editor.$sc.offset().top + s_height && $el.parent().offset().top + new_top > 0 && new_top > 0) {
          // Make sure we can display it.
          if (new_top > editor.$wp.scrollTop()) {
            top = new_top;
            $el.addClass('fr-above');
          }
        } else {
          $el.removeClass('fr-above');
        }
      }

      return top;
    }
    /**
     * Normalize left position.
     */


    function _leftNormalized($el, left) {
      var width = $el.outerWidth(true); // Normalize right.

      if (left + width > editor.$sc.get(0).clientWidth - 10) {
        left = editor.$sc.get(0).clientWidth - width - 10;
      } // Normalize left.


      if (left < 0) {
        left = 10;
      }

      return left;
    }
    /**
     * Place editor below selection.
     */


    function forSelection($el) {
      var selection_rect = getBoundingRect();

      if (selection_rect.top == undefined) {
        return;
      }

      $el.css({
        top: 0,
        left: 0
      });
      var top = selection_rect.top + selection_rect.height;
      var left = selection_rect.left + selection_rect.width / 2 - $el.get(0).offsetWidth / 2 + editor.helpers.scrollLeft();

      if (!editor.opts.iframe) {
        top += editor.helpers.scrollTop();
      }

      at(left, top, $el, selection_rect.height);
    }
    /**
     * Position element at the specified position.
     */


    function at(left, top, $el, obj_height) {
      var $container = $el.data('container');

      if ($container && ($container.get(0).tagName !== 'BODY' || $container.css('position') !== 'static')) {
        if (left) {
          left -= $container.offset().left;
        }

        if (top) {
          top -= $container.offset().top;
        }

        if ($container.get(0).tagName !== 'BODY') {
          if (left) {
            left += $container.get(0).scrollLeft;
          }

          if (top) {
            top += $container.get(0).scrollTop;
          }
        } else if ($container.css('position') === 'absolute') {
          if (left) {
            left += $container.position().left;
          }

          if (top) {
            top += $container.position().top;
          }
        }
      } // Apply iframe correction.


      if (editor.opts.iframe && $container && editor.$tb && $container.get(0) !== editor.$tb.get(0)) {
        var iframePaddingTop = editor.helpers.getPX(editor.$wp.find('.fr-iframe').css('padding-top'));
        var iframePaddingLeft = editor.helpers.getPX(editor.$wp.find('.fr-iframe').css('padding-left'));

        if (left) {
          left += editor.$iframe.offset().left + iframePaddingLeft;
        }

        if (top) {
          top += editor.$iframe.offset().top + iframePaddingTop;
        }
      }

      var new_left = _leftNormalized($el, left);

      if (left) {
        // Set the new left.
        $el.css('left', new_left);
      }

      if (top) {
        $el.css('top', _topNormalized($el, top, obj_height));
      }
    }
    /**
     * Special case for update sticky on iOS.
     */


    function _updateIOSSticky(el) {
      var $el = $(el);
      var is_on = $el.is('.fr-sticky-on');
      var prev_top = $el.data('sticky-top');
      var scheduled_top = $el.data('sticky-scheduled'); // Create a dummy div that we show then sticky is on.

      if (typeof prev_top === 'undefined') {
        $el.data('sticky-top', 0);
        var $dummy = $("<div class=\"fr-sticky-dummy\" style=\"height: ".concat($el.outerHeight(), "px;\"></div>"));
        editor.$box.prepend($dummy);
      } else {
        editor.$box.find('.fr-sticky-dummy').css('height', $el.outerHeight());
      } // Position sticky doesn't work when the keyboard is on the screen.


      if (editor.core.hasFocus() || editor.$tb.findVisible('input:focus').length > 0) {
        // Get the current scroll.
        var x_scroll = editor.helpers.scrollTop(); // Get the current top.
        // We make sure that we keep it within the editable box.

        var x_top = Math.min(Math.max(x_scroll - editor.$tb.parent().offset().top, 0), editor.$tb.parent().outerHeight() - $el.outerHeight()); // Not the same top and different than the already scheduled.

        if (x_top !== prev_top && x_top !== scheduled_top) {
          // Clear any too soon change to avoid flickering.
          clearTimeout($el.data('sticky-timeout')); // Store the current scheduled top.

          $el.data('sticky-scheduled', x_top); // Hide the toolbar for a rich experience.

          if ($el.outerHeight() < x_scroll - editor.$tb.parent().offset().top) {
            $el.addClass('fr-opacity-0');
          } // Set the timeout for changing top.
          // Based on the test 100ms seems to be the best timeout.


          $el.data('sticky-timeout', setTimeout(function () {
            // Get the current top.
            var c_scroll = editor.helpers.scrollTop();
            var c_top = Math.min(Math.max(c_scroll - editor.$tb.parent().offset().top, 0), editor.$tb.parent().outerHeight() - $el.outerHeight());

            if (c_top > 0 && editor.$tb.parent().get(0).tagName === 'BODY') {
              c_top += editor.$tb.parent().position().top;
            } // Don't update if it is not different than the prev top.


            if (c_top !== prev_top) {
              $el.css('top', Math.max(c_top, 0));
              $el.data('sticky-top', c_top);
              $el.data('sticky-scheduled', c_top);
            } // Show toolbar.


            $el.removeClass('fr-opacity-0');
          }, 100));
        } // Turn on sticky mode.


        if (!is_on) {
          var $parent = editor.$tb.parent();
          var parentBorderWidth = $parent.get(0).offsetWidth - $parent.get(0).clientWidth;
          $el.css('top', '0');
          $el.width($parent.width() - parentBorderWidth);
          $el.addClass('fr-sticky-on');
          editor.$box.addClass('fr-sticky-box');
        }
      } // Turn off sticky mode.
      else {
        clearTimeout($(el).css('sticky-timeout'));
        $el.css('top', '0');
        $el.css('position', '');
        $el.css('width', '');
        $el.data('sticky-top', 0);
        $el.removeClass('fr-sticky-on');
        editor.$box.removeClass('fr-sticky-box');
      }
    }
    /**
     * Update sticky location for browsers that don't support sticky.
     * https://github.com/filamentgroup/fixed-sticky
     *
     * The MIT License (MIT)
     *
     * Copyright (c) 2013 Filament Group
     */


    function _updateSticky(el) {
      if (!el.offsetWidth) {
        return;
      }

      var $el = $(el);
      var height = $el.outerHeight();
      var position = $el.data('sticky-position'); // Viewport height.

      var viewport_height = $(editor.opts.scrollableContainer === 'body' ? editor.o_win : editor.opts.scrollableContainer).outerHeight();
      var scrollable_top = 0;
      var scrollable_bottom = 0;

      if (editor.opts.scrollableContainer !== 'body') {
        scrollable_top = editor.$sc.offset().top;
        scrollable_bottom = $(editor.o_win).outerHeight() - scrollable_top - viewport_height;
      }

      var offset_top = editor.opts.scrollableContainer === 'body' ? editor.helpers.scrollTop() : scrollable_top;
      var is_on = $el.is('.fr-sticky-on'); // Decide parent.

      if (!$el.data('sticky-parent')) {
        $el.data('sticky-parent', $el.parent());
      }

      var $parent = $el.data('sticky-parent');
      var parent_top = $parent.offset().top;
      var parent_height = $parent.outerHeight();

      if (!$el.data('sticky-offset')) {
        $el.data('sticky-offset', true);
        $el.after("<div class=\"fr-sticky-dummy\" style=\"height: ".concat(height, "px;\"></div>"));
      } else {
        editor.$box.find('.fr-sticky-dummy').css('height', "".concat(height, "px"));
      } // Detect position placement.


      if (!position) {
        // Some browsers require fixed/absolute to report accurate top/left values.
        var skip_setting_fixed = $el.css('top') !== 'auto' || $el.css('bottom') !== 'auto'; // Set to position fixed for a split of second.

        if (!skip_setting_fixed) {
          $el.css('position', 'fixed');
        } // Find position.


        position = {
          top: editor.node.hasClass($el.get(0), 'fr-top'),
          bottom: editor.node.hasClass($el.get(0), 'fr-bottom')
        }; // Remove position fixed.

        if (!skip_setting_fixed) {
          $el.css('position', '');
        } // Store position.


        $el.data('sticky-position', position);
        $el.data('top', editor.node.hasClass($el.get(0), 'fr-top') ? $el.css('top') : 'auto');
        $el.data('bottom', editor.node.hasClass($el.get(0), 'fr-bottom') ? $el.css('bottom') : 'auto');
      }

      var el_top = editor.helpers.getPX($el.data('top'));
      var el_bottom = editor.helpers.getPX($el.data('bottom')); // Detect if is OK to fix at the top.

      function isFixedToTop() {
        // 1. Top condition.
        // 2. Bottom condition.
        return parent_top < offset_top + el_top && parent_top + parent_height - height >= offset_top + el_top;
      } // Detect if it is OK to fix at the bottom.


      function isFixedToBottom() {
        return parent_top + height < offset_top + viewport_height - el_bottom && parent_top + parent_height > offset_top + viewport_height - el_bottom;
      }

      var at_top = position.top && isFixedToTop() && (editor.helpers.isInViewPort(editor.$sc.get(0)) || editor.opts.scrollableContainer === 'body');
      var at_bottom = position.bottom && isFixedToBottom(); // Should be fixed.

      if (at_top || at_bottom) {
        // Account for parent border in calculating toolbar width
        var parentBorderWidth = $parent.get(0).offsetWidth - $parent.get(0).clientWidth;
        $el.css('width', "".concat($parent.get(0).getBoundingClientRect().width - parentBorderWidth, "px"));

        if (!is_on) {
          $el.addClass('fr-sticky-on');
          $el.removeClass('fr-sticky-off');

          if ($el.css('top')) {
            if ($el.data('top') !== 'auto') {
              $el.css('top', editor.helpers.getPX($el.data('top')) + scrollable_top);
            } else {
              $el.data('top', 'auto');
            }
          }

          if ($el.css('bottom')) {
            if ($el.data('bottom') !== 'auto') {
              $el.css('bottom', editor.helpers.getPX($el.data('bottom')) + scrollable_bottom);
            } else {
              $el.css('bottom', 'auto');
            }
          }
        }
      } // Shouldn't be fixed.
      else if (!editor.node.hasClass($el.get(0), 'fr-sticky-off')) {
        // Reset.
        $el.css('width', '');
        $el.removeClass('fr-sticky-on');
        $el.addClass('fr-sticky-off');

        if ($el.css('top') && $el.data('top') !== 'auto' && position.top) {
          $el.css('top', 0);
        }

        if ($el.css('bottom') && $el.data('bottom') !== 'auto' && position.bottom) {
          $el.css('bottom', 0);
        }
      }
    }
    /**
     * Test if browser supports sticky.
     */


    function _testSticky() {
      return false;
    } // Use an animation frame to make sure we're always OK with the updates.


    function animate() {
      editor.helpers.requestAnimationFrame()(animate);

      if (editor.events.trigger('position.refresh') === false) {
        return;
      }

      for (var i = 0; i < editor._stickyElements.length; i++) {
        if (!editor.opts.toolbarBottom) {
          _updateIOSSticky(editor._stickyElements[i]);
        } else {
          var $parent = editor.$tb.parent();
          var parentBorderWidth = $parent.get(0).offsetWidth - $parent.get(0).clientWidth;
          var $el = $(editor._stickyElements[i]);
          $el.width($parent.width() - parentBorderWidth);
          $el.addClass('fr-sticky-on');
          editor.$box.addClass('fr-sticky-box');
        }
      }
    }
    /**
     * Initialize sticky position.
     */


    function _initSticky() {
      if (!_testSticky()) {
        editor._stickyElements = []; // iOS special case.

        if (editor.helpers.isIOS()) {
          animate(); // Hide toolbar on touchmove. This is very useful on iOS versions < 8.

          editor.events.$on($(editor.o_win), 'scroll', function () {
            if (editor.core.hasFocus()) {
              for (var i = 0; i < editor._stickyElements.length; i++) {
                var $el = $(editor._stickyElements[i]);
                var $parent = $el.parent();
                var c_scroll = editor.helpers.scrollTop();

                if ($el.outerHeight() < c_scroll - $parent.offset().top) {
                  if (!editor.opts.toolbarBottom || !editor.helpers.isIOS()) {
                    $el.addClass('fr-opacity-0');
                    $el.data('sticky-top', -1);
                    $el.data('sticky-scheduled', -1);
                  }
                }
              }
            }
          }, true);
        } // Default case. Do the updates on scroll.
        else {
          if (editor.opts.scrollableContainer !== 'body') {
            editor.events.$on($(editor.opts.scrollableContainer), 'scroll', refresh, true);
          }

          editor.events.$on($(editor.o_win), 'scroll', refresh, true);
          editor.events.$on($(editor.o_win), 'resize', refresh, true);
          editor.events.on('initialized', refresh);
          editor.events.on('focus', refresh);
          editor.events.$on($(editor.o_win), 'resize', 'textarea', refresh, true);
        }
      }

      editor.events.on('destroy', function () {
        editor._stickyElements = [];
      });
    }

    function refresh() {
      if (editor._stickyElements) {
        for (var i = 0; i < editor._stickyElements.length; i++) {
          _updateSticky(editor._stickyElements[i]);
        }
      }
    }
    /**
     * Mark element as sticky.
     */


    function addSticky($el) {
      $el.addClass('fr-sticky');

      if (editor.helpers.isIOS() && !editor.opts.toolbarBottom) {
        $el.addClass('fr-sticky-ios');
      }

      if (!_testSticky()) {
        $el.removeClass('fr-sticky');

        editor._stickyElements.push($el.get(0));
      }
    }

    function _init() {
      _initSticky();
    }

    return {
      _init: _init,
      forSelection: forSelection,
      addSticky: addSticky,
      refresh: refresh,
      at: at,
      getBoundingRect: getBoundingRect
    };
  };

  FroalaEditor.MODULES.refresh = function (editor) {
    var $ = editor.$;

    function undo($btn) {
      _setDisabled($btn, !editor.undo.canDo());
    }

    function redo($btn) {
      _setDisabled($btn, !editor.undo.canRedo());
    }

    function indent($btn) {
      if (editor.node.hasClass($btn.get(0), 'fr-no-refresh')) {
        return false;
      }

      if ($("button#markdown-".concat(editor.id, ".fr-active")).length) {
        return false;
      }

      var blocks = editor.selection.blocks();

      for (var i = 0; i < blocks.length; i++) {
        var p_node = blocks[i].previousSibling;

        while (p_node && p_node.nodeType === Node.TEXT_NODE && p_node.textContent.length === 0) {
          p_node = p_node.previousSibling;
        }

        if (blocks[i].tagName === 'LI' && !p_node) {
          _setDisabled($btn, true);
        } else {
          _setDisabled($btn, false);

          return true;
        }
      }
    }

    function outdent($btn) {
      if (editor.node.hasClass($btn.get(0), 'fr-no-refresh')) {
        return false;
      }

      if ($("button#markdown-".concat(editor.id, ".fr-active")).length) {
        return false;
      }

      var blocks = editor.selection.blocks();

      for (var i = 0; i < blocks.length; i++) {
        var prop = editor.opts.direction === 'rtl' || $(blocks[i]).css('direction') === 'rtl' ? 'margin-right' : 'margin-left'; //Outend is not allowed if parent is not an list

        var parentBlk = blocks[0].parentElement;

        if (parentBlk.parentNode.tagName != 'HTML' && parentBlk.parentNode.tagName != 'P' && parentBlk.parentNode.tagName != 'DIV' && parentBlk.parentNode.tagName != 'UL' && parentBlk.parentNode.tagName != 'OL' && parentBlk.parentNode.tagName != 'LI') {
          _setDisabled($btn, true);

          return true;
        }

        if (blocks[0].previousSibling && parentBlk.parentNode.style.listStyleType == 'none') {
          _setDisabled($btn, true);

          return true;
        }

        if (blocks[i].tagName === 'LI' || blocks[i].parentNode.tagName === 'LI') {
          _setDisabled($btn, false);

          return true;
        }

        if (editor.helpers.getPX($(blocks[i]).css(prop)) > 0) {
          _setDisabled($btn, false);

          return true;
        }
      }

      _setDisabled($btn, true);
    }
    /**
     * Disable/enable buton.
     */


    function _setDisabled($btn, disabled) {
      $btn.toggleClass('fr-disabled', disabled).attr('aria-disabled', disabled);
    }
    /**
     * Apply styles to button groups
     */


    function more($moreButton) {
      // Align the hidden toolbar with respect to its corresponding more button
      // Set its width to cover the complete editor width
      var $moreToolbar = editor.$tb.find(".fr-more-toolbar[data-name=\"".concat($moreButton.attr('data-group-name'), "\"]"));

      var offset = _computeMoreToolbarPosition($moreButton, $moreToolbar); // Position hidden toolbar w.r.t. more button


      if (editor.opts.direction === 'rtl') {
        $moreToolbar.css('padding-right', offset);
      } else {
        $moreToolbar.css('padding-left', offset);
      }
    }
    /**
     * Compute more toolbar new position w.r.t more button
     */


    function _computeMoreToolbarPosition($moreButton, $moreToolbar) {
      // Compute total buttons width in the more toolbar
      var totalButtonWidth = 0;
      var $moreToolbarBtns = $moreToolbar.find('> .fr-command, > .fr-btn-wrap');
      $moreToolbarBtns.each(function (index, btn) {
        totalButtonWidth += $(btn).outerWidth();
      }); // Calculate the position to place the hidden toolbar w.r.t. its more button

      var buttonMarginLeft = editor.helpers.getPX($($moreToolbarBtns[0]).css('margin-left'));
      var buttonMarginRight = editor.helpers.getPX($($moreToolbarBtns[0]).css('margin-right'));
      var offset;

      if (editor.opts.direction === 'rtl') {
        offset = editor.$tb.outerWidth() - $moreButton.offset().left + editor.$tb.offset().left - (totalButtonWidth + $moreButton.outerWidth() + $moreToolbarBtns.length * (buttonMarginLeft + buttonMarginRight)) / 2;
      } else {
        offset = $moreButton.offset().left - editor.$tb.offset().left - (totalButtonWidth - $moreButton.outerWidth() + $moreToolbarBtns.length * (buttonMarginLeft + buttonMarginRight)) / 2;
      } // Handle right side going outside the editor


      if (offset + totalButtonWidth + $moreToolbarBtns.length * (buttonMarginLeft + buttonMarginRight) > editor.$tb.outerWidth()) {
        offset -= (totalButtonWidth + $moreToolbarBtns.length * (buttonMarginLeft + buttonMarginRight) - $moreButton.outerWidth()) / 2;
      } // Handle left side going outside the editor


      if (offset < 0) {
        offset = 0;
      }

      return offset;
    }

    return {
      undo: undo,
      redo: redo,
      outdent: outdent,
      indent: indent,
      moreText: more,
      moreParagraph: more,
      moreMisc: more,
      moreRich: more
    };
  };

  Object.assign(FroalaEditor.DEFAULTS, {
    attribution: true,
    toolbarBottom: false,
    toolbarButtons: null,
    toolbarButtonsXS: null,
    toolbarButtonsSM: null,
    toolbarButtonsMD: null,
    toolbarContainer: null,
    toolbarInline: false,
    toolbarSticky: true,
    toolbarStickyOffset: 0,
    toolbarVisibleWithoutSelection: false
  }); // Default toolbar buttons.

  FroalaEditor.TOOLBAR_BUTTONS = {
    'moreText': {
      'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
    },
    'moreParagraph': {
      'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
    },
    'moreRich': {
      'buttons': ['trackChanges', 'markdown', 'insertLink', 'insertFiles', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR'],
      'buttonsVisible': 4
    },
    'moreMisc': {
      'buttons': ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
      'align': 'right',
      'buttonsVisible': 2
    },
    'trackChanges': {
      'buttons': ['showChanges', 'applyAll', 'removeAll', 'applyLast', 'removeLast'],
      'buttonsVisible': 0
    }
  };
  FroalaEditor.TOOLBAR_BUTTONS_MD = null;
  FroalaEditor.TOOLBAR_BUTTONS_SM = {};
  FroalaEditor.TOOLBAR_BUTTONS_SM.moreText = Object.assign({}, FroalaEditor.TOOLBAR_BUTTONS.moreText, {
    'buttonsVisible': 2
  });
  FroalaEditor.TOOLBAR_BUTTONS_SM.moreParagraph = Object.assign({}, FroalaEditor.TOOLBAR_BUTTONS.moreParagraph, {
    'buttonsVisible': 2
  });
  FroalaEditor.TOOLBAR_BUTTONS_SM.moreRich = Object.assign({}, FroalaEditor.TOOLBAR_BUTTONS.moreRich, {
    'buttonsVisible': 2
  });
  FroalaEditor.TOOLBAR_BUTTONS_SM.moreMisc = Object.assign({}, FroalaEditor.TOOLBAR_BUTTONS.moreMisc, {
    'buttonsVisible': 2
  });
  FroalaEditor.TOOLBAR_BUTTONS_SM.trackChanges = Object.assign({}, FroalaEditor.TOOLBAR_BUTTONS.trackChanges, {
    'buttonsVisible': 0
  });
  FroalaEditor.TOOLBAR_BUTTONS_XS = {};
  FroalaEditor.TOOLBAR_BUTTONS_XS.moreText = Object.assign({}, FroalaEditor.TOOLBAR_BUTTONS.moreText, {
    'buttonsVisible': 0
  });
  FroalaEditor.TOOLBAR_BUTTONS_XS.moreParagraph = Object.assign({}, FroalaEditor.TOOLBAR_BUTTONS.moreParagraph, {
    'buttonsVisible': 0
  });
  FroalaEditor.TOOLBAR_BUTTONS_XS.moreRich = Object.assign({}, FroalaEditor.TOOLBAR_BUTTONS.moreRich, {
    'buttonsVisible': 0
  });
  FroalaEditor.TOOLBAR_BUTTONS_XS.moreMisc = Object.assign({}, FroalaEditor.TOOLBAR_BUTTONS.moreMisc, {
    'buttonsVisible': 2
  });
  FroalaEditor.TOOLBAR_BUTTONS_XS.trackChanges = Object.assign({}, FroalaEditor.TOOLBAR_BUTTONS.trackChanges, {
    'buttonsVisible': 0
  });
  FroalaEditor.POWERED_BY = '<a id="fr-logo" href="https://froala.com/wysiwyg-editor" target="_blank" title="Froala WYSIWYG HTML Editor"><span>Powered by</span><svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 822.8 355.33"><defs><style>.fr-logo{fill:#b1b2b7;}</style></defs><title>Froala</title><path class="fr-logo" d="M123.58,78.65A16.16,16.16,0,0,0,111.13,73H16.6C7.6,73,0,80.78,0,89.94V128.3a16.45,16.45,0,0,0,32.9,0V104.14h78.5A15.63,15.63,0,0,0,126.87,91.2,15.14,15.14,0,0,0,123.58,78.65Z"/><path class="fr-logo" d="M103.54,170a16.05,16.05,0,0,0-11.44-4.85H15.79A15.81,15.81,0,0,0,0,180.93v88.69a16.88,16.88,0,0,0,5,11.92,16,16,0,0,0,11.35,4.7h.17a16.45,16.45,0,0,0,16.41-16.6v-73.4H92.2A15.61,15.61,0,0,0,107.89,181,15.1,15.1,0,0,0,103.54,170Z"/><path class="fr-logo" d="M233,144.17c-5.29-6.22-16-7.52-24.14-7.52-16.68,0-28.72,7.71-36.5,23.47v-5.67a16.15,16.15,0,1,0-32.3,0v115.5a16.15,16.15,0,1,0,32.3,0v-38.7c0-19.09,3.5-63.5,35.9-63.5a44.73,44.73,0,0,1,5.95.27h.12c12.79,1.2,20.06-2.73,21.6-11.69C236.76,151.48,235.78,147.39,233,144.17Z"/><path class="fr-logo" d="M371.83,157c-13.93-13.11-32.9-20.33-53.43-20.33S279,143.86,265.12,157c-14.67,13.88-22.42,32.82-22.42,54.77,0,21.68,8,41.28,22.4,55.2,13.92,13.41,32.85,20.8,53.3,20.8s39.44-7.38,53.44-20.79c14.55-13.94,22.56-33.54,22.56-55.21S386.39,170.67,371.83,157Zm-9.73,54.77c0,25.84-18.38,44.6-43.7,44.6s-43.7-18.76-43.7-44.6c0-25.15,18.38-43.4,43.7-43.4S362.1,186.59,362.1,211.74Z"/><path class="fr-logo" d="M552.7,138.14a16.17,16.17,0,0,0-16,16.3v1C526.41,143.85,509,136.64,490,136.64c-19.83,0-38.19,7.24-51.69,20.4C424,171,416.4,190,416.4,212c0,21.61,7.78,41.16,21.9,55,13.56,13.33,31.92,20.67,51.7,20.67,18.83,0,36.29-7.41,46.7-19.37v1.57a16.15,16.15,0,1,0,32.3,0V154.44A16.32,16.32,0,0,0,552.7,138.14Zm-16.3,73.6c0,30.44-22.81,44.3-44,44.3-24.57,0-43.1-19-43.1-44.3s18.13-43.4,43.1-43.4C513.73,168.34,536.4,183.55,536.4,211.74Z"/><path class="fr-logo" d="M623.5,61.94a16.17,16.17,0,0,0-16,16.3v191.7a16.15,16.15,0,1,0,32.3,0V78.24A16.32,16.32,0,0,0,623.5,61.94Z"/><path class="fr-logo" d="M806.5,138.14a16.17,16.17,0,0,0-16,16.3v1c-10.29-11.63-27.74-18.84-46.7-18.84-19.83,0-38.19,7.24-51.69,20.4-14.33,14-21.91,33-21.91,55,0,21.61,7.78,41.16,21.9,55,13.56,13.33,31.92,20.67,51.7,20.67,18.83,0,36.29-7.41,46.7-19.37v1.57a16.15,16.15,0,1,0,32.3,0V154.44A16.32,16.32,0,0,0,806.5,138.14Zm-16.3,73.6c0,30.44-22.81,44.3-44,44.3-24.57,0-43.1-19-43.1-44.3s18.13-43.4,43.1-43.4C767.53,168.34,790.2,183.55,790.2,211.74Z"/></svg></a>';

  FroalaEditor.MODULES.toolbar = function (editor) {
    var $ = editor.$; // Create a button map for each screen size.

    var _buttons_map = [];
    _buttons_map[FroalaEditor.XS] = _normalizeButtons(editor.opts.toolbarButtonsXS || editor.opts.toolbarButtons || FroalaEditor.TOOLBAR_BUTTONS_XS || FroalaEditor.TOOLBAR_BUTTONS || []);
    _buttons_map[FroalaEditor.SM] = _normalizeButtons(editor.opts.toolbarButtonsSM || editor.opts.toolbarButtons || FroalaEditor.TOOLBAR_BUTTONS_SM || FroalaEditor.TOOLBAR_BUTTONS || []);
    _buttons_map[FroalaEditor.MD] = _normalizeButtons(editor.opts.toolbarButtonsMD || editor.opts.toolbarButtons || FroalaEditor.TOOLBAR_BUTTONS_MD || FroalaEditor.TOOLBAR_BUTTONS || []);
    _buttons_map[FroalaEditor.LG] = _normalizeButtons(editor.opts.toolbarButtons || FroalaEditor.TOOLBAR_BUTTONS || []); // Store previous screen size for resizing optimization

    var previousScreenSize;
    /**
     * Normalize buttons for regular structure.
     */

    function _normalizeButtons(buttons) {
      // All this method should do is to change the structure of the _buttons_map to be inline with the specs for buttons in V3.
      // Buttons is an array
      var buttonGroups = {};

      if (Array.isArray(buttons)) {
        // Convert from old button list to new button list
        if (!Array.isArray(buttons[0])) {
          var toolbarButtonGroups = [];
          var currentButtonGroup = [];

          for (var i = 0; i < buttons.length; i++) {
            // If the value is of type separator then add the currentButtonGroup to the toolbarButtonGroups
            // Re-initialize the currentButtonGroup for new group
            if (buttons[i] === '|' || buttons[i] === '-') {
              if (currentButtonGroup.length > 0) {
                toolbarButtonGroups.push(currentButtonGroup);
              }

              currentButtonGroup = [];
            } // Otherwise add the button to the currentButtonGroup
            else {
              currentButtonGroup.push(buttons[i]);
            }
          } // If there are buttons in the currentButtonGroup then add the group to the toolbar button groups


          if (currentButtonGroup.length > 0) {
            toolbarButtonGroups.push(currentButtonGroup);
          }

          buttons = toolbarButtonGroups;
        } // Create a button group object from button group array


        buttons.forEach(function (button, index) {
          buttonGroups["group".concat(index + 1)] = {
            buttons: button
          };
        }); // Don't show more buttons when input buttons is a list

        buttonGroups.showMoreButtons = false;
      } // Button is an Object with group name and buttons info
      else if (_typeof(buttons) === 'object' && !Array.isArray(buttons)) {
        buttonGroups = buttons; // Show more buttons when input is more button groups

        buttonGroups.showMoreButtons = true;
      }

      return buttonGroups;
    }
    /**
     * Add buttons to the toolbar.
     */


    function _addButtons() {
      var buttons_list = editor.button.buildGroup(_screenButtons());
      editor.$tb.append(buttons_list); // Set the height of all more toolbars

      setMoreToolbarsHeight();
      editor.button.bindCommands(editor.$tb);
    }
    /**
     * The buttons that should be visible on the current screen size.
     */


    function _screenButtons() {
      var screen_size = editor.helpers.screenSize(); // Update previous screen size

      previousScreenSize = screen_size;
      return _buttons_map[screen_size];
    }
    /**
     * Remove button group wrappers
     */


    function _removeButtonGroupWrappers() {
      // Remove all wrapper button groups
      var $buttonGroups = editor.$tb.find('.fr-btn-grp, .fr-more-toolbar');

      var _loop = function _loop(index) {
        // Remove parent wrapper
        var $buttonGroup = $($buttonGroups[index]);
        $buttonGroup.children().each(function (index, $btn) {
          $buttonGroup.before($btn);
        });
        $buttonGroup.remove();
      };

      for (var index = 0; index < $buttonGroups.length; index++) {
        _loop(index);
      }
    }
    /**
     * Sets the more toolbar height
     */


    function setMoreToolbarsHeight() {
      var $moreToolbars = editor.$tb.find('.fr-more-toolbar');

      for (var i = 0; i < $moreToolbars.length; i++) {
        var $moreToolbar = $($moreToolbars[i]); // Do only if more toolbar is expanded

        if ($moreToolbar.hasClass('fr-expanded')) {
          (function () {
            // More toolbar left padding
            var moreToolbarWidth = editor.helpers.getPX($moreToolbar.css('padding-left')); // Get all more toolbar buttons

            var $moreToolbarBtns = $moreToolbar.find('> .fr-command, > .fr-btn-wrap');
            var $moreToolbarBtn = $($moreToolbarBtns[0]); // Compute button margins if any

            var buttonMarginLeft = editor.helpers.getPX($moreToolbarBtn.css('margin-left'));
            var buttonMarginRight = editor.helpers.getPX($moreToolbarBtn.css('margin-right'));
            var buttonMarginTop = editor.helpers.getPX($moreToolbarBtn.css('margin-top'));
            var buttonMarginBottom = editor.helpers.getPX($moreToolbarBtn.css('margin-bottom')); // Compute more toolbar content width

            $moreToolbarBtns.each(function (index, btn) {
              moreToolbarWidth += $(btn).outerWidth() + buttonMarginLeft + buttonMarginRight;
            }); // Compute complete toolbar width

            var toolbarWidth = editor.$tb.outerWidth(); // If all the more toolbar buttons can't be accomodated in one row

            if (moreToolbarWidth > toolbarWidth) {
              // Compute no of rows required to accomodate all more toolbar buttons
              var moreToolbarRows = Math.floor(moreToolbarWidth / editor.$tb.outerWidth());
              moreToolbarWidth += moreToolbarRows * (moreToolbarWidth / $moreToolbar[0].childElementCount);
              moreToolbarRows = Math.ceil(moreToolbarWidth / editor.$tb.outerWidth()); // Set more toolbar height

              var moreToolbarHeight = (editor.helpers.getPX($moreToolbarBtn.css('height')) + buttonMarginTop + buttonMarginBottom) * moreToolbarRows;
              $moreToolbar.css('height', moreToolbarHeight);
            }
          })();
        } // Otherwise reset the properties
        else {
          $moreToolbar.css('height', '');
        }
      } // merged conflict from master, incoming change and commented first line in below if block


      if (!editor.helpers.isMobile() && editor.opts.toolbarBottom) {
        // Shift the editor area by the new toolbar height
        // editor.$tb.css('padding-bottom', toolbarPaddingBottom)
        editor.$tb.find('.fr-toolbar .fr-more-toolbar').removeClass('position-relative');
      } else {
        editor.$tb.find('.fr-toolbar .fr-more-toolbar').addClass('position-relative');
      } // till here

    }
    /**
     * Reorder the toolbar buttons on resize
     */


    function _showScreenButtons() {
      if ($("[data-name='trackChanges-".concat(editor.id, "']")).length == 0) {
        var trackingBtns = ['showChanges', 'applyAll', 'removeAll', 'applyLast', 'removeLast'];
        $('.fr-toolbar').append($('<div class="fr-more-toolbar"></div>').data('name', "trackChanges-".concat(editor.id)));

        for (var _i = 0, _trackingBtns = trackingBtns; _i < _trackingBtns.length; _i++) {
          var cmdName = _trackingBtns[_i];
          var cmdInfo = FroalaEditor.COMMANDS[cmdName];

          if (!cmdInfo) {
            continue;
          }

          cmdInfo.more_btn = true;
          var $moreButton = $(editor.button.build(cmdName, cmdInfo, true)); // Register the more button

          editor.button.addButtons($moreButton);
          $("[data-name='trackChanges-".concat(editor.id, "']")).append($moreButton);
        }
      } // Update the toolbar only if screen size is changed


      if (previousScreenSize !== editor.helpers.screenSize()) {
        // Get screen button groups
        var buttonGroups = _screenButtons(); // Toolbar groups


        var mainToolbarButtonGroups = $();
        var moreToolbarButtonGroups = $(); // Hide all buttons

        editor.$tb.find('.fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command, .fr-btn-grp > .fr-btn-wrap > .fr-command, .fr-more-toolbar > .fr-btn-wrap > .fr-command').addClass('fr-hidden'); // Remove wrapper div from button groups

        _removeButtonGroupWrappers();

        for (var groupName in buttonGroups) {
          // Current button group
          var buttonGroup = buttonGroups[groupName]; // Ignore non-button groups

          if (!buttonGroup.buttons) {
            continue;
          } // Current button group Details


          var moreToolbarButtons = void 0;
          var buttonCount = 0;
          var visibleButtons = 3;
          var mainToolbarButtons = void 0; // No need to create a track change primary button as it is already present in moreRich group

          if (groupName !== 'trackChanges') {
            mainToolbarButtons = $("<div class=\"fr-btn-grp fr-float-".concat(buttonGroups[groupName].align ? buttonGroups[groupName].align : 'left', "\"></div>"));
          }

          if (buttonGroups.showMoreButtons) {
            moreToolbarButtons = $('<div class="fr-more-toolbar"></div>').data('name', "".concat(groupName, "-").concat(editor.id)); // On screen resize, maintain the expanded state of moreRich and trackChanges section

            if ((groupName === 'trackChanges' || groupName === 'moreRich') && editor.opts.trackChangesEnabled) {
              moreToolbarButtons.addClass('fr-expanded');
            }
          }

          for (var i = 0; i < buttonGroup.buttons.length; i++) {
            // If buttonVisible is provided then use it
            if (buttonGroup.buttonsVisible !== undefined) {
              visibleButtons = buttonGroup.buttonsVisible;
            } // Get the button for the command


            var $btn = editor.$tb.find('> .fr-command[data-cmd="' + buttonGroup.buttons[i] + '"], > div.fr-btn-wrap > .fr-command[data-cmd="' + buttonGroup.buttons[i] + '"]');
            var $dropdown = null; // If it is a dropdown button

            if (editor.node.hasClass($btn.next().get(0), 'fr-dropdown-menu')) {
              $dropdown = $btn.next();
            } // If it is a button with options


            if (editor.node.hasClass($btn.next().get(0), 'fr-options')) {
              $btn.removeClass('fr-hidden');
              $btn.next().removeClass('fr-hidden');
              $btn = $btn.parent();
            } // Show the buttons in the toolbar


            $btn.removeClass('fr-hidden'); // Wrap the buttons in a button group

            if (buttonGroups.showMoreButtons && buttonCount >= visibleButtons) {
              moreToolbarButtons.append($btn);

              if ($dropdown) {
                moreToolbarButtons.append($dropdown);
              }
            } else {
              mainToolbarButtons.append($btn);

              if ($dropdown) {
                mainToolbarButtons.append($dropdown);
              }
            }

            buttonCount++;
          } // Add more button if buttons in group are more than 'buttonsVisible'


          if (buttonGroups.showMoreButtons && buttonCount > visibleButtons) {
            var _$moreButton = editor.$tb.find(".fr-command[data-cmd=\"".concat(groupName, "\"]"));

            if (_$moreButton.length > 0) {
              _$moreButton.removeClass('fr-hidden fr-open');
            } else {
              // Create a new more button if not present already
              var _cmdName = groupName;
              var _cmdInfo = FroalaEditor.COMMANDS[_cmdName];

              if (_cmdInfo) {
                _cmdInfo.more_btn = true;
                _$moreButton = $(editor.button.build(_cmdName, _cmdInfo, true)); // Register the more button

                editor.button.addButtons(_$moreButton);
              }
            }

            if (mainToolbarButtons) {
              mainToolbarButtons.append(_$moreButton);
            }
          } // Append visible buttons on the main toolbar


          if (mainToolbarButtons) {
            mainToolbarButtonGroups.push(mainToolbarButtons);
          } // Append more toolbar buttons


          if (buttonGroups.showMoreButtons) {
            moreToolbarButtonGroups.push(moreToolbarButtons);
          }
        } // Append button groups to the editor


        if (editor.opts.toolbarBottom) {
          editor.$tb.append(moreToolbarButtonGroups);
          editor.$tb.find('.fr-newline').remove();
          editor.$tb.append('<div class="fr-newline"></div>');
          editor.$tb.append(mainToolbarButtonGroups);
        } else {
          editor.$tb.append(mainToolbarButtonGroups);
          editor.$tb.find('.fr-newline').remove();
          editor.$tb.append('<div class="fr-newline"></div>');
          editor.$tb.append(moreToolbarButtonGroups);
        } // Close the more toolbar


        editor.$tb.removeClass('fr-toolbar-open');
        editor.$box.removeClass('fr-toolbar-open'); // Switch to normal view if in code view

        editor.events.trigger('codeView.toggle');
      } // Refresh more toolbar height on resize


      setMoreToolbarsHeight();
    }
    /**
     * Set the buttons visibility based on screen size.
     */


    function _setVisibility() {
      editor.events.$on($(editor.o_win), 'resize', _showScreenButtons);
      editor.events.$on($(editor.o_win), 'orientationchange', _showScreenButtons);

      if (editor.opts.toolbarButtons && JSON.stringify(editor.opts.toolbarButtons).indexOf('trackChanges') > -1) {
        _showScreenButtons();
      }
    }

    function showInline(e, force) {
      setTimeout(function () {
        // https://github.com/froala-labs/froala-editor-js-2/issues/1571
        // Condition added to avoid showing toolbar when the table has contenteditable:false
        if ((!e || e.which != FroalaEditor.KEYCODE.ESC) && editor.selection.inEditor() && editor.core.hasFocus() && !editor.popups.areVisible() && $(editor.selection.blocks()[0]).closest('table').attr('contenteditable') != 'false') {
          if (editor.opts.toolbarVisibleWithoutSelection || !editor.selection.isCollapsed() && !editor.keys.isIME() || force) {
            editor.$tb.data('instance', editor); // Check if we should actually show the toolbar.

            if (editor.events.trigger('toolbar.show', [e]) === false) {
              return;
            }

            editor.$tb.show();

            if (!editor.opts.toolbarContainer) {
              editor.position.forSelection(editor.$tb);
            }

            if (editor.opts.zIndex > 1) {
              editor.$tb.css('z-index', editor.opts.zIndex + 1);
            } else {
              editor.$tb.css('z-index', null);
            }
          }
        }
      }, 0);
    }

    function hide(e) {
      // Prevent hiding the editor toolbar when changing the window.
      if (e && e.type === 'blur' && document.activeElement === editor.el) {
        return false;
      } // Do not hide toolbar if we press CTRL.


      if (e && e.type === 'keydown' && editor.keys.ctrlKey(e)) {
        return true;
      } // Prevent hiding when dropdown is active and we scoll in it.
      // https://github.com/froala/wysiwyg-editor/issues/1290


      var $active_dropdowns = editor.button.getButtons('.fr-dropdown.fr-active');

      if ($active_dropdowns.next().find(editor.o_doc.activeElement).length) {
        return true;
      } // closed sub-toolbar before showing toolbar, since blur event is not firing
      // https://github.com/froala-labs/froala-editor-js-2/issues/2186


      if (editor.helpers.isMobile() && editor.opts.toolbarInline) {
        editor.$tb.find('.fr-expanded').toggleClass('fr-expanded');
        editor.$tb.find('.fr-open').removeClass('fr-open');
        editor.$tb.removeClass('fr-toolbar-open');
        setMoreToolbarsHeight();
      } // Check if we should actually hide the toolbar.


      if (editor.events.trigger('toolbar.hide') !== false) {
        editor.$tb.hide();
      }
    }

    function show() {
      // Check if we should actually hide the toolbar.
      if (editor.events.trigger('toolbar.show') === false) {
        return false;
      }

      editor.$tb.show();
    }

    var tm = null;

    function _showInlineWithTimeout(e) {
      clearTimeout(tm);

      if (!e || e.which !== FroalaEditor.KEYCODE.ESC) {
        tm = setTimeout(showInline, editor.opts.typingTimer);
      }
    }
    /**
     * Set the events for show / hide toolbar.
     */


    function _initInlineBehavior() {
      // Window mousedown.
      editor.events.on('window.mousedown', hide); // Element keydown.

      editor.events.on('keydown', hide); // Element blur.

      editor.events.on('blur', hide); // Position the toolbar after expanding the more toolbar completely if toolbar is inline

      editor.events.$on(editor.$tb, 'transitionend', '.fr-more-toolbar', function () {
        editor.position.forSelection(editor.$tb);
      }); // Window mousedown.

      if (!editor.helpers.isMobile()) {
        editor.events.on('window.mouseup', showInline);
      }

      if (editor.helpers.isMobile()) {
        if (!editor.helpers.isIOS()) {
          editor.events.on('window.touchend', showInline);

          if (editor.browser.mozilla) {
            setInterval(showInline, 200);
          }
        }
      } else {
        editor.events.on('window.keyup', _showInlineWithTimeout);
      } // Hide editor on ESC.


      editor.events.on('keydown', function (e) {
        if (e && e.which === FroalaEditor.KEYCODE.ESC) {
          editor.events.trigger('toolbar.esc');
        }
      }); // Enable accessibility shortcut.

      editor.events.on('keydown', function (e) {
        if (e.which === FroalaEditor.KEYCODE.ALT) {
          e.stopPropagation();
          return false;
        }
      }, true);
      editor.events.$on(editor.$wp, 'scroll.toolbar', showInline);
      editor.events.on('commands.after', showInline);

      if (editor.helpers.isMobile()) {
        editor.events.$on(editor.$doc, 'selectionchange', _showInlineWithTimeout);
        editor.events.$on(editor.$doc, 'orientationchange', showInline);
      }
    }

    function _initPositioning() {
      // Toolbar is inline.
      if (editor.opts.toolbarInline) {
        // Mobile should handle this as regular.
        editor.$sc.append(editor.$tb); // Add toolbar to body.

        editor.$tb.data('container', editor.$sc); // Add inline class.

        editor.$tb.addClass('fr-inline'); // Init mouse behavior.

        _initInlineBehavior();

        editor.opts.toolbarBottom = false;
      } // Toolbar is normal.
      else {
        // Won't work on iOS.
        if (editor.opts.toolbarBottom) {
          editor.$box.append(editor.$tb);
          editor.$tb.addClass('fr-bottom');
          editor.$box.addClass('fr-bottom');
        } else {
          editor.opts.toolbarBottom = false;
          editor.$box.prepend(editor.$tb);
          editor.$tb.addClass('fr-top');
          editor.$box.addClass('fr-top');
        }

        editor.$tb.addClass('fr-basic');

        if (editor.opts.toolbarSticky) {
          if (editor.opts.toolbarStickyOffset) {
            if (editor.opts.toolbarBottom) {
              editor.$tb.css('bottom', editor.opts.toolbarStickyOffset);
            } else {
              editor.$tb.css('top', editor.opts.toolbarStickyOffset);
            }
          }

          editor.position.addSticky(editor.$tb);
        }
      }
    }
    /**
     * Destroy.
     */


    function _sharedDestroy() {
      editor.$tb.html('').removeData().remove();
      editor.$tb = null;

      if (editor.$second_tb) {
        editor.$second_tb.html('').removeData().remove();
        editor.$second_tb = null;
      }
    }

    function _destroy() {
      editor.$box.removeClass('fr-top fr-bottom fr-inline fr-basic');
      editor.$box.find('.fr-sticky-dummy').remove();
    }

    function _setDefaults() {
      if (editor.opts.theme) {
        editor.$tb.addClass("".concat(editor.opts.theme, "-theme"));
      }

      if (editor.opts.zIndex > 1) {
        editor.$tb.css('z-index', editor.opts.zIndex + 1);
      } // Set direction.


      if (editor.opts.direction !== 'auto') {
        editor.$tb.removeClass('fr-ltr fr-rtl').addClass("fr-".concat(editor.opts.direction));
      } // Mark toolbar for desktop / mobile.


      if (!editor.helpers.isMobile()) {
        editor.$tb.addClass('fr-desktop');
      } else {
        editor.$tb.addClass('fr-mobile');
      } // Set the toolbar specific position inline / normal.


      if (!editor.opts.toolbarContainer) {
        _initPositioning();
      } else {
        if (editor.opts.toolbarInline) {
          _initInlineBehavior();

          hide();
        }

        if (editor.opts.toolbarBottom) {
          editor.$tb.addClass('fr-bottom');
        } else {
          editor.$tb.addClass('fr-top');
        }
      } // Add buttons to the toolbar.
      // Set their visibility for different screens.
      // Asses commands to the butttons.


      _addButtons();

      _setVisibility();

      editor.accessibility.registerToolbar(editor.$tb); // Make sure we don't trigger blur.

      editor.events.$on(editor.$tb, "".concat(editor._mousedown, " ").concat(editor._mouseup), function (e) {
        var originalTarget = e.originalEvent ? e.originalEvent.target || e.originalEvent.originalTarget : null;

        if (originalTarget && originalTarget.tagName !== 'INPUT' && !editor.edit.isDisabled()) {
          e.stopPropagation();
          e.preventDefault();
          return false;
        }
      }, true); // https://github.com/froala-labs/froala-editor-js-2/issues/1972

      if (editor.helpers.isMobile()) {
        editor.events.$on(editor.$tb, 'click', function () {
          // Check for active popups and retain focus in editor if none.
          if (!editor.popups.areVisible().length && (editor.id === editor.shared.selected_editor || !editor.shared.selected_editor)) {
            editor.$el.focus();
          }
        });
      } // Refresh the screen size if in fullscreen mode after the more toolbar expands completely


      editor.events.$on(editor.$tb, 'transitionend', '.fr-more-toolbar', function () {
        if (editor.$box.hasClass('fr-fullscreen')) {
          editor.opts.height = editor.o_win.innerHeight - (editor.opts.toolbarInline ? 0 : editor.$tb.outerHeight() + (editor.$second_tb ? editor.$second_tb.outerHeight() : 0));
          editor.size.refresh();
        }
      });
    }
    /**
     * Initialize
     */


    function _init() {
      editor.$sc = $(editor.opts.scrollableContainer).first();

      if (!editor.$wp) {
        return false;
      } // Add second toolbar


      if (!editor.opts.toolbarInline && !editor.opts.toolbarBottom) {
        editor.$second_tb = $(editor.doc.createElement('div')).attr('class', 'fr-second-toolbar');
        editor.$box.append(editor.$second_tb); // Add powered by attribution.

        if (!(editor.ul === false && !editor.opts.attribution)) {
          editor.$second_tb.prepend(FroalaEditor.POWERED_BY);
        }
      } // Container for toolbar.


      if (editor.opts.toolbarContainer) {
        // Shared toolbar.
        if (!editor.shared.$tb) {
          editor.shared.$tb = $(editor.doc.createElement('DIV'));
          editor.shared.$tb.addClass('fr-toolbar');
          editor.$tb = editor.shared.$tb;
          $(editor.opts.toolbarContainer).append(editor.$tb);

          _setDefaults();

          editor.$tb.data('instance', editor);
        } else {
          editor.$tb = editor.shared.$tb;

          if (editor.opts.toolbarInline) {
            _initInlineBehavior();
          }
        }

        if (editor.opts.toolbarInline) {
          // Update box.
          editor.$box.addClass('fr-inline');
        } else {
          editor.$box.addClass('fr-basic');
        } // On focus set the current instance.


        editor.events.on('focus', function () {
          editor.$tb.data('instance', editor);
        }, true);
        editor.opts.toolbarInline = false;
      } else if (editor.opts.toolbarInline) {
        // Update box.
        editor.$box.addClass('fr-inline'); // Check for shared toolbar.

        if (!editor.shared.$tb) {
          editor.shared.$tb = $(editor.doc.createElement('DIV'));
          editor.shared.$tb.addClass('fr-toolbar');
          editor.$tb = editor.shared.$tb;

          _setDefaults();
        } else {
          editor.$tb = editor.shared.$tb; // Init mouse behavior.

          _initInlineBehavior();
        }
      } else {
        editor.$box.addClass('fr-basic');
        editor.$tb = $(editor.doc.createElement('DIV'));
        editor.$tb.addClass('fr-toolbar');

        _setDefaults();

        editor.$tb.data('instance', editor);
      } // Destroy.


      editor.events.on('destroy', _destroy, true);
      editor.events.on(!editor.opts.toolbarInline && !editor.opts.toolbarContainer ? 'destroy' : 'shared.destroy', _sharedDestroy, true); // Bind edit on /off events.

      editor.events.on('edit.on', function () {
        editor.$tb.removeClass('fr-disabled').removeAttr('aria-disabled');
      });
      editor.events.on('edit.off', function () {
        editor.$tb.addClass('fr-disabled').attr('aria-disabled', true);
      });

      _initShortcuts();
    }

    function _initShortcuts() {
      editor.events.on('shortcut', function (e, cmd, val) {
        // Search for button.
        var $btn;

        if (cmd && !val) {
          $btn = editor.$tb.find(".fr-command[data-cmd=\"".concat(cmd, "\"]"));
        } else if (cmd && val) {
          $btn = editor.$tb.find(".fr-command[data-cmd=\"".concat(cmd, "\"][data-param1=\"").concat(val, "\"]"));
        } // Button found.


        if ($btn.length) {
          e.preventDefault();
          e.stopPropagation();
          $btn.parents('.fr-toolbar').data('instance', editor);

          if (e.type === 'keydown') {
            editor.button.exec($btn);
            return false;
          }
        }
      });
    }

    var disabled = false;

    function disable() {
      if (!disabled && editor.$tb) {
        // Toolbar Button is two level down from toolbar div
        editor.$tb.find('.fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command').addClass('fr-disabled fr-no-refresh').attr('aria-disabled', true);
        disabled = true;
      }
    }

    function enable() {
      if (disabled && editor.$tb) {
        // Toolbar Button is two level down from toolbar div
        editor.$tb.find('.fr-btn-grp > .fr-command, .fr-more-toolbar > .fr-command').removeClass('fr-disabled fr-no-refresh').attr('aria-disabled', false);
        disabled = false;
      }

      editor.button.bulkRefresh();
    }

    return {
      _init: _init,
      hide: hide,
      show: show,
      showInline: showInline,
      disable: disable,
      enable: enable,
      setMoreToolbarsHeight: setMoreToolbarsHeight
    };
  };

  var passiveEvents = ['scroll', 'wheel', 'touchmove', 'touchstart', 'touchend']; // All possible prefixes of an event

  var eventPrefixes = ['webkit', 'moz', 'ms', 'o']; // Events which are browser dependent

  var irregularEvents = ['transitionend']; // List of all styles

  var stylesList = document.createElement('div').style; // All possible prefixes of a css property

  var cssPrefixes = ['Webkit', 'Moz', 'ms', 'O', 'css', 'style']; // Properties to be applied to get correct element styles

  var cssShow = {
    visibility: 'hidden',
    display: 'block'
  }; // Special Events

  var specialEvents = ['focus', 'blur', 'click']; // Map to cache computed correct style names

  var correctStyleName = {};

  var _getEvent = function _getEvent(e, target) {
    return {
      altKey: e.altKey,
      bubbles: e.bubbles,
      cancelable: e.cancelable,
      changedTouches: e.changedTouches,
      ctrlKey: e.ctrlKey,
      detail: e.detail,
      eventPhase: e.eventPhase,
      metaKey: e.metaKey,
      pageX: e.pageX,
      pageY: e.pageY,
      shiftKey: e.shiftKey,
      view: e.view,
      'char': e["char"],
      key: e.key,
      keyCode: e.keyCode,
      button: e.button,
      buttons: e.buttons,
      clientX: e.clientX,
      clientY: e.clientY,
      offsetX: e.offsetX,
      offsetY: e.offsetY,
      pointerId: e.pointerId,
      pointerType: e.pointerType,
      screenX: e.screenX,
      screenY: e.screenY,
      targetTouches: e.targetTouches,
      toElement: e.toElement,
      touches: e.touches,
      type: e.type,
      which: e.which,
      target: e.target,
      currentTarget: target,
      originalEvent: e,
      stopPropagation: function stopPropagation() {
        e.stopPropagation();
      },
      stopImmediatePropagation: function stopImmediatePropagation() {
        e.stopImmediatePropagation();
      },
      preventDefault: function preventDefault() {
        if (passiveEvents.indexOf(e.type) === -1) {
          e.preventDefault();
        }
      }
    };
  };

  var isPartOfDOM = function isPartOfDOM(target) {
    return target.ownerDocument && target.ownerDocument.body && target.ownerDocument.body.contains(target) || target.nodeName === '#document' || target.nodeName === 'HTML' || target === window;
  };

  var _getDelegator = function _getDelegator(fn, selector) {
    return function (e) {
      // Get the element the event was raised by.
      var target = e.target; // Loop parents.

      if (selector) {
        selector = _normalizeSelector(selector);

        while (target && target !== this) {
          // Check if the current target matches
          if (Element.prototype.matches.call(target, _normalizeSelector(selector))) {
            fn.call(target, _getEvent(e, target));
          }

          target = target.parentNode;
        }
      } else {
        if (isPartOfDOM(target)) {
          fn.call(target, _getEvent(e, target));
        }
      }
    };
  };

  var jQuery = function jQuery(selector, context) {
    return new init(selector, context);
  };

  var _normalizeSelector = function _normalizeSelector(selector) {
    if (selector && typeof selector == 'string') {
      // Modified the regex to handle the spaces before '>'
      return selector.replace(/^\s*>/g, ':scope >').replace(/,\s*>/g, ', :scope >');
    }

    return selector;
  };

  var isFunction = function isFunction(obj) {
    // Support: Chrome <=57, Firefox <=52
    // In some browsers, typeof returns "function" for HTML <object> elements
    // (i.e., `typeof document.createElement( "object" ) === "function"`).
    // We don't want to classify *any* DOM node as a function.
    return typeof obj === 'function' && typeof obj.nodeType !== 'number';
  };

  var $ = jQuery;
  jQuery.fn = jQuery.prototype = {
    constructor: jQuery,
    // The default length of a jQuery object is 0
    length: 0,
    contains: function contains(obj) {
      if (!obj) return false;

      if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
          if (this.contains(obj[i]) && this != obj[i]) return true;
        }

        return false;
      }

      for (var _i = 0; _i < this.length; _i++) {
        var node = obj;

        while (node) {
          if (node == this[_i] || node[0] && node[0].isEqualNode(this[_i])) {
            return true;
          }

          node = node.parentNode;
        }
      }

      return false;
    },
    findVisible: function findVisible(selector) {
      var $els = this.find(selector);

      for (var i = $els.length - 1; i >= 0; i--) {
        if (!$($els[i]).isVisible()) {
          $els.splice(i, 1);
        }
      }

      return $els;
    },
    // Encode URL parameters
    formatParams: function formatParams(params) {
      var formattedParams = "".concat(Object.keys(params).map(function (key) {
        return "".concat(key, "=").concat(encodeURIComponent(params[key]));
      }).join('&'));
      return formattedParams ? formattedParams : '';
    },
    // Takes a request object for making http requests using XMLHttpRequest
    ajax: function ajax(request) {
      var xhr = new XMLHttpRequest();
      var data = this.formatParams(request.data); // Add request params to the URL for GET request

      if (request.method.toUpperCase() === 'GET') {
        request.url = data ? request.url + '?' + data : request.url;
      } // Make it async.


      xhr.open(request.method, request.url, true); // Set with credentials.

      if (request.withCredentials) {
        xhr.withCredentials = true;
      } // Set with CORS


      if (request.crossDomain) {
        xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
      } // Set headers.


      for (var header in request.headers) {
        if (Object.prototype.hasOwnProperty.call(request.headers, header)) {
          xhr.setRequestHeader(header, request.headers[header]);
        }
      }

      if (!Object.prototype.hasOwnProperty.call(request.headers, 'Content-Type')) {
        // Set json data type
        if (request.dataType === 'json') {
          xhr.setRequestHeader('Content-Type', 'application/json');
        } else {
          //Set deafult Content-Type
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        }
      } // Set events.


      xhr.onload = function () {
        if (xhr.status == 200) {
          var _data = xhr.responseText;

          if (request.dataType === 'json') {
            _data = JSON.parse(_data);
          }

          request.done(_data, xhr.status, xhr);
        } else {
          request.fail(xhr);
        }
      }; // Send data.


      xhr.send(data);
    },
    // Get all previous siblings of an element
    prevAll: function prevAll() {
      var res = $();

      if (!this[0]) {
        return res;
      }

      var elem = this[0];

      while (elem && elem.previousSibling) {
        elem = elem.previousSibling;
        res.push(elem);
      }

      return res;
    },
    // Determine the position of an element within the set
    index: function index(elem) {
      // No argument, return index in parent
      if (!elem) {
        return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
      } // Index in selector


      if (typeof elem === 'string') {
        return [].indexOf.call($(elem), this[0]);
      } // Locate the position of the desired element


      return [].indexOf.call(this, // If it receives a jQuery object, the first element is used
      elem.length ? elem[0] : elem);
    },
    isVisible: function isVisible() {
      if (!this[0]) {
        return false;
      }

      return !!(this[0].offsetWidth || this[0].offsetHeight || this[0].getClientRects().length);
    },
    toArray: function toArray() {
      return [].slice.call(this);
    },
    // Get the Nth element in the matched element set OR
    // Get the whole matched element set as a clean array
    get: function get(num) {
      // Return all the elements in a clean array
      if (num == null) {
        return [].slice.call(this);
      } // Return just the one element from the set


      return num < 0 ? this[num + this.length] : this[num];
    },
    // Take an array of elements and push it onto the stack
    // (returning the new matched element set)
    pushStack: function pushStack(elems) {
      // Build a new jQuery matched element set
      var ret = jQuery.merge(this.constructor(), elems); // Add the old object onto the stack (as a reference)

      ret.prevObject = this; // Return the newly-formed element set

      return ret;
    },
    wrapAll: function wrapAll(html) {
      var wrap;

      if (this[0]) {
        if (isFunction(html)) {
          html = html.call(this[0]);
        } // The elements to wrap the target around


        wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

        if (this[0].parentNode) {
          wrap.insertBefore(this[0]);
        }

        wrap.map(function () {
          var elem = this;

          while (elem.firstElementChild) {
            elem = elem.firstElementChild;
          }

          return elem;
        }).append(this);
      }

      return this;
    },
    wrapInner: function wrapInner(wrapper) {
      if (typeof wrapper === 'string') {
        var wrapperProps = wrapper.split(' ');
        var i = 0; // Remove all empty props

        while (i < wrapperProps.length && wrapperProps[i].trim().length === 0) {
          i++;
        } // First non-empty property is the element itself


        if (i < wrapperProps.length) {
          // https://github.com/froala-labs/froala-editor-js-2/issues/1928
          if ($(wrapper).length && wrapperProps[i].trim() === $(wrapper)[0].tagName) {
            wrapper = document.createElement(wrapperProps[i].trim());
          }

          i++;
        } // Make sure it is re-initialized


        if (typeof wrapper !== 'string') {
          // Add all wrapper attributes
          var $wrapper = $(wrapper);

          for (; i < wrapperProps.length; i++) {
            wrapperProps[i] = wrapperProps[i].trim();
            var attr = wrapperProps[i].split('=');
            $wrapper.attr(attr[0], attr[1].replace('"', ''));
          }
        }
      }

      while (this[0].firstChild && this[0].firstChild !== wrapper && typeof wrapper !== 'string') {
        wrapper.appendChild(this[0].firstChild);
      }
    },
    wrap: function wrap(html) {
      var htmlIsFunction = isFunction(html);
      return this.each(function (i) {
        $(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
      });
    },
    unwrap: function unwrap() {
      return this.parent().each(function () {
        if (!(this.nodeName && this.nodeName.toLowerCase() === name.toLowerCase())) {
          jQuery(this).replaceWith(this.childNodes);
        }
      });
    },
    grep: function grep(elems, callback, invert) {
      var callbackInverse,
          matches = [],
          i = 0,
          length = elems.length,
          callbackExpect = !invert; // Go through the array, only saving the items
      // that pass the validator function

      for (; i < length; i++) {
        callbackInverse = !callback(elems[i], i);

        if (callbackInverse !== callbackExpect) {
          matches.push(elems[i]);
        }
      }

      return matches;
    },
    map: function map(callback) {
      return this.pushStack(jQuery.map(this, function (elem, i) {
        return callback.call(elem, i, elem);
      }));
    },
    slice: function slice() {
      return this.pushStack([].slice.apply(this, arguments));
    },
    each: function each(fn) {
      if (this.length) {
        for (var i = 0; i < this.length; i++) {
          if (fn.call(this[i], i, this[i]) === false) {
            break;
          }
        }
      }

      return this;
    },
    first: function first() {
      return this.eq(0);
    },
    last: function last() {
      return this.eq(-1);
    },
    eq: function eq(i) {
      var len = this.length,
          j = +i + (i < 0 ? len : 0);
      return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
    },
    empty: function empty() {
      for (var i = 0; i < this.length; i++) {
        this[i].innerHTML = '';
      }
    },
    contents: function contents() {
      var ret = $();

      for (var i = 0; i < this.length; i++) {
        var cldrn = this[i].childNodes;

        for (var j = 0; j < cldrn.length; j++) {
          ret.push(cldrn[j]);
        }
      }

      return ret;
    },
    attr: function attr(name, val) {
      if (_typeof(name) === 'object') {
        for (var k in name) {
          if (Object.prototype.hasOwnProperty.call(name, k)) {
            if (name[k] !== null) {
              this.attr(k, name[k]);
            }
          }
        }

        return this;
      }

      if (typeof val !== 'undefined') {
        if (name === 'checked') {
          for (var i = 0; i < this.length; i++) {
            this[i].checked = val;
          }
        } else if (name === 'tagName') {
          for (var _i2 = 0; _i2 < this.length; _i2++) {
            this[_i2].tagName = val;
          }
        } else {
          for (var _i3 = 0; _i3 < this.length; _i3++) {
            this[_i3].setAttribute(name, val);
          }
        } // Chain.


        return this;
      } else {
        if (this.length === 0 || !(this[0].getAttribute || name === 'checked')) {
          return undefined;
        }

        if (name === 'checked') {
          return this[0].checked;
        } else if (name === 'tagName') {
          return this[0].tagName;
        }

        return this[0].getAttribute(name);
      }
    },
    removeAttr: function removeAttr(name) {
      for (var i = 0; i < this.length; i++) {
        if (this[i].removeAttribute) this[i].removeAttribute(name);
      }

      return this;
    },
    hide: function hide() {
      this.css('display', 'none');
      return this;
    },
    show: function show() {
      this.css('display', 'block');
      return this;
    },
    focus: function focus() {
      if (this.length) {
        this[0].focus();
      }

      return this;
    },
    blur: function blur() {
      if (this.length) {
        this[0].blur();
      }

      return this;
    },
    data: function data(name, val) {
      // Object.
      if (typeof val !== 'undefined') {
        for (var i = 0; i < this.length; i++) {
          this[i]['data-' + name] = val;

          if (_typeof(val) !== 'object' && typeof val !== 'function') {
            if (this[i].setAttribute) {
              this[i].setAttribute('data-' + name, val);
            }
          }
        } // Chain.


        return this;
      } else {
        if (typeof val !== 'undefined') {
          return this.attr('data-' + name, val);
        } else {
          if (this.length === 0) return undefined;

          for (var _i4 = 0; _i4 < this.length; _i4++) {
            var dt = this[_i4]['data-' + name];

            if (typeof dt === 'undefined' || dt === null) {
              if (this[_i4].getAttribute) {
                dt = this[_i4].getAttribute('data-' + name);
              }
            }

            if (typeof dt != 'undefined' && dt != null) {
              return dt;
            }
          }

          return undefined;
        }
      }
    },
    removeData: function removeData(name) {
      for (var i = 0; i < this.length; i++) {
        if (this[i].removeAttribute) this[i].removeAttribute('data-' + name);
        this[i]['data-' + name] = null;
      }

      return this;
    },
    getCorrectStyleName: function getCorrectStyleName(name) {
      // Compute only if not computed before
      if (!correctStyleName[name]) {
        var finalName; // If a style with same name exists then it is the original name

        if (name in stylesList) {
          finalName = name;
        } // Make first letter capital


        var capName = name[0].toUpperCase() + name.slice(1); // Try attaching the prefixes and checking if it is a valid style name

        var i = cssPrefixes.length;

        while (i--) {
          name = cssPrefixes[i] + capName;

          if (name in stylesList) {
            finalName = name;
          }
        } // Store for future use


        correctStyleName[name] = finalName;
      }

      return correctStyleName[name];
    },
    css: function css(name, val) {
      if (typeof val !== 'undefined') {
        if (this.length === 0) return this;

        if ((typeof val === 'string' && val.trim() !== '' && !isNaN(val) || typeof val === 'number') && /(margin)|(padding)|(height)|(width)|(top)|(left)|(right)|(bottom)/gi.test(name) && !/(line-height)/gi.test(name)) {
          val = val + 'px';
        }

        for (var i = 0; i < this.length; i++) {
          // Make sure the style name is correct
          name = $(this).getCorrectStyleName(name);
          this[i].style[name] = val;
        }

        return this;
      } else if (typeof name == 'string') {
        if (this.length === 0) return undefined;
        var doc = this[0].ownerDocument || document;
        var win = doc.defaultView || doc.parentWindow; // Make sure the style name is correct

        name = $(this).getCorrectStyleName(name);
        return win.getComputedStyle(this[0])[name];
      } else {
        for (var key in name) {
          if (Object.prototype.hasOwnProperty.call(name, key)) {
            this.css(key, name[key]);
          }
        }

        return this;
      }
    },
    toggleClass: function toggleClass(name, val) {
      if (name.split(' ').length > 1) {
        var names = name.split(' ');

        for (var i = 0; i < names.length; i++) {
          this.toggleClass(names[i], val);
        }

        return this;
      }

      for (var _i5 = 0; _i5 < this.length; _i5++) {
        if (typeof val === 'undefined') {
          if (this[_i5].classList.contains(name)) {
            this[_i5].classList.remove(name);
          } else {
            this[_i5].classList.add(name);
          }
        } else {
          if (val) {
            if (!this[_i5].classList.contains(name)) {
              this[_i5].classList.add(name);
            }
          } else {
            if (this[_i5].classList.contains(name)) {
              this[_i5].classList.remove(name);
            }
          }
        }
      }

      return this;
    },
    addClass: function addClass(name) {
      if (name.length === 0) return this;

      if (name.split(' ').length > 1) {
        var names = name.split(' ');

        for (var i = 0; i < names.length; i++) {
          this.addClass(names[i]);
        }

        return this;
      }

      for (var _i6 = 0; _i6 < this.length; _i6++) {
        this[_i6].classList.add(name);
      }

      return this;
    },
    removeClass: function removeClass(name) {
      if (name.split(' ').length > 1) {
        var names = name.split(' ');

        for (var i = 0; i < names.length; i++) {
          names[i] = names[i].trim();

          if (names[i].length) {
            this.removeClass(names[i]);
          }
        }

        return this;
      }

      for (var _i7 = 0; _i7 < this.length; _i7++) {
        if (name.length) {
          this[_i7].classList.remove(name);
        }
      }

      return this;
    },
    getClass: function getClass(elem) {
      return elem.getAttribute && elem.getAttribute('class') || '';
    },
    stripAndCollapse: function stripAndCollapse(value) {
      var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
      var tokens = value.match(rnothtmlwhite) || [];
      return tokens.join(' ');
    },
    hasClass: function hasClass(selector) {
      var className,
          elem,
          i = 0;
      className = ' ' + selector + ' ';

      while (elem = this[i++]) {
        if (elem.nodeType === 1 && (' ' + $(this).stripAndCollapse($(this).getClass(elem)) + ' ').indexOf(className) > -1) {
          return true;
        }
      }

      return false;
    },
    scrollTop: function scrollTop(val) {
      if (typeof val !== 'undefined') {
        for (var i = 0; i < this.length; i++) {
          if (this[i] === document) {
            window.scrollTo(document.documentElement.scrollLeft, val);
          } else {
            this[i].scrollTop = val;
          }
        }
      } else {
        if (this.length === 0) return undefined;

        if (this[0] === document) {
          return document.documentElement.scrollTop;
        }

        return this[0].scrollTop;
      }
    },
    scrollLeft: function scrollLeft(val) {
      if (typeof val !== 'undefined') {
        for (var i = 0; i < this.length; i++) {
          if (this[i] === document) {
            window.scrollTo(val, document.documentElement.scrollTop);
          } else {
            this[i].scrollLeft = val;
          }
        }
      } else {
        if (this.length === 0) return undefined;

        if (this[0] === document) {
          return document.documentElement.scrollLeft;
        }

        return this[0].scrollLeft;
      }
    },
    on: function on(eventName, selector, fn) {
      if (eventName.split(' ').length > 1) {
        var events = eventName.split(' ');

        for (var i = 0; i < events.length; i++) {
          // If it is a browser dependent or irregular event
          if (irregularEvents.indexOf(eventName) !== -1) {
            // Bind all events created by attaching all possible prefixes
            for (var j = 0; j < eventPrefixes.length; j++) {
              this.on(eventPrefixes[j] + eventName[0].toUpperCase() + eventName.slice(1), selector, fn);
            }
          } else {
            this.on(events[i], selector, fn);
          }
        } // Chain.


        return this;
      }

      if (typeof selector === 'function') {
        fn = _getDelegator(selector, null);
      } else {
        fn = _getDelegator(fn, selector);
      }

      for (var _i8 = 0; _i8 < this.length; _i8++) {
        var $el = $(this[_i8]);

        if (!$el.data('events')) {
          $el.data('events', []);
        }

        var eventHandlers = $el.data('events');
        eventHandlers.push([eventName, fn]);
        var domEvent = eventName.split('.');
        domEvent = domEvent[0];

        if (passiveEvents.indexOf(domEvent) >= 0) {
          $el.get(0).addEventListener(domEvent, fn, {
            passive: true
          });
        } else {
          $el.get(0).addEventListener(domEvent, fn);
        }
      }
    },
    off: function off(eventName) {
      if (eventName.split(' ').length > 1) {
        var events = eventName.split(' ');

        for (var i = 0; i < events.length; i++) {
          this.off(events[i]);
        } // Chain.


        return this;
      }

      for (var _i9 = 0; _i9 < this.length; _i9++) {
        var $el = $(this[_i9]);
        var eventHandlers = $el.data('events');

        if (eventHandlers) {
          var domEvent = eventName.split('.');
          domEvent = domEvent[0];

          var _eventHandlers = $el.data('events') || [];

          for (var k = _eventHandlers.length - 1; k >= 0; k--) {
            var eventHandler = _eventHandlers[k];

            if (eventHandler[0] == eventName) {
              $el.get(0).removeEventListener(domEvent, eventHandler[1]);

              _eventHandlers.splice(k, 1);
            }
          }
        }
      }
    },
    trigger: function trigger(type) {
      for (var i = 0; i < this.length; i++) {
        var event = void 0; // If it is a mouse event

        if (typeof Event === 'function') {
          if (type.search(/^mouse/g) >= 0) {
            event = new MouseEvent(type, {
              view: window,
              cancelable: true,
              bubbles: true
            });
          } else {
            event = new Event(type);
          }
        } else {
          // If it is a mouse event
          if (type.search(/^mouse/g) >= 0) {
            event = document.createEvent('MouseEvents');
            event.initMouseEvent(type, true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          } else {
            event = document.createEvent('Event');
            event.initEvent(type, true, true);
          }
        } // Handle special events separately


        if (specialEvents.indexOf(type) >= 0 && typeof this[i][type] === 'function') {
          this[i][type]();
        } else {
          this[i].dispatchEvent(event);
        }
      }
    },
    triggerHandler: function triggerHandler() {},
    val: function val(new_val) {
      if (typeof new_val != 'undefined') {
        for (var i = 0; i < this.length; i++) {
          this[i].value = new_val;
        }

        return this;
      } else {
        return this[0].value;
      }
    },
    siblings: function siblings() {
      return $(this[0]).parent().children().not(this);
    },
    find: function find(selector) {
      var ret = $();

      if (typeof selector !== 'string') {
        for (var i = 0; i < selector.length; i++) {
          for (var j = 0; j < this.length; j++) {
            if (this[j] !== selector[i] && $(this[j]).contains(selector[i])) {
              ret.push(selector[i]);
              break;
            }
          }
        }

        return ret;
      }

      var isElement = function isElement(o) {
        return (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === 'object' ? o instanceof HTMLElement : //DOM2
        o && _typeof(o) === 'object' && o !== null && o.nodeType === 1 && typeof o.nodeName === 'string';
      };

      selector = _normalizeSelector(selector);

      for (var _i10 = 0; _i10 < this.length; _i10++) {
        if (this[_i10].querySelectorAll) {
          var els = [];

          if (selector && typeof selector == 'string') {
            try {
              els = this[_i10].querySelectorAll(selector);
            } catch (e) {
              // https://github.com/froala-labs/froala-editor-js-2/issues/2399
              els = this[_i10].children;
            }
          } else if (isElement(selector)) {
            els = [selector];
          }

          for (var _j = 0; _j < els.length; _j++) {
            ret.push(els[_j]);
          }
        }
      }

      return ret;
    },
    children: function children() {
      var ret = $();

      for (var i = 0; i < this.length; i++) {
        var cldrn = this[i].children;

        for (var j = 0; j < cldrn.length; j++) {
          ret.push(cldrn[j]);
        }
      }

      return ret;
    },
    not: function not(selector) {
      if (typeof selector === 'string') {
        for (var i = this.length - 1; i >= 0; i--) {
          if (Element.prototype.matches.call(this[i], selector)) {
            this.splice(i, 1);
          }
        }
      } else {
        if (selector instanceof jQuery) {
          for (var _i11 = this.length - 1; _i11 >= 0; _i11--) {
            for (var j = 0; j < selector.length; j++) {
              if (this[_i11] === selector[j]) {
                this.splice(_i11, 1);
                break;
              }
            }
          }
        } else {
          for (var _i12 = this.length - 1; _i12 >= 0; _i12--) {
            if (this[_i12] === selector[0]) {
              this.splice(_i12, 1);
            }
          }
        }
      }

      return this;
    },
    add: function add(ary) {
      for (var i = 0; i < ary.length; i++) {
        this.push(ary[i]);
      }

      return this;
    },
    closest: function closest(selector) {
      for (var i = 0; i < this.length; i++) {
        // https://github.com/froala-labs/froala-editor-js-2/issues/3640
        var clst = Element.prototype.closest.call(this[i], selector);
        if (clst) return $(clst);
      }

      return $();
    },
    html: function html(str) {
      if (typeof str == 'undefined') {
        if (this.length === 0) return undefined;
        return this[0].innerHTML;
      }

      if (typeof str === 'string') {
        for (var i = 0; i < this.length; i++) {
          this[i].innerHTML = str; // If any of the child nodes are scripts then run them

          var children = this[i].children;
          var doc = this[i].ownerDocument || document;

          for (var j = 0; j < children.length; j++) {
            if (children[j].tagName === 'SCRIPT') {
              var script = doc.createElement('script');
              script.innerHTML = children[j].innerHTML;

              if (children[j].hasAttribute('async')) {
                script.setAttribute('async', '');
              }

              script.src = children[j].src;

              if (children[j].hasAttribute('defer')) {
                script.setAttribute('defer', '');
              }

              doc.head.appendChild(script).parentNode.removeChild(script);
            }
          }
        }
      } else {
        this[0].innerHTML = '';
        this.append(str[0]); // Execute if it is script tag

        var _doc = this[0].ownerDocument || document;

        if (str[0].tagName === 'SCRIPT') {
          var _script = _doc.createElement('script');

          _script.innerHTML = str[0].innerHTML;

          _doc.head.appendChild(_script).parentNode.removeChild(_script);
        }
      }

      return this;
    },
    text: function text(content) {
      if (content) {
        for (var i = 0; i < this.length; i++) {
          this[i].textContent = content;
        }
      } else {
        if (!this.length) return '';
        return this[0].textContent;
      }
    },
    after: function after(content) {
      if (content) {
        if (typeof content == 'string') {
          for (var i = 0; i < this.length; i++) {
            var after = this[i];

            if (after.nodeType != Node.ELEMENT_NODE) {
              var doc = after.ownerDocument;
              var tmp = doc.createElement('SPAN');
              $(after).after(tmp);
              $(tmp).after(content).remove();
            } else {
              after.insertAdjacentHTML('afterend', content);
            }
          }
        } else {
          var _after = this[0];

          if (_after.nextSibling) {
            if (content instanceof jQuery) {
              for (var _i13 = 0; _i13 < content.length; _i13++) {
                _after.nextSibling.parentNode.insertBefore(content[_i13], _after.nextSibling);
              }
            } else {
              _after.nextSibling.parentNode.insertBefore(content, _after.nextSibling);
            }
          } else {
            $(_after.parentNode).append(content);
          }
        }
      }

      return this;
    },
    clone: function clone(deep) {
      var ret = $();

      for (var i = 0; i < this.length; i++) {
        ret.push(this[i].cloneNode(deep));
      }

      return ret;
    },
    replaceWith: function replaceWith(content) {
      if (typeof content === 'string') {
        for (var i = 0; i < this.length; i++) {
          if (this[i].parentNode) {
            this[i].outerHTML = content;
          }
        }
      } else if (content.length) {
        for (var _i14 = 0; _i14 < this.length; _i14++) {
          this.replaceWith(content[_i14]);
        }
      } else {
        this.after(content).remove();
      }
    },
    insertBefore: function insertBefore(el) {
      $(el).before(this[0]);
      return this;
    },
    before: function before(content) {
      if (content instanceof jQuery) {
        for (var i = 0; i < content.length; i++) {
          this.before(content[i]);
        }

        return this;
      }

      if (content) {
        if (typeof content == 'string') {
          for (var _i15 = 0; _i15 < this.length; _i15++) {
            var before = this[_i15];

            if (before.nodeType != Node.ELEMENT_NODE) {
              var doc = before.ownerDocument;
              var tmp = doc.createElement('SPAN');
              $(before).before(tmp);
              $(tmp).before(content).remove();
            } else {
              if (before.parentNode) {
                before.insertAdjacentHTML('beforebegin', content);
              }
            }
          }
        } else {
          var _before = this[0];

          if (_before.parentNode) {
            if (content instanceof jQuery) {
              for (var _i16 = 0; _i16 < content.length; _i16++) {
                _before.parentNode.insertBefore(content[_i16], _before);
              }
            } else {
              _before.parentNode.insertBefore(content, _before);
            }
          }
        }
      }

      return this;
    },
    append: function append(content) {
      if (this.length == 0) return this;

      if (typeof content == 'string') {
        for (var i = 0; i < this.length; i++) {
          var parent = this[i];
          var doc = parent.ownerDocument;
          var tmp = doc.createElement('SPAN');
          $(parent).append(tmp);
          $(tmp).after(content).remove();
        }
      } else {
        if (content instanceof jQuery || Array.isArray(content)) {
          for (var _i17 = 0; _i17 < content.length; _i17++) {
            this.append(content[_i17]);
          }
        } else {
          if (typeof content !== 'function') {
            this[0].appendChild(content);
          }
        }
      }

      return this;
    },
    prepend: function prepend(content) {
      if (this.length == 0) return this;

      if (typeof content == 'string') {
        for (var i = 0; i < this.length; i++) {
          var parent = this[i];
          var doc = parent.ownerDocument;
          var tmp = doc.createElement('SPAN');
          $(parent).prepend(tmp);
          $(tmp).before(content).remove();
        }
      } else {
        if (content instanceof jQuery) {
          for (var _i18 = 0; _i18 < content.length; _i18++) {
            this.prepend(content[_i18]);
          }
        } else {
          var _parent = this[0];

          if (!_parent.firstChild) {
            $(_parent).append(content);
          } else {
            if (_parent.firstChild) {
              _parent.insertBefore(content, _parent.firstChild);
            } else {
              _parent.appendChild(content);
            }
          }
        }
      }

      return this;
    },
    remove: function remove() {
      for (var i = 0; i < this.length; i++) {
        if (this[i].parentNode) {
          this[i].parentNode.removeChild(this[i]);
        }
      }

      return this;
    },
    prev: function prev() {
      // replicate the jQuery behavior
      if (this.length && this[0].previousElementSibling) {
        return $(this[0].previousElementSibling);
      } else {
        return $();
      }
    },
    next: function next() {
      if (this.length && this[0].nextElementSibling) {
        return $(this[0].nextElementSibling);
      } else {
        return $();
      }
    },
    //https://github.com/froala-labs/froala-editor-js-2/issues/1874
    nextAllVisible: function nextAllVisible() {
      return this.next();
    },
    //https://github.com/froala-labs/froala-editor-js-2/issues/1874
    prevAllVisible: function prevAllVisible() {
      return this.prev();
    },
    outerHeight: function outerHeight(margin) {
      if (this.length === 0) return undefined;
      var el = this[0];

      if (el === el.window) {
        return el.innerHeight;
      } // Remember the old values, and insert the new ones


      var old = {};
      var isVisible = this.isVisible();

      if (!isVisible) {
        for (var _name in cssShow) {
          old[_name] = el.style[_name];
          el.style[_name] = cssShow[_name];
        }
      }

      var height = el.offsetHeight;

      if (margin) {
        height += parseInt($(el).css('marginTop')) + parseInt($(el).css('marginBottom'));
      } // Revert the old values


      if (!isVisible) {
        for (var _name2 in cssShow) {
          el.style[_name2] = old[_name2];
        }
      }

      return height;
    },
    outerWidth: function outerWidth(margin) {
      if (this.length === 0) return undefined;
      var el = this[0];

      if (el === el.window) {
        return el.outerWidth;
      } // Remember the old values, and insert the new ones


      var old = {};
      var isVisible = this.isVisible();

      if (!isVisible) {
        for (var _name3 in cssShow) {
          old[_name3] = el.style[_name3];
          el.style[_name3] = cssShow[_name3];
        }
      }

      var width = el.offsetWidth;

      if (margin) {
        width += parseInt($(el).css('marginLeft')) + parseInt($(el).css('marginRight'));
      } // Revert the old values


      if (!isVisible) {
        for (var _name4 in cssShow) {
          el.style[_name4] = old[_name4];
        }
      }

      return width;
    },
    width: function width(newWidth) {
      if (newWidth === undefined) {
        if (this[0] instanceof HTMLDocument) {
          return this[0].body.offsetWidth;
        }

        if (this[0]) {
          return this[0].offsetWidth;
        }
      } else {
        this[0].style.width = newWidth + 'px';
      }
    },
    height: function height(newHeight) {
      var elem = this[0];

      if (newHeight === undefined) {
        if (elem instanceof HTMLDocument) {
          var doc = elem.documentElement;
          return Math.max(elem.body.scrollHeight, doc.scrollHeight, elem.body.offsetHeight, doc.offsetHeight, doc.clientHeight);
        }

        return elem.offsetHeight;
      } else {
        elem.style.height = newHeight + 'px';
      }
    },
    is: function is(el) {
      if (this.length === 0) return false;

      if (typeof el == 'string' && this[0].matches) {
        return this[0].matches(el);
      } else if (el instanceof jQuery) {
        return this[0] == el[0];
      } else {
        return this[0] == el;
      }
    },
    parent: function parent() {
      if (this.length === 0) return $();
      return $(this[0].parentNode);
    },
    _matches: function _matches(el, selector) {
      var matchesFn = el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector;

      if (el && !selector) {
        return matchesFn;
      }

      return matchesFn.call(el, selector);
    },
    parents: function parents(selector) {
      var ret = $();

      for (var i = 0; i < this.length; i++) {
        var el = this[i].parentNode;

        while (el && el != document && this._matches(el)) {
          if (selector) {
            if (this._matches(el, selector)) {
              ret.push(el);
            }
          } else {
            ret.push(el);
          }

          el = el.parentNode;
        }
      }

      return ret;
    },
    parentsUntil: function parentsUntil(until, selector) {
      var ret = $();

      if (until instanceof jQuery && until.length > 0) {
        until = until[0];
      }

      for (var i = 0; i < this.length; i++) {
        var el = this[i].parentNode; // https://github.com/froala-labs/froala-editor-js-2/issues/3642

        while (el && el != document && el != until && this[i] != until && !(typeof until == 'string' && Element.prototype.matches.call(el, until))) {
          if (selector) {
            if (Element.prototype.matches.call(el, selector)) {
              ret.push(el);
            }
          } else {
            ret.push(el);
          }

          el = el.parentNode;
        }
      }

      return ret;
    },
    insertAfter: function insertAfter(elem) {
      var parentNode = elem.parent()[0];

      if (parentNode) {
        parentNode.insertBefore(this[0], elem[0].nextElementSibling);
      }
    },
    filter: function filter(fn) {
      var ret = $();

      if (typeof fn === 'function') {
        for (var i = 0; i < this.length; i++) {
          if (fn.call(this[i], this[i])) {
            ret.push(this[i]);
          }
        }
      } else if (typeof fn === 'string') {
        for (var _i19 = 0; _i19 < this.length; _i19++) {
          if (this[_i19].matches(fn)) {
            ret.push(this[_i19]);
          }
        }
      }

      return ret;
    },
    offset: function offset() {
      if (this.length === 0) return undefined;
      var rect = this[0].getBoundingClientRect();
      var win = this[0].ownerDocument.defaultView;
      return {
        top: rect.top + win.pageYOffset,
        left: rect.left + win.pageXOffset
      };
    },
    position: function position() {
      return {
        left: this[0].offsetLeft,
        top: this[0].offsetTop
      };
    },
    // For internal use only.
    // Behaves like an Array's method, not like a jQuery method.
    push: [].push,
    splice: [].splice
  };

  jQuery.extend = function (new_obj) {
    new_obj = new_obj || {}; // Loop arguments.

    for (var i = 1; i < arguments.length; i++) {
      if (!arguments[i]) continue;

      for (var key in arguments[i]) {
        if (Object.prototype.hasOwnProperty.call(arguments[i], key)) new_obj[key] = arguments[i][key];
      }
    }

    return new_obj;
  };

  jQuery.merge = function (first, second) {
    var len = +second.length,
        j = 0,
        i = first.length;

    for (; j < len; j++) {
      first[i++] = second[j];
    }

    first.length = i;
    return first;
  };

  jQuery.map = function (elems, callback, arg) {
    var length,
        value,
        i = 0,
        ret = []; // Go through the array, translating each of the items to their new values

    if (Array.isArray(elems)) {
      length = elems.length;

      for (; i < length; i++) {
        value = callback(elems[i], i, arg);

        if (value != null) {
          ret.push(value);
        }
      } // Go through every key on the object,

    } else {
      for (i in elems) {
        value = callback(elems[i], i, arg);

        if (value != null) {
          ret.push(value);
        }
      }
    } // Flatten any nested arrays


    return [].concat.apply([], ret);
  };

  var init = function init(selector, context) {
    if (!selector) {
      return this;
    }

    if (typeof selector == 'string' && selector[0] === '<') {
      var tmp = document.createElement('DIV');
      tmp.innerHTML = selector;
      return $(tmp.firstElementChild);
    }

    context = context instanceof jQuery ? context[0] : context;

    if (typeof selector == 'string') {
      selector = _normalizeSelector(selector);
      var els = (context || document).querySelectorAll(selector);

      for (var i = 0; i < els.length; i++) {
        this[i] = els[i];
      }

      this.length = els.length;
      return this;
    } else {
      if (!(selector instanceof jQuery)) {
        this[0] = selector;
        this.length = 1;
        return this;
      }

      return selector;
    }
  };

  init.prototype = jQuery.prototype;

  var FE = FroalaEditor;

  function init$1(e) {
    if (e.type === 'touchend' && !this.$el.data('touched')) {
      return true;
    }

    if (e.which === 1 || !e.which) {
      this.$el.off('mousedown.init touchstart.init touchmove.init touchend.init dragenter.init focus.init');
      this.load(FE.MODULES);
      this.load(FE.PLUGINS);
      var target = e.originalEvent && e.originalEvent.originalTarget;

      if (target && target.tagName === 'IMG') {
        jQuery(target).trigger('mousedown');
      }

      if (typeof this.ul === 'undefined') {
        this.destroy();
      }

      if (e.type === 'touchend' && this.image && e.originalEvent && e.originalEvent.target && jQuery(e.originalEvent.target).is('img')) {
        var that = this;
        setTimeout(function () {
          that.image.edit(jQuery(e.originalEvent.target));
        }, 100);
      }

      this.ready = true;
      this.events.trigger('initialized');
    }
  }

  function doInit() {
    this.doc = this.$el.get(0).ownerDocument;
    this.win = 'defaultView' in this.doc ? this.doc.defaultView : this.doc.parentWindow;
    this.$doc = jQuery(this.doc);
    this.$win = jQuery(this.win);

    if (!this.opts.pluginsEnabled) {
      this.opts.pluginsEnabled = Object.keys(FE.PLUGINS);
    }

    if (this.opts.initOnClick) {
      this.load(FE.MODULES); // https://github.com/froala/wysiwyg-editor/issues/1207.

      this.$el.on('touchstart.init', function () {
        jQuery(this).data('touched', true);
      });
      this.$el.on('touchmove.init', function () {
        jQuery(this).removeData('touched');
      });
      this.$el.on('mousedown.init touchend.init dragenter.init focus.init', init$1.bind(this));
      this.events.trigger('initializationDelayed');
    } else {
      this.load(FE.MODULES);
      this.load(FE.PLUGINS);
      jQuery(this.o_win).scrollTop(this.c_scroll);

      if (typeof this.ul === 'undefined') {
        this.destroy();
      }

      this.ready = true;
      this.events.trigger('initialized');
    }
  }

  FE.Bootstrap = function (element, options, initCallback) {
    this.id = ++FE.ID;
    this.$ = jQuery;
    var presets = {}; // If init callback is passed and no options.

    if (typeof options == 'function') {
      initCallback = options;
      options = {};
    }

    if (initCallback) {
      if (!options.events) options.events = {};
      options.events.initialized = initCallback;
    }

    if (options && options.documentReady) {
      presets.toolbarButtons = [['fullscreen', 'undo', 'redo', 'getPDF', 'print'], ['bold', 'italic', 'underline', 'textColor', 'backgroundColor', 'clearFormatting'], ['alignLeft', 'alignCenter', 'alignRight', 'alignJustify'], ['formatOL', 'formatUL', 'indent', 'outdent'], ['paragraphFormat'], ['fontFamily'], ['fontSize'], ['insertLink', 'insertImage', 'quote']];
      presets.paragraphFormatSelection = true;
      presets.fontFamilySelection = true;
      presets.fontSizeSelection = true;
      presets.placeholderText = '';
      presets.quickInsertEnabled = false;
      presets.charCounterCount = false;
    }

    this.opts = Object.assign({}, Object.assign({}, FE.DEFAULTS, presets, _typeof(options) === 'object' && options));
    var opts_string = JSON.stringify(this.opts);
    FE.OPTS_MAPPING[opts_string] = FE.OPTS_MAPPING[opts_string] || this.id;
    this.sid = FE.OPTS_MAPPING[opts_string];
    FE.SHARED[this.sid] = FE.SHARED[this.sid] || {};
    this.shared = FE.SHARED[this.sid];
    this.shared.count = (this.shared.count || 0) + 1;
    this.$oel = jQuery(element);
    this.$oel.data('froala.editor', this);
    this.o_doc = element.ownerDocument;
    this.o_win = 'defaultView' in this.o_doc ? this.o_doc.defaultView : this.o_doc.parentWindow;
    this.c_scroll = jQuery(this.o_win).scrollTop();

    this._init();
  };

  FE.Bootstrap.prototype._init = function () {
    // Get the tag name of the original element.
    var tag_name = this.$oel.get(0).tagName;

    if (this.$oel.closest('label').length >= 1) {
      //
      console.warn('Note! It is not recommended to initialize the Froala Editor within a label tag.');
    }

    var initOnDefault = function () {
      if (tag_name !== 'TEXTAREA') {
        this._original_html = this._original_html || this.$oel.html();
      }

      this.$box = this.$box || this.$oel; // Turn on iframe if fullPage is on.

      if (this.opts.fullPage) {
        this.opts.iframe = true;
      }

      if (!this.opts.iframe) {
        this.$el = jQuery(this.o_doc.createElement('DIV'));
        this.el = this.$el.get(0);
        this.$wp = jQuery(this.o_doc.createElement('DIV')).append(this.$el);
        this.$box.html(this.$wp);
        setTimeout(doInit.bind(this), 0);
      } else {
        this.$iframe = jQuery('<iframe src="about:blank" frameBorder="0">');
        this.$wp = jQuery('<div></div>');
        this.$box.html(this.$wp);
        this.$wp.append(this.$iframe);
        this.$iframe.get(0).contentWindow.document.open();
        this.$iframe.get(0).contentWindow.document.write('<!DOCTYPE html>');
        this.$iframe.get(0).contentWindow.document.write('<html><head></head><body></body></html>');
        this.$iframe.get(0).contentWindow.document.close();
        this.iframe_document = this.$iframe.get(0).contentWindow.document;
        this.$el = jQuery(this.iframe_document.querySelector('body'));
        this.el = this.$el.get(0);
        this.$head = jQuery(this.iframe_document.querySelector('head'));
        this.$html = jQuery(this.iframe_document.querySelector('html'));
        setTimeout(doInit.bind(this), 0);
      }
    }.bind(this);

    var initOnTextarea = function () {
      this.$box = jQuery('<div>');
      this.$oel.before(this.$box).hide();
      this._original_html = this.$oel.val(); // Before submit textarea do a sync.

      var that = this;
      this.$oel.parents('form').on("submit.".concat(this.id), function () {
        that.events.trigger('form.submit');
      });
      this.$oel.parents('form').on("reset.".concat(this.id), function () {
        that.events.trigger('form.reset');
      });
      initOnDefault();
    }.bind(this);

    var initOnA = function () {
      this.$el = this.$oel;
      this.el = this.$el.get(0);
      this.$el.attr('contenteditable', true).css('outline', 'none').css('display', 'inline-block');
      this.opts.multiLine = false;
      this.opts.toolbarInline = false;
      setTimeout(doInit.bind(this), 0);
    }.bind(this);

    var initOnImg = function () {
      this.$el = this.$oel;
      this.el = this.$el.get(0);
      this.opts.toolbarInline = false;
      setTimeout(doInit.bind(this), 0);
    }.bind(this);

    var editInPopup = function () {
      this.$el = this.$oel;
      this.el = this.$el.get(0);
      this.opts.toolbarInline = false;
      this.$oel.on('click.popup', function (e) {
        e.preventDefault();
      });
      setTimeout(doInit.bind(this), 0);
    }.bind(this); // Check on what element it was initialized.


    if (this.opts.editInPopup) {
      editInPopup();
    } else if (tag_name === 'TEXTAREA') {
      initOnTextarea();
    } else if (tag_name === 'A') {
      initOnA();
    } else if (tag_name === 'IMG') {
      initOnImg();
    } else if (tag_name === 'BUTTON' || tag_name === 'INPUT') {
      this.opts.editInPopup = true;
      this.opts.toolbarInline = false;
      editInPopup();
    } else {
      initOnDefault();
    }
  };

  FE.Bootstrap.prototype.load = function (module_list) {
    // Bind modules to the current instance and tear them up.
    for (var m_name in module_list) {
      if (Object.prototype.hasOwnProperty.call(module_list, m_name)) {
        if (this[m_name]) {
          continue;
        } // Do not include plugin.


        if (FE.PLUGINS[m_name] && this.opts.pluginsEnabled.indexOf(m_name) < 0) {
          continue;
        }

        this[m_name] = new module_list[m_name](this);

        if (this[m_name]._init) {
          this[m_name]._init();

          if (this.opts.initOnClick && m_name === 'core') {
            return false;
          }
        }
      }
    }
  };

  FE.Bootstrap.prototype.destroy = function () {
    this.destrying = true;
    this.shared.count--;
    this.events && this.events.$off(); // HTML.

    var html = this.html && this.html.get(); // Focus main frame.

    if (this.opts.iframe) {
      this.events.disableBlur();
      this.win.focus();
      this.events.enableBlur();
    }

    if (this.events) {
      this.events.trigger('destroy', [], true);
      this.events.trigger('shared.destroy', [], true);
    } // Remove shared.


    if (this.shared.count === 0) {
      for (var k in this.shared) {
        if (Object.prototype.hasOwnProperty.call(this.shared, k)) {
          this.shared[k] = null;
          FE.SHARED[this.sid][k] = null;
        }
      }

      delete FE.SHARED[this.sid];
    }

    this.$oel.parents('form').off(".".concat(this.id));
    this.$oel.off('click.popup');
    this.$oel.removeData('froala.editor');
    this.$oel.off('froalaEditor'); // Destroy editor basic elements.

    if (this.core) {
      this.core.destroy(html);
    }

    FE.INSTANCES.splice(FE.INSTANCES.indexOf(this), 1);
  };

  return FroalaEditor;

})));
//# sourceMappingURL=froala_editor.js.map
